import { jsx as y, jsxs as E, Fragment as Re } from "react/jsx-runtime";
import Ye, { forwardRef as dt, useRef as lt, useEffect as _e, useId as Oo, useState as ie, useMemo as Ct, useDebugValue as Cc, useLayoutEffect as _h, createContext as Ro, useContext as xc, useImperativeHandle as Oh, useCallback as Rh } from "react";
import Ih from "react-dom";
import { getAllowList as f4, richTextAllowList as p4 } from "./rich-text-allow-list.js";
const Lh = "_breadcrumb_1supa_1", Dh = "_item_1supa_8", Ph = "_button_1supa_14", zh = "_text_1supa_37", Bh = "_separator_1supa_41", $h = "_current_1supa_49", kn = {
  breadcrumb: Lh,
  item: Dh,
  button: Ph,
  text: zh,
  separator: Bh,
  current: $h
};
function i4({
  items: t,
  separator: e = ">",
  onItemClick: n,
  renderLink: r,
  className: i = ""
}) {
  return t.length === 0 ? null : /* @__PURE__ */ y("nav", { "aria-label": "Breadcrumb navigation", className: `${kn.breadcrumb} ${i}`, children: t.map((s, o) => {
    const l = o === t.length - 1;
    return /* @__PURE__ */ y("span", { className: kn.item, children: l ? /* @__PURE__ */ y("span", { className: kn.current, "aria-current": "page", children: s.name }) : /* @__PURE__ */ E(Re, { children: [
      r ? r(s, o) : n ? /* @__PURE__ */ y(
        "button",
        {
          type: "button",
          className: kn.button,
          onClick: () => n(s, o),
          children: s.name
        }
      ) : /* @__PURE__ */ y("span", { className: kn.text, children: s.name }),
      /* @__PURE__ */ y("span", { className: kn.separator, "aria-hidden": "true", children: e })
    ] }) }, s.id);
  }) });
}
const Hh = "_button_q3mmz_1", Vh = "_disabled_q3mmz_140", Fh = "_startIcon_q3mmz_145", Wh = "_endIcon_q3mmz_150", qh = "_fullWidth_q3mmz_156", jh = "_icon_q3mmz_191", Mt = {
  button: Hh,
  "button-small": "_button-small_q3mmz_18",
  "button-medium": "_button-medium_q3mmz_24",
  "button-large": "_button-large_q3mmz_30",
  "button-contained": "_button-contained_q3mmz_37",
  "button-primary": "_button-primary_q3mmz_37",
  "button-secondary": "_button-secondary_q3mmz_48",
  "button-success": "_button-success_q3mmz_53",
  "button-warning": "_button-warning_q3mmz_58",
  "button-error": "_button-error_q3mmz_63",
  "button-default": "_button-default_q3mmz_68",
  "button-outlined": "_button-outlined_q3mmz_74",
  "button-text": "_button-text_q3mmz_110",
  disabled: Vh,
  startIcon: Fh,
  endIcon: Wh,
  fullWidth: qh,
  "button-icon": "_button-icon_q3mmz_167",
  icon: jh,
  "button-add": "_button-add_q3mmz_247",
  "button-link": "_button-link_q3mmz_271",
  "button-white": "_button-white_q3mmz_310",
  "button-group": "_button-group_q3mmz_341"
}, ot = dt(
  ({
    children: t,
    className: e = "",
    size: n = "medium",
    variant: r = "contained",
    color: i = "default",
    onClick: s,
    disabled: o = !1,
    type: l = "button",
    fullWidth: a = !1,
    startIcon: c,
    endIcon: d,
    ...u
  }, h) => {
    const f = [
      Mt.button,
      Mt[`button-${n}`],
      Mt[`button-${r}`],
      Mt[`button-${i}`],
      a ? Mt.fullWidth : "",
      o ? Mt.disabled : "",
      e
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ E(
      "button",
      {
        ref: h,
        className: f,
        onClick: s,
        disabled: o,
        type: l,
        ...u,
        children: [
          c && /* @__PURE__ */ y("span", { className: Mt.startIcon, children: c }),
          t,
          d && /* @__PURE__ */ y("span", { className: Mt.endIcon, children: d })
        ]
      }
    );
  }
);
ot.displayName = "Button";
const Uh = "_chip_wrg4g_1", Kh = "_disabled_wrg4g_101", Zh = "_icon_wrg4g_118", Gh = "_label_wrg4g_124", Jh = "_deleteIcon_wrg4g_130", vn = {
  chip: Uh,
  "chip-small": "_chip-small_wrg4g_18",
  "chip-medium": "_chip-medium_wrg4g_24",
  "chip-large": "_chip-large_wrg4g_30",
  "chip-filled": "_chip-filled_wrg4g_36",
  "chip-primary": "_chip-primary_wrg4g_36",
  "chip-secondary": "_chip-secondary_wrg4g_41",
  "chip-success": "_chip-success_wrg4g_46",
  "chip-warning": "_chip-warning_wrg4g_51",
  "chip-error": "_chip-error_wrg4g_56",
  "chip-default": "_chip-default_wrg4g_61",
  "chip-outlined": "_chip-outlined_wrg4g_66",
  disabled: Kh,
  icon: Zh,
  label: Gh,
  deleteIcon: Jh
}, Qh = "_icon_1dq82_1", Yh = "_small_1dq82_13", Xh = "_large_1dq82_23", ef = "_xlarge_1dq82_28", tf = "_inline_1dq82_33", nf = "_fluid_1dq82_39", as = {
  icon: Qh,
  small: Yh,
  default: "_default_1dq82_18",
  large: Xh,
  xlarge: ef,
  inline: tf,
  fluid: nf
}, rf = () => /* @__PURE__ */ y(
  "path",
  {
    fillRule: "evenodd",
    d: "M18 21V3H6v18l6-6.3 6 6.3ZM7 18.5l5-5.25 5 5.25V4H7v14.5Z",
    clipRule: "evenodd"
  }
), sf = () => /* @__PURE__ */ y("path", { d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" }), of = () => /* @__PURE__ */ E(Re, { children: [
  /* @__PURE__ */ y("path", { d: "M11.638 14.355 6.5 19.75V3.5h11v16.25l-5.138-5.395-.362-.38-.362.38Z" }),
  /* @__PURE__ */ y("path", { d: "M11.638 14.355 6.5 19.75V3.5h11v16.25l-5.138-5.395-.362-.38-.362.38Z" })
] }), lf = () => /* @__PURE__ */ y("path", { d: "M20 6 10 16l-6-6-2 2 8 8L22 8l-2-2Z" }), af = () => /* @__PURE__ */ y("path", { d: "m20.003 9.876-8 6.624-8.006-6.624V7.5l8.006 4.5 8-4.5v2.376Z" }), cf = () => /* @__PURE__ */ y("path", { d: "m14.124 20.003-6.624-8 6.624-8.006H16.5L12 12.003l4.5 8h-2.376Z" }), df = () => /* @__PURE__ */ y("path", { d: "m9.876 4 6.624 8-6.624 8.006H7.5L12 12 7.5 4h2.376Z" }), uf = () => /* @__PURE__ */ y("path", { d: "m3.997 14.124 8-6.624 8.006 6.624V16.5L11.997 12l-8 4.5v-2.376Z" }), hf = () => /* @__PURE__ */ y("path", { d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0z" }), ff = () => /* @__PURE__ */ y("path", { d: "M12 4a8 8 0 1 0 0 16V4Z" }), pf = () => /* @__PURE__ */ E(Re, { children: [
  /* @__PURE__ */ y("path", { d: "M15.0042 31.4452H0.03479V31.0627C2.3612 31.0627 2.49804 29.6286 2.49804 27.2702V12.4187C2.49804 10.0603 2.3612 8.6261 0.03479 8.6261V8.24365H7.97194V8.6261C5.64554 8.6261 5.50869 10.0603 5.50869 12.4187V29.0549C5.50869 30.0429 5.8166 30.5528 6.84295 30.5528H9.23778C12.9327 30.5528 13.3278 29.8517 15.4489 25.8041H15.8595L15.0042 31.4452Z" }),
  /* @__PURE__ */ y("path", { d: "M30.6604 27.4295L31.2762 27.7801C30.0788 29.5648 27.9919 31.8276 24.3654 31.8276C19.8152 31.8276 17.0441 28.0988 17.0441 23.382C17.0441 18.0916 20.7047 14.3627 25.1523 14.3627C28.8472 14.3627 31.5157 16.8486 31.242 21.0555H20.0205C19.9863 21.4379 19.9521 21.8204 19.9521 22.2347C19.9521 26.6646 21.868 30.0747 25.6655 30.0747C27.9919 30.0747 29.5656 28.7043 30.6604 27.4295ZM25.0154 15.1914C22.3811 15.1914 20.7047 17.2948 20.1574 20.0994H28.2998C28.5393 16.9442 27.5129 15.1914 25.0154 15.1914Z" }),
  /* @__PURE__ */ y("path", { d: "M36.6493 28.0032H42.1079C45.7685 28.0032 47.7186 29.3099 47.7186 32.0507C47.7186 36.4169 42.5526 39.094 38.6399 39.094C34.6029 39.094 32.4755 37.0862 32.4755 34.4728C32.4755 33.0068 33.2966 31.987 34.6651 31.0309L35.0756 30.744H35.8967C35.0414 31.5089 34.7335 32.465 34.7335 33.5167C34.7335 36.162 36.6898 37.7236 40.2821 37.7236C42.9974 37.7236 45.8027 36.0345 45.8027 33.453C45.8027 31.5726 44.5027 30.3934 41.9026 30.3934H35.794C33.9124 30.3934 33.0913 29.4692 33.0913 28.3538C33.0913 27.0471 34.0835 26.1547 36.1362 25.0711C34.1177 24.2106 32.8518 22.4259 32.8518 20.0675C32.8518 16.6255 35.5888 14.3627 39.3521 14.3627C40.5495 14.3627 41.6785 14.5858 42.6022 15.0001L48.5551 14.5221L47.9393 16.2749L44.0733 15.9562C45.1339 16.9442 45.7497 18.2828 45.7497 19.9719C45.7497 23.4139 43.0812 25.6767 39.2837 25.6767C38.4626 25.6767 37.7099 25.581 36.9915 25.3898C35.7598 26.1547 35.4177 26.6009 35.4177 27.1108C35.4177 27.6207 35.7941 28.0032 36.6493 28.0032ZM39.3179 15.1914C36.8546 15.1914 35.5888 17.008 35.5888 20.0038C35.5888 22.9996 36.8204 24.848 39.3179 24.848C41.7811 24.848 43.0128 22.9996 43.0128 20.0038C43.0128 17.008 41.7811 15.1914 39.3179 15.1914Z" }),
  /* @__PURE__ */ y("path", { d: "M63.1955 29.5648L63.6745 29.9791C63.1271 30.7122 61.9981 31.8276 60.4586 31.8276C58.8506 31.8276 58.4059 30.4891 58.3375 29.3417C56.9006 30.9034 54.512 31.8276 52.6304 31.8276C50.3039 31.8276 48.6618 29.9908 48.6618 27.9193C48.6618 25.529 50.5092 23.7443 54.6831 22.6288L58.2006 21.7683V19.94C58.2006 19.0158 57.9332 15.9244 54.5804 15.9244C52.3567 15.9244 50.7829 17.2948 49.7908 19.0795L49.1065 18.8246C49.6539 17.1036 52.0425 14.3627 56.0111 14.3627C59.3296 14.3627 60.9376 16.498 60.9376 19.4938V27.9713C60.9376 29.023 60.9376 30.1385 61.9981 30.1385C62.5113 30.1385 62.9219 29.8198 63.1955 29.5648ZM54.1699 30.2341C55.5726 30.2341 57.2769 29.4055 58.2006 28.6406V22.6288L55.5041 23.3618C53.1777 24.0311 51.4329 24.8597 51.4329 27.1225C51.4329 28.8435 52.5961 30.2341 54.1699 30.2341Z" }),
  /* @__PURE__ */ y("path", { d: "M69.9166 31.4452H64.1348V31.0627C65.5375 31.0627 65.6401 29.9791 65.6401 27.9394V11.5406C65.6401 9.50094 65.0585 8.83166 63.8953 8.54483V8.16239L68.1376 7.27002H68.4113V27.9394C68.4113 29.9791 68.5139 31.0627 69.9166 31.0627V31.4452Z" }),
  /* @__PURE__ */ y("path", { d: "M75.8621 16.2664L76.1358 16.2983C83.765 16.9357 87.2546 19.804 87.2546 24.2658C87.2546 28.8551 83.3545 31.9784 77.8806 31.9784C75.9305 31.9784 73.5015 31.596 72.2698 31.1498L72.7146 26.6242H73.3304C73.8094 28.0584 75.2121 30.6399 78.0859 30.6399C80.686 30.6399 82.6702 29.1738 82.6702 26.4967C82.6702 23.5647 80.3096 21.4613 75.1436 21.0151L73.3304 20.8557L74.8015 8.01202C78.0517 8.58569 80.5149 8.71317 82.2255 8.71317C85.0993 8.71317 85.8862 8.29886 86.5362 7.8208H87.152C85.6467 12.3782 83.6624 13.6212 79.9333 13.6212C79.1464 13.6212 77.8122 13.5574 76.2042 13.3662L75.8621 16.2664Z" }),
  /* @__PURE__ */ y("path", { d: "M98.6846 31.9784C92.4238 31.9784 89.0027 27.3254 89.0027 20.059C89.0027 12.92 92.5607 8.01202 98.753 8.01202C104.98 8.01202 108.435 12.6651 108.435 19.9315C108.435 27.0704 104.877 31.9784 98.6846 31.9784ZM98.7188 30.6399C101.319 30.6399 101.866 26.6242 101.866 19.9952C101.866 13.5574 101.285 9.35057 98.7188 9.35057C96.1187 9.35057 95.5713 13.3662 95.5713 19.9952C95.5713 26.433 96.1529 30.6399 98.7188 30.6399Z" }),
  /* @__PURE__ */ y("path", { d: "M120.185 31.9784C113.924 31.9784 110.503 27.3254 110.503 20.059C110.503 12.92 114.061 8.01202 120.253 8.01202C126.48 8.01202 129.935 12.6651 129.935 19.9315C129.935 27.0704 126.377 31.9784 120.185 31.9784ZM120.219 30.6399C122.819 30.6399 123.366 26.6242 123.366 19.9952C123.366 13.5574 122.785 9.35057 120.219 9.35057C117.619 9.35057 117.071 13.3662 117.071 19.9952C117.071 26.433 117.653 30.6399 120.219 30.6399Z" })
] }), mf = () => /* @__PURE__ */ y("path", { d: "m3.99658 6.004 2.008-2.008 6.00002 6 5.999-5.996 1.997 1.999-5.997 5.996 6 6.001-2.007 2.008-6-6-5.99902 5.996-1.997-1.998 5.997-5.997z" }), gf = () => /* @__PURE__ */ y("path", { d: "M12 22c5.522 0 10-4.478 10-10S17.522 2 12 2 2 6.478 2 12s4.478 10 10 10ZM6.826 8.397l1.571-1.571L12 10.429l3.603-3.603 1.571 1.571L13.571 12l3.603 3.603-1.571 1.571L12 13.571l-3.603 3.603-1.571-1.571L10.429 12 6.826 8.397Z" }), yf = () => /* @__PURE__ */ y("path", { d: "M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1ZM19 5H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16h-9V7h9v14Z" }), bf = () => /* @__PURE__ */ y("path", { d: "M6 7h12v13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7Zm3 3v8h2v-8H9Zm4 0v8h2v-8h-2ZM9 2h6a2 2 0 0 1 2 2v1h4v2H3V5h4V4a2 2 0 0 1 2-2Zm0 3h6V4H9v1Z" }), kf = () => /* @__PURE__ */ y("path", { d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a1 1 0 0 0 0-1.41L18.37 3.29a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" }), vf = () => /* @__PURE__ */ y("path", { d: "M14.2117 3.00002L13.6852 14.9332H10.7521L10.2006 3.00002H14.2117ZM12.2061 16.5878C13.4345 16.5878 14.4373 17.5905 14.4373 18.7939C14.4373 19.9972 13.4345 21 12.2061 21C11.0279 21 10 19.9972 10 18.7688C10 17.5655 11.0279 16.5878 12.2061 16.5878Z" }), Cf = () => /* @__PURE__ */ E(Re, { children: [
  /* @__PURE__ */ y("path", { d: "M10 6H7a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3h1v3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3v1Z" }),
  /* @__PURE__ */ y("path", { d: "M17.333 6H12V5h7v7h-1V6.748l-5.626 5.626-.707-.707L17.333 6Z" })
] }), xf = () => /* @__PURE__ */ y("path", { d: "M23 12.04C23 5.944 18.075 1 12 1S1 5.943 1 12.04c0 5.178 3.552 9.523 8.343 10.716v-7.341H7.075V12.04h2.268v-1.454c0-3.758 1.694-5.5 5.37-5.5.697 0 1.9.138 2.391.274V8.42c-.26-.028-.71-.041-1.27-.041-1.804 0-2.5.686-2.5 2.468v1.194h3.592l-.617 3.374h-2.976V23C18.78 22.34 23 17.686 23 12.04Z" }), wf = () => /* @__PURE__ */ E(Re, { children: [
  /* @__PURE__ */ y("path", { d: "M3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H21C21.5523 6 22 5.55228 22 5C22 4.44772 21.5523 4 21 4H3Z" }),
  /* @__PURE__ */ y("path", { d: "M5.99964 8C5.71335 8 5.44949 8.13696 5.29202 8.36418C5.13456 8.5914 5.10281 8.87878 5.20425 9.13394L9 18.381V20C9 20.5523 9.44772 21 10 21H14C14.5523 21 15 20.5523 15 20V18.381L18.7958 9.13394C18.8972 8.87878 18.8654 8.5914 18.708 8.36418C18.5505 8.13696 18.2866 8 18.0004 8H5.99964Z" })
] }), Sf = () => /* @__PURE__ */ y("path", { d: "M12 22.121c5.474 0 10-4.526 10-10 0-5.483-4.526-10-10.01-10-5.474 0-9.99 4.517-9.99 10 0 5.474 4.526 10 10 10ZM5.868 5.651a9.025 9.025 0 0 1 3.998-2.204c-.777.708-1.445 1.795-1.934 3.17-.807-.238-1.505-.567-2.064-.966Zm8.266-2.204a9.07 9.07 0 0 1 3.998 2.204c-.569.399-1.257.728-2.064.967-.489-1.376-1.157-2.463-1.934-3.17Zm-5.175 3.43c.618-1.765 1.526-2.991 2.523-3.32v3.59c-.918-.03-1.755-.12-2.523-.27Zm3.56-3.32c.996.329 1.904 1.555 2.522 3.32-.768.15-1.605.24-2.523.27v-3.59Zm-9.432 8.046A8.855 8.855 0 0 1 5.17 6.389c.639.488 1.476.887 2.463 1.186-.319 1.186-.518 2.542-.558 4.028H3.087Zm13.838 0c-.04-1.486-.24-2.842-.558-4.028.987-.3 1.824-.698 2.462-1.177a8.8 8.8 0 0 1 2.084 5.205h-3.988Zm-4.407 0v-3.43c.997-.03 1.955-.14 2.822-.329.3 1.127.479 2.403.518 3.759h-3.34Zm-4.376 0c.04-1.356.229-2.632.518-3.759.877.19 1.825.3 2.822.33v3.429h-3.34ZM3.087 12.64h3.988c.04 1.495.24 2.871.558 4.068-.967.299-1.804.698-2.433 1.166a8.792 8.792 0 0 1-2.113-5.234Zm5.055 0h3.34v3.48c-.987.02-1.935.139-2.802.318a16.011 16.011 0 0 1-.538-3.798Zm4.376 3.48v-3.48h3.35a16.525 16.525 0 0 1-.548 3.798c-.867-.18-1.805-.299-2.802-.319Zm3.849.588c.319-1.197.518-2.573.558-4.068h3.988a8.793 8.793 0 0 1-2.113 5.234c-.628-.468-1.466-.867-2.433-1.166Zm-3.849.438c.908.03 1.745.12 2.503.27-.618 1.724-1.516 2.96-2.503 3.29v-3.56Zm-3.539.27c.768-.15 1.595-.24 2.503-.27v3.56c-.987-.33-1.885-1.566-2.503-3.29Zm7.089.259c.787.239 1.475.558 2.034.937a9.036 9.036 0 0 1-3.928 2.173c.757-.707 1.405-1.774 1.894-3.11Zm-10.17.937c.559-.379 1.247-.698 2.044-.937.479 1.336 1.127 2.402 1.885 3.11a9.036 9.036 0 0 1-3.929-2.173Z" }), Mf = () => /* @__PURE__ */ y(Re, { children: /* @__PURE__ */ y("path", { d: "M4 5h16v2H4V5ZM4 11h16v2H4v-2ZM4 17h16v2H4v-2Z" }) }), Tf = () => /* @__PURE__ */ y("path", { d: "m12.364 13.778 4.95 4.95 1.414-1.414-4.95-4.95 4.95-4.95L17.314 6l-4.95 4.95L7.414 6 6 7.414l4.95 4.95L6 17.314l1.414 1.414 4.95-4.95Z" }), Ef = () => /* @__PURE__ */ y(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2L2.97818 11.0218H4.00001V21H9.33334V14H14.6667V21H20V11.0218H21.0218L12 2Z"
  }
), Af = () => /* @__PURE__ */ E(Re, { children: [
  /* @__PURE__ */ y("path", { d: "M12.806 8.794c.82 0 1.327-.598 1.327-1.287 0-.625-.481-1.132-1.235-1.132-.82 0-1.327.585-1.327 1.275 0 .611.468 1.144 1.235 1.144Zm-2.796 6.568c-.104.442-.143.715-.143 1.066 0 .664.442 1.197 1.288 1.197 1.027 0 1.716-.663 2.627-1.925l-.312-.273c-.495.611-.82.923-1.054.923-.117 0-.182-.065-.182-.195 0-.104.04-.299.104-.533l1.327-5.268h-.403l-2.953.56-.078.35.69.508-.911 3.59Z" }),
  /* @__PURE__ */ y(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
      clipRule: "evenodd"
    }
  )
] }), Nf = ({ fill: t }) => /* @__PURE__ */ y(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: t,
    d: "M4.22263 4.22232C6.88684 3.7299 9.63801 4.05992 12.1106 5.16822C14.5832 6.27652 16.6597 8.11083 18.0645 10.4276C19.4697 12.7442 20.1367 15.4337 19.9767 18.1385C18.3132 12.8067 14.716 9.93825 11.6698 8.9252C14.0266 10.5569 18.1036 14.8437 18.1391 19.9767C15.4345 20.1366 12.7451 19.4697 10.4283 18.0646C8.11145 16.6597 6.27717 14.5829 5.16884 12.1106C4.06052 9.63834 3.73019 6.88679 4.22263 4.22232Z"
  }
), _f = () => /* @__PURE__ */ y("path", { d: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" }), Of = () => /* @__PURE__ */ y("path", { d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" }), Rf = () => /* @__PURE__ */ y(
  "path",
  {
    fillRule: "evenodd",
    d: "M15.769 17.286a8.333 8.333 0 1 1 2.357-2.357l4.714 4.714L20.483 22l-4.714-4.714Zm1.738-6.953a6.333 6.333 0 1 1-12.667 0 6.333 6.333 0 0 1 12.667 0Z",
    clipRule: "evenodd"
  }
), If = () => /* @__PURE__ */ y("path", { d: "M13.48 2h-3v8.486H2v3h8.48V22h3v-8.514H22v-3h-8.52V2Z" }), Lf = () => /* @__PURE__ */ E(Re, { children: [
  /* @__PURE__ */ y(
    "path",
    {
      fillRule: "evenodd",
      d: "M12 21.121a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 1c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ y("path", { d: "M13 6.121h-2v5H6v2h5v5h2v-5h5v-2h-5v-5Z" })
] }), Df = () => /* @__PURE__ */ y(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.87 18.93 12 22l-2.87-3.07-4.201.141.142-4.2L2 12l3.07-2.87-.141-4.201 4.2.142L12 2l2.87 3.07 4.201-.141-.142 4.2L22 12l-3.07 2.87.141 4.201-4.2-.142Zm.093-10.263 1.481 1.481-5.185 5.185-3.703-3.703 1.481-1.482 2.222 2.222 3.704-3.703Z"
  }
), Pf = () => /* @__PURE__ */ y("path", { d: "M5 4h1v1.063a2 2 0 0 1 0 3.874V20H5V8.937a2 2 0 0 1 0-3.874V4Zm1.5 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM11.5 4h1v11.063a2 2 0 0 1 0 3.874V20h-1v-1.063a2 2 0 0 1 0-3.874V4ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM18 4h1v6.063a2 2 0 0 1 0 3.874V20h-1v-6.063a2 2 0 0 1 0-3.874V4Zm1.5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }), zf = () => /* @__PURE__ */ y("path", { d: "M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7.93-1.82-1.72-.34a.5.5 0 0 1-.4-.36 6.01 6.01 0 0 0-.38-.92.5.5 0 0 1 .03-.54l1.02-1.42a.75.75 0 0 0-.11-.95l-1.12-1.12a.75.75 0 0 0-.95-.11l-1.42 1.02a.5.5 0 0 1-.54.03 6.01 6.01 0 0 0-.92-.38.5.5 0 0 1-.36-.4l-.34-1.72a.75.75 0 0 0-.74-.6h-1.58a.75.75 0 0 0-.74.6l-.34 1.72a.5.5 0 0 1-.36.4 6.01 6.01 0 0 0-.92.38.5.5 0 0 1-.54-.03l-1.42-1.02a.75.75 0 0 0-.95.11L4.49 7.57a.75.75 0 0 0-.11.95l1.02 1.42a.5.5 0 0 1 .03.54 6.01 6.01 0 0 0-.38.92.5.5 0 0 1-.4.36l-1.72.34a.75.75 0 0 0-.6.74v1.58c0 .37.27.68.6.74l1.72.34a.5.5 0 0 1 .4.36c.1.32.23.63.38.92a.5.5 0 0 1-.03.54l-1.02 1.42a.75.75 0 0 0 .11.95l1.12 1.12c.25.25.66.31.95.11l1.42-1.02a.5.5 0 0 1 .54-.03c.29.15.6.28.92.38a.5.5 0 0 1 .36.4l.34 1.72c.06.33.37.6.74.6h1.58c.37 0 .68-.27.74-.6l.34-1.72a.5.5 0 0 1 .36-.4c.32-.1.63-.23.92-.38a.5.5 0 0 1 .54.03l1.42 1.02c.29.2.7.14.95-.11l1.12-1.12c.25-.25.31-.66.11-.95l-1.02-1.42a.5.5 0 0 1-.03-.54c.15-.29.28-.6.38-.92a.5.5 0 0 1 .4-.36l1.72-.34c.33-.06.6-.37.6-.74v-1.58a.75.75 0 0 0-.6-.74Z" }), Bf = () => /* @__PURE__ */ y("path", { d: "M12 17.301 5.783 22l2.45-7.642L2 9.642h7.632L12 2l2.368 7.642H22l-6.234 4.716L18.217 22 12 17.301Z" }), $f = () => /* @__PURE__ */ y("path", { d: "M12 17.301 5.783 22l2.45-7.642L2 9.642h7.632L12 2v15.301Z" }), Hf = () => /* @__PURE__ */ y("path", { d: "M12 18 5 6l7 2 7-2-7 12Z" }), Vf = () => /* @__PURE__ */ y("path", { d: "m6 12 12-6-2 6 2 6-12-6Z" }), Ff = () => /* @__PURE__ */ y("path", { d: "M18 12 6 18l2-6-2-6 12 6Z" }), Wf = () => /* @__PURE__ */ y("path", { d: "m12 6 7 12-7-2-7 2 7-12Z" }), qf = () => /* @__PURE__ */ y("path", { d: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM3 22a9 9 0 0 1 18 0H3Z" }), jf = () => /* @__PURE__ */ E(
  "svg",
  {
    width: "157",
    height: "24",
    viewBox: "0 0 157 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [
      /* @__PURE__ */ y(
        "mask",
        {
          id: "mask0_8084_84425",
          className: "mask-type:alpha",
          maskUnits: "userSpaceOnUse",
          x: "-12",
          y: "-12",
          width: "48",
          height: "48",
          children: /* @__PURE__ */ y("rect", { x: "-12", y: "-12", width: "48", height: "48", fill: "url(#pattern0_8084_84425)" })
        }
      ),
      /* @__PURE__ */ E("g", { mask: "url(#mask0_8084_84425)", children: [
        /* @__PURE__ */ y(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 21.3333C17.1547 21.3333 21.3333 17.1547 21.3333 12C21.3333 6.84534 17.1547 2.66667 12 2.66667C6.84534 2.66667 2.66667 6.84534 2.66667 12C2.66667 17.1547 6.84534 21.3333 12 21.3333ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
            fill: "#082536"
          }
        ),
        /* @__PURE__ */ y(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 20.6667C16.7865 20.6667 20.6667 16.7865 20.6667 12C20.6667 7.21353 16.7865 3.33333 12 3.33333C7.21353 3.33333 3.33333 7.21353 3.33333 12C3.33333 16.7865 7.21353 20.6667 12 20.6667Z",
            fill: "#082536"
          }
        ),
        /* @__PURE__ */ y(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 14.6667C13.4728 14.6667 14.6667 13.4728 14.6667 12C14.6667 10.5272 13.4728 9.33333 12 9.33333C10.5272 9.33333 9.33333 10.5272 9.33333 12C9.33333 13.4728 10.5272 14.6667 12 14.6667ZM12 17.3333C14.9455 17.3333 17.3333 14.9455 17.3333 12C17.3333 9.05448 14.9455 6.66667 12 6.66667C9.05448 6.66667 6.66667 9.05448 6.66667 12C6.66667 14.9455 9.05448 17.3333 12 17.3333Z",
            fill: "#082536"
          }
        ),
        /* @__PURE__ */ y(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 11.3333C11.6318 11.3333 11.3333 11.6318 11.3333 12C11.3333 12.3682 11.6318 12.6667 12 12.6667C12.3682 12.6667 12.6667 12.3682 12.6667 12C12.6667 11.6318 12.3682 11.3333 12 11.3333ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
            fill: "#082536"
          }
        )
      ] }),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M155.601 12.08V17.48C155.601 18.76 155.661 19.44 156.481 19.44V19.68H151.921V19.44C152.741 19.44 152.801 18.76 152.801 17.48V12.8C152.801 11.42 152.561 10.54 151.261 10.54C150.701 10.54 149.961 10.78 149.361 11.18V17.48C149.361 18.76 149.421 19.44 150.241 19.44V19.68H145.681V19.44C146.501 19.44 146.561 18.76 146.561 17.48V6.79998C146.561 5.51998 146.221 5.15998 145.541 4.91998V4.67998L149.201 4.03998H149.361V10.62C150.361 9.67998 151.681 8.95998 153.001 8.95998C154.721 8.95998 155.601 10.08 155.601 12.08Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M141.161 19.92C138.181 19.92 136.621 17.48 136.621 14.62C136.621 11.42 138.701 8.95996 141.661 8.95996C143.121 8.95996 144.381 9.67996 145.141 10.6L143.981 12.3H143.741C143.421 10.72 142.941 9.47996 141.661 9.47996C140.221 9.47996 139.461 11 139.461 13.54C139.461 16.42 140.461 18.32 142.401 18.32C143.601 18.32 144.381 17.62 144.981 16.86L145.341 17.08C144.541 18.48 143.381 19.92 141.161 19.92Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M136.425 17.8L136.725 18.12C135.785 19.2 134.445 19.92 133.205 19.92C131.585 19.92 130.625 19.1 130.625 17.1V10.18H129.585V9.61997L129.865 9.47997C131.285 8.81997 132.205 7.97997 133.185 6.21997H133.425V9.19997H136.585L136.245 10.18H133.425V16.94C133.425 17.98 133.925 18.5 134.825 18.5C135.425 18.5 135.965 18.18 136.425 17.8Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M129.333 18.22L129.613 18.48C129.293 18.96 128.473 19.92 127.133 19.92C125.913 19.92 125.573 19.12 125.473 18.44C124.753 19.34 123.533 19.92 122.393 19.92C121.013 19.92 120.053 19.08 120.053 17.72C120.053 16.18 121.153 15.02 123.513 14.36L125.333 13.84V12.68C125.333 12.12 125.333 10.3 123.473 10.3C122.233 10.3 121.293 11.12 120.753 12.12L120.353 11.96C120.873 10.34 122.473 8.95996 124.753 8.95996C126.873 8.95996 128.073 10.3 128.073 12.48V17.26C128.073 17.92 128.073 18.52 128.653 18.52C128.933 18.52 129.173 18.38 129.333 18.22ZM123.953 18.58C124.453 18.58 124.953 18.34 125.333 18V14.38L124.513 14.68C123.513 15.06 122.673 15.52 122.673 16.94C122.673 18.06 123.253 18.58 123.953 18.58Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M118.194 5.36V5.12H121.634V5.36C120.894 5.62 120.234 6.84 119.494 9.27999L116.334 19.96H115.834L112.534 9.79999L109.034 19.96H108.554L104.674 7.68C104.174 6.05999 103.694 5.44 102.854 5.36V5.12H108.654V5.36C107.574 5.44 107.214 6.02 107.554 7.14L110.014 15.14L112.194 8.7L111.854 7.68C111.334 6.05999 110.874 5.44 110.094 5.36V5.12H115.914V5.36C114.734 5.44 114.374 6 114.734 7.14L117.174 14.8L118.814 9.12C119.514 6.69999 119.494 5.62 118.194 5.36Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M94.2981 19.92C91.2581 19.92 89.2581 17.84 89.2581 14.48C89.2581 11.16 91.3381 8.95996 94.3381 8.95996C97.3781 8.95996 99.3781 11.04 99.3781 14.4C99.3781 17.72 97.2981 19.92 94.2981 19.92ZM94.3381 19.4C95.8981 19.4 96.4181 17.3 96.4181 14.44C96.4181 11.7 95.8581 9.47996 94.2981 9.47996C92.7381 9.47996 92.2181 11.58 92.2181 14.44C92.2181 17.18 92.7781 19.4 94.3381 19.4Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M89.0619 17.8L89.3619 18.12C88.4219 19.2 87.0819 19.92 85.8419 19.92C84.2219 19.92 83.2619 19.1 83.2619 17.1V10.18H82.2219V9.61997L82.5019 9.47997C83.9219 8.81997 84.8419 7.97997 85.8219 6.21997H86.0619V9.19997H89.2219L88.8819 10.18H86.0619V16.94C86.0619 17.98 86.5619 18.5 87.4619 18.5C88.0619 18.5 88.6019 18.18 89.0619 17.8Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M73.6676 19.92C72.6876 19.92 71.4476 19.72 70.6876 19.38L70.5076 16.48H70.7476C71.5876 18.14 72.4276 19.4 74.0076 19.4C75.0276 19.4 75.8476 18.86 75.8476 17.88C75.8476 16.9 75.1676 16.46 73.7676 15.72L72.9876 15.3C72.1276 14.84 70.7476 14.1 70.7476 12.2C70.7476 10.14 72.3876 8.95996 74.4476 8.95996C75.2476 8.95996 76.4876 9.13996 77.3076 9.45996V11.88H77.0676C76.4076 10.44 75.5476 9.47996 74.2676 9.47996C73.2676 9.47996 72.6876 10.06 72.6876 10.84C72.6876 11.94 73.6276 12.42 74.2476 12.74L75.0276 13.16C76.3876 13.88 77.8076 14.54 77.8076 16.48C77.8076 18.6 76.1276 19.92 73.6676 19.92Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M68.9641 12.08V17.48C68.9641 18.76 69.0241 19.44 69.8441 19.44V19.68H65.2841V19.44C66.1041 19.44 66.1641 18.76 66.1641 17.48V12.8C66.1641 11.42 65.9241 10.54 64.6241 10.54C64.0641 10.54 63.3641 10.8 62.8041 11.2C62.8441 11.48 62.8641 11.76 62.8641 12.08V17.48C62.8641 18.76 62.9241 19.44 63.7441 19.44V19.68H59.1841V19.44C60.0041 19.44 60.0641 18.76 60.0641 17.48V12.8C60.0641 11.42 59.8041 10.54 58.5241 10.54C57.9641 10.54 57.3041 10.78 56.7441 11.16V17.48C56.7441 18.76 56.8041 19.44 57.6241 19.44V19.68H53.0641V19.44C53.8841 19.44 53.9441 18.76 53.9441 17.48V11.92C53.9441 10.64 53.6041 10.28 52.9241 10.04V9.79996L56.5841 8.99996H56.7441V10.6C57.6841 9.65996 58.9241 8.95996 60.2441 8.95996C61.5441 8.95996 62.3641 9.57996 62.7041 10.74C63.6441 9.73996 64.9841 8.95996 66.3641 8.95996C68.0841 8.95996 68.9641 10.08 68.9641 12.08Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M51.8497 8.95996C52.1097 8.95996 52.3897 8.99996 52.6697 9.11996L52.0897 11.68H51.8897C51.3697 11.1 50.7697 10.88 50.2497 10.88C49.8297 10.88 49.4297 11.02 49.0097 11.4V17.48C49.0097 18.76 49.0697 19.44 49.8897 19.44V19.68H45.3297V19.44C46.1497 19.44 46.2097 18.76 46.2097 17.48V11.92C46.2097 10.64 45.8697 10.28 45.1897 10.04V9.79996L48.8497 8.99996H49.0097V10.84C49.8497 9.67996 50.8097 8.95996 51.8497 8.95996Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M42.2749 7.63996C41.3749 7.63996 40.6749 6.93996 40.6749 6.03996C40.6749 5.17996 41.3749 4.45996 42.2749 4.45996C43.1349 4.45996 43.8549 5.17996 43.8549 6.03996C43.8549 6.93996 43.1349 7.63996 42.2749 7.63996ZM44.6749 19.68H40.1149V19.44C40.9349 19.44 40.9949 18.76 40.9949 17.48V11.92C40.9949 10.64 40.6549 10.28 39.9749 10.04V9.79996L43.6349 8.99996H43.7949V17.48C43.7949 18.76 43.8549 19.44 44.6749 19.44V19.68Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ y(
        "path",
        {
          d: "M35.1333 5.68H33.7333V12.18H34.9133C36.8733 12.18 37.3733 11.6 37.8333 10.32H38.0733V14.86H37.8333C37.3533 13.48 36.8733 12.82 34.9133 12.82H33.7333V16.96C33.7333 18.44 33.8133 19.44 35.1733 19.44V19.68H29.3333V19.44C30.6933 19.44 30.7733 18.44 30.7733 16.96V7.84C30.7733 6.36 30.6933 5.36 29.3333 5.36V5.12H39.2933L39.5933 8.52H39.3533C38.1333 6.3 37.3333 5.68 35.1333 5.68Z",
          fill: "#082536"
        }
      ),
      /* @__PURE__ */ E("defs", { children: [
        /* @__PURE__ */ y(
          "pattern",
          {
            id: "pattern0_8084_84425",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /* @__PURE__ */ y("use", { xlinkHref: "#image0_8084_84425", transform: "scale(0.00694444)" })
          }
        ),
        /* @__PURE__ */ y(
          "image",
          {
            id: "image0_8084_84425",
            width: "144",
            height: "144",
            xlinkHref: "data:image/png;base64,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"
          }
        )
      ] })
    ]
  }
), Uf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Bell: sf,
  Bookmark: rf,
  BookmarkActive: of,
  Check: lf,
  ChevronDown: af,
  ChevronLeft: cf,
  ChevronRight: df,
  ChevronUp: uf,
  CircleFull: hf,
  CircleHalf: ff,
  CombinationLogo: pf,
  Copy: yf,
  Cross: mf,
  CrossCircle: gf,
  Delete: bf,
  Edit: kf,
  Exclamation: vf,
  External: Cf,
  Facebook: xf,
  Filter: wf,
  FirmsToWatch: jf,
  Globe: Sf,
  Hamburger: Mf,
  HamburgerClose: Tf,
  Home: Ef,
  Info: Af,
  Leaf: Nf,
  Logo: _f,
  Logout: Of,
  Magnifier: Rf,
  Plus: If,
  PlusCircle: Lf,
  SatisfactionMark: Df,
  Settings: Pf,
  SettingsCog: zf,
  StarFull: Bf,
  StarHalf: $f,
  TriangleDown: Hf,
  TriangleLeft: Vf,
  TriangleRight: Ff,
  TriangleUp: Wf,
  User: qf
}, Symbol.toStringTag, { value: "Module" })), wl = {
  bookmark: "Bookmark",
  "bookmark-active": "BookmarkActive",
  check: "Check",
  combinationLogo: "CombinationLogo",
  bell: "Bell",
  "chevron-down": "ChevronDown",
  "chevron-left": "ChevronLeft",
  "chevron-right": "ChevronRight",
  "chevron-up": "ChevronUp",
  "circle-full": "CircleFull",
  "circle-half": "CircleHalf",
  cross: "Cross",
  "cross-circle": "CrossCircle",
  copy: "Copy",
  delete: "Delete",
  edit: "Edit",
  exclamation: "Exclamation",
  external: "External",
  facebook: "Facebook",
  filter: "Filter",
  "firms-to-watch": "FirmsToWatch",
  globe: "Globe",
  hamburger: "Hamburger",
  "hamburger-close": "HamburgerClose",
  home: "Home",
  info: "Info",
  leaf: "Leaf",
  logo: "Logo",
  logout: "Logout",
  magnifier: "Magnifier",
  plus: "Plus",
  "plus-circle": "PlusCircle",
  "satisfaction-mark": "SatisfactionMark",
  settings: "Settings",
  "settings-cog": "SettingsCog",
  star: "StarFull",
  "star-full": "StarFull",
  "star-half": "StarHalf",
  "triangle-down": "TriangleDown",
  "triangle-left": "TriangleLeft",
  "triangle-right": "TriangleRight",
  "triangle-up": "TriangleUp",
  user: "User"
}, j = ({
  icon: t,
  size: e = "default",
  className: n = "",
  title: r,
  as: i = "i",
  onClick: s
}) => {
  if (typeof t != "string")
    return /* @__PURE__ */ y(i, { className: `${as.icon} ${n}`, children: t });
  if (!t || !(t in wl))
    return null;
  const o = wl[t], l = Uf[o], a = {
    combinationLogo: "0 0 130 40",
    // default viewBox for others
    default: "0 0 24 24"
  }, c = a[t] || a.default, d = typeof e == "object" ? { width: `${e.width}rem`, height: `${e.height}rem` } : as[e];
  return /* @__PURE__ */ y(
    i,
    {
      className: `${as.icon} ${typeof e == "string" ? d : ""} ${n}`,
      style: typeof e == "object" ? d : void 0,
      role: "img",
      "aria-label": r || t,
      onClick: s,
      children: /* @__PURE__ */ y("svg", { viewBox: c, fill: "currentColor", children: /* @__PURE__ */ y(l, {}) })
    }
  );
};
j.displayName = "Icon";
const Kf = dt(
  ({
    className: t = "",
    size: e = "medium",
    variant: n = "filled",
    color: r = "default",
    onClick: i,
    disabled: s = !1,
    children: o,
    onDelete: l
  }, a) => {
    const c = i && !s, d = [
      vn.chip,
      vn[`chip-${e}`],
      vn[`chip-${n}`],
      vn[`chip-${r}`],
      s ? vn.disabled : "",
      t
    ].filter(Boolean).join(" "), u = (p) => {
      (p.key === "Enter" || p.key === " ") && c && (p.preventDefault(), i?.(p));
    }, h = (p) => {
      p.stopPropagation(), l && !s && l();
    }, f = (p) => {
      (p.key === "Enter" || p.key === " ") && l && !s && (p.preventDefault(), p.stopPropagation(), l());
    };
    return /* @__PURE__ */ E(
      "div",
      {
        ref: a,
        className: d,
        onClick: c ? i : void 0,
        role: c ? "button" : void 0,
        tabIndex: c ? 0 : void 0,
        onKeyDown: c ? u : void 0,
        "aria-disabled": s,
        children: [
          o,
          l && !s && /* @__PURE__ */ y(
            "div",
            {
              className: vn.deleteIcon,
              onClick: h,
              onKeyDown: f,
              role: "button",
              "aria-label": "Remove",
              tabIndex: 0,
              children: /* @__PURE__ */ y(j, { icon: "cross", size: "small" })
            }
          )
        ]
      }
    );
  }
);
Kf.displayName = "Chip";
const Zf = "_disclosure_tjnsy_1", Gf = "_summary_tjnsy_6", Jf = "_chevron_tjnsy_32", Qf = "_content_tjnsy_47", Mr = {
  disclosure: Zf,
  summary: Gf,
  chevron: Jf,
  content: Qf
}, s4 = ({
  summary: t,
  children: e,
  defaultOpen: n = !1,
  className: r = ""
}) => {
  const i = [Mr.disclosure, r].filter(Boolean).join(" ");
  return /* @__PURE__ */ E("details", { className: i, open: n, children: [
    /* @__PURE__ */ E("summary", { className: Mr.summary, children: [
      /* @__PURE__ */ y("span", { className: Mr.chevron, "aria-hidden": "true", children: /* @__PURE__ */ y(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 12 12",
          width: "12",
          height: "12",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: /* @__PURE__ */ y("polyline", { points: "4 2 8 6 4 10" })
        }
      ) }),
      /* @__PURE__ */ y("span", { children: t })
    ] }),
    /* @__PURE__ */ y("div", { className: Mr.content, children: e })
  ] });
}, Yf = "_searchBar_hyaaj_1", Xf = "_large_hyaaj_34", ep = "_input_hyaaj_45", tp = "_icon_hyaaj_66", np = "_clearButton_hyaaj_81", Cn = {
  searchBar: Yf,
  default: "_default_hyaaj_30",
  large: Xf,
  input: ep,
  icon: tp,
  clearButton: np
}, rp = ({
  onChange: t,
  onSubmit: e,
  value: n = "",
  onClear: r,
  size: i = "default",
  formAction: s,
  className: o = "",
  placeholder: l = "Search...",
  startIcon: a,
  endIcon: c
}) => {
  const d = (f) => {
    t?.(f.target.value);
  }, u = (f) => {
    if (e) {
      f.preventDefault(), e(f);
      return;
    }
    s || f.preventDefault();
  }, h = n && r;
  return /* @__PURE__ */ E(
    "form",
    {
      role: "search",
      "aria-label": "Search site",
      className: `${Cn.searchBar} ${Cn[i]}`,
      action: s,
      onSubmit: u,
      children: [
        a && /* @__PURE__ */ y("div", { className: Cn.icon, children: typeof a == "string" ? /* @__PURE__ */ y(j, { icon: a }) : a }),
        /* @__PURE__ */ y(
          "input",
          {
            type: "search",
            className: `${Cn.input} ${o}`,
            value: t ? n : void 0,
            onChange: t ? d : void 0,
            placeholder: l,
            "aria-label": "Search",
            enterKeyHint: "search"
          }
        ),
        c && /* @__PURE__ */ y("div", { className: Cn.icon, children: typeof c == "string" ? /* @__PURE__ */ y(j, { icon: c }) : c }),
        h && /* @__PURE__ */ y(
          ot,
          {
            variant: "icon",
            onClick: r,
            color: "secondary",
            size: "large",
            type: "button",
            className: Cn.clearButton,
            "aria-label": "Clear search",
            children: /* @__PURE__ */ y(j, { icon: "cross-circle" })
          }
        )
      ]
    }
  );
}, ip = "_checkboxWrapper_198va_1", sp = "_fullWidth_198va_7", op = "_checkboxContainer_198va_11", lp = "_checkboxOnlyContainer_198va_18", ap = "_checkbox_198va_1", cp = "_checkboxLabel_198va_43", dp = "_checkmark_198va_55", up = "_checkIcon_198va_98", hp = "_label_198va_144", fp = "_errorText_198va_154", pp = "_helperText_198va_160", Ue = {
  checkboxWrapper: ip,
  fullWidth: sp,
  checkboxContainer: op,
  checkboxOnlyContainer: lp,
  checkbox: ap,
  checkboxLabel: cp,
  checkmark: dp,
  checkIcon: up,
  label: hp,
  errorText: fp,
  helperText: pp
}, wc = dt(
  ({ label: t, error: e, helperText: n, fullWidth: r = !1, className: i = "", id: s, ...o }, l) => {
    const a = s || `checkbox-${Math.random().toString(36).substr(2, 9)}`, c = e ? `${a}-error` : void 0, d = n ? `${a}-helper` : void 0, u = [c, d].filter(Boolean).join(" ");
    return /* @__PURE__ */ E(
      "div",
      {
        className: `${Ue.checkboxWrapper} ${r ? Ue.fullWidth : ""} ${i}`,
        children: [
          /* @__PURE__ */ E("div", { className: Ue.checkboxContainer, children: [
            /* @__PURE__ */ E("div", { className: Ue.checkboxOnlyContainer, children: [
              /* @__PURE__ */ y(
                "input",
                {
                  ref: l,
                  type: "checkbox",
                  id: a,
                  className: Ue.checkbox,
                  "aria-invalid": e ? "true" : void 0,
                  "aria-describedby": u || void 0,
                  ...o
                }
              ),
              /* @__PURE__ */ y("label", { htmlFor: a, className: Ue.checkboxLabel, children: /* @__PURE__ */ y("span", { className: Ue.checkmark, children: /* @__PURE__ */ y(j, { icon: "check", className: Ue.checkIcon }) }) })
            ] }),
            t && /* @__PURE__ */ y("span", { className: Ue.label, children: t })
          ] }),
          e && /* @__PURE__ */ y("p", { id: c, className: Ue.errorText, role: "alert", children: e }),
          n && !e && /* @__PURE__ */ y("p", { id: d, className: Ue.helperText, children: n })
        ]
      }
    );
  }
);
wc.displayName = "Checkbox";
const mp = "_backdrop_5k69d_2", gp = "_fadeIn_5k69d_1", yp = "_backdropBlur_5k69d_17", bp = "_modal_5k69d_22", kp = "_slideIn_5k69d_1", vp = "_header_5k69d_33", Cp = "_title_5k69d_41", xp = "_closeButton_5k69d_48", wp = "_content_5k69d_71", Sp = "_small_5k69d_77", Mp = "_medium_5k69d_81", Tp = "_mediumLarge_5k69d_85", Ep = "_large_5k69d_89", Tt = {
  backdrop: mp,
  fadeIn: gp,
  backdropBlur: yp,
  modal: bp,
  slideIn: kp,
  header: vp,
  title: Cp,
  closeButton: xp,
  content: wp,
  small: Sp,
  medium: Mp,
  mediumLarge: Tp,
  large: Ep
}, Sc = ({
  isOpen: t,
  onClose: e,
  title: n,
  children: r,
  size: i = "medium",
  className: s = "",
  blurBackground: o = !1,
  backdropClick: l = !0
}) => {
  const a = lt(null), c = lt(null);
  _e(() => (t ? (c.current = document.activeElement, document.body.style.overflow = "hidden") : (document.body.style.overflow = "", c.current?.focus()), () => {
    document.body.style.overflow = "";
  }), [t]), _e(() => {
    const u = (h) => {
      h.key === "Escape" && e();
    };
    return t && document.addEventListener("keydown", u), () => {
      document.removeEventListener("keydown", u);
    };
  }, [t, e]);
  const d = (u) => {
    l && u.target === a.current && e();
  };
  return t ? /* @__PURE__ */ y(
    "div",
    {
      ref: a,
      className: `${Tt.backdrop} ${o ? Tt.backdropBlur : ""}`,
      onClick: d,
      role: "presentation",
      children: /* @__PURE__ */ E(
        "div",
        {
          className: `${Tt.modal} ${Tt[i]} ${s}`,
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": n ? "modal-title" : void 0,
          children: [
            /* @__PURE__ */ E("div", { className: Tt.header, children: [
              n && /* @__PURE__ */ y("h2", { id: "modal-title", className: Tt.title, children: n }),
              /* @__PURE__ */ y(ot, { className: Tt.closeButton, onClick: e, "aria-label": "Close modal", children: /* @__PURE__ */ y(j, { icon: "cross", "aria-hidden": "true" }) })
            ] }),
            /* @__PURE__ */ y("div", { className: Tt.content, children: r })
          ]
        }
      )
    }
  ) : null;
};
Sc.displayName = "Modal";
const Ap = "_wrapper_1lxw7_1", Np = "_label_1lxw7_9", _p = "_selectedList_1lxw7_16", Op = "_selectedRow_1lxw7_28", Rp = "_selectedName_1lxw7_44", Ip = "_removeButton_1lxw7_50", Lp = "_openButton_1lxw7_74", Dp = "_empty_1lxw7_78", Pp = "_emptyMuted_1lxw7_86", zp = "_error_1lxw7_92", Bp = "_modalBody_1lxw7_98", $p = "_modalList_1lxw7_107", Hp = "_tree_1lxw7_115", Vp = "_modalFooter_1lxw7_132", Fp = "_node_1lxw7_149", Wp = "_row_1lxw7_154", qp = "_expandButton_1lxw7_166", jp = "_expandSpacer_1lxw7_186", Up = "_countryHeader_1lxw7_192", Kp = "_groupHeader_1lxw7_198", Zp = "_children_1lxw7_204", W = {
  wrapper: Ap,
  label: Np,
  selectedList: _p,
  selectedRow: Op,
  selectedName: Rp,
  removeButton: Ip,
  openButton: Lp,
  empty: Dp,
  emptyMuted: Pp,
  error: zp,
  modalBody: Bp,
  modalList: $p,
  tree: Hp,
  modalFooter: Vp,
  node: Fp,
  row: Wp,
  expandButton: qp,
  expandSpacer: jp,
  countryHeader: Up,
  groupHeader: Kp,
  children: Zp
};
function Sl(t) {
  return [...t].sort((e, n) => e.name.localeCompare(n.name));
}
function Gp(t) {
  const e = /* @__PURE__ */ new Map();
  for (const i of t) {
    const s = i.countryId !== null ? `id:${i.countryId}` : `name:${i.country ?? ""}`;
    let o = e.get(s);
    if (o || (o = { name: i.country ?? "Unspecified country", ungrouped: [], groups: /* @__PURE__ */ new Map() }, e.set(s, o)), i.practiceGroupId !== null) {
      const l = `id:${i.practiceGroupId}`;
      let a = o.groups.get(l);
      a || (a = { key: l, name: i.practiceGroup ?? "Unspecified group", areas: [] }, o.groups.set(l, a)), a.areas.push(i);
    } else
      o.ungrouped.push(i);
  }
  const n = (i, s) => (i.practiceArea ?? "").localeCompare(s.practiceArea ?? ""), r = Array.from(e.entries()).map(([i, s]) => ({
    key: i,
    name: s.name,
    ungrouped: [...s.ungrouped].sort(n),
    groups: Sl(Array.from(s.groups.values())).map((o) => ({
      ...o,
      areas: [...o.areas].sort(n)
    }))
  }));
  return Sl(r);
}
function Jp(t, e) {
  if (!e) return t;
  const n = (i) => i.toLowerCase().includes(e), r = [];
  for (const i of t) {
    const s = n(i.name), o = s ? i.ungrouped : i.ungrouped.filter((a) => n(a.practiceArea ?? "")), l = [];
    for (const a of i.groups) {
      if (s || n(a.name)) {
        l.push(a);
        continue;
      }
      const c = a.areas.filter((d) => n(d.practiceArea ?? ""));
      c.length > 0 && l.push({ ...a, areas: c });
    }
    (s || o.length > 0 || l.length > 0) && r.push({ ...i, ungrouped: o, groups: l });
  }
  return r;
}
function Qp(t) {
  return [t.country, t.practiceGroup, t.practiceArea].filter(Boolean).join(" › ");
}
function Mc({ area: t, checked: e, disabled: n, onToggle: r }) {
  const i = t.practiceArea ?? "Untitled practice area";
  return /* @__PURE__ */ y("li", { className: W.node, children: /* @__PURE__ */ E("div", { className: W.row, children: [
    /* @__PURE__ */ y("span", { className: W.expandSpacer, "aria-hidden": "true" }),
    /* @__PURE__ */ y(
      wc,
      {
        label: i,
        "aria-label": i,
        checked: e,
        disabled: n,
        onChange: () => r(t.id)
      }
    )
  ] }) });
}
function Yp({
  group: t,
  value: e,
  disabled: n,
  expanded: r,
  forceOpen: i,
  onToggleExpanded: s,
  onToggle: o
}) {
  const l = i ? !0 : r, a = `editorial-category-group-${t.key}`;
  return /* @__PURE__ */ E("li", { className: W.node, children: [
    /* @__PURE__ */ E("div", { className: W.row, children: [
      /* @__PURE__ */ y(
        "button",
        {
          type: "button",
          className: W.expandButton,
          "aria-expanded": l,
          "aria-controls": a,
          "aria-label": l ? `Collapse ${t.name}` : `Expand ${t.name}`,
          onClick: () => s(t.key),
          children: /* @__PURE__ */ y(j, { icon: l ? "chevron-down" : "chevron-right", size: "small" })
        }
      ),
      /* @__PURE__ */ y("span", { className: W.groupHeader, children: t.name })
    ] }),
    l && /* @__PURE__ */ y("ul", { id: a, className: W.children, children: t.areas.map((c) => /* @__PURE__ */ y(
      Mc,
      {
        area: c,
        checked: e.includes(c.id),
        disabled: n,
        onToggle: o
      },
      c.id
    )) })
  ] });
}
function Xp({
  country: t,
  value: e,
  disabled: n,
  expanded: r,
  forceOpen: i,
  onToggleExpanded: s,
  onToggle: o
}) {
  const l = i ? !0 : r[t.key] ?? !0, a = `editorial-category-country-${t.key}`, c = t.ungrouped.length > 0 || t.groups.length > 0;
  return /* @__PURE__ */ E("li", { className: W.node, children: [
    /* @__PURE__ */ E("div", { className: W.row, children: [
      c ? /* @__PURE__ */ y(
        "button",
        {
          type: "button",
          className: W.expandButton,
          "aria-expanded": l,
          "aria-controls": a,
          "aria-label": l ? `Collapse ${t.name}` : `Expand ${t.name}`,
          onClick: () => s(t.key),
          children: /* @__PURE__ */ y(j, { icon: l ? "chevron-down" : "chevron-right", size: "small" })
        }
      ) : /* @__PURE__ */ y("span", { className: W.expandSpacer, "aria-hidden": "true" }),
      /* @__PURE__ */ y("span", { className: W.countryHeader, children: t.name })
    ] }),
    c && l && /* @__PURE__ */ E("ul", { id: a, className: W.children, children: [
      t.ungrouped.map((d) => /* @__PURE__ */ y(
        Mc,
        {
          area: d,
          checked: e.includes(d.id),
          disabled: n,
          onToggle: o
        },
        d.id
      )),
      t.groups.map((d) => /* @__PURE__ */ y(
        Yp,
        {
          group: d,
          value: e,
          disabled: n,
          expanded: r[d.key] ?? !0,
          forceOpen: i,
          onToggleExpanded: s,
          onToggle: o
        },
        d.key
      ))
    ] })
  ] });
}
function o4({
  value: t,
  onChange: e,
  options: n,
  label: r,
  buttonLabel: i,
  modalTitle: s = "Select practice areas",
  searchPlaceholder: o = "Search practice areas...",
  emptyMessage: l = "No practice areas found.",
  noSelectionMessage: a = "No practice areas selected.",
  disabled: c = !1,
  error: d,
  className: u = ""
}) {
  const h = Oo(), [f, p] = ie(!1), [m, g] = ie(""), [b, k] = ie({}), C = Ct(() => Gp(n), [n]), v = Ct(() => {
    const P = /* @__PURE__ */ new Map();
    for (const _ of n) P.set(_.id, _);
    return P;
  }, [n]), x = m.trim().toLowerCase(), M = x.length > 0, S = Ct(() => Jp(C, x), [C, x]), N = (P) => {
    if (c) return;
    const _ = t.includes(P) ? t.filter((V) => V !== P) : [...t, P];
    e(_);
  }, D = (P) => {
    c || e(t.filter((_) => _ !== P));
  }, $ = (P) => k((_) => ({ ..._, [P]: !(_[P] ?? !0) })), oe = () => {
    p(!1), g("");
  }, q = i ?? (t.length === 0 ? "Select practice areas" : "Edit practice areas");
  return /* @__PURE__ */ E("div", { className: `${W.wrapper} ${u}`, children: [
    r && /* @__PURE__ */ y("span", { id: h, className: W.label, children: r }),
    t.length > 0 ? /* @__PURE__ */ y("ul", { className: W.selectedList, "aria-label": "Selected practice areas", children: t.map((P) => {
      const _ = v.get(P), V = _ ? Qp(_) : String(P);
      return /* @__PURE__ */ E("li", { className: W.selectedRow, children: [
        /* @__PURE__ */ y("span", { className: W.selectedName, children: V }),
        !c && /* @__PURE__ */ y(
          "button",
          {
            type: "button",
            className: W.removeButton,
            "aria-label": `Remove ${V}`,
            onClick: () => D(P),
            children: /* @__PURE__ */ y(j, { icon: "cross", size: "small" })
          }
        )
      ] }, P);
    }) }) : /* @__PURE__ */ y("p", { className: `${W.empty} ${W.emptyMuted}`, children: a }),
    /* @__PURE__ */ y(
      ot,
      {
        type: "button",
        variant: "outlined",
        className: W.openButton,
        onClick: () => p(!0),
        children: q
      }
    ),
    d && /* @__PURE__ */ y("p", { className: W.error, role: "alert", children: d }),
    /* @__PURE__ */ y(Sc, { isOpen: f, onClose: oe, title: s, size: "mediumLarge", children: /* @__PURE__ */ E("div", { className: W.modalBody, children: [
      /* @__PURE__ */ y(
        rp,
        {
          value: m,
          onChange: g,
          onClear: () => g(""),
          startIcon: "magnifier",
          placeholder: o
        }
      ),
      /* @__PURE__ */ y("div", { className: W.modalList, children: S.length === 0 ? /* @__PURE__ */ y("p", { className: W.empty, children: l }) : /* @__PURE__ */ y("ul", { className: W.tree, role: "tree", "aria-label": r ?? "Practice areas", children: S.map((P) => /* @__PURE__ */ y(
        Xp,
        {
          country: P,
          value: t,
          disabled: c,
          expanded: b,
          forceOpen: M,
          onToggleExpanded: $,
          onToggle: N
        },
        P.key
      )) }) }),
      /* @__PURE__ */ y("div", { className: W.modalFooter, children: /* @__PURE__ */ y(ot, { type: "button", onClick: oe, children: "Done" }) })
    ] }) })
  ] });
}
const em = "_inputWrapper_1uh9i_1", tm = "_fullWidth_1uh9i_7", nm = "_label_1uh9i_11", rm = "_inputContainer_1uh9i_17", im = "_input_1uh9i_1", sm = "_error_1uh9i_59", om = "_startIcon_1uh9i_68", lm = "_endIcon_1uh9i_69", am = "_hasStartIcon_1uh9i_87", cm = "_hasEndIcon_1uh9i_91", dm = "_errorText_1uh9i_95", um = "_helperText_1uh9i_101", Be = {
  inputWrapper: em,
  fullWidth: tm,
  label: nm,
  inputContainer: rm,
  input: im,
  error: sm,
  startIcon: om,
  endIcon: lm,
  hasStartIcon: am,
  hasEndIcon: cm,
  errorText: dm,
  helperText: um
}, hm = dt(
  ({
    label: t,
    error: e,
    helperText: n,
    fullWidth: r = !1,
    startIcon: i,
    endIcon: s,
    className: o = "",
    id: l,
    ...a
  }, c) => {
    const d = l || `input-${Math.random().toString(36).substr(2, 9)}`, u = e ? `${d}-error` : void 0, h = n ? `${d}-helper` : void 0, f = [u, h].filter(Boolean).join(" ");
    return /* @__PURE__ */ E("div", { className: `${Be.inputWrapper} ${r ? Be.fullWidth : ""} ${o}`, children: [
      t && /* @__PURE__ */ y("label", { htmlFor: d, className: Be.label, children: t }),
      /* @__PURE__ */ E("div", { className: Be.inputContainer, children: [
        i && /* @__PURE__ */ y("span", { className: Be.startIcon, children: i }),
        /* @__PURE__ */ y(
          "input",
          {
            ref: c,
            id: d,
            className: `${Be.input} ${e ? Be.error : ""} ${i ? Be.hasStartIcon : ""} ${s ? Be.hasEndIcon : ""}`,
            "aria-invalid": e ? "true" : void 0,
            "aria-describedby": f || void 0,
            ...a
          }
        ),
        s && /* @__PURE__ */ y("span", { className: Be.endIcon, children: s })
      ] }),
      e && /* @__PURE__ */ y("p", { id: u, className: Be.errorText, role: "alert", children: e }),
      n && !e && /* @__PURE__ */ y("p", { id: h, className: Be.helperText, children: n })
    ] });
  }
);
hm.displayName = "Input";
const fm = "_selectWrapper_11tue_1", pm = "_fullWidth_11tue_7", mm = "_label_11tue_11", gm = "_selectContainer_11tue_17", ym = "_select_11tue_1", bm = "_error_11tue_62", km = "_chevron_11tue_70", vm = "_small_11tue_85", Cm = "_medium_11tue_90", xm = "_large_11tue_95", wm = "_errorText_11tue_100", Sm = "_helperText_11tue_106", tt = {
  selectWrapper: fm,
  fullWidth: pm,
  label: mm,
  selectContainer: gm,
  select: ym,
  error: bm,
  chevron: km,
  small: vm,
  medium: Cm,
  large: xm,
  errorText: wm,
  helperText: Sm
}, Mm = (t) => "options" in t && Array.isArray(t.options), Tm = dt(
  ({
    label: t,
    error: e,
    helperText: n,
    options: r,
    fullWidth: i = !1,
    size: s = "medium",
    className: o = "",
    id: l,
    ...a
  }, c) => {
    const d = l || `select-${Math.random().toString(36).substr(2, 9)}`, u = e ? `${d}-error` : void 0, h = n ? `${d}-helper` : void 0, f = [u, h].filter(Boolean).join(" ");
    return /* @__PURE__ */ E("div", { className: `${tt.selectWrapper} ${i ? tt.fullWidth : ""} ${o}`, children: [
      t && /* @__PURE__ */ y("label", { htmlFor: d, className: tt.label, children: t }),
      /* @__PURE__ */ E("div", { className: tt.selectContainer, children: [
        /* @__PURE__ */ y(
          "select",
          {
            ref: c,
            id: d,
            className: `${tt.select} ${tt[s]} ${e ? tt.error : ""}`,
            "aria-invalid": e ? "true" : void 0,
            "aria-describedby": f || void 0,
            ...a,
            children: r.map((p, m) => Mm(p) ? /* @__PURE__ */ y("optgroup", { label: p.label, disabled: p.disabled, children: p.options.map((g) => /* @__PURE__ */ y("option", { value: g.value, disabled: g.disabled, children: g.label }, g.value)) }, `optgroup-${m}`) : /* @__PURE__ */ y("option", { value: p.value, disabled: p.disabled, children: p.label }, p.value))
          }
        ),
        /* @__PURE__ */ y(j, { icon: "chevron-down", className: tt.chevron, "aria-hidden": "true" })
      ] }),
      e && /* @__PURE__ */ y("p", { id: u, className: tt.errorText, role: "alert", children: e }),
      n && !e && /* @__PURE__ */ y("p", { id: h, className: tt.helperText, children: n })
    ] });
  }
);
Tm.displayName = "Select";
const Em = "_comboWrapper_16exq_1", Am = "_fullWidth_16exq_7", Nm = "_label_16exq_11", _m = "_comboContainer_16exq_17", Om = "_input_16exq_23", Rm = "_error_16exq_63", Im = "_warning_16exq_71", Lm = "_chevronButton_16exq_79", Dm = "_chevron_16exq_79", Pm = "_chevronOpen_16exq_101", zm = "_small_16exq_106", Bm = "_medium_16exq_111", $m = "_large_16exq_116", Hm = "_listbox_16exq_122", Vm = "_listboxOpen_16exq_149", Fm = "_listboxUp_16exq_154", Wm = "_option_16exq_159", qm = "_optionSelected_16exq_168", jm = "_optionHighlighted_16exq_176", Um = "_optionDisabled_16exq_181", Km = "_emptyOption_16exq_187", Zm = "_errorText_16exq_194", Gm = "_warningText_16exq_200", Jm = "_warningIcon_16exq_209", Qm = "_helperText_16exq_216", ee = {
  comboWrapper: Em,
  fullWidth: Am,
  label: Nm,
  comboContainer: _m,
  input: Om,
  error: Rm,
  warning: Im,
  chevronButton: Lm,
  chevron: Dm,
  chevronOpen: Pm,
  small: zm,
  medium: Bm,
  large: $m,
  listbox: Hm,
  listboxOpen: Vm,
  listboxUp: Fm,
  option: Wm,
  optionSelected: qm,
  optionHighlighted: jm,
  optionDisabled: Um,
  emptyOption: Km,
  errorText: Zm,
  warningText: Gm,
  warningIcon: Jm,
  helperText: Qm
};
function Ym(t, e, n = 256) {
  const r = e - t.bottom, i = t.top;
  return r < n && i > r;
}
const Xm = ({
  label: t,
  value: e,
  onChange: n,
  options: r,
  error: i,
  helperText: s,
  placeholder: o,
  fullWidth: l = !1,
  size: a = "medium",
  id: c,
  className: d = "",
  warnOnUnknownValue: u = !0
}) => {
  const h = Oo(), f = c || `combo-${h}`, p = `${f}-listbox`, m = i ? `${f}-error` : void 0, g = `${f}-warning`, b = s ? `${f}-helper` : void 0, k = lt(null), C = lt(null), [v, x] = ie(!1), [M, S] = ie(0), [N, D] = ie(!1), [$, oe] = ie(null), q = Ct(() => r.find((R) => R.value === e), [r, e]), P = q ? q.label : e, V = e !== "" && !q && u && !i && !v, je = $ !== null ? $ : P, me = Ct(() => {
    const R = ($ ?? "").trim().toLowerCase();
    return R ? r.filter(
      (U) => U.label.toLowerCase().includes(R) || U.value.toLowerCase().includes(R)
    ) : r;
  }, [r, $]);
  _e(() => {
    S((R) => me.length === 0 ? 0 : Math.min(R, me.length - 1));
  }, [me.length]), _e(() => {
    if (!v) return;
    const R = (U) => {
      k.current && !k.current.contains(U.target) && Zt();
    };
    return document.addEventListener("mousedown", R), () => document.removeEventListener("mousedown", R);
  }, [v]), _e(() => {
    if (!v) {
      D(!1);
      return;
    }
    if (typeof window > "u" || !C.current) return;
    const R = () => {
      if (!C.current) return;
      const U = C.current.getBoundingClientRect();
      D(Ym(U, window.innerHeight));
    };
    return R(), window.addEventListener("resize", R, { passive: !0 }), window.addEventListener("scroll", R, { passive: !0, capture: !0 }), () => {
      window.removeEventListener("resize", R), window.removeEventListener("scroll", R, { capture: !0 });
    };
  }, [v]);
  const ht = () => {
    if (v) return;
    x(!0);
    const R = me.findIndex((U) => U.value === e);
    S(R >= 0 ? R : 0);
  }, Zt = () => {
    x(!1), oe(null);
  }, Bn = (R) => {
    R.disabled || (n(R.value), oe(null), x(!1), C.current?.focus());
  }, ge = (R) => {
    const U = R.target.value;
    oe(U), x(!0), n(U);
  }, Sr = (R) => {
    switch (R.key) {
      case "ArrowDown": {
        if (R.preventDefault(), !v) {
          ht();
          return;
        }
        S(
          (U) => me.length === 0 ? 0 : (U + 1) % me.length
        );
        break;
      }
      case "ArrowUp": {
        if (R.preventDefault(), !v) {
          ht();
          return;
        }
        S(
          (U) => me.length === 0 ? 0 : (U - 1 + me.length) % me.length
        );
        break;
      }
      case "Enter": {
        v && me.length > 0 && (R.preventDefault(), Bn(me[M]));
        break;
      }
      case "Escape": {
        v && (R.preventDefault(), Zt());
        break;
      }
      case "Tab": {
        v && Zt();
        break;
      }
    }
  }, ss = [m, V ? g : void 0, b].filter(Boolean).join(" "), ls = v && me.length > 0 ? `${f}-option-${M}` : void 0;
  return /* @__PURE__ */ E(
    "div",
    {
      ref: k,
      className: `${ee.comboWrapper} ${l ? ee.fullWidth : ""} ${d}`,
      children: [
        t && /* @__PURE__ */ y("label", { htmlFor: f, className: ee.label, children: t }),
        /* @__PURE__ */ E("div", { className: ee.comboContainer, children: [
          /* @__PURE__ */ y(
            "input",
            {
              ref: C,
              id: f,
              type: "text",
              role: "combobox",
              autoComplete: "off",
              "aria-autocomplete": "list",
              "aria-expanded": v,
              "aria-controls": p,
              "aria-activedescendant": ls,
              "aria-invalid": i ? "true" : void 0,
              "aria-describedby": ss || void 0,
              placeholder: o,
              className: `${ee.input} ${ee[a]} ${i ? ee.error : ""} ${V ? ee.warning : ""}`,
              value: je,
              onChange: ge,
              onKeyDown: Sr,
              onFocus: ht,
              onClick: ht
            }
          ),
          /* @__PURE__ */ y(
            "button",
            {
              type: "button",
              tabIndex: -1,
              "aria-label": "Toggle options",
              className: ee.chevronButton,
              onClick: () => {
                v ? Zt() : (C.current?.focus(), ht());
              },
              children: /* @__PURE__ */ y(
                j,
                {
                  icon: "chevron-down",
                  className: `${ee.chevron} ${v ? ee.chevronOpen : ""}`,
                  "aria-hidden": "true"
                }
              )
            }
          ),
          /* @__PURE__ */ y(
            "ul",
            {
              id: p,
              role: "listbox",
              "aria-label": t,
              className: `${ee.listbox} ${v ? ee.listboxOpen : ""} ${N ? ee.listboxUp : ""}`,
              children: me.length === 0 ? /* @__PURE__ */ y("li", { className: ee.emptyOption, role: "presentation", children: "No matching options" }) : me.map((R, U) => {
                const et = R.value === e, Ah = U === M;
                return /* @__PURE__ */ y(
                  "li",
                  {
                    id: `${f}-option-${U}`,
                    role: "option",
                    "aria-selected": et,
                    "aria-disabled": R.disabled || void 0,
                    className: `${ee.option} ${Ah ? ee.optionHighlighted : ""} ${et ? ee.optionSelected : ""} ${R.disabled ? ee.optionDisabled : ""}`,
                    onMouseDown: (Nh) => {
                      Nh.preventDefault(), Bn(R);
                    },
                    onMouseEnter: () => S(U),
                    children: R.label
                  },
                  R.value
                );
              })
            }
          )
        ] }),
        i && /* @__PURE__ */ y("p", { id: m, className: ee.errorText, role: "alert", children: i }),
        V && /* @__PURE__ */ E("p", { id: g, className: ee.warningText, children: [
          /* @__PURE__ */ y(j, { icon: "exclamation", className: ee.warningIcon, "aria-hidden": "true" }),
          /* @__PURE__ */ y("span", { children: `"${e}" isn't a valid option — pick one below` })
        ] }),
        s && !i && !V && /* @__PURE__ */ y("p", { id: b, className: ee.helperText, children: s })
      ]
    }
  );
};
Xm.displayName = "ComboField";
const e1 = "_radioWrapper_sdxl4_1", t1 = "_fullWidth_sdxl4_7", n1 = "_radioContainer_sdxl4_11", r1 = "_radio_sdxl4_1", i1 = "_radioButton_sdxl4_26", s1 = "_label_sdxl4_73", o1 = "_errorText_sdxl4_85", l1 = "_helperText_sdxl4_91", Et = {
  radioWrapper: e1,
  fullWidth: t1,
  radioContainer: n1,
  radio: r1,
  radioButton: i1,
  label: s1,
  errorText: o1,
  helperText: l1
}, a1 = dt(
  ({ label: t, error: e, helperText: n, fullWidth: r = !1, className: i = "", id: s, ...o }, l) => {
    const a = s || `radio-${Math.random().toString(36).substr(2, 9)}`, c = e ? `${a}-error` : void 0, d = n ? `${a}-helper` : void 0, u = [c, d].filter(Boolean).join(" ");
    return /* @__PURE__ */ E("div", { className: `${Et.radioWrapper} ${r ? Et.fullWidth : ""} ${i}`, children: [
      /* @__PURE__ */ E("div", { className: Et.radioContainer, children: [
        /* @__PURE__ */ y(
          "input",
          {
            ref: l,
            type: "radio",
            id: a,
            className: Et.radio,
            "aria-invalid": e ? "true" : void 0,
            "aria-describedby": u || void 0,
            ...o
          }
        ),
        /* @__PURE__ */ y("span", { className: Et.radioButton }),
        t && /* @__PURE__ */ y("label", { htmlFor: a, className: Et.label, children: t })
      ] }),
      e && /* @__PURE__ */ y("p", { id: c, className: Et.errorText, role: "alert", children: e }),
      n && !e && /* @__PURE__ */ y("p", { id: d, className: Et.helperText, children: n })
    ] });
  }
);
a1.displayName = "Radio";
const c1 = "_textareaWrapper_7mtx0_1", d1 = "_fullWidth_7mtx0_7", u1 = "_label_7mtx0_11", h1 = "_textarea_7mtx0_1", f1 = "_error_7mtx0_46", p1 = "_resizevertical_7mtx0_55", m1 = "_resizehorizontal_7mtx0_59", g1 = "_resizeboth_7mtx0_63", y1 = "_resizenone_7mtx0_67", b1 = "_errorText_7mtx0_71", k1 = "_helperText_7mtx0_77", At = {
  textareaWrapper: c1,
  fullWidth: d1,
  label: u1,
  textarea: h1,
  error: f1,
  resizevertical: p1,
  resizehorizontal: m1,
  resizeboth: g1,
  resizenone: y1,
  errorText: b1,
  helperText: k1
}, v1 = dt(
  ({
    label: t,
    error: e,
    helperText: n,
    fullWidth: r = !1,
    resize: i = "vertical",
    className: s = "",
    id: o,
    ...l
  }, a) => {
    const c = o || `textarea-${Math.random().toString(36).substr(2, 9)}`, d = e ? `${c}-error` : void 0, u = n ? `${c}-helper` : void 0, h = [d, u].filter(Boolean).join(" ");
    return /* @__PURE__ */ E(
      "div",
      {
        className: `${At.textareaWrapper} ${r ? At.fullWidth : ""} ${s}`,
        children: [
          t && /* @__PURE__ */ y("label", { htmlFor: c, className: At.label, children: t }),
          /* @__PURE__ */ y(
            "textarea",
            {
              ref: a,
              id: c,
              className: `${At.textarea} ${At[`resize${i}`]} ${e ? At.error : ""}`,
              "aria-invalid": e ? "true" : void 0,
              "aria-describedby": h || void 0,
              ...l
            }
          ),
          e && /* @__PURE__ */ y("p", { id: d, className: At.errorText, role: "alert", children: e }),
          n && !e && /* @__PURE__ */ y("p", { id: u, className: At.helperText, children: n })
        ]
      }
    );
  }
);
v1.displayName = "Textarea";
const C1 = "_datePickerWrapper_14u3v_1", x1 = "_fullWidth_14u3v_7", w1 = "_label_14u3v_11", S1 = "_requiredIndicator_14u3v_17", M1 = "_datePickerContainer_14u3v_21", T1 = "_input_14u3v_41", E1 = "_error_14u3v_73", A1 = "_errorText_14u3v_82", N1 = "_helperText_14u3v_88", nt = {
  datePickerWrapper: C1,
  fullWidth: x1,
  label: w1,
  requiredIndicator: S1,
  datePickerContainer: M1,
  input: T1,
  error: E1,
  errorText: A1,
  helperText: N1
}, _1 = dt(
  ({ label: t, error: e, helperText: n, fullWidth: r = !1, className: i = "", id: s, ...o }, l) => {
    const a = s || `datepicker-${Math.random().toString(36).substr(2, 9)}`, c = e ? `${a}-error` : void 0, d = n ? `${a}-helper` : void 0, u = [c, d].filter(Boolean).join(" "), { required: h } = o;
    return /* @__PURE__ */ E(
      "div",
      {
        className: `${nt.datePickerWrapper} ${r ? nt.fullWidth : ""} ${i}`,
        children: [
          t && /* @__PURE__ */ E("label", { htmlFor: a, className: nt.label, children: [
            t,
            h && /* @__PURE__ */ E("span", { className: nt.requiredIndicator, "aria-hidden": "true", children: [
              " ",
              "*"
            ] })
          ] }),
          /* @__PURE__ */ y("div", { className: `${nt.datePickerContainer} ${e ? nt.error : ""}`, children: /* @__PURE__ */ y(
            "input",
            {
              ref: l,
              id: a,
              type: "date",
              className: `${nt.input} ${e ? nt.error : ""}`,
              "aria-invalid": e ? "true" : "false",
              "aria-required": h ? "true" : void 0,
              "aria-describedby": u || void 0,
              ...o
            }
          ) }),
          e && /* @__PURE__ */ y("p", { id: c, className: nt.errorText, role: "alert", children: e }),
          n && !e && /* @__PURE__ */ y("p", { id: d, className: nt.helperText, children: n })
        ]
      }
    );
  }
);
_1.displayName = "DatePicker";
const O1 = "_header_16oif_1", R1 = "_container_16oif_10", I1 = "_logo_16oif_19", $n = {
  header: O1,
  container: R1,
  logo: I1
}, L1 = ({ title: t, logo: e, className: n = "" }) => /* @__PURE__ */ y("header", { className: `${$n.header} ${n}`, children: /* @__PURE__ */ y("div", { className: $n.container, children: /* @__PURE__ */ E("div", { className: $n.logoContainer, children: [
  e && /* @__PURE__ */ y(j, { icon: e, className: $n.logo }),
  /* @__PURE__ */ y("h1", { className: $n.title, children: t })
] }) }) });
L1.displayName = "Header";
const D1 = "_navLinkWrapper_u6upf_8", P1 = "_navLink_u6upf_8", z1 = "_navLinkActive_u6upf_41", B1 = "_navIcon_u6upf_46", $1 = "_navChevron_u6upf_52", H1 = "_navChevronOpen_u6upf_65", V1 = "_navChildren_u6upf_69", F1 = "_navGroupTitle_u6upf_129", Ke = {
  navLinkWrapper: D1,
  "navLinkWrapper--top": "_navLinkWrapper--top_u6upf_13",
  "navLinkWrapper--bottom": "_navLinkWrapper--bottom_u6upf_18",
  navLink: P1,
  navLinkActive: z1,
  navIcon: B1,
  navChevron: $1,
  navChevronOpen: H1,
  navChildren: V1,
  "navChildren--top": "_navChildren--top_u6upf_74",
  "navChildren--bottom": "_navChildren--bottom_u6upf_89",
  navGroupTitle: F1
};
function Tc(t) {
  return "groupTitle" in t;
}
const Us = ({
  path: t,
  icon: e,
  isActive: n,
  onClick: r,
  label: i,
  children: s,
  isOpen: o = !1,
  activeItem: l,
  variant: a = "side"
}) => {
  const [c, d] = ie(o), u = lt(o);
  _e(() => {
    u.current !== o && (u.current = o, d(o));
  }, [o]);
  const h = !t && !!r, f = s && s.length > 0, p = (g) => {
    f ? (g.preventDefault(), d(!c)) : r && (g.preventDefault(), r());
  }, m = (g) => {
    r && (g.key === "Enter" || g.key === " ") && (g.preventDefault(), r());
  };
  return /* @__PURE__ */ E("div", { className: `${Ke.navLinkWrapper} ${Ke[`navLinkWrapper--${a}`]}`, children: [
    /* @__PURE__ */ E(
      "a",
      {
        href: t || void 0,
        className: `${Ke.navLink} ${n ? Ke.navLinkActive : ""} ${f ? Ke.navLinkParent : ""}`,
        onClick: p,
        onKeyDown: h ? m : void 0,
        role: h ? "button" : void 0,
        tabIndex: h ? 0 : void 0,
        "aria-current": n ? "page" : void 0,
        "aria-expanded": f ? c : void 0,
        style: r || f ? { cursor: "pointer" } : void 0,
        children: [
          e && /* @__PURE__ */ y("span", { className: Ke.navIcon, "aria-hidden": !0, children: e }),
          /* @__PURE__ */ y("span", { children: i }),
          f && /* @__PURE__ */ y("span", { className: `${Ke.navChevron} ${c ? Ke.navChevronOpen : ""}`, children: /* @__PURE__ */ y(j, { icon: "chevron-down" }) })
        ]
      }
    ),
    f && c && /* @__PURE__ */ y("ul", { className: `${Ke.navChildren} ${Ke[`navChildren--${a}`]}`, children: s.map(
      (g, b) => Tc(g) ? /* @__PURE__ */ E("li", { children: [
        /* @__PURE__ */ y("span", { className: Ke.navGroupTitle, children: g.groupTitle }),
        /* @__PURE__ */ y("ul", { children: g.items.map((k, C) => /* @__PURE__ */ y("li", { children: /* @__PURE__ */ y(
          Us,
          {
            ...k,
            isActive: l === k.path,
            variant: a
          }
        ) }, C)) })
      ] }, b) : /* @__PURE__ */ y("li", { children: /* @__PURE__ */ y(Us, { ...g, isActive: l === g.path, variant: a }) }, b)
    ) })
  ] });
}, W1 = "_navbar_t6358_1", q1 = "_navbarContent_t6358_34", j1 = "_logo_t6358_62", U1 = "_mobileMenuButton_t6358_78", K1 = "_nav_t6358_1", Z1 = "_userMenuSlot_t6358_186", G1 = "_bottomNav_t6358_192", J1 = "_navOpen_t6358_277", Q1 = "_navbarHeader_t6358_322", Ze = {
  navbar: W1,
  navbarContent: q1,
  logo: j1,
  mobileMenuButton: U1,
  nav: K1,
  userMenuSlot: Z1,
  bottomNav: G1,
  navOpen: J1,
  navbarHeader: Q1
}, l4 = ({
  items: t,
  bottomItems: e,
  logo: n,
  className: r = "",
  activeItem: i,
  variant: s = "side",
  renderLink: o,
  userMenuSlot: l
}) => {
  const [a, c] = ie(!1), d = () => c((f) => !f), u = (f) => {
    f.onClick?.(), window.innerWidth <= 768 && c(!1);
  }, h = (f) => f.map((p) => {
    const m = i === p.path, g = p.children?.some(
      (k) => Tc(k) ? k.items.some((C) => i === C.path) : i === k.path
    ) || !1;
    return o ? o(p) : /* @__PURE__ */ y("li", { children: /* @__PURE__ */ y(
      Us,
      {
        ...p,
        isActive: m || g,
        activeItem: i,
        onClick: () => u(p),
        variant: s
      }
    ) }, p.path ?? p.label);
  });
  return /* @__PURE__ */ y(
    "nav",
    {
      className: `${Ze.navbar} ${r}`,
      "data-variant": s,
      role: "navigation",
      "aria-label": "Main navigation",
      children: /* @__PURE__ */ E("div", { className: Ze.navbarContent, children: [
        /* @__PURE__ */ E("div", { className: Ze.navbarHeader, children: [
          n && /* @__PURE__ */ y("div", { className: Ze.logo, children: n }),
          /* @__PURE__ */ E(
            "button",
            {
              className: Ze.mobileMenuButton,
              onClick: d,
              "aria-expanded": a,
              "aria-controls": "main-navigation",
              children: [
                /* @__PURE__ */ y(j, { icon: a ? "hamburger-close" : "hamburger" }),
                /* @__PURE__ */ y("span", { className: "sr-only", children: "Toggle navigation" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ y(
          "ul",
          {
            id: "main-navigation",
            className: `${Ze.nav} ${a ? Ze.navOpen : ""}`,
            children: h(t)
          }
        ),
        l && /* @__PURE__ */ y("div", { className: `${Ze.userMenuSlot} ${a ? Ze.navOpen : ""}`, children: l }),
        e && /* @__PURE__ */ y("ul", { className: `${Ze.bottomNav} ${a ? Ze.navOpen : ""}`, children: h(e) })
      ] })
    }
  );
}, Y1 = "_pagination_5whos_1", X1 = "_pageButton_5whos_8", eg = "_active_5whos_39", tg = "_small_5whos_46", ng = "_large_5whos_52", rg = "_primary_5whos_59", ig = "_secondary_5whos_64", sg = "_simple_5whos_86", og = "_simpleButton_5whos_93", lg = "_simpleText_5whos_115", Te = {
  pagination: Y1,
  pageButton: X1,
  active: eg,
  small: tg,
  large: ng,
  primary: rg,
  secondary: ig,
  simple: sg,
  simpleButton: og,
  simpleText: lg
}, ag = ({
  currentPage: t,
  totalPages: e,
  onPageChange: n,
  className: r = "",
  size: i = "medium",
  variant: s = "primary",
  showFirstLast: o = !0,
  maxVisiblePages: l = 5,
  iconLeft: a,
  iconRight: c
}) => {
  const d = () => {
    const f = [], p = s === "compact" ? 3 : l, m = Math.floor(p / 2);
    let g = Math.max(1, t - m);
    const b = Math.min(e, g + p - 1);
    b - g + 1 < p && (g = Math.max(1, b - p + 1));
    for (let k = g; k <= b; k++)
      f.push(k);
    return f;
  }, u = (f) => {
    f >= 1 && f <= e && n(f);
  }, h = d();
  return s === "simple" ? /* @__PURE__ */ E(
    "nav",
    {
      className: `${Te.pagination} ${Te[i]} ${Te.simple} ${r}`,
      role: "navigation",
      "aria-label": "Pagination",
      children: [
        /* @__PURE__ */ y(
          "button",
          {
            onClick: () => u(t - 1),
            disabled: t === 1,
            "aria-label": "Previous page",
            className: Te.simpleButton,
            children: "Previous"
          }
        ),
        /* @__PURE__ */ E("span", { className: Te.simpleText, children: [
          "Page ",
          t,
          " of ",
          e
        ] }),
        /* @__PURE__ */ y(
          "button",
          {
            onClick: () => u(t + 1),
            disabled: t === e,
            "aria-label": "Next page",
            className: Te.simpleButton,
            children: "Next"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ E(
    "nav",
    {
      className: `${Te.pagination} ${Te[i]} ${Te[s]} ${r}`,
      role: "navigation",
      "aria-label": "Pagination",
      children: [
        o && /* @__PURE__ */ y(
          ot,
          {
            variant: "icon",
            size: i,
            onClick: () => u(1),
            disabled: t === 1,
            "aria-label": "First page",
            className: Te.first,
            children: /* @__PURE__ */ y(j, { icon: a || "chevron-left", size: "large" })
          }
        ),
        /* @__PURE__ */ y(
          ot,
          {
            variant: "icon",
            size: i,
            onClick: () => u(t - 1),
            disabled: t === 1,
            "aria-label": "Previous page",
            className: Te.prev,
            children: /* @__PURE__ */ y(j, { icon: a || "chevron-left", size: "small" })
          }
        ),
        h.map((f) => /* @__PURE__ */ y(
          ot,
          {
            variant: f === t ? "contained" : "text",
            size: i,
            onClick: () => u(f),
            "aria-current": f === t ? "page" : void 0,
            className: `${Te.pageButton} ${f === t ? Te.active : ""}`,
            children: f
          },
          f
        )),
        /* @__PURE__ */ y(
          ot,
          {
            variant: "text",
            size: i,
            onClick: () => u(t + 1),
            disabled: t === e,
            "aria-label": "Next page",
            className: Te.next,
            children: /* @__PURE__ */ y(j, { icon: c || "chevron-right", size: "small" })
          }
        ),
        o && /* @__PURE__ */ y(
          ot,
          {
            variant: "icon",
            size: i,
            onClick: () => u(e),
            disabled: t === e,
            "aria-label": "Last page",
            className: Te.last,
            children: /* @__PURE__ */ y(j, { icon: c || "chevron-right", size: "large" })
          }
        )
      ]
    }
  );
};
ag.displayName = "Pagination";
const cg = "_tableContainer_1iwng_1", dg = "_stickyContainer_1iwng_7", ug = "_noWrap_1iwng_11", hg = "_stickyThead_1iwng_16", fg = "_table_1iwng_1", pg = "_small_1iwng_116", mg = "_medium_1iwng_130", gg = "_large_1iwng_144", yg = "_emptyCell_1iwng_158", bg = "_clickableRow_1iwng_164", ft = {
  tableContainer: cg,
  stickyContainer: dg,
  noWrap: ug,
  stickyThead: hg,
  table: fg,
  small: pg,
  medium: mg,
  large: gg,
  emptyCell: yg,
  clickableRow: bg
}, kg = ({
  data: t,
  columns: e,
  onRowClick: n,
  className: r = "",
  size: i = "small",
  stickyHeader: s = !1,
  maxHeight: o,
  rowClassName: l
}) => {
  const a = /* @__PURE__ */ E("table", { className: `${ft.table} ${ft[i]} ${o ? ft.noWrap : ""}`, children: [
    /* @__PURE__ */ y("thead", { className: s || o ? ft.stickyThead : "", children: /* @__PURE__ */ y("tr", { children: e.map((c, d) => /* @__PURE__ */ y("th", { style: c.wrap ? { whiteSpace: "normal" } : void 0, children: c.header }, d)) }) }),
    /* @__PURE__ */ y("tbody", { children: t.map((c) => /* @__PURE__ */ y(
      "tr",
      {
        onClick: () => n?.(c),
        className: `${n ? ft.clickableRow : ""} ${l?.(c) ?? ""}`.trim(),
        children: e.map((d, u) => /* @__PURE__ */ y("td", { style: d.wrap ? { whiteSpace: "normal" } : void 0, children: d.render ? d.render(c[d.accessor], c) : String(c[d.accessor]) }, u))
      },
      c.id
    )) })
  ] });
  return o ? /* @__PURE__ */ y("div", { className: `${ft.tableContainer} ${r}`, children: /* @__PURE__ */ y("div", { className: ft.stickyContainer, style: { maxHeight: o }, children: a }) }) : /* @__PURE__ */ y(
    "div",
    {
      className: `${ft.tableContainer} ${s ? ft.stickyContainer : ""} ${r}`,
      children: a
    }
  );
};
kg.displayName = "Table";
const vg = "_toast_1usz0_1", Cg = "_slideInUp_1usz0_1", xg = "_toastIcon_1usz0_31", wg = "_toastMessage_1usz0_40", Sg = "_toastClose_1usz0_48", Mg = "_success_1usz0_67", Tg = "_error_1usz0_81", Eg = "_warning_1usz0_95", Ag = "_info_1usz0_109", Hn = {
  toast: vg,
  slideInUp: Cg,
  toastIcon: xg,
  toastMessage: wg,
  toastClose: Sg,
  success: Mg,
  error: Tg,
  warning: Eg,
  info: Ag
};
function a4({ message: t, type: e = "info", duration: n = 3e3, onClose: r }) {
  _e(() => {
    if (n > 0) {
      const s = setTimeout(r, n);
      return () => clearTimeout(s);
    }
  }, [n, r]);
  const i = () => {
    switch (e) {
      case "success":
        return /* @__PURE__ */ y(j, { icon: "check", size: "small" });
      case "error":
        return /* @__PURE__ */ y(j, { icon: "cross-circle", size: "small" });
      case "warning":
        return /* @__PURE__ */ y(j, { icon: "exclamation", size: "small" });
      default:
        return /* @__PURE__ */ y(j, { icon: "info", size: "small" });
    }
  };
  return /* @__PURE__ */ E("div", { className: `${Hn.toast} ${Hn[e]}`, role: "alert", children: [
    /* @__PURE__ */ y("div", { className: Hn.toastIcon, children: i() }),
    /* @__PURE__ */ y("div", { className: Hn.toastMessage, children: t }),
    /* @__PURE__ */ y("button", { className: Hn.toastClose, onClick: r, "aria-label": "Close", children: /* @__PURE__ */ y(j, { icon: "cross", size: "small" }) })
  ] });
}
const Ng = "_tooltipContainer_1y6yn_1", _g = "_tooltip_1y6yn_1", Og = "_fadeIn_1y6yn_1", cs = {
  tooltipContainer: Ng,
  tooltip: _g,
  fadeIn: Og,
  "tooltip-top": "_tooltip-top_1y6yn_24",
  "tooltip-bottom": "_tooltip-bottom_1y6yn_25",
  "tooltip-left": "_tooltip-left_1y6yn_26",
  "tooltip-right": "_tooltip-right_1y6yn_27"
}, Rg = ({
  title: t,
  content: e,
  children: n,
  position: r = "top",
  className: i,
  clickToShow: s = !1
}) => {
  const [o, l] = ie(!1), [a, c] = ie(r), [d, u] = ie({}), h = lt(null), f = lt(null), p = () => {
    s || l(!0);
  }, m = () => {
    s || l(!1);
  }, g = (b) => {
    s && (b.stopPropagation(), l(!o));
  };
  return _e(() => {
    if (s && o) {
      const b = (k) => {
        f.current && !f.current.contains(k.target) && l(!1);
      };
      return document.addEventListener("click", b), () => {
        document.removeEventListener("click", b);
      };
    }
  }, [s, o]), _e(() => {
    if (o && f.current) {
      const b = () => {
        if (!f.current) return;
        const k = f.current.getBoundingClientRect(), C = window.innerHeight, v = window.innerWidth, x = k.top, M = C - k.bottom, S = k.left, N = v - k.right;
        let D = r;
        r === "top" && x < 50 && M > x ? D = "bottom" : r === "bottom" && M < 50 && x > M ? D = "top" : r === "left" && S < 100 && N > S ? D = "right" : r === "right" && N < 100 && S > N && (D = "left"), c(D);
        let $ = {};
        switch (D) {
          case "top":
            $ = {
              left: k.left + k.width / 2,
              bottom: C - k.top + 8,
              transform: "translateX(-50%)"
            };
            break;
          case "bottom":
            $ = {
              left: k.left + k.width / 2,
              top: k.bottom + 8,
              transform: "translateX(-50%)"
            };
            break;
          case "left":
            $ = {
              right: v - k.left + 8,
              top: k.top + k.height / 2,
              transform: "translateY(-50%)"
            };
            break;
          case "right":
            $ = {
              left: k.right + 8,
              top: k.top + k.height / 2,
              transform: "translateY(-50%)"
            };
            break;
        }
        u($);
      };
      return b(), window.addEventListener("scroll", b), window.addEventListener("resize", b), () => {
        window.removeEventListener("scroll", b), window.removeEventListener("resize", b);
      };
    }
  }, [o, r]), /* @__PURE__ */ E(
    "div",
    {
      ref: f,
      className: `${cs.tooltipContainer} ${i || ""}`,
      onMouseEnter: p,
      onMouseLeave: m,
      onClick: g,
      onFocus: p,
      onBlur: m,
      children: [
        n,
        o && /* @__PURE__ */ y(
          "div",
          {
            ref: h,
            className: `${cs.tooltip} ${cs[`tooltip-${a}`]}`,
            "aria-label": String(t),
            style: d,
            children: e
          }
        )
      ]
    }
  );
};
Rg.displayName = "Tooltip";
const Ig = "_treeNode_114s7_1", Lg = "_treeNodeContent_114s7_6", Dg = "_selected_114s7_23", Pg = "_highlighted_114s7_29", zg = "_listMode_114s7_35", Bg = "_dragging_114s7_40", $g = "_dragOver_114s7_45", Hg = "_expandIcon_114s7_50", Vg = "_expanded_114s7_65", Fg = "_disabled_114s7_69", Wg = "_nodeName_114s7_78", qg = "_nodeCode_114s7_91", jg = "_highlight_114s7_29", Ug = "_nodeActions_114s7_110", Kg = "_visible_114s7_117", Zg = "_actionButton_114s7_121", Gg = "_children_114s7_143", ue = {
  treeNode: Ig,
  treeNodeContent: Lg,
  selected: Dg,
  highlighted: Pg,
  listMode: zg,
  dragging: Bg,
  dragOver: $g,
  expandIcon: Hg,
  expanded: Vg,
  disabled: Fg,
  nodeName: Wg,
  nodeCode: qg,
  highlight: jg,
  nodeActions: Ug,
  visible: Kg,
  actionButton: Zg,
  children: Gg
};
function ds({ text: t, highlight: e }) {
  if (!e.trim())
    return /* @__PURE__ */ y("span", { children: t });
  const n = new RegExp(`(${e})`, "gi"), r = t.split(n);
  return /* @__PURE__ */ y("span", { children: r.map(
    (i, s) => n.test(i) ? /* @__PURE__ */ y("mark", { className: ue.highlight, children: i }, s) : /* @__PURE__ */ y("span", { children: i }, s)
  ) });
}
function Jg({
  item: t,
  level: e,
  expanded: n,
  selected: r,
  highlighted: i,
  draggedItem: s,
  dragOverItem: o,
  searchTerm: l,
  mode: a = "tree",
  enableDragDrop: c = !0,
  onToggle: d,
  onSelect: u,
  onEdit: h,
  onAddChild: f,
  onDragStart: p,
  onDragOver: m,
  onDrop: g,
  showCode: b = !0,
  showSlug: k = !1,
  customIcon: C,
  customLabel: v
}) {
  const x = t.children && t.children.length > 0, M = n.has(t.id), S = r === t.id, N = i?.has(t.id) ?? !1, D = s?.id === t.id, $ = o?.id === t.id, [oe, q] = ie(!1), P = a === "list";
  return /* @__PURE__ */ E("div", { className: ue.treeNode, children: [
    /* @__PURE__ */ E(
      "div",
      {
        className: `${ue.treeNodeContent} ${P ? ue.listMode : ""} ${S ? ue.selected : ""} ${N ? ue.highlighted : ""} ${D ? ue.dragging : ""} ${$ ? ue.dragOver : ""}`,
        onClick: () => u(t),
        onMouseEnter: () => q(!0),
        onMouseLeave: () => q(!1),
        draggable: c,
        onDragStart: c ? (_) => {
          _.stopPropagation(), p(t);
        } : void 0,
        onDragOver: c ? (_) => {
          _.preventDefault(), _.stopPropagation(), m(_, t);
        } : void 0,
        onDrop: c ? (_) => {
          _.preventDefault(), _.stopPropagation(), g(_, t);
        } : void 0,
        role: P ? "listitem" : "treeitem",
        "aria-expanded": !P && x ? M : void 0,
        "aria-selected": S,
        tabIndex: 0,
        onKeyDown: (_) => {
          _.key === "Enter" || _.key === " " ? (_.preventDefault(), u(t)) : (!P && _.key === "ArrowRight" && x && !M || !P && _.key === "ArrowLeft" && x && M) && (_.preventDefault(), d(t.id));
        },
        children: [
          !P && /* @__PURE__ */ y(
            "div",
            {
              className: `${ue.expandIcon} ${M ? ue.expanded : ""} ${x ? "" : ue.disabled}`,
              onClick: (_) => {
                _.stopPropagation(), x && d(t.id);
              },
              role: "button",
              "aria-label": M ? "Collapse" : "Expand",
              children: /* @__PURE__ */ y(j, { icon: "chevron-right", size: "small" })
            }
          ),
          /* @__PURE__ */ E("div", { className: ue.nodeName, children: [
            C && C(t),
            v ? v(t) : /* @__PURE__ */ E(Re, { children: [
              /* @__PURE__ */ y(ds, { text: t.name, highlight: l }),
              b && t.code && /* @__PURE__ */ E("span", { className: ue.nodeCode, children: [
                "(",
                /* @__PURE__ */ y(ds, { text: t.code, highlight: l }),
                ")"
              ] }),
              k && t.slug && /* @__PURE__ */ E("span", { className: ue.nodeCode, children: [
                "[",
                /* @__PURE__ */ y(ds, { text: t.slug, highlight: l }),
                "]"
              ] })
            ] })
          ] }),
          !P && /* @__PURE__ */ y("div", { className: `${ue.nodeActions} ${oe ? ue.visible : ""}`, children: /* @__PURE__ */ y(
            "button",
            {
              className: ue.actionButton,
              onClick: (_) => {
                _.stopPropagation(), f(t);
              },
              "aria-label": "Add child",
              title: "Add child",
              children: /* @__PURE__ */ y(j, { icon: "plus", size: "small" })
            }
          ) })
        ]
      }
    ),
    !P && x && M && /* @__PURE__ */ y("div", { className: ue.children, role: "group", children: t.children.map((_) => /* @__PURE__ */ y(
      Jg,
      {
        item: _,
        level: e + 1,
        expanded: n,
        selected: r,
        highlighted: i,
        draggedItem: s,
        dragOverItem: o,
        searchTerm: l,
        mode: a,
        enableDragDrop: c,
        onToggle: d,
        onSelect: u,
        onEdit: h,
        onAddChild: f,
        onDragStart: p,
        onDragOver: m,
        onDrop: g,
        showCode: b,
        showSlug: k,
        customIcon: C,
        customLabel: v
      },
      _.id
    )) })
  ] });
}
const Qg = "_tile_1racn_1", Yg = "_tileDisabled_1racn_31", Xg = "_iconWrapper_1racn_41", e0 = "_iconText_1racn_53", t0 = "_title_1racn_66", n0 = "_comingSoonBadge_1racn_78", r0 = "_description_1racn_91", i0 = "_arrow_1racn_99", Nt = {
  tile: Qg,
  tileDisabled: Yg,
  iconWrapper: Xg,
  iconText: e0,
  title: t0,
  comingSoonBadge: n0,
  description: r0,
  arrow: i0
}, c4 = ({
  to: t,
  icon: e,
  title: n,
  description: r,
  disabled: i = !1,
  comingSoon: s = !1,
  className: o = "",
  onClick: l
}) => {
  const a = [Nt.tile, i ? Nt.tileDisabled : "", o].filter(Boolean).join(" "), c = /* @__PURE__ */ E(Re, { children: [
    e && /* @__PURE__ */ y("div", { className: Nt.iconWrapper, children: /* @__PURE__ */ y("span", { className: Nt.iconText, children: e }) }),
    /* @__PURE__ */ E("h3", { className: Nt.title, children: [
      n,
      s && /* @__PURE__ */ y("span", { className: Nt.comingSoonBadge, children: "Coming Soon" })
    ] }),
    /* @__PURE__ */ y("p", { className: Nt.description, children: r }),
    !i && /* @__PURE__ */ y("div", { className: Nt.arrow, children: /* @__PURE__ */ y(j, { icon: "arrowRight", size: { width: 1.5, height: 1.5 } }) })
  ] });
  return i ? /* @__PURE__ */ y("div", { className: a, children: c }) : l ? /* @__PURE__ */ y("button", { type: "button", className: a, onClick: l, children: c }) : /* @__PURE__ */ y("a", { href: t, className: a, children: c });
};
var Tr = { exports: {} }, us = {};
var Ml;
function s0() {
  if (Ml) return us;
  Ml = 1;
  var t = Ye;
  function e(u, h) {
    return u === h && (u !== 0 || 1 / u === 1 / h) || u !== u && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, i = t.useEffect, s = t.useLayoutEffect, o = t.useDebugValue;
  function l(u, h) {
    var f = h(), p = r({ inst: { value: f, getSnapshot: h } }), m = p[0].inst, g = p[1];
    return s(
      function() {
        m.value = f, m.getSnapshot = h, a(m) && g({ inst: m });
      },
      [u, f, h]
    ), i(
      function() {
        return a(m) && g({ inst: m }), u(function() {
          a(m) && g({ inst: m });
        });
      },
      [u]
    ), o(f), f;
  }
  function a(u) {
    var h = u.getSnapshot;
    u = u.value;
    try {
      var f = h();
      return !n(u, f);
    } catch {
      return !0;
    }
  }
  function c(u, h) {
    return h();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return us.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, us;
}
var hs = {};
var Tl;
function o0() {
  return Tl || (Tl = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(f, p) {
      return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
    }
    function e(f, p) {
      d || i.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = p();
      if (!u) {
        var g = p();
        s(m, g) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), u = !0);
      }
      g = o({
        inst: { value: m, getSnapshot: p }
      });
      var b = g[0].inst, k = g[1];
      return a(
        function() {
          b.value = m, b.getSnapshot = p, n(b) && k({ inst: b });
        },
        [f, m, p]
      ), l(
        function() {
          return n(b) && k({ inst: b }), f(function() {
            n(b) && k({ inst: b });
          });
        },
        [f]
      ), c(m), m;
    }
    function n(f) {
      var p = f.getSnapshot;
      f = f.value;
      try {
        var m = p();
        return !s(f, m);
      } catch {
        return !0;
      }
    }
    function r(f, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = Ye, s = typeof Object.is == "function" ? Object.is : t, o = i.useState, l = i.useEffect, a = i.useLayoutEffect, c = i.useDebugValue, d = !1, u = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    hs.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), hs;
}
var El;
function Io() {
  return El || (El = 1, process.env.NODE_ENV === "production" ? Tr.exports = s0() : Tr.exports = o0()), Tr.exports;
}
var Ec = Io();
function be(t) {
  this.content = t;
}
be.prototype = {
  constructor: be,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var r = n && n != t ? this.remove(n) : this, i = r.find(t), s = r.content.slice();
    return i == -1 ? s.push(n || t, e) : (s[i + 1] = e, n && (s[i] = n)), new be(s);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var n = this.content.slice();
    return n.splice(e, 2), new be(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new be([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new be(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var r = this.remove(e), i = r.content.slice(), s = r.find(t);
    return i.splice(s == -1 ? i.length : s, 0, e, n), new be(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = be.from(t), t.size ? new be(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = be.from(t), t.size ? new be(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = be.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, n) {
      t[e] = n;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
be.from = function(t) {
  if (t instanceof be) return t;
  var e = [];
  if (t) for (var n in t) e.push(n, t[n]);
  return new be(e);
};
function Ac(t, e, n) {
  for (let r = 0; ; r++) {
    if (r == t.childCount || r == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let i = t.child(r), s = e.child(r);
    if (i == s) {
      n += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(s))
      return n;
    if (i.isText && i.text != s.text) {
      for (let o = 0; i.text[o] == s.text[o]; o++)
        n++;
      return n;
    }
    if (i.content.size || s.content.size) {
      let o = Ac(i.content, s.content, n + 1);
      if (o != null)
        return o;
    }
    n += i.nodeSize;
  }
}
function Nc(t, e, n, r) {
  for (let i = t.childCount, s = e.childCount; ; ) {
    if (i == 0 || s == 0)
      return i == s ? null : { a: n, b: r };
    let o = t.child(--i), l = e.child(--s), a = o.nodeSize;
    if (o == l) {
      n -= a, r -= a;
      continue;
    }
    if (!o.sameMarkup(l))
      return { a: n, b: r };
    if (o.isText && o.text != l.text) {
      let c = 0, d = Math.min(o.text.length, l.text.length);
      for (; c < d && o.text[o.text.length - c - 1] == l.text[l.text.length - c - 1]; )
        c++, n--, r--;
      return { a: n, b: r };
    }
    if (o.content.size || l.content.size) {
      let c = Nc(o.content, l.content, n - 1, r - 1);
      if (c)
        return c;
    }
    n -= a, r -= a;
  }
}
class w {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, r, i = 0, s) {
    for (let o = 0, l = 0; l < n; o++) {
      let a = this.content[o], c = l + a.nodeSize;
      if (c > e && r(a, i + l, s || null, o) !== !1 && a.content.size) {
        let d = l + 1;
        a.nodesBetween(Math.max(0, e - d), Math.min(a.content.size, n - d), r, i + d);
      }
      l = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, r, i) {
    let s = "", o = !0;
    return this.nodesBetween(e, n, (l, a) => {
      let c = l.isText ? l.text.slice(Math.max(e, a) - a, n - a) : l.isLeaf ? i ? typeof i == "function" ? i(l) : i : l.type.spec.leafText ? l.type.spec.leafText(l) : "" : "";
      l.isBlock && (l.isLeaf && c || l.isTextblock) && r && (o ? o = !1 : s += r), s += c;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, r = e.firstChild, i = this.content.slice(), s = 0;
    for (n.isText && n.sameMarkup(r) && (i[i.length - 1] = n.withText(n.text + r.text), s = 1); s < e.content.length; s++)
      i.push(e.content[s]);
    return new w(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let r = [], i = 0;
    if (n > e)
      for (let s = 0, o = 0; o < n; s++) {
        let l = this.content[s], a = o + l.nodeSize;
        a > e && ((o < e || a > n) && (l.isText ? l = l.cut(Math.max(0, e - o), Math.min(l.text.length, n - o)) : l = l.cut(Math.max(0, e - o - 1), Math.min(l.content.size, n - o - 1))), r.push(l), i += l.nodeSize), o = a;
      }
    return new w(r, i);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? w.empty : e == 0 && n == this.content.length ? this : new w(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let r = this.content[e];
    if (r == n)
      return this;
    let i = this.content.slice(), s = this.size + n.nodeSize - r.nodeSize;
    return i[e] = n, new w(i, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new w([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new w(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let i = this.content[n];
      e(i, r, n), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return Ac(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, r = e.size) {
    return Nc(this, e, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return Er(0, e);
    if (e == this.size)
      return Er(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let n = 0, r = 0; ; n++) {
      let i = this.child(n), s = r + i.nodeSize;
      if (s >= e)
        return s == e ? Er(n + 1, s) : Er(n, r);
      r = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return w.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return w.fromArray(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return w.empty;
    let n, r = 0;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      r += s.nodeSize, i && s.isText && e[i - 1].sameMarkup(s) ? (n || (n = e.slice(0, i)), n[n.length - 1] = s.withText(n[n.length - 1].text + s.text)) : n && n.push(s);
    }
    return new w(n || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return w.empty;
    if (e instanceof w)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new w([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
w.empty = new w([], 0);
const fs = { index: 0, offset: 0 };
function Er(t, e) {
  return fs.index = t, fs.offset = e, fs;
}
function Xr(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!Xr(t[r], e[r]))
        return !1;
  } else {
    for (let r in t)
      if (!(r in e) || !Xr(t[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in t))
        return !1;
  }
  return !0;
}
let K = class Ks {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let n, r = !1;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        n || (n = e.slice(0, i));
      else {
        if (s.type.excludes(this.type))
          return e;
        !r && s.type.rank > this.type.rank && (n || (n = e.slice(0, i)), n.push(this), r = !0), n && n.push(s);
      }
    }
    return n || (n = e.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return e.slice(0, n).concat(e.slice(n + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Xr(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let i = r.create(n.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, n) {
    if (e == n)
      return !0;
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return Ks.none;
    if (e instanceof Ks)
      return [e];
    let n = e.slice();
    return n.sort((r, i) => r.type.rank - i.type.rank), n;
  }
};
K.none = [];
class ei extends Error {
}
class A {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, r) {
    this.content = e, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let r = Oc(this.content, e + this.openStart, n, this.openStart + 1, this.openEnd + 1);
    return r && new A(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new A(_c(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return A.empty;
    let r = n.openStart || 0, i = n.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new A(w.fromJSON(e, n.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let r = 0, i = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (n || !s.type.spec.isolating); s = s.firstChild)
      r++;
    for (let s = e.lastChild; s && !s.isLeaf && (n || !s.type.spec.isolating); s = s.lastChild)
      i++;
    return new A(e, r, i);
  }
}
A.empty = new A(w.empty, 0, 0);
function _c(t, e, n) {
  let { index: r, offset: i } = t.findIndex(e), s = t.maybeChild(r), { index: o, offset: l } = t.findIndex(n);
  if (i == e || s.isText) {
    if (l != n && !t.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(r, s.copy(_c(s.content, e - i - 1, n - i - 1)));
}
function Oc(t, e, n, r, i, s) {
  let { index: o, offset: l } = t.findIndex(e), a = t.maybeChild(o);
  if (l == e || a.isText)
    return s && r <= 0 && i <= 0 && !s.canReplace(o, o, n) ? null : t.cut(0, e).append(n).append(t.cut(e));
  let c = Oc(a.content, e - l - 1, n, o == 0 ? r - 1 : 0, o == t.childCount - 1 ? i - 1 : 0, a);
  return c && t.replaceChild(o, a.copy(c));
}
function l0(t, e, n) {
  if (n.openStart > t.depth)
    throw new ei("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new ei("Inconsistent open depths");
  return Rc(t, e, n, 0);
}
function Rc(t, e, n, r) {
  let i = t.index(r), s = t.node(r);
  if (i == e.index(r) && r < t.depth - n.openStart) {
    let o = Rc(t, e, n, r + 1);
    return s.copy(s.content.replaceChild(i, o));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == r && e.depth == r) {
      let o = t.parent, l = o.content;
      return sn(o, l.cut(0, t.parentOffset).append(n.content).append(l.cut(e.parentOffset)));
    } else {
      let { start: o, end: l } = a0(n, t);
      return sn(s, Lc(t, o, l, e, r));
    }
  else return sn(s, ti(t, e, r));
}
function Ic(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new ei("Cannot join " + e.type.name + " onto " + t.type.name);
}
function Zs(t, e, n) {
  let r = t.node(n);
  return Ic(r, e.node(n)), r;
}
function rn(t, e) {
  let n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function Jn(t, e, n, r) {
  let i = (e || t).node(n), s = 0, o = e ? e.index(n) : i.childCount;
  t && (s = t.index(n), t.depth > n ? s++ : t.textOffset && (rn(t.nodeAfter, r), s++));
  for (let l = s; l < o; l++)
    rn(i.child(l), r);
  e && e.depth == n && e.textOffset && rn(e.nodeBefore, r);
}
function sn(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function Lc(t, e, n, r, i) {
  let s = t.depth > i && Zs(t, e, i + 1), o = r.depth > i && Zs(n, r, i + 1), l = [];
  return Jn(null, t, i, l), s && o && e.index(i) == n.index(i) ? (Ic(s, o), rn(sn(s, Lc(t, e, n, r, i + 1)), l)) : (s && rn(sn(s, ti(t, e, i + 1)), l), Jn(e, n, i, l), o && rn(sn(o, ti(n, r, i + 1)), l)), Jn(r, null, i, l), new w(l);
}
function ti(t, e, n) {
  let r = [];
  if (Jn(null, t, n, r), t.depth > n) {
    let i = Zs(t, e, n + 1);
    rn(sn(i, ti(t, e, n + 1)), r);
  }
  return Jn(e, null, n, r), new w(r);
}
function a0(t, e) {
  let n = e.depth - t.openStart, i = e.node(n).copy(t.content);
  for (let s = n - 1; s >= 0; s--)
    i = e.node(s).copy(w.from(i));
  return {
    start: i.resolveNoCache(t.openStart + n),
    end: i.resolveNoCache(i.content.size - t.openEnd - n)
  };
}
class ar {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, n = this.index(this.depth);
    if (n == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(n);
    return r ? e.child(n).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(e).cut(0, n) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], i = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let s = 0; s < e; s++)
      i += r.child(s).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, n = this.index();
    if (e.content.size == 0)
      return K.none;
    if (this.textOffset)
      return e.child(n).marks;
    let r = e.maybeChild(n - 1), i = e.maybeChild(n);
    if (!r) {
      let l = r;
      r = i, i = l;
    }
    let s = r.marks;
    for (var o = 0; o < s.length; o++)
      s[o].type.spec.inclusive === !1 && (!i || !s[o].isInSet(i.marks)) && (s = s[o--].removeFromSet(s));
    return s;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, i = e.parent.maybeChild(e.index());
    for (var s = 0; s < r.length; s++)
      r[s].type.spec.inclusive === !1 && (!i || !r[s].isInSet(i.marks)) && (r = r[s--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= e && this.end(n) >= e)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, n) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!n || n(this.node(r))))
        return new ni(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 1; n <= this.depth; n++)
      e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, n) {
    if (!(n >= 0 && n <= e.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], i = 0, s = n;
    for (let o = e; ; ) {
      let { index: l, offset: a } = o.content.findIndex(s), c = s - a;
      if (r.push(o, l, i + a), !c || (o = o.child(l), o.isText))
        break;
      s = c - 1, i += a + 1;
    }
    return new ar(n, r, s);
  }
  /**
  @internal
  */
  static resolveCached(e, n) {
    let r = Al.get(e);
    if (r)
      for (let s = 0; s < r.elts.length; s++) {
        let o = r.elts[s];
        if (o.pos == n)
          return o;
      }
    else
      Al.set(e, r = new c0());
    let i = r.elts[r.i] = ar.resolve(e, n);
    return r.i = (r.i + 1) % d0, i;
  }
}
class c0 {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const d0 = 12, Al = /* @__PURE__ */ new WeakMap();
class ni {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const u0 = /* @__PURE__ */ Object.create(null);
class Qe {
  /**
  @internal
  */
  constructor(e, n, r, i = K.none) {
    this.type = e, this.attrs = n, this.marks = i, this.content = r || w.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively overlapping
  the given two positions that are relative to start of this
  node's content. This includes all ancestors of the nodes
  containing the two positions. The callback is invoked with the
  node, its position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, n, r, i = 0) {
    this.content.nodesBetween(e, n, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, n, r, i) {
    return this.content.textBetween(e, n, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, n, r) {
    return this.type == e && Xr(this.attrs, n || e.defaultAttrs || u0) && K.sameSet(this.marks, r || K.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Qe(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Qe(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, n = this.content.size) {
    return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, n = this.content.size, r = !1) {
    if (e == n)
      return A.empty;
    let i = this.resolve(e), s = this.resolve(n), o = r ? 0 : i.sharedDepth(n), l = i.start(o), c = i.node(o).content.cut(i.pos - l, s.pos - l);
    return new A(c, i.depth - o, s.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, n, r) {
    return l0(this.resolve(e), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let n = this; ; ) {
      let { index: r, offset: i } = n.content.findIndex(e);
      if (n = n.maybeChild(r), !n)
        return null;
      if (i == e || n.isText)
        return n;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: n, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(n), index: n, offset: r };
    let i = this.content.child(n - 1);
    return { node: i, index: n - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return ar.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return ar.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, n, r) {
    let i = !1;
    return n > e && this.nodesBetween(e, n, (s) => (r.isInSet(s.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Dc(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, n, r = w.empty, i = 0, s = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, i, s), l = o && o.matchFragment(this.content, n);
    if (!l || !l.validEnd)
      return !1;
    for (let a = i; a < s; a++)
      if (!this.type.allowsMarks(r.child(a).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, n, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let s = this.contentMatchAt(e).matchType(r), o = s && s.matchFragment(this.content, n);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = K.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!K.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((n) => n.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(e.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(n.text, r);
    }
    let i = w.fromJSON(e, n.content), s = e.nodeType(n.type).create(n.attrs, i, r);
    return s.type.checkAttrs(s.attrs), s;
  }
}
Qe.prototype.text = void 0;
class ri extends Qe {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    if (super(e, n, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Dc(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, n) {
    return this.text.slice(e, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new ri(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new ri(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, n = this.text.length) {
    return e == 0 && n == this.text.length ? this : this.withText(this.text.slice(e, n));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function Dc(t, e) {
  for (let n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
class cn {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, n) {
    let r = new h0(e, n);
    if (r.next == null)
      return cn.empty;
    let i = Pc(r);
    r.next && r.err("Unexpected trailing text");
    let s = k0(b0(i));
    return v0(s, r), s;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == e)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, n = 0, r = e.childCount) {
    let i = this;
    for (let s = n; i && s < r; s++)
      i = i.matchType(e.child(s).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: n } = this.next[e];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[n].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, n = !1, r = 0) {
    let i = [this];
    function s(o, l) {
      let a = o.matchFragment(e, r);
      if (a && (!n || a.validEnd))
        return w.from(l.map((c) => c.createAndFill()));
      for (let c = 0; c < o.next.length; c++) {
        let { type: d, next: u } = o.next[c];
        if (!(d.isText || d.hasRequiredAttrs()) && i.indexOf(u) == -1) {
          i.push(u);
          let h = s(u, l.concat(d));
          if (h)
            return h;
        }
      }
      return null;
    }
    return s(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(e);
    return this.wrapCache.push(e, n), n;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), s = i.match;
      if (s.matchType(e)) {
        let o = [];
        for (let l = i; l.type; l = l.via)
          o.push(l.type);
        return o.reverse();
      }
      for (let o = 0; o < s.next.length; o++) {
        let { type: l, next: a } = s.next[o];
        !l.isLeaf && !l.hasRequiredAttrs() && !(l.name in n) && (!i.type || a.validEnd) && (r.push({ match: l.contentMatch, type: l, via: i }), n[l.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function n(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && n(r.next[i].next);
    }
    return n(this), e.map((r, i) => {
      let s = i + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        s += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return s;
    }).join(`
`);
  }
}
cn.empty = new cn(!0);
class h0 {
  constructor(e, n) {
    this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function Pc(t) {
  let e = [];
  do
    e.push(f0(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function f0(t) {
  let e = [];
  do
    e.push(p0(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function p0(t) {
  let e = y0(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = m0(t, e);
    else
      break;
  return e;
}
function Nl(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function m0(t, e) {
  let n = Nl(t), r = n;
  return t.eat(",") && (t.next != "}" ? r = Nl(t) : r = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: e };
}
function g0(t, e) {
  let n = t.nodeTypes, r = n[e];
  if (r)
    return [r];
  let i = [];
  for (let s in n) {
    let o = n[s];
    o.isInGroup(e) && i.push(o);
  }
  return i.length == 0 && t.err("No node type or group '" + e + "' found"), i;
}
function y0(t) {
  if (t.eat("(")) {
    let e = Pc(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = g0(t, t.next).map((n) => (t.inline == null ? t.inline = n.isInline : t.inline != n.isInline && t.err("Mixing inline and block content"), { type: "name", value: n }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function b0(t) {
  let e = [[]];
  return i(s(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function r(o, l, a) {
    let c = { term: a, to: l };
    return e[o].push(c), c;
  }
  function i(o, l) {
    o.forEach((a) => a.to = l);
  }
  function s(o, l) {
    if (o.type == "choice")
      return o.exprs.reduce((a, c) => a.concat(s(c, l)), []);
    if (o.type == "seq")
      for (let a = 0; ; a++) {
        let c = s(o.exprs[a], l);
        if (a == o.exprs.length - 1)
          return c;
        i(c, l = n());
      }
    else if (o.type == "star") {
      let a = n();
      return r(l, a), i(s(o.expr, a), a), [r(a)];
    } else if (o.type == "plus") {
      let a = n();
      return i(s(o.expr, l), a), i(s(o.expr, a), a), [r(a)];
    } else {
      if (o.type == "opt")
        return [r(l)].concat(s(o.expr, l));
      if (o.type == "range") {
        let a = l;
        for (let c = 0; c < o.min; c++) {
          let d = n();
          i(s(o.expr, a), d), a = d;
        }
        if (o.max == -1)
          i(s(o.expr, a), a);
        else
          for (let c = o.min; c < o.max; c++) {
            let d = n();
            r(a, d), i(s(o.expr, a), d), a = d;
          }
        return [r(a)];
      } else {
        if (o.type == "name")
          return [r(l, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function zc(t, e) {
  return e - t;
}
function _l(t, e) {
  let n = [];
  return r(e), n.sort(zc);
  function r(i) {
    let s = t[i];
    if (s.length == 1 && !s[0].term)
      return r(s[0].to);
    n.push(i);
    for (let o = 0; o < s.length; o++) {
      let { term: l, to: a } = s[o];
      !l && n.indexOf(a) == -1 && r(a);
    }
  }
}
function k0(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return n(_l(t, 0));
  function n(r) {
    let i = [];
    r.forEach((o) => {
      t[o].forEach(({ term: l, to: a }) => {
        if (!l)
          return;
        let c;
        for (let d = 0; d < i.length; d++)
          i[d][0] == l && (c = i[d][1]);
        _l(t, a).forEach((d) => {
          c || i.push([l, c = []]), c.indexOf(d) == -1 && c.push(d);
        });
      });
    });
    let s = e[r.join(",")] = new cn(r.indexOf(t.length - 1) > -1);
    for (let o = 0; o < i.length; o++) {
      let l = i[o][1].sort(zc);
      s.next.push({ type: i[o][0], next: e[l.join(",")] || n(l) });
    }
    return s;
  }
}
function v0(t, e) {
  for (let n = 0, r = [t]; n < r.length; n++) {
    let i = r[n], s = !i.validEnd, o = [];
    for (let l = 0; l < i.next.length; l++) {
      let { type: a, next: c } = i.next[l];
      o.push(a.name), s && !(a.isText || a.hasRequiredAttrs()) && (s = !1), r.indexOf(c) == -1 && r.push(c);
    }
    s && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Bc(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    if (!r.hasDefault)
      return null;
    e[n] = r.default;
  }
  return e;
}
function $c(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let i = e && e[r];
    if (i === void 0) {
      let s = t[r];
      if (s.hasDefault)
        i = s.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = i;
  }
  return n;
}
function Hc(t, e, n, r) {
  for (let i in e)
    if (!(i in t))
      throw new RangeError(`Unsupported attribute ${i} for ${n} of type ${i}`);
  for (let i in t) {
    let s = t[i];
    s.validate && s.validate(e[i]);
  }
}
function Vc(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      n[r] = new x0(t, r, e[r]);
  return n;
}
let Ol = class Fc {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.name = e, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = Vc(e, r.attrs), this.defaultAttrs = Bc(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == cn.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : $c(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Qe(this, this.computeAttrs(e), w.from(n), K.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, n, r) {
    return n = w.from(n), this.checkContent(n), new Qe(this, this.computeAttrs(e), n, K.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, n, r) {
    if (e = this.computeAttrs(e), n = w.from(n), n.size) {
      let o = this.contentMatch.fillBefore(n);
      if (!o)
        return null;
      n = o.append(n);
    }
    let i = this.contentMatch.matchFragment(n), s = i && i.fillBefore(w.empty, !0);
    return s ? new Qe(this, e, n.append(s), K.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let n = this.contentMatch.matchFragment(e);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Hc(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < e.length; n++)
      if (!this.allowsMarkType(e[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let n;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? n && n.push(e[r]) : n || (n = e.slice(0, r));
    return n ? n.length ? n : K.none : e;
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((s, o) => r[s] = new Fc(s, n, o));
    let i = n.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function C0(t, e, n) {
  let r = n.split("|");
  return (i) => {
    let s = i === null ? "null" : typeof i;
    if (r.indexOf(s) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${t}, got ${s}`);
  };
}
class x0 {
  constructor(e, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? C0(e, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Wi {
  /**
  @internal
  */
  constructor(e, n, r, i) {
    this.name = e, this.rank = n, this.schema = r, this.spec = i, this.attrs = Vc(e, i.attrs), this.excluded = null;
    let s = Bc(this.attrs);
    this.instance = s ? new K(this, s) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new K(this, $c(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, n) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((s, o) => r[s] = new Wi(s, i++, n, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var n = 0; n < e.length; n++)
      e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (e[n].type == this)
        return e[n];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Hc(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Wc {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let i in e)
      n[i] = e[i];
    n.nodes = be.from(e.nodes), n.marks = be.from(e.marks || {}), this.nodes = Ol.compile(this.spec.nodes, this), this.marks = Wi.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let s = this.nodes[i], o = s.spec.content || "", l = s.spec.marks;
      if (s.contentMatch = r[o] || (r[o] = cn.parse(o, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!s.isInline || !s.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = s;
      }
      s.markSet = l == "_" ? null : l ? Rl(this, l.split(" ")) : l == "" || !s.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let s = this.marks[i], o = s.spec.excludes;
      s.excluded = o == null ? [s] : o == "" ? [] : Rl(this, o.split(" "));
    }
    this.nodeFromJSON = (i) => Qe.fromJSON(this, i), this.markFromJSON = (i) => K.fromJSON(this, i), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, n = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Ol) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(n, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, n) {
    let r = this.nodes.text;
    return new ri(r, r.defaultAttrs, e, K.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, n) {
    return typeof e == "string" && (e = this.marks[e]), e.create(n);
  }
  /**
  @internal
  */
  nodeType(e) {
    let n = this.nodes[e];
    if (!n)
      throw new RangeError("Unknown node type: " + e);
    return n;
  }
}
function Rl(t, e) {
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], s = t.marks[i], o = s;
    if (s)
      n.push(s);
    else
      for (let l in t.marks) {
        let a = t.marks[l];
        (i == "_" || a.spec.group && a.spec.group.split(" ").indexOf(i) > -1) && n.push(o = a);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return n;
}
function w0(t) {
  return t.tag != null;
}
function S0(t) {
  return t.style != null;
}
let Qn = class Gs {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, n) {
    this.schema = e, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((i) => {
      if (w0(i))
        this.tags.push(i);
      else if (S0(i)) {
        let s = /[^=]*/.exec(i.style)[0];
        r.indexOf(s) < 0 && r.push(s), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let s = e.nodes[i.node];
      return s.contentMatch.matchType(s);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, n = {}) {
    let r = new Ll(this, n, !1);
    return r.addAll(e, K.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, n = {}) {
    let r = new Ll(this, n, !0);
    return r.addAll(e, K.none, n.from, n.to), A.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, n, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let s = this.tags[i];
      if (E0(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || n.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, n, r, i) {
    for (let s = i ? this.styles.indexOf(i) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], l = o.style;
      if (!(l.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      l.length > e.length && (l.charCodeAt(e.length) != 61 || l.slice(e.length + 1) != n))) {
        if (o.getAttrs) {
          let a = o.getAttrs(n);
          if (a === !1)
            continue;
          o.attrs = a || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let n = [];
    function r(i) {
      let s = i.priority == null ? 50 : i.priority, o = 0;
      for (; o < n.length; o++) {
        let l = n[o];
        if ((l.priority == null ? 50 : l.priority) < s)
          break;
      }
      n.splice(o, 0, i);
    }
    for (let i in e.marks) {
      let s = e.marks[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = Dl(o)), o.mark || o.ignore || o.clearMark || (o.mark = i);
      });
    }
    for (let i in e.nodes) {
      let s = e.nodes[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = Dl(o)), o.node || o.ignore || o.mark || (o.node = i);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Gs(e, Gs.schemaRules(e)));
  }
};
const qc = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, M0 = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, jc = { ol: !0, ul: !0 }, cr = 1, Js = 2, Yn = 4;
function Il(t, e, n) {
  return e != null ? (e ? cr : 0) | (e === "full" ? Js : 0) : t && t.whitespace == "pre" ? cr | Js : n & ~Yn;
}
class Ar {
  constructor(e, n, r, i, s, o) {
    this.type = e, this.attrs = n, this.marks = r, this.solid = i, this.options = o, this.content = [], this.activeMarks = K.none, this.match = s || (o & Yn ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(w.from(e));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & cr)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let s = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - i[0].length));
      }
    }
    let n = w.from(this.content);
    return !e && this.match && (n = n.append(this.match.fillBefore(w.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !qc.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Ll {
  constructor(e, n, r) {
    this.parser = e, this.options = n, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = n.topNode, s, o = Il(null, n.preserveWhitespace, 0) | (r ? Yn : 0);
    i ? s = new Ar(i.type, i.attrs, K.none, !0, n.topMatch || i.type.contentMatch, o) : r ? s = new Ar(null, null, K.none, !0, null, o) : s = new Ar(e.schema.topNodeType, null, K.none, !0, null, o), this.nodes = [s], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, n) {
    e.nodeType == 3 ? this.addTextNode(e, n) : e.nodeType == 1 && this.addElement(e, n);
  }
  addTextNode(e, n) {
    let r = e.nodeValue, i = this.top, s = i.options & Js ? "full" : this.localPreserveWS || (i.options & cr) > 0, { schema: o } = this.parser;
    if (s === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (s)
        if (s === "full")
          r = r.replace(/\r\n?/g, `
`);
        else if (o.linebreakReplacement && /[\r\n]/.test(r) && this.top.findWrapping(o.linebreakReplacement.create())) {
          let l = r.split(/\r?\n|\r/);
          for (let a = 0; a < l.length; a++)
            a && this.insertNode(o.linebreakReplacement.create(), n, !0), l[a] && this.insertNode(o.text(l[a]), n, !/\S/.test(l[a]));
          r = "";
        } else
          r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let l = i.content[i.content.length - 1], a = e.previousSibling;
        (!l || a && a.nodeName == "BR" || l.isText && /[ \t\r\n\u000c]$/.test(l.text)) && (r = r.slice(1));
      }
      r && this.insertNode(o.text(r), n, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, n, r) {
    let i = this.localPreserveWS, s = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), l;
    jc.hasOwnProperty(o) && this.parser.normalizeLists && T0(e);
    let a = this.options.ruleFromNode && this.options.ruleFromNode(e) || (l = this.parser.matchTag(e, this, r));
    e: if (a ? a.ignore : M0.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, n);
    else if (!a || a.skip || a.closeParent) {
      a && a.closeParent ? this.open = Math.max(0, this.open - 1) : a && a.skip.nodeType && (e = a.skip);
      let c, d = this.needsBlock;
      if (qc.hasOwnProperty(o))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), c = !0, s.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, n);
        break e;
      }
      let u = a && a.skip ? n : this.readStyles(e, n);
      u && this.addAll(e, u), c && this.sync(s), this.needsBlock = d;
    } else {
      let c = this.readStyles(e, n);
      c && this.addElementByRule(e, a, c, a.consuming === !1 ? l : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, n) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(e, n) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, n) {
    let r = e.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let s = this.parser.matchedStyles[i], o = r.getPropertyValue(s);
        if (o)
          for (let l = void 0; ; ) {
            let a = this.parser.matchStyle(s, o, this, l);
            if (!a)
              break;
            if (a.ignore)
              return null;
            if (a.clearMark ? n = n.filter((c) => !a.clearMark(c)) : n = n.concat(this.parser.schema.marks[a.mark].create(a.attrs)), a.consuming === !1)
              l = a;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, n, r, i) {
    let s, o;
    if (n.node)
      if (o = this.parser.schema.nodes[n.node], o.isLeaf)
        this.insertNode(o.create(n.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let a = this.enter(o, n.attrs || null, r, n.preserveWhitespace);
        a && (s = !0, r = a);
      }
    else {
      let a = this.parser.schema.marks[n.mark];
      r = r.concat(a.create(n.attrs));
    }
    let l = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, r, i);
    else if (n.getContent)
      this.findInside(e), n.getContent(e, this.parser.schema).forEach((a) => this.insertNode(a, r, !1));
    else {
      let a = e;
      typeof n.contentElement == "string" ? a = e.querySelector(n.contentElement) : typeof n.contentElement == "function" ? a = n.contentElement(e) : n.contentElement && (a = n.contentElement), this.findAround(e, a, !0), this.addAll(a, r), this.findAround(e, a, !1);
    }
    s && this.sync(l) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, n, r, i) {
    let s = r || 0;
    for (let o = r ? e.childNodes[r] : e.firstChild, l = i == null ? null : e.childNodes[i]; o != l; o = o.nextSibling, ++s)
      this.findAtPoint(e, s), this.addDOM(o, n);
    this.findAtPoint(e, s);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, n, r) {
    let i, s;
    for (let o = this.open, l = 0; o >= 0; o--) {
      let a = this.nodes[o], c = a.findWrapping(e);
      if (c && (!i || i.length > c.length + l) && (i = c, s = a, !c.length))
        break;
      if (a.solid) {
        if (r)
          break;
        l += 2;
      }
    }
    if (!i)
      return null;
    this.sync(s);
    for (let o = 0; o < i.length; o++)
      n = this.enterInner(i[o], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, n, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let s = this.textblockFromContext();
      s && (n = this.enterInner(s, null, n));
    }
    let i = this.findPlace(e, n, r);
    if (i) {
      this.closeExtra();
      let s = this.top;
      s.match && (s.match = s.match.matchType(e.type));
      let o = K.none;
      for (let l of i.concat(e.marks))
        (s.type ? s.type.allowsMarkType(l.type) : Pl(l.type, e.type)) && (o = l.addToSet(o));
      return s.content.push(e.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, n, r, i) {
    let s = this.findPlace(e.create(n), r, !1);
    return s && (s = this.enterInner(e, n, r, !0, i)), s;
  }
  // Open a node of the given type
  enterInner(e, n, r, i = !1, s) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let l = Il(e, s, o.options);
    o.options & Yn && o.content.length == 0 && (l |= Yn);
    let a = K.none;
    return r = r.filter((c) => (o.type ? o.type.allowsMarkType(c.type) : Pl(c.type, e)) ? (a = c.addToSet(a), !1) : !0), this.nodes.push(new Ar(e, n, a, i, null, l)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == e)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= cr);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      n && e++;
    }
    return e;
  }
  findAtPoint(e, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(e, n, r) {
    if (e != n && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && n.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), s = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), o = (l, a) => {
      for (; l >= 0; l--) {
        let c = n[l];
        if (c == "") {
          if (l == n.length - 1 || l == 0)
            continue;
          for (; a >= s; a--)
            if (o(l - 1, a))
              return !0;
          return !1;
        } else {
          let d = a > 0 || a == 0 && i ? this.nodes[a].type : r && a >= s ? r.node(a - s).type : null;
          if (!d || d.name != c && !d.isInGroup(c))
            return !1;
          a--;
        }
      }
      return !0;
    };
    return o(n.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let n = e.depth; n >= 0; n--) {
        let r = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function T0(t) {
  for (let e = t.firstChild, n = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && jc.hasOwnProperty(r) && n ? (n.appendChild(e), e = n) : r == "li" ? n = e : r && (n = null);
  }
}
function E0(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function Dl(t) {
  let e = {};
  for (let n in t)
    e[n] = t[n];
  return e;
}
function Pl(t, e) {
  let n = e.schema.nodes;
  for (let r in n) {
    let i = n[r];
    if (!i.allowsMarkType(t))
      continue;
    let s = [], o = (l) => {
      s.push(l);
      for (let a = 0; a < l.edgeCount; a++) {
        let { type: c, next: d } = l.edge(a);
        if (c == e || s.indexOf(d) < 0 && o(d))
          return !0;
      }
    };
    if (o(i.contentMatch))
      return !0;
  }
}
class gn {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, n) {
    this.nodes = e, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, n = {}, r) {
    r || (r = Nr(n).createDocumentFragment());
    let i = r, s = [];
    return e.forEach((o) => {
      if (s.length || o.marks.length) {
        let l = 0, a = 0;
        for (; l < s.length && a < o.marks.length; ) {
          let c = o.marks[a];
          if (!this.marks[c.type.name]) {
            a++;
            continue;
          }
          if (!c.eq(s[l][0]) || c.type.spec.spanning === !1)
            break;
          l++, a++;
        }
        for (; l < s.length; )
          i = s.pop()[1];
        for (; a < o.marks.length; ) {
          let c = o.marks[a++], d = this.serializeMark(c, o.isInline, n);
          d && (s.push([c, i]), i.appendChild(d.dom), i = d.contentDOM || d.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(o, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, n) {
    if (e.isText)
      return Nr(n).createTextNode(e.text);
    let { dom: r, contentDOM: i } = Ur(Nr(n), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, n, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, n = {}) {
    let r = this.serializeNodeInner(e, n);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let s = this.serializeMark(e.marks[i], e.isInline, n);
      s && ((s.contentDOM || s.dom).appendChild(r), r = s.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, n, r = {}) {
    let i = this.marks[e.type.name];
    return i && Ur(Nr(r), i(e, n), null, e.attrs);
  }
  static renderSpec(e, n, r = null, i) {
    return typeof n == "string" ? { dom: e.createTextNode(n) } : Ur(e, n, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new gn(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let n = zl(e.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return zl(e.marks);
  }
}
function zl(t) {
  let e = {};
  for (let n in t) {
    let r = t[n].spec.toDOM;
    r && (e[n] = r);
  }
  return e;
}
function Nr(t) {
  return t.document || window.document;
}
const Bl = /* @__PURE__ */ new WeakMap();
function A0(t) {
  let e = Bl.get(t);
  return e === void 0 && Bl.set(t, e = N0(t)), e;
}
function N0(t) {
  let e = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let i = 0; i < r.length; i++)
            n(r[i]);
      else
        for (let i in r)
          n(r[i]);
  }
  return n(t), e;
}
function Ur(t, e, n, r) {
  if (e.nodeType == 1)
    return { dom: e };
  if (e.dom && e.dom.nodeType == 1)
    return e;
  let i = e[0], s;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (s = A0(r)) && s.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = i.indexOf(" ");
  o > 0 && (n = i.slice(0, o), i = i.slice(o + 1));
  let l, a = n ? t.createElementNS(n, i) : t.createElement(i), c = e[1], d = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    d = 2;
    for (let u in c)
      if (c[u] != null) {
        let h = u.indexOf(" ");
        h > 0 ? a.setAttributeNS(u.slice(0, h), u.slice(h + 1), c[u]) : u == "style" && a.style ? a.style.cssText = c[u] : a.setAttribute(u, c[u]);
      }
  }
  for (let u = d; u < e.length; u++) {
    let h = e[u];
    if (h === 0) {
      if (u < e.length - 1 || u > d)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: a, contentDOM: a };
    } else if (typeof h == "string")
      a.appendChild(t.createTextNode(h));
    else {
      let { dom: f, contentDOM: p } = Ur(t, h, n, r);
      if (a.appendChild(f), p) {
        if (l)
          throw new RangeError("Multiple content holes");
        l = p;
      }
    }
  }
  return { dom: a, contentDOM: l };
}
const Uc = 65535, Kc = Math.pow(2, 16);
function _0(t, e) {
  return t + e * Kc;
}
function $l(t) {
  return t & Uc;
}
function O0(t) {
  return (t - (t & Uc)) / Kc;
}
const Zc = 1, Gc = 2, Kr = 4, Jc = 8;
class Qs {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.pos = e, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Jc) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Zc | Kr)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Gc | Kr)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Kr) > 0;
  }
}
class De {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && De.empty)
      return De.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, r = $l(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        n += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + n + O0(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let i = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? i : 0);
      if (a > e)
        break;
      let c = this.ranges[l + s], d = this.ranges[l + o], u = a + c;
      if (e <= u) {
        let h = c ? e == a ? -1 : e == u ? 1 : n : n, f = a + i + (h < 0 ? 0 : d);
        if (r)
          return f;
        let p = e == (n < 0 ? a : u) ? null : _0(l / 3, e - a), m = e == a ? Gc : e == u ? Zc : Kr;
        return (n < 0 ? e != a : e != u) && (m |= Jc), new Qs(f, m, p);
      }
      i += d - c;
    }
    return r ? e + i : new Qs(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let r = 0, i = $l(n), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? r : 0);
      if (a > e)
        break;
      let c = this.ranges[l + s], d = a + c;
      if (e <= d && l == i * 3)
        return !0;
      r += this.ranges[l + o] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, s = 0; i < this.ranges.length; i += 3) {
      let o = this.ranges[i], l = o - (this.inverted ? s : 0), a = o + (this.inverted ? 0 : s), c = this.ranges[i + n], d = this.ranges[i + r];
      e(l, l + c, a, a + d), s += d - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new De(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? De.empty : new De(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
De.empty = new De([]);
class dr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, n, r = 0, i = e ? e.length : 0) {
    this.mirror = n, this.from = r, this.to = i, this._maps = e || [], this.ownData = !(e || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, n = this.maps.length) {
    return new dr(this._maps, this.mirror, e, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let n = 0, r = this._maps.length; n < e._maps.length; n++) {
      let i = e.getMirror(n);
      this.appendMap(e._maps[n], i != null && i < n ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == e)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, n) {
    this.mirror || (this.mirror = []), this.mirror.push(e, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let n = e.maps.length - 1, r = this._maps.length + e._maps.length; n >= 0; n--) {
      let i = e.getMirror(n);
      this.appendMap(e._maps[n].invert(), i != null && i > n ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new dr();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, n = 1) {
    if (this.mirror)
      return this._map(e, n, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, n);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  /**
  @internal
  */
  _map(e, n, r) {
    let i = 0;
    for (let s = this.from; s < this.to; s++) {
      let o = this._maps[s], l = o.mapResult(e, n);
      if (l.recover != null) {
        let a = this.getMirror(s);
        if (a != null && a > s && a < this.to) {
          s = a, e = this._maps[a].recover(l.recover);
          continue;
        }
      }
      i |= l.delInfo, e = l.pos;
    }
    return r ? e : new Qs(e, i, null);
  }
}
const ps = /* @__PURE__ */ Object.create(null);
class Me {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return De.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = ps[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in ps)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return ps[e] = n, n.prototype.jsonID = e, n;
  }
}
class ae {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new ae(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new ae(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, r, i) {
    try {
      return ae.ok(e.replace(n, r, i));
    } catch (s) {
      if (s instanceof ei)
        return ae.fail(s.message);
      throw s;
    }
  }
}
function Lo(t, e, n) {
  let r = [];
  for (let i = 0; i < t.childCount; i++) {
    let s = t.child(i);
    s.content.size && (s = s.copy(Lo(s.content, e, s))), s.isInline && (s = e(s, n, i)), r.push(s);
  }
  return w.fromArray(r);
}
class zt extends Me {
  /**
  Create a mark step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), s = new A(Lo(n.content, (o, l) => !o.isAtom || !l.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), i), n.openStart, n.openEnd);
    return ae.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new Je(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new zt(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof zt && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new zt(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new zt(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Me.jsonID("addMark", zt);
class Je extends Me {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, r) {
    super(), this.from = e, this.to = n, this.mark = r;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), r = new A(Lo(n.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), n.openStart, n.openEnd);
    return ae.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new zt(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Je(n.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Je && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Je(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Je(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Me.jsonID("removeMark", Je);
class Bt extends Me {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return ae.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return ae.fromReplace(e, this.pos, this.pos + 1, new A(w.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let i = 0; i < n.marks.length; i++)
          if (!n.marks[i].isInSet(r))
            return new Bt(this.pos, n.marks[i]);
        return new Bt(this.pos, this.mark);
      }
    }
    return new dn(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Bt(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Bt(n.pos, e.markFromJSON(n.mark));
  }
}
Me.jsonID("addNodeMark", Bt);
class dn extends Me {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return ae.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return ae.fromReplace(e, this.pos, this.pos + 1, new A(w.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Bt(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new dn(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new dn(n.pos, e.markFromJSON(n.mark));
  }
}
Me.jsonID("removeNodeMark", dn);
class le extends Me {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, r, i = !1) {
    super(), this.from = e, this.to = n, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && Ys(e, this.from, this.to) ? ae.fail("Structure replace would overwrite content") : ae.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new De([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new le(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.to, -1), r = this.from == this.to && le.MAP_BIAS < 0 ? n : e.mapResult(this.from, 1);
    return r.deletedAcross && n.deletedAcross ? null : new le(r.pos, Math.max(r.pos, n.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof le) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? A.empty : new A(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new le(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? A.empty : new A(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new le(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new le(n.from, n.to, A.fromJSON(e, n.slice), !!n.structure);
  }
}
le.MAP_BIAS = 1;
Me.jsonID("replace", le);
class fe extends Me {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, r, i, s, o, l = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = r, this.gapTo = i, this.slice = s, this.insert = o, this.structure = l;
  }
  apply(e) {
    if (this.structure && (Ys(e, this.from, this.gapFrom) || Ys(e, this.gapTo, this.to)))
      return ae.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return ae.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? ae.fromReplace(e, this.from, this.to, r) : ae.fail("Content does not fit in gap");
  }
  getMap() {
    return new De([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new fe(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), s = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || i < n.pos || s > r.pos ? null : new fe(n.pos, r.pos, i, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new fe(n.from, n.to, n.gapFrom, n.gapTo, A.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
Me.jsonID("replaceAround", fe);
function Ys(t, e, n) {
  let r = t.resolve(e), i = n - e, s = r.depth;
  for (; i > 0 && s > 0 && r.indexAfter(s) == r.node(s).childCount; )
    s--, i--;
  if (i > 0) {
    let o = r.node(s).maybeChild(r.indexAfter(s));
    for (; i > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, i--;
    }
  }
  return !1;
}
function R0(t, e, n, r) {
  let i = [], s = [], o, l;
  t.doc.nodesBetween(e, n, (a, c, d) => {
    if (!a.isInline)
      return;
    let u = a.marks;
    if (!r.isInSet(u) && d.type.allowsMarkType(r.type)) {
      let h = Math.max(c, e), f = Math.min(c + a.nodeSize, n), p = r.addToSet(u);
      for (let m = 0; m < u.length; m++)
        u[m].isInSet(p) || (o && o.to == h && o.mark.eq(u[m]) ? o.to = f : i.push(o = new Je(h, f, u[m])));
      l && l.to == h ? l.to = f : s.push(l = new zt(h, f, r));
    }
  }), i.forEach((a) => t.step(a)), s.forEach((a) => t.step(a));
}
function I0(t, e, n, r) {
  let i = [], s = 0;
  t.doc.nodesBetween(e, n, (o, l) => {
    if (!o.isInline)
      return;
    s++;
    let a = null;
    if (r instanceof Wi) {
      let c = o.marks, d;
      for (; d = r.isInSet(c); )
        (a || (a = [])).push(d), c = d.removeFromSet(c);
    } else r ? r.isInSet(o.marks) && (a = [r]) : a = o.marks;
    if (a && a.length) {
      let c = Math.min(l + o.nodeSize, n);
      for (let d = 0; d < a.length; d++) {
        let u = a[d], h;
        for (let f = 0; f < i.length; f++) {
          let p = i[f];
          p.step == s - 1 && u.eq(i[f].style) && (h = p);
        }
        h ? (h.to = c, h.step = s) : i.push({ style: u, from: Math.max(l, e), to: c, step: s });
      }
    }
  }), i.forEach((o) => t.step(new Je(o.from, o.to, o.style)));
}
function Do(t, e, n, r = n.contentMatch, i = !0) {
  let s = t.doc.nodeAt(e), o = [], l = e + 1;
  for (let a = 0; a < s.childCount; a++) {
    let c = s.child(a), d = l + c.nodeSize, u = r.matchType(c.type);
    if (!u)
      o.push(new le(l, d, A.empty));
    else {
      r = u;
      for (let h = 0; h < c.marks.length; h++)
        n.allowsMarkType(c.marks[h].type) || t.step(new Je(l, d, c.marks[h]));
      if (i && c.isText && n.whitespace != "pre") {
        let h, f = /\r?\n|\r/g, p;
        for (; h = f.exec(c.text); )
          p || (p = new A(w.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0)), o.push(new le(l + h.index, l + h.index + h[0].length, p));
      }
    }
    l = d;
  }
  if (!r.validEnd) {
    let a = r.fillBefore(w.empty, !0);
    t.replace(l, l, new A(a, 0, 0));
  }
  for (let a = o.length - 1; a >= 0; a--)
    t.step(o[a]);
}
function L0(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function zn(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let r = t.depth, i = 0, s = 0; ; --r) {
    let o = t.$from.node(r), l = t.$from.index(r) + i, a = t.$to.indexAfter(r) - s;
    if (r < t.depth && o.canReplace(l, a, n))
      return r;
    if (r == 0 || o.type.spec.isolating || !L0(o, l, a))
      break;
    l && (i = 1), a < o.childCount && (s = 1);
  }
  return null;
}
function D0(t, e, n) {
  let { $from: r, $to: i, depth: s } = e, o = r.before(s + 1), l = i.after(s + 1), a = o, c = l, d = w.empty, u = 0;
  for (let p = s, m = !1; p > n; p--)
    m || r.index(p) > 0 ? (m = !0, d = w.from(r.node(p).copy(d)), u++) : a--;
  let h = w.empty, f = 0;
  for (let p = s, m = !1; p > n; p--)
    m || i.after(p + 1) < i.end(p) ? (m = !0, h = w.from(i.node(p).copy(h)), f++) : c++;
  t.step(new fe(a, c, o, l, new A(d.append(h), u, f), d.size - u, !0));
}
function Po(t, e, n = null, r = t) {
  let i = P0(t, e), s = i && z0(r, e);
  return s ? i.map(Hl).concat({ type: e, attrs: n }).concat(s.map(Hl)) : null;
}
function Hl(t) {
  return { type: t, attrs: null };
}
function P0(t, e) {
  let { parent: n, startIndex: r, endIndex: i } = t, s = n.contentMatchAt(r).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return n.canReplaceWith(r, i, o) ? s : null;
}
function z0(t, e) {
  let { parent: n, startIndex: r, endIndex: i } = t, s = n.child(r), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let a = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let c = r; a && c < i; c++)
    a = a.matchType(n.child(c).type);
  return !a || !a.validEnd ? null : o;
}
function B0(t, e, n) {
  let r = w.empty;
  for (let o = n.length - 1; o >= 0; o--) {
    if (r.size) {
      let l = n[o].type.contentMatch.matchFragment(r);
      if (!l || !l.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = w.from(n[o].type.create(n[o].attrs, r));
  }
  let i = e.start, s = e.end;
  t.step(new fe(i, s, i, s, new A(r, 0, 0), n.length, !0));
}
function $0(t, e, n, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = t.steps.length;
  t.doc.nodesBetween(e, n, (o, l) => {
    let a = typeof i == "function" ? i(o) : i;
    if (o.isTextblock && !o.hasMarkup(r, a) && H0(t.doc, t.mapping.slice(s).map(l), r)) {
      let c = null;
      if (r.schema.linebreakReplacement) {
        let f = r.whitespace == "pre", p = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        f && !p ? c = !1 : !f && p && (c = !0);
      }
      c === !1 && Yc(t, o, l, s), Do(t, t.mapping.slice(s).map(l, 1), r, void 0, c === null);
      let d = t.mapping.slice(s), u = d.map(l, 1), h = d.map(l + o.nodeSize, 1);
      return t.step(new fe(u, h, u + 1, h - 1, new A(w.from(r.create(a, null, o.marks)), 0, 0), 1, !0)), c === !0 && Qc(t, o, l, s), !1;
    }
  });
}
function Qc(t, e, n, r) {
  e.forEach((i, s) => {
    if (i.isText) {
      let o, l = /\r?\n|\r/g;
      for (; o = l.exec(i.text); ) {
        let a = t.mapping.slice(r).map(n + 1 + s + o.index);
        t.replaceWith(a, a + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function Yc(t, e, n, r) {
  e.forEach((i, s) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let o = t.mapping.slice(r).map(n + 1 + s);
      t.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function H0(t, e, n) {
  let r = t.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, n);
}
function V0(t, e, n, r, i) {
  let s = t.doc.nodeAt(e);
  if (!s)
    throw new RangeError("No node at given position");
  n || (n = s.type);
  let o = n.create(r, null, i || s.marks);
  if (s.isLeaf)
    return t.replaceWith(e, e + s.nodeSize, o);
  if (!n.validContent(s.content))
    throw new RangeError("Invalid content for node type " + n.name);
  t.step(new fe(e, e + s.nodeSize, e + 1, e + s.nodeSize - 1, new A(w.from(o), 0, 0), 1, !0));
}
function xt(t, e, n = 1, r) {
  let i = t.resolve(e), s = i.depth - n, o = r && r[r.length - 1] || i.parent;
  if (s < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let c = i.depth - 1, d = n - 2; c > s; c--, d--) {
    let u = i.node(c), h = i.index(c);
    if (u.type.spec.isolating)
      return !1;
    let f = u.content.cutByIndex(h, u.childCount), p = r && r[d + 1];
    p && (f = f.replaceChild(0, p.type.create(p.attrs)));
    let m = r && r[d] || u;
    if (!u.canReplace(h + 1, u.childCount) || !m.type.validContent(f))
      return !1;
  }
  let l = i.indexAfter(s), a = r && r[0];
  return i.node(s).canReplaceWith(l, l, a ? a.type : i.node(s + 1).type);
}
function F0(t, e, n = 1, r) {
  let i = t.doc.resolve(e), s = w.empty, o = w.empty;
  for (let l = i.depth, a = i.depth - n, c = n - 1; l > a; l--, c--) {
    s = w.from(i.node(l).copy(s));
    let d = r && r[c];
    o = w.from(d ? d.type.create(d.attrs, o) : i.node(l).copy(o));
  }
  t.step(new le(e, e, new A(s.append(o), n, n), !0));
}
function jt(t, e) {
  let n = t.resolve(e), r = n.index();
  return Xc(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function W0(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: r } = t.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let s = e.child(i), o = s.type == r ? t.type.schema.nodes.text : s.type;
    if (n = n.matchType(o), !n || !t.type.allowsMarks(s.marks))
      return !1;
  }
  return n.validEnd;
}
function Xc(t, e) {
  return !!(t && e && !t.isLeaf && W0(t, e));
}
function qi(t, e, n = -1) {
  let r = t.resolve(e);
  for (let i = r.depth; ; i--) {
    let s, o, l = r.index(i);
    if (i == r.depth ? (s = r.nodeBefore, o = r.nodeAfter) : n > 0 ? (s = r.node(i + 1), l++, o = r.node(i).maybeChild(l)) : (s = r.node(i).maybeChild(l - 1), o = r.node(i + 1)), s && !s.isTextblock && Xc(s, o) && r.node(i).canReplace(l, l + 1))
      return e;
    if (i == 0)
      break;
    e = n < 0 ? r.before(i) : r.after(i);
  }
}
function q0(t, e, n) {
  let r = null, { linebreakReplacement: i } = t.doc.type.schema, s = t.doc.resolve(e - n), o = s.node().type;
  if (i && o.inlineContent) {
    let d = o.whitespace == "pre", u = !!o.contentMatch.matchType(i);
    d && !u ? r = !1 : !d && u && (r = !0);
  }
  let l = t.steps.length;
  if (r === !1) {
    let d = t.doc.resolve(e + n);
    Yc(t, d.node(), d.before(), l);
  }
  o.inlineContent && Do(t, e + n - 1, o, s.node().contentMatchAt(s.index()), r == null);
  let a = t.mapping.slice(l), c = a.map(e - n);
  if (t.step(new le(c, a.map(e + n, -1), A.empty, !0)), r === !0) {
    let d = t.doc.resolve(c);
    Qc(t, d.node(), d.before(), t.steps.length);
  }
  return t;
}
function j0(t, e, n) {
  let r = t.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.index(i);
      if (r.node(i).canReplaceWith(s, s, n))
        return r.before(i + 1);
      if (s > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.indexAfter(i);
      if (r.node(i).canReplaceWith(s, s, n))
        return r.after(i + 1);
      if (s < r.node(i).childCount)
        return null;
    }
  return null;
}
function ed(t, e, n) {
  let r = t.resolve(e);
  if (!n.content.size)
    return e;
  let i = n.content;
  for (let s = 0; s < n.openStart; s++)
    i = i.firstChild.content;
  for (let s = 1; s <= (n.openStart == 0 && n.size ? 2 : 1); s++)
    for (let o = r.depth; o >= 0; o--) {
      let l = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, a = r.index(o) + (l > 0 ? 1 : 0), c = r.node(o), d = !1;
      if (s == 1)
        d = c.canReplace(a, a, i);
      else {
        let u = c.contentMatchAt(a).findWrapping(i.firstChild.type);
        d = u && c.canReplaceWith(a, a, u[0]);
      }
      if (d)
        return l == 0 ? r.pos : l < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function ji(t, e, n = e, r = A.empty) {
  if (e == n && !r.size)
    return null;
  let i = t.resolve(e), s = t.resolve(n);
  return td(i, s, r) ? new le(e, n, r) : new U0(i, s, r).fit();
}
function td(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class U0 {
  constructor(e, n, r) {
    this.$from = e, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = w.empty;
    for (let i = 0; i <= e.depth; i++) {
      let s = e.node(i);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = w.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let s = this.placed, o = r.depth, l = i.depth;
    for (; o && l && s.childCount == 1; )
      s = s.firstChild.content, o--, l--;
    let a = new A(s, o, l);
    return e > -1 ? new fe(r.pos, e, this.$to.pos, this.$to.end(), a, n) : a.size || r.pos != this.$to.pos ? new le(r.pos, i.pos, a) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let s = n.firstChild;
      if (n.childCount > 1 && (i = 0), s.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      n = s.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, s = null;
        r ? (s = ms(this.unplaced.content, r - 1).firstChild, i = s.content) : i = this.unplaced.content;
        let o = i.firstChild;
        for (let l = this.depth; l >= 0; l--) {
          let { type: a, match: c } = this.frontier[l], d, u = null;
          if (n == 1 && (o ? c.matchType(o.type) || (u = c.fillBefore(w.from(o), !1)) : s && a.compatibleContent(s.type)))
            return { sliceDepth: r, frontierDepth: l, parent: s, inject: u };
          if (n == 2 && o && (d = c.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: l, parent: s, wrap: d };
          if (s && c.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, i = ms(e, n);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new A(e, n + 1, Math.max(r, i.size + n >= e.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: r } = this.unplaced, i = ms(e, n);
    if (i.childCount <= 1 && n > 0) {
      let s = e.size - n <= n + i.size;
      this.unplaced = new A(jn(e, n - 1, 1), n - 1, s ? n - 1 : r);
    } else
      this.unplaced = new A(jn(e, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: r, inject: i, wrap: s }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (s)
      for (let m = 0; m < s.length; m++)
        this.openFrontierNode(s[m]);
    let o = this.unplaced, l = r ? r.content : o.content, a = o.openStart - e, c = 0, d = [], { match: u, type: h } = this.frontier[n];
    if (i) {
      for (let m = 0; m < i.childCount; m++)
        d.push(i.child(m));
      u = u.matchFragment(i);
    }
    let f = l.size + e - (o.content.size - o.openEnd);
    for (; c < l.childCount; ) {
      let m = l.child(c), g = u.matchType(m.type);
      if (!g)
        break;
      c++, (c > 1 || a == 0 || m.content.size) && (u = g, d.push(nd(m.mark(h.allowedMarks(m.marks)), c == 1 ? a : 0, c == l.childCount ? f : -1)));
    }
    let p = c == l.childCount;
    p || (f = -1), this.placed = Un(this.placed, n, w.from(d)), this.frontier[n].match = u, p && f < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, g = l; m < f; m++) {
      let b = g.lastChild;
      this.frontier.push({ type: b.type, match: b.contentMatchAt(b.childCount) }), g = b.content;
    }
    this.unplaced = p ? e == 0 ? A.empty : new A(jn(o.content, e - 1, 1), e - 1, f < 0 ? o.openEnd : e - 1) : new A(jn(o.content, e, c), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !gs(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
      let { match: r, type: i } = this.frontier[n], s = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), o = gs(e, n, i, r, s);
      if (o) {
        for (let l = n - 1; l >= 0; l--) {
          let { match: a, type: c } = this.frontier[l], d = gs(e, l, c, a, !0);
          if (!d || d.childCount)
            continue e;
        }
        return { depth: n, fit: o, move: s ? e.doc.resolve(e.after(n + 1)) : e };
      }
    }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Un(this.placed, n.depth, n.fit)), e = n.move;
    for (let r = n.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), s = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, n = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Un(this.placed, this.depth, w.from(e.create(n, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(w.empty, !0);
    n.childCount && (this.placed = Un(this.placed, this.frontier.length, n));
  }
}
function jn(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(jn(t.firstChild.content, e - 1, n)));
}
function Un(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(Un(t.lastChild.content, e - 1, n)));
}
function ms(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function nd(t, e, n) {
  if (e <= 0)
    return t;
  let r = t.content;
  return e > 1 && (r = r.replaceChild(0, nd(r.firstChild, e - 1, r.childCount == 1 ? n - 1 : 0))), e > 0 && (r = t.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(t.type.contentMatch.matchFragment(r).fillBefore(w.empty, !0)))), t.copy(r);
}
function gs(t, e, n, r, i) {
  let s = t.node(e), o = i ? t.indexAfter(e) : t.index(e);
  if (o == s.childCount && !n.compatibleContent(s.type))
    return null;
  let l = r.fillBefore(s.content, !0, o);
  return l && !K0(n, s.content, o) ? l : null;
}
function K0(t, e, n) {
  for (let r = n; r < e.childCount; r++)
    if (!t.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function Z0(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function G0(t, e, n, r) {
  if (!r.size)
    return t.deleteRange(e, n);
  let i = t.doc.resolve(e), s = t.doc.resolve(n);
  if (td(i, s, r))
    return t.step(new le(e, n, r));
  let o = id(i, s);
  o[o.length - 1] == 0 && o.pop();
  let l = -(i.depth + 1);
  o.unshift(l);
  for (let h = i.depth, f = i.pos - 1; h > 0; h--, f--) {
    let p = i.node(h).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    o.indexOf(h) > -1 ? l = h : i.before(h) == f && o.splice(1, 0, -h);
  }
  let a = o.indexOf(l), c = [], d = r.openStart;
  for (let h = r.content, f = 0; ; f++) {
    let p = h.firstChild;
    if (c.push(p), f == r.openStart)
      break;
    h = p.content;
  }
  for (let h = d - 1; h >= 0; h--) {
    let f = c[h], p = Z0(f.type);
    if (p && !f.sameMarkup(i.node(Math.abs(l) - 1)))
      d = h;
    else if (p || !f.type.isTextblock)
      break;
  }
  for (let h = r.openStart; h >= 0; h--) {
    let f = (h + d + 1) % (r.openStart + 1), p = c[f];
    if (p)
      for (let m = 0; m < o.length; m++) {
        let g = o[(m + a) % o.length], b = !0;
        g < 0 && (b = !1, g = -g);
        let k = i.node(g - 1), C = i.index(g - 1);
        if (k.canReplaceWith(C, C, p.type, p.marks))
          return t.replace(i.before(g), b ? s.after(g) : n, new A(rd(r.content, 0, r.openStart, f), f, r.openEnd));
      }
  }
  let u = t.steps.length;
  for (let h = o.length - 1; h >= 0 && (t.replace(e, n, r), !(t.steps.length > u)); h--) {
    let f = o[h];
    f < 0 || (e = i.before(f), n = s.after(f));
  }
}
function rd(t, e, n, r, i) {
  if (e < n) {
    let s = t.firstChild;
    t = t.replaceChild(0, s.copy(rd(s.content, e + 1, n, r, s)));
  }
  if (e > r) {
    let s = i.contentMatchAt(0), o = s.fillBefore(t).append(t);
    t = o.append(s.matchFragment(o).fillBefore(w.empty, !0));
  }
  return t;
}
function J0(t, e, n, r) {
  if (!r.isInline && e == n && t.doc.resolve(e).parent.content.size) {
    let i = j0(t.doc, e, r.type);
    i != null && (e = n = i);
  }
  t.replaceRange(e, n, new A(w.from(r), 0, 0));
}
function Q0(t, e, n) {
  let r = t.doc.resolve(e), i = t.doc.resolve(n);
  if (r.parent.isTextblock && i.parent.isTextblock && r.start() != i.start() && r.parentOffset == 0 && i.parentOffset == 0) {
    let o = r.sharedDepth(n), l = !1;
    for (let a = r.depth; a > o; a--)
      r.node(a).type.spec.isolating && (l = !0);
    for (let a = i.depth; a > o; a--)
      i.node(a).type.spec.isolating && (l = !0);
    if (!l) {
      for (let a = r.depth; a > 0 && e == r.start(a); a--)
        e = r.before(a);
      for (let a = i.depth; a > 0 && n == i.start(a); a--)
        n = i.before(a);
      r = t.doc.resolve(e), i = t.doc.resolve(n);
    }
  }
  let s = id(r, i);
  for (let o = 0; o < s.length; o++) {
    let l = s[o], a = o == s.length - 1;
    if (a && l == 0 || r.node(l).type.contentMatch.validEnd)
      return t.delete(r.start(l), i.end(l));
    if (l > 0 && (a || r.node(l - 1).canReplace(r.index(l - 1), i.indexAfter(l - 1))))
      return t.delete(r.before(l), i.after(l));
  }
  for (let o = 1; o <= r.depth && o <= i.depth; o++)
    if (e - r.start(o) == r.depth - o && n > r.end(o) && i.end(o) - n != i.depth - o && r.start(o - 1) == i.start(o - 1) && r.node(o - 1).canReplace(r.index(o - 1), i.index(o - 1)))
      return t.delete(r.before(o), n);
  t.delete(e, n);
}
function id(t, e) {
  let n = [], r = Math.min(t.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let s = t.start(i);
    if (s < t.pos - (t.depth - i) || e.end(i) > e.pos + (e.depth - i) || t.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (s == e.start(i) || i == t.depth && i == e.depth && t.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == s - 1) && n.push(i);
  }
  return n;
}
class An extends Me {
  /**
  Construct an attribute step.
  */
  constructor(e, n, r) {
    super(), this.pos = e, this.attr = n, this.value = r;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return ae.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let s in n.attrs)
      r[s] = n.attrs[s];
    r[this.attr] = this.value;
    let i = n.type.create(r, null, n.marks);
    return ae.fromReplace(e, this.pos, this.pos + 1, new A(w.from(i), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return De.empty;
  }
  invert(e) {
    return new An(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new An(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new An(n.pos, n.attr, n.value);
  }
}
Me.jsonID("attr", An);
class ur extends Me {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      n[i] = e.attrs[i];
    n[this.attr] = this.value;
    let r = e.type.create(n, e.content, e.marks);
    return ae.ok(r);
  }
  getMap() {
    return De.empty;
  }
  invert(e) {
    return new ur(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new ur(n.attr, n.value);
  }
}
Me.jsonID("docAttr", ur);
let _n = class extends Error {
};
_n = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
_n.prototype = Object.create(Error.prototype);
_n.prototype.constructor = _n;
_n.prototype.name = "TransformError";
class zo {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new dr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let n = this.maybeStep(e);
    if (n.failed)
      throw new _n(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let n = e.apply(this.doc);
    return n.failed || this.addStep(e, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let e = 1e9, n = -1e9;
    for (let r = 0; r < this.mapping.maps.length; r++) {
      let i = this.mapping.maps[r];
      r && (e = i.map(e, 1), n = i.map(n, -1)), i.forEach((s, o, l, a) => {
        e = Math.min(e, l), n = Math.max(n, a);
      });
    }
    return e == 1e9 ? null : { from: e, to: n };
  }
  /**
  @internal
  */
  addStep(e, n) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, n = e, r = A.empty) {
    let i = ji(this.doc, e, n, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, n, r) {
    return this.replace(e, n, new A(w.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, n) {
    return this.replace(e, n, A.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, n) {
    return this.replaceWith(e, e, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, n, r) {
    return G0(this, e, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, n, r) {
    return J0(this, e, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, n) {
    return Q0(this, e, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, n) {
    return D0(this, e, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, n = 1) {
    return q0(this, e, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, n) {
    return B0(this, e, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, n = e, r, i = null) {
    return $0(this, e, n, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, n, r = null, i) {
    return V0(this, e, n, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, n, r) {
    return this.step(new An(e, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, n) {
    return this.step(new ur(e, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, n) {
    return this.step(new Bt(e, n)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, n) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (n instanceof K)
      n.isInSet(r.marks) && this.step(new dn(e, n));
    else {
      let i = r.marks, s, o = [];
      for (; s = n.isInSet(i); )
        o.push(new dn(e, s)), i = s.removeFromSet(i);
      for (let l = o.length - 1; l >= 0; l--)
        this.step(o[l]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, n = 1, r) {
    return F0(this, e, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, n, r) {
    return R0(this, e, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, n, r) {
    return I0(this, e, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, n, r) {
    return Do(this, e, n, r), this;
  }
}
const ys = /* @__PURE__ */ Object.create(null);
class z {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, r) {
    this.$anchor = e, this.$head = n, this.ranges = r || [new sd(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = A.empty) {
    let r = n.content.lastChild, i = null;
    for (let l = 0; l < n.openEnd; l++)
      i = r, r = r.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let l = 0; l < o.length; l++) {
      let { $from: a, $to: c } = o[l], d = e.mapping.slice(s);
      e.replaceRange(d.map(a.pos), d.map(c.pos), l ? A.empty : n), l == 0 && Wl(e, s, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let r = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      let { $from: o, $to: l } = i[s], a = e.mapping.slice(r), c = a.map(o.pos), d = a.map(l.pos);
      s ? e.deleteRange(c, d) : (e.replaceRangeWith(c, d, n), Wl(e, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, r = !1) {
    let i = e.parent.inlineContent ? new I(e) : Sn(e.node(0), e.parent, e.pos, e.index(), n, r);
    if (i)
      return i;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = n < 0 ? Sn(e.node(0), e.node(s), e.before(s + 1), e.index(s), n, r) : Sn(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, n, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new ze(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Sn(e, e, 0, 0, 1) || new ze(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Sn(e, e, e.content.size, e.childCount, -1) || new ze(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = ys[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in ys)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return ys[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return I.between(this.$anchor, this.$head).getBookmark();
  }
}
z.prototype.visible = !0;
class sd {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let Vl = !1;
function Fl(t) {
  !Vl && !t.parent.inlineContent && (Vl = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class I extends z {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    Fl(e), Fl(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return z.near(r);
    let i = e.resolve(n.map(this.anchor));
    return new I(i.parent.inlineContent ? i : r, r);
  }
  replace(e, n = A.empty) {
    if (super.replace(e, n), n == A.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof I && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Ui(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new I(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, r = n) {
    let i = e.resolve(n);
    return new this(i, r == n ? i : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, r) {
    let i = e.pos - n.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let s = z.findFrom(n, r, !0) || z.findFrom(n, -r, !0);
      if (s)
        n = s.$head;
      else
        return z.near(n, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = n : (e = (z.findFrom(e, -r, !0) || z.findFrom(e, r, !0)).$anchor, e.pos < n.pos != i < 0 && (e = n))), new I(e, n);
  }
}
z.jsonID("text", I);
class Ui {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new Ui(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return I.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class L extends z {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, r = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, r), this.node = n;
  }
  map(e, n) {
    let { deleted: r, pos: i } = n.mapResult(this.anchor), s = e.resolve(i);
    return r ? z.near(s) : new L(s);
  }
  content() {
    return new A(w.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof L && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Bo(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new L(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new L(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
L.prototype.visible = !1;
z.jsonID("node", L);
class Bo {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: r } = e.mapResult(this.anchor);
    return n ? new Ui(r, r) : new Bo(r);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), r = n.nodeAfter;
    return r && L.isSelectable(r) ? new L(n) : z.near(n);
  }
}
class ze extends z {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = A.empty) {
    if (n == A.empty) {
      e.delete(0, e.doc.content.size);
      let r = z.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new ze(e);
  }
  map(e) {
    return new ze(e);
  }
  eq(e) {
    return e instanceof ze;
  }
  getBookmark() {
    return Y0;
  }
}
z.jsonID("all", ze);
const Y0 = {
  map() {
    return this;
  },
  resolve(t) {
    return new ze(t);
  }
};
function Sn(t, e, n, r, i, s = !1) {
  if (e.inlineContent)
    return I.create(t, n);
  for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < e.childCount : o >= 0; o += i) {
    let l = e.child(o);
    if (l.isAtom) {
      if (!s && L.isSelectable(l))
        return L.create(t, n - (i < 0 ? l.nodeSize : 0));
    } else {
      let a = Sn(t, l, n + i, i < 0 ? l.childCount : 0, i, s);
      if (a)
        return a;
    }
    n += l.nodeSize * i;
  }
  return null;
}
function Wl(t, e, n) {
  let r = t.steps.length - 1;
  if (r < e)
    return;
  let i = t.steps[r];
  if (!(i instanceof le || i instanceof fe))
    return;
  let s = t.mapping.maps[r], o;
  s.forEach((l, a, c, d) => {
    o == null && (o = d);
  }), t.setSelection(z.near(t.doc.resolve(o), n));
}
const ql = 1, _r = 2, jl = 4;
class X0 extends zo {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | ql) & ~_r, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & ql) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= _r, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return K.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & _r) > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    super.addStep(e, n), this.updated = this.updated & ~_r, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, n = !0) {
    let r = this.selection;
    return n && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || K.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, n, r) {
    let i = this.doc.type.schema;
    if (n == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), !e)
        return this.deleteRange(n, r);
      let s = this.storedMarks;
      if (!s) {
        let o = this.doc.resolve(n);
        s = r == n ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, i.text(e, s)), !this.selection.empty && this.selection.to == n + e.length && this.setSelection(z.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, n) {
    return this.meta[typeof e == "string" ? e : e.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= jl, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & jl) > 0;
  }
}
function Ul(t, e) {
  return !e || !t ? t : t.bind(e);
}
class Kn {
  constructor(e, n, r) {
    this.name = e, this.init = Ul(n.init, r), this.apply = Ul(n.apply, r);
  }
}
const ey = [
  new Kn("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new Kn("selection", {
    init(t, e) {
      return t.selection || z.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new Kn("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, n, r) {
      return r.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new Kn("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class bs {
  constructor(e, n) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = ey.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Kn(r.key, r.spec.state, r));
    });
  }
}
class En {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let n = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let s = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let l = this.config.plugins[o];
        if (l.spec.appendTransaction) {
          let a = i ? i[o].n : 0, c = i ? i[o].state : this, d = a < n.length && l.spec.appendTransaction.call(l, a ? n.slice(a) : n, c, r);
          if (d && r.filterTransaction(d, o)) {
            if (d.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let u = 0; u < this.config.plugins.length; u++)
                i.push(u < o ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(d), r = r.applyInner(d), s = !0;
          }
          i && (i[o] = { state: r, n: n.length });
        }
      }
      if (!s)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new En(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let s = r[i];
      n[s.name] = s.apply(e, this[s.name], this, n);
    }
    return n;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new X0(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let n = new bs(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new En(n);
    for (let i = 0; i < n.fields.length; i++)
      r[n.fields[i].name] = n.fields[i].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let n = new bs(this.schema, e.plugins), r = n.fields, i = new En(n);
    for (let s = 0; s < r.length; s++) {
      let o = r[s].name;
      i[o] = this.hasOwnProperty(o) ? this[o] : r[s].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], s = i.spec.state;
        s && s.toJSON && (n[r] = s.toJSON.call(i, this[i.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new bs(e.schema, e.plugins), s = new En(i);
    return i.fields.forEach((o) => {
      if (o.name == "doc")
        s.doc = Qe.fromJSON(e.schema, n.doc);
      else if (o.name == "selection")
        s.selection = z.fromJSON(s.doc, n.selection);
      else if (o.name == "storedMarks")
        n.storedMarks && (s.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let l in r) {
            let a = r[l], c = a.spec.state;
            if (a.key == o.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(n, l)) {
              s[o.name] = c.fromJSON.call(a, e, n[l], s);
              return;
            }
          }
        s[o.name] = o.init(e, s);
      }
    }), s;
  }
}
function od(t, e, n) {
  for (let r in t) {
    let i = t[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = od(i, e, {})), n[r] = i;
  }
  return n;
}
class Y {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && od(e.props, this, this.props), this.key = e.key ? e.key.key : ld("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const ks = /* @__PURE__ */ Object.create(null);
function ld(t) {
  return t in ks ? t + "$" + ++ks[t] : (ks[t] = 0, t + "$");
}
class se {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = ld(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const $o = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function ad(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const cd = (t, e, n) => {
  let r = ad(t, n);
  if (!r)
    return !1;
  let i = Ho(r);
  if (!i) {
    let o = r.blockRange(), l = o && zn(o);
    return l == null ? !1 : (e && e(t.tr.lift(o, l).scrollIntoView()), !0);
  }
  let s = i.nodeBefore;
  if (bd(t, i, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (On(s, "end") || L.isSelectable(s)))
    for (let o = r.depth; ; o--) {
      let l = ji(t.doc, r.before(o), r.after(o), A.empty);
      if (l && l.slice.size < l.to - l.from) {
        if (e) {
          let a = t.tr.step(l);
          a.setSelection(On(s, "end") ? z.findFrom(a.doc.resolve(a.mapping.map(i.pos, -1)), -1) : L.create(a.doc, i.pos - s.nodeSize)), e(a.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(t.tr.delete(i.pos - s.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, ty = (t, e, n) => {
  let r = ad(t, n);
  if (!r)
    return !1;
  let i = Ho(r);
  return i ? dd(t, i, e) : !1;
}, ny = (t, e, n) => {
  let r = hd(t, n);
  if (!r)
    return !1;
  let i = Vo(r);
  return i ? dd(t, i, e) : !1;
};
function dd(t, e, n) {
  let r = e.nodeBefore, i = r, s = e.pos - 1;
  for (; !i.isTextblock; s--) {
    if (i.type.spec.isolating)
      return !1;
    let d = i.lastChild;
    if (!d)
      return !1;
    i = d;
  }
  let o = e.nodeAfter, l = o, a = e.pos + 1;
  for (; !l.isTextblock; a++) {
    if (l.type.spec.isolating)
      return !1;
    let d = l.firstChild;
    if (!d)
      return !1;
    l = d;
  }
  let c = ji(t.doc, s, a, A.empty);
  if (!c || c.from != s || c instanceof le && c.slice.size >= a - s)
    return !1;
  if (n) {
    let d = t.tr.step(c);
    d.setSelection(I.create(d.doc, s)), n(d.scrollIntoView());
  }
  return !0;
}
function On(t, e, n = !1) {
  for (let r = t; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const ud = (t, e, n) => {
  let { $head: r, empty: i } = t.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : r.parentOffset > 0)
      return !1;
    s = Ho(r);
  }
  let o = s && s.nodeBefore;
  return !o || !L.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(L.create(t.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function Ho(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function hd(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const fd = (t, e, n) => {
  let r = hd(t, n);
  if (!r)
    return !1;
  let i = Vo(r);
  if (!i)
    return !1;
  let s = i.nodeAfter;
  if (bd(t, i, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (On(s, "start") || L.isSelectable(s))) {
    let o = ji(t.doc, r.before(), r.after(), A.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let l = t.tr.step(o);
        l.setSelection(On(s, "start") ? z.findFrom(l.doc.resolve(l.mapping.map(i.pos)), 1) : L.create(l.doc, l.mapping.map(i.pos))), e(l.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(t.tr.delete(i.pos, i.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, pd = (t, e, n) => {
  let { $head: r, empty: i } = t.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size)
      return !1;
    s = Vo(r);
  }
  let o = s && s.nodeAfter;
  return !o || !L.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(L.create(t.doc, s.pos)).scrollIntoView()), !0);
};
function Vo(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const ry = (t, e) => {
  let n = t.selection, r = n instanceof L, i;
  if (r) {
    if (n.node.isTextblock || !jt(t.doc, n.from))
      return !1;
    i = n.from;
  } else if (i = qi(t.doc, n.from, -1), i == null)
    return !1;
  if (e) {
    let s = t.tr.join(i);
    r && s.setSelection(L.create(s.doc, i - t.doc.resolve(i).nodeBefore.nodeSize)), e(s.scrollIntoView());
  }
  return !0;
}, iy = (t, e) => {
  let n = t.selection, r;
  if (n instanceof L) {
    if (n.node.isTextblock || !jt(t.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = qi(t.doc, n.to, 1), r == null)
    return !1;
  return e && e(t.tr.join(r).scrollIntoView()), !0;
}, sy = (t, e) => {
  let { $from: n, $to: r } = t.selection, i = n.blockRange(r), s = i && zn(i);
  return s == null ? !1 : (e && e(t.tr.lift(i, s).scrollIntoView()), !0);
}, md = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function Fo(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const oy = (t, e) => {
  let { $head: n, $anchor: r } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let i = n.node(-1), s = n.indexAfter(-1), o = Fo(i.contentMatchAt(s));
  if (!o || !i.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let l = n.after(), a = t.tr.replaceWith(l, l, o.createAndFill());
    a.setSelection(z.near(a.doc.resolve(l), 1)), e(a.scrollIntoView());
  }
  return !0;
}, gd = (t, e) => {
  let n = t.selection, { $from: r, $to: i } = n;
  if (n instanceof ze || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let s = Fo(i.parent.contentMatchAt(i.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, l = t.tr.insert(o, s.createAndFill());
    l.setSelection(I.create(l.doc, o + 1)), e(l.scrollIntoView());
  }
  return !0;
}, yd = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let s = n.before();
    if (xt(t.doc, s))
      return e && e(t.tr.split(s).scrollIntoView()), !0;
  }
  let r = n.blockRange(), i = r && zn(r);
  return i == null ? !1 : (e && e(t.tr.lift(r, i).scrollIntoView()), !0);
};
function ly(t) {
  return (e, n) => {
    let { $from: r, $to: i } = e.selection;
    if (e.selection instanceof L && e.selection.node.isBlock)
      return !r.parentOffset || !xt(e.doc, r.pos) ? !1 : (n && n(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let s = [], o, l, a = !1, c = !1;
    for (let f = r.depth; ; f--)
      if (r.node(f).isBlock) {
        a = r.end(f) == r.pos + (r.depth - f), c = r.start(f) == r.pos - (r.depth - f), l = Fo(r.node(f - 1).contentMatchAt(r.indexAfter(f - 1))), s.unshift(a && l ? { type: l } : null), o = f;
        break;
      } else {
        if (f == 1)
          return !1;
        s.unshift(null);
      }
    let d = e.tr;
    (e.selection instanceof I || e.selection instanceof ze) && d.deleteSelection();
    let u = d.mapping.map(r.pos), h = xt(d.doc, u, s.length, s);
    if (h || (s[0] = l ? { type: l } : null, h = xt(d.doc, u, s.length, s)), !h)
      return !1;
    if (d.split(u, s.length, s), !a && c && r.node(o).type != l) {
      let f = d.mapping.map(r.before(o)), p = d.doc.resolve(f);
      l && r.node(o - 1).canReplaceWith(p.index(), p.index() + 1, l) && d.setNodeMarkup(d.mapping.map(r.before(o)), l);
    }
    return n && n(d.scrollIntoView()), !0;
  };
}
const ay = ly(), cy = (t, e) => {
  let { $from: n, to: r } = t.selection, i, s = n.sharedDepth(r);
  return s == 0 ? !1 : (i = n.before(s), e && e(t.tr.setSelection(L.create(t.doc, i))), !0);
};
function dy(t, e, n) {
  let r = e.nodeBefore, i = e.nodeAfter, s = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(s - 1, s) ? (n && n(t.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(i.isTextblock || jt(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function bd(t, e, n, r) {
  let i = e.nodeBefore, s = e.nodeAfter, o, l, a = i.type.spec.isolating || s.type.spec.isolating;
  if (!a && dy(t, e, n))
    return !0;
  let c = !a && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (o = (l = i.contentMatchAt(i.childCount)).findWrapping(s.type)) && l.matchType(o[0] || s.type).validEnd) {
    if (n) {
      let f = e.pos + s.nodeSize, p = w.empty;
      for (let b = o.length - 1; b >= 0; b--)
        p = w.from(o[b].create(null, p));
      p = w.from(i.copy(p));
      let m = t.tr.step(new fe(e.pos - 1, f, e.pos, f, new A(p, 1, 0), o.length, !0)), g = m.doc.resolve(f + 2 * o.length);
      g.nodeAfter && g.nodeAfter.type == i.type && jt(m.doc, g.pos) && m.join(g.pos), n(m.scrollIntoView());
    }
    return !0;
  }
  let d = s.type.spec.isolating || r > 0 && a ? null : z.findFrom(e, 1), u = d && d.$from.blockRange(d.$to), h = u && zn(u);
  if (h != null && h >= e.depth)
    return n && n(t.tr.lift(u, h).scrollIntoView()), !0;
  if (c && On(s, "start", !0) && On(i, "end")) {
    let f = i, p = [];
    for (; p.push(f), !f.isTextblock; )
      f = f.lastChild;
    let m = s, g = 1;
    for (; !m.isTextblock; m = m.firstChild)
      g++;
    if (f.canReplace(f.childCount, f.childCount, m.content)) {
      if (n) {
        let b = w.empty;
        for (let C = p.length - 1; C >= 0; C--)
          b = w.from(p[C].copy(b));
        let k = t.tr.step(new fe(e.pos - p.length, e.pos + s.nodeSize, e.pos + g, e.pos + s.nodeSize - g, new A(b, p.length, 0), 0, !0));
        n(k.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function kd(t) {
  return function(e, n) {
    let r = e.selection, i = t < 0 ? r.$from : r.$to, s = i.depth;
    for (; i.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return i.node(s).isTextblock ? (n && n(e.tr.setSelection(I.create(e.doc, t < 0 ? i.start(s) : i.end(s)))), !0) : !1;
  };
}
const uy = kd(-1), hy = kd(1);
function fy(t, e = null) {
  return function(n, r) {
    let { $from: i, $to: s } = n.selection, o = i.blockRange(s), l = o && Po(o, t, e);
    return l ? (r && r(n.tr.wrap(o, l).scrollIntoView()), !0) : !1;
  };
}
function Kl(t, e = null) {
  return function(n, r) {
    let i = !1;
    for (let s = 0; s < n.selection.ranges.length && !i; s++) {
      let { $from: { pos: o }, $to: { pos: l } } = n.selection.ranges[s];
      n.doc.nodesBetween(o, l, (a, c) => {
        if (i)
          return !1;
        if (!(!a.isTextblock || a.hasMarkup(t, e)))
          if (a.type == t)
            i = !0;
          else {
            let d = n.doc.resolve(c), u = d.index();
            i = d.parent.canReplaceWith(u, u + 1, t);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let s = n.tr;
      for (let o = 0; o < n.selection.ranges.length; o++) {
        let { $from: { pos: l }, $to: { pos: a } } = n.selection.ranges[o];
        s.setBlockType(l, a, t, e);
      }
      r(s.scrollIntoView());
    }
    return !0;
  };
}
function Wo(...t) {
  return function(e, n, r) {
    for (let i = 0; i < t.length; i++)
      if (t[i](e, n, r))
        return !0;
    return !1;
  };
}
Wo($o, cd, ud);
Wo($o, fd, pd);
Wo(md, gd, yd, ay);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function py(t, e = null) {
  return function(n, r) {
    let { $from: i, $to: s } = n.selection, o = i.blockRange(s);
    if (!o)
      return !1;
    let l = r ? n.tr : null;
    return my(l, o, t, e) ? (r && r(l.scrollIntoView()), !0) : !1;
  };
}
function my(t, e, n, r = null) {
  let i = !1, s = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let a = o.resolve(e.start - 2);
    s = new ni(a, a, e.depth), e.endIndex < e.parent.childCount && (e = new ni(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let l = Po(s, n, r, e);
  return l ? (t && gy(t, e, l, i, n), !0) : !1;
}
function gy(t, e, n, r, i) {
  let s = w.empty;
  for (let d = n.length - 1; d >= 0; d--)
    s = w.from(n[d].type.create(n[d].attrs, s));
  t.step(new fe(e.start - (r ? 2 : 0), e.end, e.start, e.end, new A(s, 0, 0), n.length, !0));
  let o = 0;
  for (let d = 0; d < n.length; d++)
    n[d].type == i && (o = d + 1);
  let l = n.length - o, a = e.start + n.length - (r ? 2 : 0), c = e.parent;
  for (let d = e.startIndex, u = e.endIndex, h = !0; d < u; d++, h = !1)
    !h && xt(t.doc, a, l) && (t.split(a, l), a += 2 * l), a += c.child(d).nodeSize;
  return t;
}
function yy(t) {
  return function(e, n) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (o) => o.childCount > 0 && o.firstChild.type == t);
    return s ? n ? r.node(s.depth - 1).type == t ? by(e, n, t, s) : ky(e, n, s) : !0 : !1;
  };
}
function by(t, e, n, r) {
  let i = t.tr, s = r.end, o = r.$to.end(r.depth);
  s < o && (i.step(new fe(s - 1, o, s, o, new A(w.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new ni(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
  const l = zn(r);
  if (l == null)
    return !1;
  i.lift(r, l);
  let a = i.doc.resolve(i.mapping.map(s, -1) - 1);
  return jt(i.doc, a.pos) && a.nodeBefore.type == a.nodeAfter.type && i.join(a.pos), e(i.scrollIntoView()), !0;
}
function ky(t, e, n) {
  let r = t.tr, i = n.parent;
  for (let f = n.end, p = n.endIndex - 1, m = n.startIndex; p > m; p--)
    f -= i.child(p).nodeSize, r.delete(f - 1, f + 1);
  let s = r.doc.resolve(n.start), o = s.nodeAfter;
  if (r.mapping.map(n.end) != n.start + s.nodeAfter.nodeSize)
    return !1;
  let l = n.startIndex == 0, a = n.endIndex == i.childCount, c = s.node(-1), d = s.index(-1);
  if (!c.canReplace(d + (l ? 0 : 1), d + 1, o.content.append(a ? w.empty : w.from(i))))
    return !1;
  let u = s.pos, h = u + o.nodeSize;
  return r.step(new fe(u - (l ? 1 : 0), h + (a ? 1 : 0), u + 1, h - 1, new A((l ? w.empty : w.from(i.copy(w.empty))).append(a ? w.empty : w.from(i.copy(w.empty))), l ? 0 : 1, a ? 0 : 1), l ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function vy(t) {
  return function(e, n) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let l = s.parent, a = l.child(o - 1);
    if (a.type != t)
      return !1;
    if (n) {
      let c = a.lastChild && a.lastChild.type == l.type, d = w.from(c ? t.create() : null), u = new A(w.from(t.create(null, w.from(l.type.create(null, d)))), c ? 3 : 1, 0), h = s.start, f = s.end;
      n(e.tr.step(new fe(h - (c ? 3 : 1), f, h, f, u, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const ke = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, Rn = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Xs = null;
const kt = function(t, e, n) {
  let r = Xs || (Xs = document.createRange());
  return r.setEnd(t, n ?? t.nodeValue.length), r.setStart(t, e || 0), r;
}, Cy = function() {
  Xs = null;
}, un = function(t, e, n, r) {
  return n && (Zl(t, e, n, r, -1) || Zl(t, e, n, r, 1));
}, xy = /^(img|br|input|textarea|hr)$/i;
function Zl(t, e, n, r, i) {
  for (var s; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (i < 0 ? 0 : Fe(t))) {
      let o = t.parentNode;
      if (!o || o.nodeType != 1 || vr(t) || xy.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = ke(t) + (i < 0 ? 0 : 1), t = o;
    } else if (t.nodeType == 1) {
      let o = t.childNodes[e + (i < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((s = o.pmViewDesc) === null || s === void 0) && s.ignoreForSelection)
          e += i;
        else
          return !1;
      else
        t = o, e = i < 0 ? Fe(t) : 0;
    } else
      return !1;
  }
}
function Fe(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function wy(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = Fe(t);
    } else if (t.parentNode && !vr(t))
      e = ke(t), t = t.parentNode;
    else
      return null;
  }
}
function Sy(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !vr(t))
      e = ke(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function My(t, e, n) {
  for (let r = e == 0, i = e == Fe(t); r || i; ) {
    if (t == n)
      return !0;
    let s = ke(t);
    if (t = t.parentNode, !t)
      return !1;
    r = r && s == 0, i = i && s == Fe(t);
  }
}
function vr(t) {
  let e;
  for (let n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const Ki = function(t) {
  return t.focusNode && un(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function Qt(t, e) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function Ty(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Ey(t, e, n) {
  if (t.caretPositionFromPoint)
    try {
      let r = t.caretPositionFromPoint(e, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Fe(r.offsetNode), r.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let r = t.caretRangeFromPoint(e, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(Fe(r.startContainer), r.startOffset) };
  }
}
const at = typeof navigator < "u" ? navigator : null, Gl = typeof document < "u" ? document : null, Ut = at && at.userAgent || "", eo = /Edge\/(\d+)/.exec(Ut), vd = /MSIE \d/.exec(Ut), to = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ut), Oe = !!(vd || to || eo), Ht = vd ? document.documentMode : to ? +to[1] : eo ? +eo[1] : 0, We = !Oe && /gecko\/(\d+)/i.test(Ut);
We && +(/Firefox\/(\d+)/.exec(Ut) || [0, 0])[1];
const no = !Oe && /Chrome\/(\d+)/.exec(Ut), Ce = !!no, Cd = no ? +no[1] : 0, we = !Oe && !!at && /Apple Computer/.test(at.vendor), In = we && (/Mobile\/\w+/.test(Ut) || !!at && at.maxTouchPoints > 2), Ve = In || (at ? /Mac/.test(at.platform) : !1), xd = at ? /Win/.test(at.platform) : !1, vt = /Android \d/.test(Ut), Cr = !!Gl && "webkitFontSmoothing" in Gl.documentElement.style, Ay = Cr ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function Ny(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function pt(t, e) {
  return typeof t == "number" ? t : t[e];
}
function _y(t) {
  let e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, r = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * r
  };
}
function Jl(t, e, n) {
  let r = t.someProp("scrollThreshold") || 0, i = t.someProp("scrollMargin") || 5, s = t.dom.ownerDocument;
  for (let o = n || t.dom; o; ) {
    if (o.nodeType != 1) {
      o = Rn(o);
      continue;
    }
    let l = o, a = l == s.body, c = a ? Ny(s) : _y(l), d = 0, u = 0;
    if (e.top < c.top + pt(r, "top") ? u = -(c.top - e.top + pt(i, "top")) : e.bottom > c.bottom - pt(r, "bottom") && (u = e.bottom - e.top > c.bottom - c.top ? e.top + pt(i, "top") - c.top : e.bottom - c.bottom + pt(i, "bottom")), e.left < c.left + pt(r, "left") ? d = -(c.left - e.left + pt(i, "left")) : e.right > c.right - pt(r, "right") && (d = e.right - c.right + pt(i, "right")), d || u)
      if (a)
        s.defaultView.scrollBy(d, u);
      else {
        let f = l.scrollLeft, p = l.scrollTop;
        u && (l.scrollTop += u), d && (l.scrollLeft += d);
        let m = l.scrollLeft - f, g = l.scrollTop - p;
        e = { left: e.left - m, top: e.top - g, right: e.right - m, bottom: e.bottom - g };
      }
    let h = a ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(h))
      break;
    o = h == "absolute" ? o.offsetParent : Rn(o);
  }
}
function Oy(t) {
  let e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), r, i;
  for (let s = (e.left + e.right) / 2, o = n + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let l = t.root.elementFromPoint(s, o);
    if (!l || l == t.dom || !t.dom.contains(l))
      continue;
    let a = l.getBoundingClientRect();
    if (a.top >= n - 20) {
      r = l, i = a.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: wd(t.dom) };
}
function wd(t) {
  let e = [], n = t.ownerDocument;
  for (let r = t; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), t != n); r = Rn(r))
    ;
  return e;
}
function Ry({ refDOM: t, refTop: e, stack: n }) {
  let r = t ? t.getBoundingClientRect().top : 0;
  Sd(n, r == 0 ? 0 : r - e);
}
function Sd(t, e) {
  for (let n = 0; n < t.length; n++) {
    let { dom: r, top: i, left: s } = t[n];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != s && (r.scrollLeft = s);
  }
}
let xn = null;
function Iy(t) {
  if (t.setActive)
    return t.setActive();
  if (xn)
    return t.focus(xn);
  let e = wd(t);
  t.focus(xn == null ? {
    get preventScroll() {
      return xn = { preventScroll: !0 }, !0;
    }
  } : void 0), xn || (xn = !1, Sd(e, 0));
}
function Md(t, e) {
  let n, r = 2e8, i, s = 0, o = e.top, l = e.top, a, c;
  for (let d = t.firstChild, u = 0; d; d = d.nextSibling, u++) {
    let h;
    if (d.nodeType == 1)
      h = d.getClientRects();
    else if (d.nodeType == 3)
      h = kt(d).getClientRects();
    else
      continue;
    for (let f = 0; f < h.length; f++) {
      let p = h[f];
      if (p.top <= o && p.bottom >= l) {
        o = Math.max(p.bottom, o), l = Math.min(p.top, l);
        let m = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (m < r) {
          n = d, r = m, i = m && n.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, d.nodeType == 1 && m && (s = u + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !a && p.left <= e.left && p.right >= e.left && (a = d, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !n && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (s = u + 1);
    }
  }
  return !n && a && (n = a, i = c, r = 0), n && n.nodeType == 3 ? Ly(n, i) : !n || r && n.nodeType == 1 ? { node: t, offset: s } : Md(n, i);
}
function Ly(t, e) {
  let n = t.nodeValue.length, r = document.createRange(), i;
  for (let s = 0; s < n; s++) {
    r.setEnd(t, s + 1), r.setStart(t, s);
    let o = Ot(r, 1);
    if (o.top != o.bottom && qo(e, o)) {
      i = { node: t, offset: s + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return r.detach(), i || { node: t, offset: 0 };
}
function qo(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function Dy(t, e) {
  let n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function Py(t, e, n) {
  let { node: r, offset: i } = Md(e, n), s = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    s = o.left != o.right && n.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(r, i, s);
}
function zy(t, e, n, r) {
  let i = -1;
  for (let s = e, o = !1; s != t.dom; ) {
    let l = t.docView.nearestDesc(s, !0), a;
    if (!l)
      return null;
    if (l.dom.nodeType == 1 && (l.node.isBlock && l.parent || !l.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((a = l.dom.getBoundingClientRect()).width || a.height) && (l.node.isBlock && l.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(l.dom.nodeName) && (!o && a.left > r.left || a.top > r.top ? i = l.posBefore : (!o && a.right < r.left || a.bottom < r.top) && (i = l.posAfter), o = !0), !l.contentDOM && i < 0 && !l.node.isText))
      return (l.node.isBlock ? r.top < (a.top + a.bottom) / 2 : r.left < (a.left + a.right) / 2) ? l.posBefore : l.posAfter;
    s = l.dom.parentNode;
  }
  return i > -1 ? i : t.docView.posFromDOM(e, n, -1);
}
function Td(t, e, n) {
  let r = t.childNodes.length;
  if (r && n.top < n.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - n.top) / (n.bottom - n.top)) - 2)), s = i; ; ) {
      let o = t.childNodes[s];
      if (o.nodeType == 1) {
        let l = o.getClientRects();
        for (let a = 0; a < l.length; a++) {
          let c = l[a];
          if (qo(e, c))
            return Td(o, e, c);
        }
      }
      if ((s = (s + 1) % r) == i)
        break;
    }
  return t;
}
function By(t, e) {
  let n = t.dom.ownerDocument, r, i = 0, s = Ey(n, e.left, e.top);
  s && ({ node: r, offset: i } = s);
  let o = (t.root.elementFromPoint ? t.root : n).elementFromPoint(e.left, e.top), l;
  if (!o || !t.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let c = t.dom.getBoundingClientRect();
    if (!qo(e, c) || (o = Td(t.dom, e, c), !o))
      return null;
  }
  if (we)
    for (let c = o; r && c; c = Rn(c))
      c.draggable && (r = void 0);
  if (o = Dy(o, e), r) {
    if (We && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let d = r.childNodes[i], u;
      d.nodeName == "IMG" && (u = d.getBoundingClientRect()).right <= e.left && u.bottom > e.top && i++;
    }
    let c;
    Cr && i && r.nodeType == 1 && (c = r.childNodes[i - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && i--, r == t.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? l = t.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (l = zy(t, r, i, e));
  }
  l == null && (l = Py(t, o, e));
  let a = t.docView.nearestDesc(o, !0);
  return { pos: l, inside: a ? a.posAtStart - a.border : -1 };
}
function Ql(t) {
  return t.top < t.bottom || t.left < t.right;
}
function Ot(t, e) {
  let n = t.getClientRects();
  if (n.length) {
    let r = n[e < 0 ? 0 : n.length - 1];
    if (Ql(r))
      return r;
  }
  return Array.prototype.find.call(n, Ql) || t.getBoundingClientRect();
}
const $y = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Ed(t, e, n) {
  let { node: r, offset: i, atom: s } = t.docView.domFromPos(e, n < 0 ? -1 : 1), o = Cr || We;
  if (r.nodeType == 3)
    if (o && ($y.test(r.nodeValue) || (n < 0 ? !i : i == r.nodeValue.length))) {
      let a = Ot(kt(r, i, i), n);
      if (We && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let c = Ot(kt(r, i - 1, i - 1), -1);
        if (c.top == a.top) {
          let d = Ot(kt(r, i, i + 1), -1);
          if (d.top != a.top)
            return Vn(d, d.left < c.left);
        }
      }
      return a;
    } else {
      let a = i, c = i, d = n < 0 ? 1 : -1;
      return n < 0 && !i ? (c++, d = -1) : n >= 0 && i == r.nodeValue.length ? (a--, d = 1) : n < 0 ? a-- : c++, Vn(Ot(kt(r, a, c), d), d < 0);
    }
  if (!t.state.doc.resolve(e - (s || 0)).parent.inlineContent) {
    if (s == null && i && (n < 0 || i == Fe(r))) {
      let a = r.childNodes[i - 1];
      if (a.nodeType == 1)
        return vs(a.getBoundingClientRect(), !1);
    }
    if (s == null && i < Fe(r)) {
      let a = r.childNodes[i];
      if (a.nodeType == 1)
        return vs(a.getBoundingClientRect(), !0);
    }
    return vs(r.getBoundingClientRect(), n >= 0);
  }
  if (s == null && i && (n < 0 || i == Fe(r))) {
    let a = r.childNodes[i - 1], c = a.nodeType == 3 ? kt(a, Fe(a) - (o ? 0 : 1)) : a.nodeType == 1 && (a.nodeName != "BR" || !a.nextSibling) ? a : null;
    if (c)
      return Vn(Ot(c, 1), !1);
  }
  if (s == null && i < Fe(r)) {
    let a = r.childNodes[i];
    for (; a.pmViewDesc && a.pmViewDesc.ignoreForCoords; )
      a = a.nextSibling;
    let c = a ? a.nodeType == 3 ? kt(a, 0, o ? 0 : 1) : a.nodeType == 1 ? a : null : null;
    if (c)
      return Vn(Ot(c, -1), !0);
  }
  return Vn(Ot(r.nodeType == 3 ? kt(r) : r, -n), n >= 0);
}
function Vn(t, e) {
  if (t.width == 0)
    return t;
  let n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function vs(t, e) {
  if (t.height == 0)
    return t;
  let n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function Ad(t, e, n) {
  let r = t.state, i = t.root.activeElement;
  r != e && t.updateState(e), i != t.dom && t.focus();
  try {
    return n();
  } finally {
    r != e && t.updateState(r), i != t.dom && i && i.focus();
  }
}
function Hy(t, e, n) {
  let r = e.selection, i = n == "up" ? r.$from : r.$to;
  return Ad(t, e, () => {
    let { node: s } = t.docView.domFromPos(i.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let l = t.docView.nearestDesc(s, !0);
      if (!l)
        break;
      if (l.node.isBlock) {
        s = l.contentDOM || l.dom;
        break;
      }
      s = l.dom.parentNode;
    }
    let o = Ed(t, i.pos, 1);
    for (let l = s.firstChild; l; l = l.nextSibling) {
      let a;
      if (l.nodeType == 1)
        a = l.getClientRects();
      else if (l.nodeType == 3)
        a = kt(l, 0, l.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < a.length; c++) {
        let d = a[c];
        if (d.bottom > d.top + 1 && (n == "up" ? o.top - d.top > (d.bottom - o.top) * 2 : d.bottom - o.bottom > (o.bottom - d.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const Vy = /[\u0590-\u08ac]/;
function Fy(t, e, n) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, s = !i, o = i == r.parent.content.size, l = t.domSelection();
  return l ? !Vy.test(r.parent.textContent) || !l.modify ? n == "left" || n == "backward" ? s : o : Ad(t, e, () => {
    let { focusNode: a, focusOffset: c, anchorNode: d, anchorOffset: u } = t.domSelectionRange(), h = l.caretBidiLevel;
    l.modify("move", n, "character");
    let f = r.depth ? t.docView.domAfterPos(r.before()) : t.dom, { focusNode: p, focusOffset: m } = t.domSelectionRange(), g = p && !f.contains(p.nodeType == 1 ? p : p.parentNode) || a == p && c == m;
    try {
      l.collapse(d, u), a && (a != d || c != u) && l.extend && l.extend(a, c);
    } catch {
    }
    return h != null && (l.caretBidiLevel = h), g;
  }) : r.pos == r.start() || r.pos == r.end();
}
let Yl = null, Xl = null, ea = !1;
function Wy(t, e, n) {
  return Yl == e && Xl == n ? ea : (Yl = e, Xl = n, ea = n == "up" || n == "down" ? Hy(t, e, n) : Fy(t, e, n));
}
const qe = 0, ta = 1, Yt = 2, ct = 3;
class xr {
  constructor(e, n, r, i) {
    this.parent = e, this.children = n, this.dom = r, this.contentDOM = i, this.dirty = qe, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, n, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let n = 0; n < this.children.length; n++)
      e += this.children[n].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let i = this.children[n];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, n, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[n - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.previousSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[n];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.nextSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = n > ke(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (i == null && n == e.childNodes.length)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, n = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let s = this.getDesc(i), o;
      if (s && (!n || s.node))
        if (r && (o = s.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return s;
    }
  }
  getDesc(e) {
    let n = e.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(e, n, r) {
    for (let i = e; i; i = i.parentNode) {
      let s = this.getDesc(i);
      if (s)
        return s.localPosFromDOM(e, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let i = this.children[n], s = r + i.size;
      if (r == e && s != r) {
        for (; !i.border && i.children.length; )
          for (let o = 0; o < i.children.length; o++) {
            let l = i.children[o];
            if (l.size) {
              i = l;
              break;
            }
          }
        return i;
      }
      if (e < s)
        return i.descAt(e - r - i.border);
      r = s;
    }
  }
  domFromPos(e, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let s = 0; r < this.children.length; r++) {
      let o = this.children[r], l = s + o.size;
      if (l > e || o instanceof _d) {
        i = e - s;
        break;
      }
      s = l;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, n);
    for (let s; r && !(s = this.children[r - 1]).size && s instanceof Nd && s.side >= 0; r--)
      ;
    if (n <= 0) {
      let s, o = !0;
      for (; s = r ? this.children[r - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return s && n && o && !s.border && !s.domAtom ? s.domFromPos(s.size, n) : { node: this.contentDOM, offset: s ? ke(s.dom) + 1 : 0 };
    } else {
      let s, o = !0;
      for (; s = r < this.children.length ? this.children[r] : null, !(!s || s.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return s && o && !s.border && !s.domAtom ? s.domFromPos(0, n) : { node: this.contentDOM, offset: s ? ke(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, s = -1;
    for (let o = r, l = 0; ; l++) {
      let a = this.children[l], c = o + a.size;
      if (i == -1 && e <= c) {
        let d = o + a.border;
        if (e >= d && n <= c - a.border && a.node && a.contentDOM && this.contentDOM.contains(a.contentDOM))
          return a.parseRange(e, n, d);
        e = o;
        for (let u = l; u > 0; u--) {
          let h = this.children[u - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            i = ke(h.dom) + 1;
            break;
          }
          e -= h.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (c > n || l == this.children.length - 1)) {
        n = c;
        for (let d = l + 1; d < this.children.length; d++) {
          let u = this.children[d];
          if (u.size && u.dom.parentNode == this.contentDOM && !u.emptyChildAt(-1)) {
            s = ke(u.dom);
            break;
          }
          n += u.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      o = c;
    }
    return { node: this.contentDOM, from: e, to: n, fromOffset: i, toOffset: s };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[e < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: n, offset: r } = this.domFromPos(e, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, n, r, i = !1) {
    let s = Math.min(e, n), o = Math.max(e, n);
    for (let f = 0, p = 0; f < this.children.length; f++) {
      let m = this.children[f], g = p + m.size;
      if (s > p && o < g)
        return m.setSelection(e - p - m.border, n - p - m.border, r, i);
      p = g;
    }
    let l = this.domFromPos(e, e ? -1 : 1), a = n == e ? l : this.domFromPos(n, n ? -1 : 1), c = r.root.getSelection(), d = r.domSelectionRange(), u = !1;
    if ((We || we) && e == n) {
      let { node: f, offset: p } = l;
      if (f.nodeType == 3) {
        if (u = !!(p && f.nodeValue[p - 1] == `
`), u && p == f.nodeValue.length)
          for (let m = f, g; m; m = m.parentNode) {
            if (g = m.nextSibling) {
              g.nodeName == "BR" && (l = a = { node: g.parentNode, offset: ke(g) + 1 });
              break;
            }
            let b = m.pmViewDesc;
            if (b && b.node && b.node.isBlock)
              break;
          }
      } else {
        let m = f.childNodes[p - 1];
        u = m && (m.nodeName == "BR" || m.contentEditable == "false");
      }
    }
    if (We && d.focusNode && d.focusNode != a.node && d.focusNode.nodeType == 1) {
      let f = d.focusNode.childNodes[d.focusOffset];
      f && f.contentEditable == "false" && (i = !0);
    }
    if (!(i || u && we) && un(l.node, l.offset, d.anchorNode, d.anchorOffset) && un(a.node, a.offset, d.focusNode, d.focusOffset))
      return;
    let h = !1;
    if ((c.extend || e == n) && !(u && We)) {
      c.collapse(l.node, l.offset);
      try {
        e != n && c.extend(a.node, a.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (e > n) {
        let p = l;
        l = a, a = p;
      }
      let f = document.createRange();
      f.setEnd(a.node, a.offset), f.setStart(l.node, l.offset), c.removeAllRanges(), c.addRange(f);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, n) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let s = this.children[i], o = r + s.size;
      if (r == o ? e <= o && n >= r : e < o && n > r) {
        let l = r + s.border, a = o - s.border;
        if (e >= l && n <= a) {
          this.dirty = e == r || n == o ? Yt : ta, e == l && n == a && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = ct : s.markDirty(e - l, n - l);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? Yt : ct;
      }
      r = o;
    }
    this.dirty = Yt;
  }
  markParentsDirty() {
    let e = 1;
    for (let n = this.parent; n; n = n.parent, e++) {
      let r = e == 1 ? Yt : ta;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class Nd extends xr {
  constructor(e, n, r, i) {
    let s, o = n.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!s)
        return i;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !n.type.spec.raw) {
      if (o.nodeType != 1) {
        let l = document.createElement("span");
        l.appendChild(o), o = l;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = n, this.widget = n, s = this;
  }
  matchesWidget(e) {
    return this.dirty == qe && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let n = this.widget.spec.stopEvent;
    return n ? n(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class qy extends xr {
  constructor(e, n, r, i) {
    super(e, [], n, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, n) {
    return e != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class hn extends xr {
  constructor(e, n, r, i, s) {
    super(e, [], r, i), this.mark = n, this.spec = s;
  }
  static create(e, n, r, i) {
    let s = i.nodeViews[n.type.name], o = s && s(n, i, r);
    return (!o || !o.dom) && (o = gn.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new hn(e, n, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & ct || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != ct && this.mark.eq(e);
  }
  markDirty(e, n) {
    if (super.markDirty(e, n), this.dirty != qe) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = qe;
    }
  }
  slice(e, n, r) {
    let i = hn.create(this.parent, this.mark, !0, r), s = this.children, o = this.size;
    n < o && (s = io(s, n, o, r)), e > 0 && (s = io(s, 0, e, r));
    for (let l = 0; l < s.length; l++)
      s[l].parent = i;
    return i.children = s, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Vt extends xr {
  constructor(e, n, r, i, s, o, l, a, c) {
    super(e, [], s, o), this.node = n, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = l;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, n, r, i, s, o) {
    let l = s.nodeViews[n.type.name], a, c = l && l(n, s, () => {
      if (!a)
        return o;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    }, r, i), d = c && c.dom, u = c && c.contentDOM;
    if (n.isText) {
      if (!d)
        d = document.createTextNode(n.text);
      else if (d.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else d || ({ dom: d, contentDOM: u } = gn.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !u && !n.isText && d.nodeName != "BR" && (d.hasAttribute("contenteditable") || (d.contentEditable = "false"), n.type.spec.draggable && (d.draggable = !0));
    let h = d;
    return d = Id(d, r, n), c ? a = new jy(e, n, r, i, d, u || null, h, c, s, o + 1) : n.isText ? new Zi(e, n, r, i, d, h, s) : new Vt(e, n, r, i, d, u || null, h, s, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => w.empty);
    }
    return e;
  }
  matchesNode(e, n, r) {
    return this.dirty == qe && e.eq(this.node) && ii(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, n) {
    let r = this.node.inlineContent, i = n, s = e.composing ? this.localCompositionInfo(e, n) : null, o = s && s.pos > -1 ? s : null, l = s && s.pos < 0, a = new Ky(this, o && o.node, e);
    Jy(this.node, this.innerDeco, (c, d, u) => {
      c.spec.marks ? a.syncToMarks(c.spec.marks, r, e, d) : c.type.side >= 0 && !u && a.syncToMarks(d == this.node.childCount ? K.none : this.node.child(d).marks, r, e, d), a.placeWidget(c, e, i);
    }, (c, d, u, h) => {
      a.syncToMarks(c.marks, r, e, h);
      let f;
      a.findNodeMatch(c, d, u, h) || l && e.state.selection.from > i && e.state.selection.to < i + c.nodeSize && (f = a.findIndexWithChild(s.node)) > -1 && a.updateNodeAt(c, d, u, f, e) || a.updateNextNode(c, d, u, e, h, i) || a.addNode(c, d, u, e, i), i += c.nodeSize;
    }), a.syncToMarks([], r, e, 0), this.node.isTextblock && a.addTextblockHacks(), a.destroyRest(), (a.changed || this.dirty == Yt) && (o && this.protectLocalComposition(e, o), Od(this.contentDOM, this.children, e), In && Qy(this.dom));
  }
  localCompositionInfo(e, n) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof I) || r < n || i > n + this.node.content.size)
      return null;
    let s = e.input.compositionNode;
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = s.nodeValue, l = Yy(this.node.content, o, r - n, i - n);
      return l < 0 ? null : { node: s, pos: l, text: o };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: n, pos: r, text: i }) {
    if (this.getDesc(n))
      return;
    let s = n;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let o = new qy(this, s, n, i);
    e.input.compositionNodes.push(o), this.children = io(this.children, r, r + i.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, n, r, i) {
    return this.dirty == ct || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, n, r, i), !0);
  }
  updateInner(e, n, r, i) {
    this.updateOuterDeco(n), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = qe;
  }
  updateOuterDeco(e) {
    if (ii(e, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = Rd(this.dom, this.nodeDOM, ro(this.outerDeco, this.node, n), ro(e, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function na(t, e, n, r, i) {
  Id(r, e, t);
  let s = new Vt(void 0, t, e, n, r, r, r, i, 0);
  return s.contentDOM && s.updateChildren(i, 0), s;
}
class Zi extends Vt {
  constructor(e, n, r, i, s, o, l) {
    super(e, n, r, i, s, null, o, l, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, n, r, i) {
    return this.dirty == ct || this.dirty != qe && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != qe || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = qe, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, n, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(e, n, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, n, r) {
    let i = this.node.cut(e, n), s = document.createTextNode(i.text);
    return new Zi(this.parent, i, this.outerDeco, this.innerDeco, s, s, r);
  }
  markDirty(e, n) {
    super.markDirty(e, n), this.dom != this.nodeDOM && (e == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = ct);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class _d extends xr {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == qe && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class jy extends Vt {
  constructor(e, n, r, i, s, o, l, a, c, d) {
    super(e, n, r, i, s, o, l, c, d), this.spec = a;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, n, r, i) {
    if (this.dirty == ct)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let s = this.spec.update(e, n, r);
      return s && this.updateInner(e, n, r, i), s;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, n, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, n, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, n, r.root) : super.setSelection(e, n, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function Od(t, e, n) {
  let r = t.firstChild, i = !1;
  for (let s = 0; s < e.length; s++) {
    let o = e[s], l = o.dom;
    if (l.parentNode == t) {
      for (; l != r; )
        r = ra(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, t.insertBefore(l, r);
    if (o instanceof hn) {
      let a = r ? r.previousSibling : t.lastChild;
      Od(o.contentDOM, o.children, n), r = a ? a.nextSibling : t.firstChild;
    }
  }
  for (; r; )
    r = ra(r), i = !0;
  i && n.trackWrites == t && (n.trackWrites = null);
}
const Xn = function(t) {
  t && (this.nodeName = t);
};
Xn.prototype = /* @__PURE__ */ Object.create(null);
const Xt = [new Xn()];
function ro(t, e, n) {
  if (t.length == 0)
    return Xt;
  let r = n ? Xt[0] : new Xn(), i = [r];
  for (let s = 0; s < t.length; s++) {
    let o = t[s].type.attrs;
    if (o) {
      o.nodeName && i.push(r = new Xn(o.nodeName));
      for (let l in o) {
        let a = o[l];
        a != null && (n && i.length == 1 && i.push(r = new Xn(e.isInline ? "span" : "div")), l == "class" ? r.class = (r.class ? r.class + " " : "") + a : l == "style" ? r.style = (r.style ? r.style + ";" : "") + a : l != "nodeName" && (r[l] = a));
      }
    }
  }
  return i;
}
function Rd(t, e, n, r) {
  if (n == Xt && r == Xt)
    return e;
  let i = e;
  for (let s = 0; s < r.length; s++) {
    let o = r[s], l = n[s];
    if (s) {
      let a;
      l && l.nodeName == o.nodeName && i != t && (a = i.parentNode) && a.nodeName.toLowerCase() == o.nodeName || (a = document.createElement(o.nodeName), a.pmIsDeco = !0, a.appendChild(i), l = Xt[0]), i = a;
    }
    Uy(i, l || Xt[0], o);
  }
  return i;
}
function Uy(t, e, n) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && t.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != e[r] && t.setAttribute(r, n[r]);
  if (e.class != n.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < r.length; s++)
      i.indexOf(r[s]) == -1 && t.classList.remove(r[s]);
    for (let s = 0; s < i.length; s++)
      r.indexOf(i[s]) == -1 && t.classList.add(i[s]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != n.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        t.style.removeProperty(i[1]);
    }
    n.style && (t.style.cssText += n.style);
  }
}
function Id(t, e, n) {
  return Rd(t, t, Xt, ro(e, n, t.nodeType != 1));
}
function ii(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function ra(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class Ky {
  constructor(e, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = Zy(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, n) {
    if (e != n) {
      for (let r = e; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, n - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, n, r, i) {
    let s = 0, o = this.stack.length >> 1, l = Math.min(o, e.length);
    for (; s < l && (s == o - 1 ? this.top : this.stack[s + 1 << 1]).matchesMark(e[s]) && e[s].type.spec.spanning !== !1; )
      s++;
    for (; s < o; )
      this.destroyRest(), this.top.dirty = qe, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1, c = this.top.children.length;
      i < this.preMatch.index && (c = Math.min(this.index + 3, c));
      for (let d = this.index; d < c; d++) {
        let u = this.top.children[d];
        if (u.matchesMark(e[o]) && !this.isLocked(u.dom)) {
          a = d;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let d = hn.create(this.top, e[o], n, r);
        this.top.children.splice(this.index, 0, d), this.top = d, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, n, r, i) {
    let s = -1, o;
    if (i >= this.preMatch.index && (o = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && o.matchesNode(e, n, r))
      s = this.top.children.indexOf(o, this.index);
    else
      for (let l = this.index, a = Math.min(this.top.children.length, l + 5); l < a; l++) {
        let c = this.top.children[l];
        if (c.matchesNode(e, n, r) && !this.preMatch.matched.has(c)) {
          s = l;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(e, n, r, i, s) {
    let o = this.top.children[i];
    return o.dirty == ct && o.dom == o.contentDOM && (o.dirty = Yt), o.update(e, n, r, s) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let n = e.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, n, r, i, s, o) {
    for (let l = this.index; l < this.top.children.length; l++) {
      let a = this.top.children[l];
      if (a instanceof Vt) {
        let c = this.preMatch.matched.get(a);
        if (c != null && c != s)
          return !1;
        let d = a.dom, u, h = this.isLocked(d) && !(e.isText && a.node && a.node.isText && a.nodeDOM.nodeValue == e.text && a.dirty != ct && ii(n, a.outerDeco));
        if (!h && a.update(e, n, r, i))
          return this.destroyBetween(this.index, l), a.dom != d && (this.changed = !0), this.index++, !0;
        if (!h && (u = this.recreateWrapper(a, e, n, r, i, o)))
          return this.destroyBetween(this.index, l), this.top.children[this.index] = u, u.contentDOM && (u.dirty = Yt, u.updateChildren(i, o + 1), u.dirty = qe), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, n, r, i, s, o) {
    if (e.dirty || n.isAtom || !e.children.length || !e.node.content.eq(n.content) || !ii(r, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let l = Vt.create(this.top, n, r, i, s, o);
    if (l.contentDOM) {
      l.children = e.children, e.children = [];
      for (let a of l.children)
        a.parent = l;
    }
    return e.destroy(), l;
  }
  // Insert the node as a newly created node desc.
  addNode(e, n, r, i, s) {
    let o = Vt.create(this.top, e, n, r, i, s);
    o.contentDOM && o.updateChildren(i, s + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, n, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new Nd(this.top, e, n, r);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], n = this.top;
    for (; e instanceof hn; )
      n = e, e = n.children[n.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof Zi) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((we || Ce) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(e, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new _d(this.top, [], r, null);
      n != this.top ? n.children.push(i) : n.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function Zy(t, e) {
  let n = e, r = n.children.length, i = t.childCount, s = /* @__PURE__ */ new Map(), o = [];
  e: for (; i > 0; ) {
    let l;
    for (; ; )
      if (r) {
        let c = n.children[r - 1];
        if (c instanceof hn)
          n = c, r = c.children.length;
        else {
          l = c, r--;
          break;
        }
      } else {
        if (n == e)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let a = l.node;
    if (a) {
      if (a != t.child(i - 1))
        break;
      --i, s.set(l, i), o.push(l);
    }
  }
  return { index: i, matched: s, matches: o.reverse() };
}
function Gy(t, e) {
  return t.type.side - e.type.side;
}
function Jy(t, e, n, r) {
  let i = e.locals(t), s = 0;
  if (i.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let d = t.child(c);
      r(d, i, e.forChild(s, d), c), s += d.nodeSize;
    }
    return;
  }
  let o = 0, l = [], a = null;
  for (let c = 0; ; ) {
    let d, u;
    for (; o < i.length && i[o].to == s; ) {
      let g = i[o++];
      g.widget && (d ? (u || (u = [d])).push(g) : d = g);
    }
    if (d)
      if (u) {
        u.sort(Gy);
        for (let g = 0; g < u.length; g++)
          n(u[g], c, !!a);
      } else
        n(d, c, !!a);
    let h, f;
    if (a)
      f = -1, h = a, a = null;
    else if (c < t.childCount)
      f = c, h = t.child(c++);
    else
      break;
    for (let g = 0; g < l.length; g++)
      l[g].to <= s && l.splice(g--, 1);
    for (; o < i.length && i[o].from <= s && i[o].to > s; )
      l.push(i[o++]);
    let p = s + h.nodeSize;
    if (h.isText) {
      let g = p;
      o < i.length && i[o].from < g && (g = i[o].from);
      for (let b = 0; b < l.length; b++)
        l[b].to < g && (g = l[b].to);
      g < p && (a = h.cut(g - s), h = h.cut(0, g - s), p = g, f = -1);
    } else
      for (; o < i.length && i[o].to < p; )
        o++;
    let m = h.isInline && !h.isLeaf ? l.filter((g) => !g.inline) : l.slice();
    r(h, m, e.forChild(s, h), f), s = p;
  }
}
function Qy(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function Yy(t, e, n, r) {
  for (let i = 0, s = 0; i < t.childCount && s <= r; ) {
    let o = t.child(i++), l = s;
    if (s += o.nodeSize, !o.isText)
      continue;
    let a = o.text;
    for (; i < t.childCount; ) {
      let c = t.child(i++);
      if (s += c.nodeSize, !c.isText)
        break;
      a += c.text;
    }
    if (s >= n) {
      if (s >= r && a.slice(r - e.length - l, r - l) == e)
        return r - e.length;
      let c = l < r ? a.lastIndexOf(e, r - l - 1) : -1;
      if (c >= 0 && c + e.length + l >= n)
        return l + c;
      if (n == r && a.length >= r + e.length - l && a.slice(r - l, r - l + e.length) == e)
        return r;
    }
  }
  return -1;
}
function io(t, e, n, r, i) {
  let s = [];
  for (let o = 0, l = 0; o < t.length; o++) {
    let a = t[o], c = l, d = l += a.size;
    c >= n || d <= e ? s.push(a) : (c < e && s.push(a.slice(0, e - c, r)), i && (s.push(i), i = void 0), d > n && s.push(a.slice(n - c, a.size, r)));
  }
  return s;
}
function jo(t, e = null) {
  let n = t.domSelectionRange(), r = t.state.doc;
  if (!n.focusNode)
    return null;
  let i = t.docView.nearestDesc(n.focusNode), s = i && i.size == 0, o = t.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (o < 0)
    return null;
  let l = r.resolve(o), a, c;
  if (Ki(n)) {
    for (a = o; i && !i.node; )
      i = i.parent;
    let u = i.node;
    if (i && u.isAtom && L.isSelectable(u) && i.parent && !(u.isInline && My(n.focusNode, n.focusOffset, i.dom))) {
      let h = i.posBefore;
      c = new L(o == h ? l : r.resolve(h));
    }
  } else {
    if (n instanceof t.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let u = o, h = o;
      for (let f = 0; f < n.rangeCount; f++) {
        let p = n.getRangeAt(f);
        u = Math.min(u, t.docView.posFromDOM(p.startContainer, p.startOffset, 1)), h = Math.max(h, t.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (u < 0)
        return null;
      [a, o] = h == t.state.selection.anchor ? [h, u] : [u, h], l = r.resolve(o);
    } else
      a = t.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (a < 0)
      return null;
  }
  let d = r.resolve(a);
  if (!c) {
    let u = e == "pointer" || t.state.selection.head < l.pos && !s ? 1 : -1;
    c = Uo(t, d, l, u);
  }
  return c;
}
function Ld(t) {
  return t.editable ? t.hasFocus() : Pd(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function wt(t, e = !1) {
  let n = t.state.selection;
  if (Dd(t, n), !!Ld(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && Ce) {
      let r = t.domSelectionRange(), i = t.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && un(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      eb(t);
    else {
      let { anchor: r, head: i } = n, s, o;
      ia && !(n instanceof I) && (n.$from.parent.inlineContent || (s = sa(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (o = sa(t, n.to))), t.docView.setSelection(r, i, t, e), ia && (s && oa(s), o && oa(o)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Xy(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const ia = we || Ce && Cd < 63;
function sa(t, e) {
  let { node: n, offset: r } = t.docView.domFromPos(e, 0), i = r < n.childNodes.length ? n.childNodes[r] : null, s = r ? n.childNodes[r - 1] : null;
  if (we && i && i.contentEditable == "false")
    return Cs(i);
  if ((!i || i.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (i)
      return Cs(i);
    if (s)
      return Cs(s);
  }
}
function Cs(t) {
  return t.contentEditable = "true", we && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function oa(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function Xy(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let n = t.domSelectionRange(), r = n.anchorNode, i = n.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != i) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!Ld(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function eb(t) {
  let e = t.domSelection();
  if (!e)
    return;
  let n = t.cursorWrapper.dom, r = n.nodeName == "IMG";
  r ? e.collapse(n.parentNode, ke(n) + 1) : e.collapse(n, 0), !r && !t.state.selection.visible && Oe && Ht <= 11 && (n.disabled = !0, n.disabled = !1);
}
function Dd(t, e) {
  if (e instanceof L) {
    let n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (la(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    la(t);
}
function la(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function Uo(t, e, n, r) {
  return t.someProp("createSelectionBetween", (i) => i(t, e, n)) || I.between(e, n, r);
}
function aa(t) {
  return t.editable && !t.hasFocus() ? !1 : Pd(t);
}
function Pd(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function tb(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.domSelectionRange();
  return un(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function so(t, e) {
  let { $anchor: n, $head: r } = t.selection, i = e > 0 ? n.max(r) : n.min(r), s = i.parent.inlineContent ? i.depth ? t.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return s && z.findFrom(s, e);
}
function Rt(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function ca(t, e, n) {
  let r = t.state.selection;
  if (r instanceof I)
    if (n.indexOf("s") > -1) {
      let { $head: i } = r, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let o = t.state.doc.resolve(i.pos + s.nodeSize * (e < 0 ? -1 : 1));
      return Rt(t, new I(r.$anchor, o));
    } else if (r.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = so(t.state, e);
        return i && i instanceof L ? Rt(t, i) : !1;
      } else if (!(Ve && n.indexOf("m") > -1)) {
        let i = r.$head, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, o;
        if (!s || s.isText)
          return !1;
        let l = e < 0 ? i.pos - s.nodeSize : i.pos;
        return s.isAtom || (o = t.docView.descAt(l)) && !o.contentDOM ? L.isSelectable(s) ? Rt(t, new L(e < 0 ? t.state.doc.resolve(i.pos - s.nodeSize) : i)) : Cr ? Rt(t, new I(t.state.doc.resolve(e < 0 ? l : l + s.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof L && r.node.isInline)
      return Rt(t, new I(e > 0 ? r.$to : r.$from));
    {
      let i = so(t.state, e);
      return i ? Rt(t, i) : !1;
    }
  }
}
function si(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function er(t, e) {
  let n = t.pmViewDesc;
  return n && n.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function wn(t, e) {
  return e < 0 ? nb(t) : rb(t);
}
function nb(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let i, s, o = !1;
  for (We && n.nodeType == 1 && r < si(n) && er(n.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let l = n.childNodes[r - 1];
        if (er(l, -1))
          i = n, s = --r;
        else if (l.nodeType == 3)
          n = l, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (zd(n))
        break;
      {
        let l = n.previousSibling;
        for (; l && er(l, -1); )
          i = n.parentNode, s = ke(l), l = l.previousSibling;
        if (l)
          n = l, r = si(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = 0;
        }
      }
    }
  o ? oo(t, n, r) : i && oo(t, i, s);
}
function rb(t) {
  let e = t.domSelectionRange(), n = e.focusNode, r = e.focusOffset;
  if (!n)
    return;
  let i = si(n), s, o;
  for (; ; )
    if (r < i) {
      if (n.nodeType != 1)
        break;
      let l = n.childNodes[r];
      if (er(l, 1))
        s = n, o = ++r;
      else
        break;
    } else {
      if (zd(n))
        break;
      {
        let l = n.nextSibling;
        for (; l && er(l, 1); )
          s = l.parentNode, o = ke(l) + 1, l = l.nextSibling;
        if (l)
          n = l, r = 0, i = si(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          r = i = 0;
        }
      }
    }
  s && oo(t, s, o);
}
function zd(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function ib(t, e) {
  for (; t && e == t.childNodes.length && !vr(t); )
    e = ke(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let n = t.childNodes[e];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = 0;
  }
}
function sb(t, e) {
  for (; t && !e && !vr(t); )
    e = ke(t), t = t.parentNode;
  for (; t && e; ) {
    let n = t.childNodes[e - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = t.childNodes.length;
  }
}
function oo(t, e, n) {
  if (e.nodeType != 3) {
    let s, o;
    (o = ib(e, n)) ? (e = o, n = 0) : (s = sb(e, n)) && (e = s, n = s.nodeValue.length);
  }
  let r = t.domSelection();
  if (!r)
    return;
  if (Ki(r)) {
    let s = document.createRange();
    s.setEnd(e, n), s.setStart(e, n), r.removeAllRanges(), r.addRange(s);
  } else r.extend && r.extend(e, n);
  t.domObserver.setCurSelection();
  let { state: i } = t;
  setTimeout(() => {
    t.state == i && wt(t);
  }, 50);
}
function da(t, e) {
  let n = t.state.doc.resolve(e);
  if (!(Ce || xd) && n.parent.inlineContent) {
    let i = t.coordsAtPos(e);
    if (e > n.start()) {
      let s = t.coordsAtPos(e - 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left < i.left ? "ltr" : "rtl";
    }
    if (e < n.end()) {
      let s = t.coordsAtPos(e + 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function ua(t, e, n) {
  let r = t.state.selection;
  if (r instanceof I && !r.empty || n.indexOf("s") > -1 || Ve && n.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: s } = r;
  if (!i.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = so(t.state, e);
    if (o && o instanceof L)
      return Rt(t, o);
  }
  if (!i.parent.inlineContent) {
    let o = e < 0 ? i : s, l = r instanceof ze ? z.near(o, e) : z.findFrom(o, e);
    return l ? Rt(t, l) : !1;
  }
  return !1;
}
function ha(t, e) {
  if (!(t.state.selection instanceof I))
    return !0;
  let { $head: n, $anchor: r, empty: i } = t.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let s = !n.textOffset && (e < 0 ? n.nodeBefore : n.nodeAfter);
  if (s && !s.isText) {
    let o = t.state.tr;
    return e < 0 ? o.delete(n.pos - s.nodeSize, n.pos) : o.delete(n.pos, n.pos + s.nodeSize), t.dispatch(o), !0;
  }
  return !1;
}
function fa(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function ob(t) {
  if (!we || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (e && e.nodeType == 1 && n == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    fa(t, r, "true"), setTimeout(() => fa(t, r, "false"), 20);
  }
  return !1;
}
function lb(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function ab(t, e) {
  let n = e.keyCode, r = lb(e);
  if (n == 8 || Ve && n == 72 && r == "c")
    return ha(t, -1) || wn(t, -1);
  if (n == 46 && !e.shiftKey || Ve && n == 68 && r == "c")
    return ha(t, 1) || wn(t, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || Ve && n == 66 && r == "c") {
    let i = n == 37 ? da(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return ca(t, i, r) || wn(t, i);
  } else if (n == 39 || Ve && n == 70 && r == "c") {
    let i = n == 39 ? da(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return ca(t, i, r) || wn(t, i);
  } else {
    if (n == 38 || Ve && n == 80 && r == "c")
      return ua(t, -1, r) || wn(t, -1);
    if (n == 40 || Ve && n == 78 && r == "c")
      return ob(t) || ua(t, 1, r) || wn(t, 1);
    if (r == (Ve ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function Ko(t, e) {
  t.someProp("transformCopied", (f) => {
    e = f(e, t);
  });
  let n = [], { content: r, openStart: i, openEnd: s } = e;
  for (; i > 1 && s > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, s--;
    let f = r.firstChild;
    n.push(f.type.name, f.attrs != f.type.defaultAttrs ? f.attrs : null), r = f.content;
  }
  let o = t.someProp("clipboardSerializer") || gn.fromSchema(t.state.schema), l = Wd(), a = l.createElement("div");
  a.appendChild(o.serializeFragment(r, { document: l }));
  let c = a.firstChild, d, u = 0;
  for (; c && c.nodeType == 1 && (d = Fd[c.nodeName.toLowerCase()]); ) {
    for (let f = d.length - 1; f >= 0; f--) {
      let p = l.createElement(d[f]);
      for (; a.firstChild; )
        p.appendChild(a.firstChild);
      a.appendChild(p), u++;
    }
    c = a.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${i} ${s}${u ? ` -${u}` : ""} ${JSON.stringify(n)}`);
  let h = t.someProp("clipboardTextSerializer", (f) => f(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: a, text: h, slice: e };
}
function Bd(t, e, n, r, i) {
  let s = i.parent.type.spec.code, o, l;
  if (!n && !e)
    return null;
  let a = !!e && (r || s || !n);
  if (a) {
    if (t.someProp("transformPastedText", (h) => {
      e = h(e, s || r, t);
    }), s)
      return l = new A(w.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), t.someProp("transformPasted", (h) => {
        l = h(l, t, !0);
      }), l;
    let u = t.someProp("clipboardTextParser", (h) => h(e, i, r, t));
    if (u)
      l = u;
    else {
      let h = i.marks(), { schema: f } = t.state, p = gn.fromSchema(f);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let g = o.appendChild(document.createElement("p"));
        m && g.appendChild(p.serializeNode(f.text(m, h)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (u) => {
      n = u(n, t);
    }), o = hb(n), Cr && fb(o);
  let c = o && o.querySelector("[data-pm-slice]"), d = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (d && d[3])
    for (let u = +d[3]; u > 0; u--) {
      let h = o.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      o = h;
    }
  if (l || (l = (t.someProp("clipboardParser") || t.someProp("domParser") || Qn.fromSchema(t.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(a || d),
    context: i,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !cb.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), d)
    l = pb(pa(l, +d[1], +d[2]), d[4]);
  else if (l = A.maxOpen(db(l.content, i), !0), l.openStart || l.openEnd) {
    let u = 0, h = 0;
    for (let f = l.content.firstChild; u < l.openStart && !f.type.spec.isolating; u++, f = f.firstChild)
      ;
    for (let f = l.content.lastChild; h < l.openEnd && !f.type.spec.isolating; h++, f = f.lastChild)
      ;
    l = pa(l, u, h);
  }
  return t.someProp("transformPasted", (u) => {
    l = u(l, t, a);
  }), l;
}
const cb = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function db(t, e) {
  if (t.childCount < 2)
    return t;
  for (let n = e.depth; n >= 0; n--) {
    let i = e.node(n).contentMatchAt(e.index(n)), s, o = [];
    if (t.forEach((l) => {
      if (!o)
        return;
      let a = i.findWrapping(l.type), c;
      if (!a)
        return o = null;
      if (c = o.length && s.length && Hd(a, s, l, o[o.length - 1], 0))
        o[o.length - 1] = c;
      else {
        o.length && (o[o.length - 1] = Vd(o[o.length - 1], s.length));
        let d = $d(l, a);
        o.push(d), i = i.matchType(d.type), s = a;
      }
    }), o)
      return w.from(o);
  }
  return t;
}
function $d(t, e, n = 0) {
  for (let r = e.length - 1; r >= n; r--)
    t = e[r].create(null, w.from(t));
  return t;
}
function Hd(t, e, n, r, i) {
  if (i < t.length && i < e.length && t[i] == e[i]) {
    let s = Hd(t, e, n, r.lastChild, i + 1);
    if (s)
      return r.copy(r.content.replaceChild(r.childCount - 1, s));
    if (r.contentMatchAt(r.childCount).matchType(i == t.length - 1 ? n.type : t[i + 1]))
      return r.copy(r.content.append(w.from($d(n, t, i + 1))));
  }
}
function Vd(t, e) {
  if (e == 0)
    return t;
  let n = t.content.replaceChild(t.childCount - 1, Vd(t.lastChild, e - 1)), r = t.contentMatchAt(t.childCount).fillBefore(w.empty, !0);
  return t.copy(n.append(r));
}
function lo(t, e, n, r, i, s) {
  let o = e < 0 ? t.firstChild : t.lastChild, l = o.content;
  return t.childCount > 1 && (s = 0), i < r - 1 && (l = lo(l, e, n, r, i + 1, s)), i >= n && (l = e < 0 ? o.contentMatchAt(0).fillBefore(l, s <= i).append(l) : l.append(o.contentMatchAt(o.childCount).fillBefore(w.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, o.copy(l));
}
function pa(t, e, n) {
  return e < t.openStart && (t = new A(lo(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new A(lo(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
const Fd = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let ma = null;
function Wd() {
  return ma || (ma = document.implementation.createHTMLDocument("title"));
}
let xs = null;
function ub(t) {
  let e = window.trustedTypes;
  return e ? (xs || (xs = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), xs.createHTML(t)) : t;
}
function hb(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let n = Wd().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(t), i;
  if ((i = r && Fd[r[1].toLowerCase()]) && (t = i.map((s) => "<" + s + ">").join("") + t + i.map((s) => "</" + s + ">").reverse().join("")), n.innerHTML = ub(t), i)
    for (let s = 0; s < i.length; s++)
      n = n.querySelector(i[s]) || n;
  return n;
}
function fb(t) {
  let e = t.querySelectorAll(Ce ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), r);
  }
}
function pb(t, e) {
  if (!t.size)
    return t;
  let n = t.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: i, openStart: s, openEnd: o } = t;
  for (let l = r.length - 2; l >= 0; l -= 2) {
    let a = n.nodes[r[l]];
    if (!a || a.hasRequiredAttrs())
      break;
    i = w.from(a.create(r[l + 1], i)), s++, o++;
  }
  return new A(i, s, o);
}
const Ee = {}, Ae = {}, mb = { touchstart: !0, touchmove: !0 };
class gb {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function yb(t) {
  for (let e in Ee) {
    let n = Ee[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (r) => {
      kb(t, r) && !Zo(t, r) && (t.editable || !(r.type in Ae)) && n(t, r);
    }, mb[e] ? { passive: !0 } : void 0);
  }
  we && t.dom.addEventListener("input", () => null), ao(t);
}
function $t(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function bb(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function ao(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let n in e)
      t.input.eventHandlers[n] || t.dom.addEventListener(n, t.input.eventHandlers[n] = (r) => Zo(t, r));
  });
}
function Zo(t, e) {
  return t.someProp("handleDOMEvents", (n) => {
    let r = n[e.type];
    return r ? r(t, e) || e.defaultPrevented : !1;
  });
}
function kb(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function vb(t, e) {
  !Zo(t, e) && Ee[e.type] && (t.editable || !(e.type in Ae)) && Ee[e.type](t, e);
}
Ae.keydown = (t, e) => {
  let n = e;
  if (t.input.shiftKey = n.keyCode == 16 || n.shiftKey, !jd(t, n) && (t.input.lastKeyCode = n.keyCode, t.input.lastKeyCodeTime = Date.now(), !(vt && Ce && n.keyCode == 13)))
    if (n.keyCode != 229 && t.domObserver.forceFlush(), In && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      t.input.lastIOSEnter = r, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == r && (t.someProp("handleKeyDown", (i) => i(t, Qt(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (r) => r(t, n)) || ab(t, n) ? n.preventDefault() : $t(t, "key");
};
Ae.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
Ae.keypress = (t, e) => {
  let n = e;
  if (jd(t, n) || !n.charCode || n.ctrlKey && !n.altKey || Ve && n.metaKey)
    return;
  if (t.someProp("handleKeyPress", (i) => i(t, n))) {
    n.preventDefault();
    return;
  }
  let r = t.state.selection;
  if (!(r instanceof I) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(n.charCode), s = () => t.state.tr.insertText(i).scrollIntoView();
    !/[\r\n]/.test(i) && !t.someProp("handleTextInput", (o) => o(t, r.$from.pos, r.$to.pos, i, s)) && t.dispatch(s()), n.preventDefault();
  }
};
function Gi(t) {
  return { left: t.clientX, top: t.clientY };
}
function Cb(t, e) {
  let n = e.x - t.clientX, r = e.y - t.clientY;
  return n * n + r * r < 100;
}
function Go(t, e, n, r, i) {
  if (r == -1)
    return !1;
  let s = t.state.doc.resolve(r);
  for (let o = s.depth + 1; o > 0; o--)
    if (t.someProp(e, (l) => o > s.depth ? l(t, n, s.nodeAfter, s.before(o), i, !0) : l(t, n, s.node(o), s.before(o), i, !1)))
      return !0;
  return !1;
}
function Nn(t, e, n) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let r = t.state.tr.setSelection(e);
  r.setMeta("pointer", !0), t.dispatch(r);
}
function xb(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.doc.resolve(e), r = n.nodeAfter;
  return r && r.isAtom && L.isSelectable(r) ? (Nn(t, new L(n)), !0) : !1;
}
function wb(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.selection, r, i;
  n instanceof L && (r = n.node);
  let s = t.state.doc.resolve(e);
  for (let o = s.depth + 1; o > 0; o--) {
    let l = o > s.depth ? s.nodeAfter : s.node(o);
    if (L.isSelectable(l)) {
      r && n.$from.depth > 0 && o >= n.$from.depth && s.before(n.$from.depth + 1) == n.$from.pos ? i = s.before(n.$from.depth) : i = s.before(o);
      break;
    }
  }
  return i != null ? (Nn(t, L.create(t.state.doc, i)), !0) : !1;
}
function Sb(t, e, n, r, i) {
  return Go(t, "handleClickOn", e, n, r) || t.someProp("handleClick", (s) => s(t, e, r)) || (i ? wb(t, n) : xb(t, n));
}
function Mb(t, e, n, r) {
  return Go(t, "handleDoubleClickOn", e, n, r) || t.someProp("handleDoubleClick", (i) => i(t, e, r));
}
function Tb(t, e, n, r) {
  return Go(t, "handleTripleClickOn", e, n, r) || t.someProp("handleTripleClick", (i) => i(t, e, r)) || Eb(t, n, r);
}
function Eb(t, e, n) {
  if (n.button != 0)
    return !1;
  let r = t.state.doc;
  if (e == -1)
    return r.inlineContent ? (Nn(t, I.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let o = s > i.depth ? i.nodeAfter : i.node(s), l = i.before(s);
    if (o.inlineContent)
      Nn(t, I.create(r, l + 1, l + 1 + o.content.size));
    else if (L.isSelectable(o))
      Nn(t, L.create(r, l));
    else
      continue;
    return !0;
  }
}
function Jo(t) {
  return oi(t);
}
const qd = Ve ? "metaKey" : "ctrlKey";
Ee.mousedown = (t, e) => {
  let n = e;
  t.input.shiftKey = n.shiftKey;
  let r = Jo(t), i = Date.now(), s = "singleClick";
  i - t.input.lastClick.time < 500 && Cb(n, t.input.lastClick) && !n[qd] && t.input.lastClick.button == n.button && (t.input.lastClick.type == "singleClick" ? s = "doubleClick" : t.input.lastClick.type == "doubleClick" && (s = "tripleClick")), t.input.lastClick = { time: i, x: n.clientX, y: n.clientY, type: s, button: n.button };
  let o = t.posAtCoords(Gi(n));
  o && (s == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new Ab(t, o, n, !!r)) : (s == "doubleClick" ? Mb : Tb)(t, o.pos, o.inside, n) ? n.preventDefault() : $t(t, "pointer"));
};
class Ab {
  constructor(e, n, r, i) {
    this.view = e, this.pos = n, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[qd], this.allowDefault = r.shiftKey;
    let s, o;
    if (n.inside > -1)
      s = e.state.doc.nodeAt(n.inside), o = n.inside;
    else {
      let d = e.state.doc.resolve(n.pos);
      s = d.parent, o = d.depth ? d.before() : 0;
    }
    const l = i ? null : r.target, a = l ? e.docView.nearestDesc(l, !0) : null;
    this.target = a && a.nodeDOM.nodeType == 1 ? a.nodeDOM : null;
    let { selection: c } = e.state;
    r.button == 0 && (s.type.spec.draggable && s.type.spec.selectable !== !1 || c instanceof L && c.from <= o && c.to > o) && (this.mightDrag = {
      node: s,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && We && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), $t(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => wt(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(Gi(e))), this.updateAllowDefault(e), this.allowDefault || !n ? $t(this.view, "pointer") : Sb(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    we && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Ce && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (Nn(this.view, z.near(this.view.state.doc.resolve(n.pos))), e.preventDefault()) : $t(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), $t(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Ee.touchstart = (t) => {
  t.input.lastTouch = Date.now(), Jo(t), $t(t, "pointer");
};
Ee.touchmove = (t) => {
  t.input.lastTouch = Date.now(), $t(t, "pointer");
};
Ee.contextmenu = (t) => Jo(t);
function jd(t, e) {
  return t.composing ? !0 : we && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const Nb = vt ? 5e3 : -1;
Ae.compositionstart = Ae.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, n = e.selection.$to;
    if (e.selection instanceof I && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1) || Ce && xd && _b(t)))
      t.markCursor = t.state.storedMarks || n.marks(), oi(t, !0), t.markCursor = null;
    else if (oi(t, !e.selection.empty), We && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = t.domSelectionRange();
      for (let i = r.focusNode, s = r.focusOffset; i && i.nodeType == 1 && s != 0; ) {
        let o = s < 0 ? i.lastChild : i.childNodes[s - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let l = t.domSelection();
          l && l.collapse(o, o.nodeValue.length);
          break;
        } else
          i = o, s = -1;
      }
    }
    t.input.composing = !0;
  }
  Ud(t, Nb);
};
function _b(t) {
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (!e || e.nodeType != 1 || n >= e.childNodes.length)
    return !1;
  let r = e.childNodes[n];
  return r.nodeType == 1 && r.contentEditable == "false";
}
Ae.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.badSafariComposition ? t.domObserver.forceFlush() : t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, Ud(t, 20));
};
function Ud(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => oi(t), e));
}
function Kd(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = Rb()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function Ob(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let n = wy(e.focusNode, e.focusOffset), r = Sy(e.focusNode, e.focusOffset);
  if (n && r && n != r) {
    let i = r.pmViewDesc, s = t.domObserver.lastChangedTextNode;
    if (n == s || r == s)
      return s;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (t.input.compositionNode == r) {
      let o = n.pmViewDesc;
      if (!(!o || !o.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function Rb() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function oi(t, e = !1) {
  if (!(vt && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), Kd(t), e || t.docView && t.docView.dirty) {
      let n = jo(t), r = t.state.selection;
      return n && !n.eq(r) ? t.dispatch(t.state.tr.setSelection(n)) : (t.markCursor || e) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function Ib(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), t.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), t.focus();
  }, 50);
}
const hr = Oe && Ht < 15 || In && Ay < 604;
Ee.copy = Ae.cut = (t, e) => {
  let n = e, r = t.state.selection, i = n.type == "cut";
  if (r.empty)
    return;
  let s = hr ? null : n.clipboardData, o = r.content(), { dom: l, text: a } = Ko(t, o);
  s ? (n.preventDefault(), s.clearData(), s.setData("text/html", l.innerHTML), s.setData("text/plain", a)) : Ib(t, l), i && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function Lb(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function Db(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, r = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), r.parentNode && r.parentNode.removeChild(r), n ? fr(t, r.value, null, i, e) : fr(t, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function fr(t, e, n, r, i) {
  let s = Bd(t, e, n, r, t.state.selection.$from);
  if (t.someProp("handlePaste", (a) => a(t, i, s || A.empty)))
    return !0;
  if (!s)
    return !1;
  let o = Lb(s), l = o ? t.state.tr.replaceSelectionWith(o, r) : t.state.tr.replaceSelection(s);
  return t.dispatch(l.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Zd(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let n = t.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Ae.paste = (t, e) => {
  let n = e;
  if (t.composing && !vt)
    return;
  let r = hr ? null : n.clipboardData, i = t.input.shiftKey && t.input.lastKeyCode != 45;
  r && fr(t, Zd(r), r.getData("text/html"), i, n) ? n.preventDefault() : Db(t, n);
};
class Gd {
  constructor(e, n, r) {
    this.slice = e, this.move = n, this.node = r;
  }
}
const Pb = Ve ? "altKey" : "ctrlKey";
function Jd(t, e) {
  let n;
  return t.someProp("dragCopies", (r) => {
    n = n || r(e);
  }), n != null ? !n : !e[Pb];
}
Ee.dragstart = (t, e) => {
  let n = e, r = t.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let i = t.state.selection, s = i.empty ? null : t.posAtCoords(Gi(n)), o;
  if (!(s && s.pos >= i.from && s.pos <= (i instanceof L ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      o = L.create(t.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let u = t.docView.nearestDesc(n.target, !0);
      u && u.node.type.spec.draggable && u != t.docView && (o = L.create(t.state.doc, u.posBefore));
    }
  }
  let l = (o || t.state.selection).content(), { dom: a, text: c, slice: d } = Ko(t, l);
  (!n.dataTransfer.files.length || !Ce || Cd > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(hr ? "Text" : "text/html", a.innerHTML), n.dataTransfer.effectAllowed = "copyMove", hr || n.dataTransfer.setData("text/plain", c), t.dragging = new Gd(d, Jd(t, n), o);
};
Ee.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
Ae.dragover = Ae.dragenter = (t, e) => e.preventDefault();
Ae.drop = (t, e) => {
  try {
    zb(t, e, t.dragging);
  } finally {
    t.dragging = null;
  }
};
function zb(t, e, n) {
  if (!e.dataTransfer)
    return;
  let r = t.posAtCoords(Gi(e));
  if (!r)
    return;
  let i = t.state.doc.resolve(r.pos), s = n && n.slice;
  s ? t.someProp("transformPasted", (f) => {
    s = f(s, t, !1);
  }) : s = Bd(t, Zd(e.dataTransfer), hr ? null : e.dataTransfer.getData("text/html"), !1, i);
  let o = !!(n && Jd(t, e));
  if (t.someProp("handleDrop", (f) => f(t, e, s || A.empty, o))) {
    e.preventDefault();
    return;
  }
  if (!s)
    return;
  e.preventDefault();
  let l = s ? ed(t.state.doc, i.pos, s) : i.pos;
  l == null && (l = i.pos);
  let a = t.state.tr;
  if (o) {
    let { node: f } = n;
    f ? f.replace(a) : a.deleteSelection();
  }
  let c = a.mapping.map(l), d = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, u = a.doc;
  if (d ? a.replaceRangeWith(c, c, s.content.firstChild) : a.replaceRange(c, c, s), a.doc.eq(u))
    return;
  let h = a.doc.resolve(c);
  if (d && L.isSelectable(s.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(s.content.firstChild))
    a.setSelection(new L(h));
  else {
    let f = a.mapping.map(l);
    a.mapping.maps[a.mapping.maps.length - 1].forEach((p, m, g, b) => f = b), a.setSelection(Uo(t, h, a.doc.resolve(f)));
  }
  t.focus(), t.dispatch(a.setMeta("uiEvent", "drop"));
}
Ee.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && wt(t);
  }, 20));
};
Ee.blur = (t, e) => {
  let n = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), n.relatedTarget && t.dom.contains(n.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
Ee.beforeinput = (t, e) => {
  if (Ce && vt && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: r } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != r || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (s) => s(t, Qt(8, "Backspace")))))
        return;
      let { $cursor: i } = t.state.selection;
      i && i.pos > 0 && t.dispatch(t.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in Ae)
  Ee[t] = Ae[t];
function pr(t, e) {
  if (t == e)
    return !0;
  for (let n in t)
    if (t[n] !== e[n])
      return !1;
  for (let n in e)
    if (!(n in t))
      return !1;
  return !0;
}
class li {
  constructor(e, n) {
    this.toDOM = e, this.spec = n || on, this.side = this.spec.side || 0;
  }
  map(e, n, r, i) {
    let { pos: s, deleted: o } = e.mapResult(n.from + i, this.side < 0 ? -1 : 1);
    return o ? null : new he(s - r, s - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof li && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && pr(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Ft {
  constructor(e, n) {
    this.attrs = e, this.spec = n || on;
  }
  map(e, n, r, i) {
    let s = e.map(n.from + i, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(n.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return s >= o ? null : new he(s, o, this);
  }
  valid(e, n) {
    return n.from < n.to;
  }
  eq(e) {
    return this == e || e instanceof Ft && pr(this.attrs, e.attrs) && pr(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Ft;
  }
  destroy() {
  }
}
class Qo {
  constructor(e, n) {
    this.attrs = e, this.spec = n || on;
  }
  map(e, n, r, i) {
    let s = e.mapResult(n.from + i, 1);
    if (s.deleted)
      return null;
    let o = e.mapResult(n.to + i, -1);
    return o.deleted || o.pos <= s.pos ? null : new he(s.pos - r, o.pos - r, this);
  }
  valid(e, n) {
    let { index: r, offset: i } = e.content.findIndex(n.from), s;
    return i == n.from && !(s = e.child(r)).isText && i + s.nodeSize == n.to;
  }
  eq(e) {
    return this == e || e instanceof Qo && pr(this.attrs, e.attrs) && pr(this.spec, e.spec);
  }
  destroy() {
  }
}
class he {
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(e, n) {
    return new he(e, n, this.type);
  }
  /**
  @internal
  */
  eq(e, n = 0) {
    return this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
  }
  /**
  @internal
  */
  map(e, n, r) {
    return this.type.map(e, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, n, r) {
    return new he(e, e, new li(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, n, r, i) {
    return new he(e, n, new Ft(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, n, r, i) {
    return new he(e, n, new Qo(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Ft;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof li;
  }
}
const Mn = [], on = {};
class Z {
  /**
  @internal
  */
  constructor(e, n) {
    this.local = e.length ? e : Mn, this.children = n.length ? n : Mn;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, n) {
    return n.length ? ai(n, e, 0, on) : xe;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, n, r) {
    let i = [];
    return this.findInner(e ?? 0, n ?? 1e9, i, 0, r), i;
  }
  findInner(e, n, r, i, s) {
    for (let o = 0; o < this.local.length; o++) {
      let l = this.local[o];
      l.from <= n && l.to >= e && (!s || s(l.spec)) && r.push(l.copy(l.from + i, l.to + i));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < n && this.children[o + 1] > e) {
        let l = this.children[o] + 1;
        this.children[o + 2].findInner(e - l, n - l, r, i + l, s);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, n, r) {
    return this == xe || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, r || on);
  }
  /**
  @internal
  */
  mapInner(e, n, r, i, s) {
    let o;
    for (let l = 0; l < this.local.length; l++) {
      let a = this.local[l].map(e, r, i);
      a && a.type.valid(n, a) ? (o || (o = [])).push(a) : s.onRemove && s.onRemove(this.local[l].spec);
    }
    return this.children.length ? Bb(this.children, o || [], e, n, r, i, s) : o ? new Z(o.sort(ln), Mn) : xe;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, n) {
    return n.length ? this == xe ? Z.create(e, n) : this.addInner(e, n, 0) : this;
  }
  addInner(e, n, r) {
    let i, s = 0;
    e.forEach((l, a) => {
      let c = a + r, d;
      if (d = Yd(n, l, c)) {
        for (i || (i = this.children.slice()); s < i.length && i[s] < a; )
          s += 3;
        i[s] == a ? i[s + 2] = i[s + 2].addInner(l, d, c + 1) : i.splice(s, 0, a, a + l.nodeSize, ai(d, l, c + 1, on)), s += 3;
      }
    });
    let o = Qd(s ? Xd(n) : n, -r);
    for (let l = 0; l < o.length; l++)
      o[l].type.valid(e, o[l]) || o.splice(l--, 1);
    return new Z(o.length ? this.local.concat(o).sort(ln) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == xe ? this : this.removeInner(e, 0);
  }
  removeInner(e, n) {
    let r = this.children, i = this.local;
    for (let s = 0; s < r.length; s += 3) {
      let o, l = r[s] + n, a = r[s + 1] + n;
      for (let d = 0, u; d < e.length; d++)
        (u = e[d]) && u.from > l && u.to < a && (e[d] = null, (o || (o = [])).push(u));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let c = r[s + 2].removeInner(o, l + 1);
      c != xe ? r[s + 2] = c : (r.splice(s, 3), s -= 3);
    }
    if (i.length) {
      for (let s = 0, o; s < e.length; s++)
        if (o = e[s])
          for (let l = 0; l < i.length; l++)
            i[l].eq(o, n) && (i == this.local && (i = this.local.slice()), i.splice(l--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new Z(i, r) : xe;
  }
  forChild(e, n) {
    if (this == xe)
      return this;
    if (n.isLeaf)
      return Z.empty;
    let r, i;
    for (let l = 0; l < this.children.length; l += 3)
      if (this.children[l] >= e) {
        this.children[l] == e && (r = this.children[l + 2]);
        break;
      }
    let s = e + 1, o = s + n.content.size;
    for (let l = 0; l < this.local.length; l++) {
      let a = this.local[l];
      if (a.from < o && a.to > s && a.type instanceof Ft) {
        let c = Math.max(s, a.from) - s, d = Math.min(o, a.to) - s;
        c < d && (i || (i = [])).push(a.copy(c, d));
      }
    }
    if (i) {
      let l = new Z(i.sort(ln), Mn);
      return r ? new Dt([l, r]) : l;
    }
    return r || xe;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof Z) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(e.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != e.children[n] || this.children[n + 1] != e.children[n + 1] || !this.children[n + 2].eq(e.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return Yo(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == xe)
      return Mn;
    if (e.inlineContent || !this.local.some(Ft.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof Ft || n.push(this.local[r]);
    return n;
  }
  forEachSet(e) {
    e(this);
  }
}
Z.empty = new Z([], []);
Z.removeOverlap = Yo;
const xe = Z.empty;
class Dt {
  constructor(e) {
    this.members = e;
  }
  map(e, n) {
    const r = this.members.map((i) => i.map(e, n, on));
    return Dt.from(r);
  }
  forChild(e, n) {
    if (n.isLeaf)
      return Z.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].forChild(e, n);
      s != xe && (s instanceof Dt ? r = r.concat(s.members) : r.push(s));
    }
    return Dt.from(r);
  }
  eq(e) {
    if (!(e instanceof Dt) || e.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(e.members[n]))
        return !1;
    return !0;
  }
  locals(e) {
    let n, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].localsInner(e);
      if (s.length)
        if (!n)
          n = s;
        else {
          r && (n = n.slice(), r = !1);
          for (let o = 0; o < s.length; o++)
            n.push(s[o]);
        }
    }
    return n ? Yo(r ? n : n.sort(ln)) : Mn;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return xe;
      case 1:
        return e[0];
      default:
        return new Dt(e.every((n) => n instanceof Z) ? e : e.reduce((n, r) => n.concat(r instanceof Z ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(e);
  }
}
function Bb(t, e, n, r, i, s, o) {
  let l = t.slice();
  for (let c = 0, d = s; c < n.maps.length; c++) {
    let u = 0;
    n.maps[c].forEach((h, f, p, m) => {
      let g = m - p - (f - h);
      for (let b = 0; b < l.length; b += 3) {
        let k = l[b + 1];
        if (k < 0 || h > k + d - u)
          continue;
        let C = l[b] + d - u;
        f >= C ? l[b + 1] = h <= C ? -2 : -1 : h >= d && g && (l[b] += g, l[b + 1] += g);
      }
      u += g;
    }), d = n.maps[c].map(d, -1);
  }
  let a = !1;
  for (let c = 0; c < l.length; c += 3)
    if (l[c + 1] < 0) {
      if (l[c + 1] == -2) {
        a = !0, l[c + 1] = -1;
        continue;
      }
      let d = n.map(t[c] + s), u = d - i;
      if (u < 0 || u >= r.content.size) {
        a = !0;
        continue;
      }
      let h = n.map(t[c + 1] + s, -1), f = h - i, { index: p, offset: m } = r.content.findIndex(u), g = r.maybeChild(p);
      if (g && m == u && m + g.nodeSize == f) {
        let b = l[c + 2].mapInner(n, g, d + 1, t[c] + s + 1, o);
        b != xe ? (l[c] = u, l[c + 1] = f, l[c + 2] = b) : (l[c + 1] = -2, a = !0);
      } else
        a = !0;
    }
  if (a) {
    let c = $b(l, t, e, n, i, s, o), d = ai(c, r, 0, o);
    e = d.local;
    for (let u = 0; u < l.length; u += 3)
      l[u + 1] < 0 && (l.splice(u, 3), u -= 3);
    for (let u = 0, h = 0; u < d.children.length; u += 3) {
      let f = d.children[u];
      for (; h < l.length && l[h] < f; )
        h += 3;
      l.splice(h, 0, d.children[u], d.children[u + 1], d.children[u + 2]);
    }
  }
  return new Z(e.sort(ln), l);
}
function Qd(t, e) {
  if (!e || !t.length)
    return t;
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let i = t[r];
    n.push(new he(i.from + e, i.to + e, i.type));
  }
  return n;
}
function $b(t, e, n, r, i, s, o) {
  function l(a, c) {
    for (let d = 0; d < a.local.length; d++) {
      let u = a.local[d].map(r, i, c);
      u ? n.push(u) : o.onRemove && o.onRemove(a.local[d].spec);
    }
    for (let d = 0; d < a.children.length; d += 3)
      l(a.children[d + 2], a.children[d] + c + 1);
  }
  for (let a = 0; a < t.length; a += 3)
    t[a + 1] == -1 && l(t[a + 2], e[a] + s + 1);
  return n;
}
function Yd(t, e, n) {
  if (e.isLeaf)
    return null;
  let r = n + e.nodeSize, i = null;
  for (let s = 0, o; s < t.length; s++)
    (o = t[s]) && o.from > n && o.to < r && ((i || (i = [])).push(o), t[s] = null);
  return i;
}
function Xd(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function ai(t, e, n, r) {
  let i = [], s = !1;
  e.forEach((l, a) => {
    let c = Yd(t, l, a + n);
    if (c) {
      s = !0;
      let d = ai(c, l, n + a + 1, r);
      d != xe && i.push(a, a + l.nodeSize, d);
    }
  });
  let o = Qd(s ? Xd(t) : t, -n).sort(ln);
  for (let l = 0; l < o.length; l++)
    o[l].type.valid(e, o[l]) || (r.onRemove && r.onRemove(o[l].spec), o.splice(l--, 1));
  return o.length || i.length ? new Z(o, i) : xe;
}
function ln(t, e) {
  return t.from - e.from || t.to - e.to;
}
function Yo(t) {
  let e = t;
  for (let n = 0; n < e.length - 1; n++) {
    let r = e[n];
    if (r.from != r.to)
      for (let i = n + 1; i < e.length; i++) {
        let s = e[i];
        if (s.from == r.from) {
          s.to != r.to && (e == t && (e = t.slice()), e[i] = s.copy(s.from, r.to), ga(e, i + 1, s.copy(r.to, s.to)));
          continue;
        } else {
          s.from < r.to && (e == t && (e = t.slice()), e[n] = r.copy(r.from, s.from), ga(e, i, r.copy(s.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function ga(t, e, n) {
  for (; e < t.length && ln(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function ws(t) {
  let e = [];
  return t.someProp("decorations", (n) => {
    let r = n(t.state);
    r && r != xe && e.push(r);
  }), t.cursorWrapper && e.push(Z.create(t.state.doc, [t.cursorWrapper.deco])), Dt.from(e);
}
const Hb = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, Vb = Oe && Ht <= 11;
class Fb {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class Wb {
  constructor(e, n) {
    this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new Fb(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      Oe && Ht <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : we && e.composing && r.some((i) => i.type == "childList" && i.target.nodeName == "TR") ? (e.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), Vb && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, Hb)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let n = 0; n < e.length; n++)
          this.queue.push(e[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (aa(this.view)) {
      if (this.suppressingSelectionUpdates)
        return wt(this.view);
      if (Oe && Ht <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && un(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let s = e.focusNode; s; s = Rn(s))
      n.add(s);
    for (let s = e.anchorNode; s; s = Rn(s))
      if (n.has(s)) {
        r = s;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && aa(e) && !this.ignoreSelectionChange(r), s = -1, o = -1, l = !1, a = [];
    if (e.editable)
      for (let d = 0; d < n.length; d++) {
        let u = this.registerMutation(n[d], a);
        u && (s = s < 0 ? u.from : Math.min(u.from, s), o = o < 0 ? u.to : Math.max(u.to, o), u.typeOver && (l = !0));
      }
    if (a.some((d) => d.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46)) {
      for (let d of a)
        if (d.nodeName == "BR" && d.parentNode) {
          let u = d.nextSibling;
          for (; u && u.nodeType == 1; ) {
            if (u.contentEditable == "false") {
              d.parentNode.removeChild(d);
              break;
            }
            u = u.firstChild;
          }
        }
    } else if (We && a.length) {
      let d = a.filter((u) => u.nodeName == "BR");
      if (d.length == 2) {
        let [u, h] = d;
        u.parentNode && u.parentNode.parentNode == h.parentNode ? h.remove() : u.remove();
      } else {
        let { focusNode: u } = this.currentSelection;
        for (let h of d) {
          let f = h.parentNode;
          f && f.nodeName == "LI" && (!u || Ub(e, u) != f) && h.remove();
        }
      }
    }
    let c = null;
    s < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Ki(r) && (c = jo(e)) && c.eq(z.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, wt(e), this.currentSelection.set(r), e.scrollToSelection()) : (s > -1 || i) && (s > -1 && (e.docView.markDirty(s, o), qb(e)), e.input.badSafariComposition && (e.input.badSafariComposition = !1, Kb(e, a)), this.handleDOMChange(s, o, l, a), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || wt(e), this.currentSelection.set(r));
  }
  registerMutation(e, n) {
    if (n.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let d = 0; d < e.addedNodes.length; d++) {
        let u = e.addedNodes[d];
        n.push(u), u.nodeType == 3 && (this.lastChangedTextNode = u);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, s = e.nextSibling;
      if (Oe && Ht <= 11 && e.addedNodes.length)
        for (let d = 0; d < e.addedNodes.length; d++) {
          let { previousSibling: u, nextSibling: h } = e.addedNodes[d];
          (!u || Array.prototype.indexOf.call(e.addedNodes, u) < 0) && (i = u), (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (s = h);
        }
      let o = i && i.parentNode == e.target ? ke(i) + 1 : 0, l = r.localPosFromDOM(e.target, o, -1), a = s && s.parentNode == e.target ? ke(s) : e.target.childNodes.length, c = r.localPosFromDOM(e.target, a, 1);
      return { from: l, to: c };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let ya = /* @__PURE__ */ new WeakMap(), ba = !1;
function qb(t) {
  if (!ya.has(t) && (ya.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = We, ba)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), ba = !0;
  }
}
function ka(t, e) {
  let n = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = t.domAtPos(t.state.selection.anchor);
  return un(o.node, o.offset, i, s) && ([n, r, i, s] = [i, s, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: s };
}
function jb(t, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(t.root)[0];
    if (i)
      return ka(t, i);
  }
  let n;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", r, !0), n ? ka(t, n) : null;
}
function Ub(t, e) {
  for (let n = e.parentNode; n && n != t.dom; n = n.parentNode) {
    let r = t.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function Kb(t, e) {
  var n;
  let { focusNode: r, focusOffset: i } = t.domSelectionRange();
  for (let s of e)
    if (((n = s.parentNode) === null || n === void 0 ? void 0 : n.nodeName) == "TR") {
      let o = s.nextSibling;
      for (; o && o.nodeName != "TD" && o.nodeName != "TH"; )
        o = o.nextSibling;
      if (o) {
        let l = o;
        for (; ; ) {
          let a = l.firstChild;
          if (!a || a.nodeType != 1 || a.contentEditable == "false" || /^(BR|IMG)$/.test(a.nodeName))
            break;
          l = a;
        }
        l.insertBefore(s, l.firstChild), r == s && t.domSelection().collapse(s, i);
      } else
        s.parentNode.removeChild(s);
    }
}
function Zb(t, e, n) {
  let { node: r, fromOffset: i, toOffset: s, from: o, to: l } = t.docView.parseRange(e, n), a = t.domSelectionRange(), c, d = a.anchorNode;
  if (d && t.dom.contains(d.nodeType == 1 ? d : d.parentNode) && (c = [{ node: d, offset: a.anchorOffset }], Ki(a) || c.push({ node: a.focusNode, offset: a.focusOffset })), Ce && t.input.lastKeyCode === 8)
    for (let g = s; g > i; g--) {
      let b = r.childNodes[g - 1], k = b.pmViewDesc;
      if (b.nodeName == "BR" && !k) {
        s = g;
        break;
      }
      if (!k || k.size)
        break;
    }
  let u = t.state.doc, h = t.someProp("domParser") || Qn.fromSchema(t.state.schema), f = u.resolve(o), p = null, m = h.parse(r, {
    topNode: f.parent,
    topMatch: f.parent.contentMatchAt(f.index()),
    topOpen: !0,
    from: i,
    to: s,
    preserveWhitespace: f.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: Gb,
    context: f
  });
  if (c && c[0].pos != null) {
    let g = c[0].pos, b = c[1] && c[1].pos;
    b == null && (b = g), p = { anchor: g + o, head: b + o };
  }
  return { doc: m, sel: p, from: o, to: l };
}
function Gb(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (we && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || we && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const Jb = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function Qb(t, e, n, r, i) {
  let s = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let S = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, N = jo(t, S);
    if (N && !t.state.selection.eq(N)) {
      if (Ce && vt && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", ($) => $(t, Qt(13, "Enter"))))
        return;
      let D = t.state.tr.setSelection(N);
      S == "pointer" ? D.setMeta("pointer", !0) : S == "key" && D.scrollIntoView(), s && D.setMeta("composition", s), t.dispatch(D);
    }
    return;
  }
  let o = t.state.doc.resolve(e), l = o.sharedDepth(n);
  e = o.before(l + 1), n = t.state.doc.resolve(n).after(l + 1);
  let a = t.state.selection, c = Zb(t, e, n), d = t.state.doc, u = d.slice(c.from, c.to), h, f;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (h = t.state.selection.to, f = "end") : (h = t.state.selection.from, f = "start"), t.input.lastKeyCode = null;
  let p = e2(u.content, c.doc.content, c.from, h, f);
  if (p && t.input.domChangeCount++, (In && t.input.lastIOSEnter > Date.now() - 225 || vt) && i.some((S) => S.nodeType == 1 && !Jb.test(S.nodeName)) && (!p || p.endA >= p.endB) && t.someProp("handleKeyDown", (S) => S(t, Qt(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (r && a instanceof I && !a.empty && a.$head.sameParent(a.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: a.from, endA: a.to, endB: a.to };
    else {
      if (c.sel) {
        let S = va(t, t.state.doc, c.sel);
        if (S && !S.eq(t.state.selection)) {
          let N = t.state.tr.setSelection(S);
          s && N.setMeta("composition", s), t.dispatch(N);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && p.start == p.endB && t.state.selection instanceof I && (p.start > t.state.selection.from && p.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? p.start = t.state.selection.from : p.endA < t.state.selection.to && p.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (p.endB += t.state.selection.to - p.endA, p.endA = t.state.selection.to)), Oe && Ht <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let m = c.doc.resolveNoCache(p.start - c.from), g = c.doc.resolveNoCache(p.endB - c.from), b = d.resolve(p.start), k = m.sameParent(g) && m.parent.inlineContent && b.end() >= p.endA;
  if ((In && t.input.lastIOSEnter > Date.now() - 225 && (!k || i.some((S) => S.nodeName == "DIV" || S.nodeName == "P")) || !k && m.pos < c.doc.content.size && (!m.sameParent(g) || !m.parent.inlineContent) && m.pos < g.pos && !/\S/.test(c.doc.textBetween(m.pos, g.pos, "", ""))) && t.someProp("handleKeyDown", (S) => S(t, Qt(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > p.start && Xb(d, p.start, p.endA, m, g) && t.someProp("handleKeyDown", (S) => S(t, Qt(8, "Backspace")))) {
    vt && Ce && t.domObserver.suppressSelectionUpdates();
    return;
  }
  Ce && p.endB == p.start && (t.input.lastChromeDelete = Date.now()), vt && !k && m.start() != g.start() && g.parentOffset == 0 && m.depth == g.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, g = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(S) {
      return S(t, Qt(13, "Enter"));
    });
  }, 20));
  let C = p.start, v = p.endA, x = (S) => {
    let N = S || t.state.tr.replace(C, v, c.doc.slice(p.start - c.from, p.endB - c.from));
    if (c.sel) {
      let D = va(t, N.doc, c.sel);
      D && !(Ce && t.composing && D.empty && (p.start != p.endB || t.input.lastChromeDelete < Date.now() - 100) && (D.head == C || D.head == N.mapping.map(v) - 1) || Oe && D.empty && D.head == C) && N.setSelection(D);
    }
    return s && N.setMeta("composition", s), N.scrollIntoView();
  }, M;
  if (k)
    if (m.pos == g.pos) {
      Oe && Ht <= 11 && m.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => wt(t), 20));
      let S = x(t.state.tr.delete(C, v)), N = d.resolve(p.start).marksAcross(d.resolve(p.endA));
      N && S.ensureMarks(N), t.dispatch(S);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (M = Yb(m.parent.content.cut(m.parentOffset, g.parentOffset), b.parent.content.cut(b.parentOffset, p.endA - b.start())))
    ) {
      let S = x(t.state.tr);
      M.type == "add" ? S.addMark(C, v, M.mark) : S.removeMark(C, v, M.mark), t.dispatch(S);
    } else if (m.parent.child(m.index()).isText && m.index() == g.index() - (g.textOffset ? 0 : 1)) {
      let S = m.parent.textBetween(m.parentOffset, g.parentOffset), N = () => x(t.state.tr.insertText(S, C, v));
      t.someProp("handleTextInput", (D) => D(t, C, v, S, N)) || t.dispatch(N());
    } else
      t.dispatch(x());
  else
    t.dispatch(x());
}
function va(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : Uo(t, e.resolve(n.anchor), e.resolve(n.head));
}
function Yb(t, e) {
  let n = t.firstChild.marks, r = e.firstChild.marks, i = n, s = r, o, l, a;
  for (let d = 0; d < r.length; d++)
    i = r[d].removeFromSet(i);
  for (let d = 0; d < n.length; d++)
    s = n[d].removeFromSet(s);
  if (i.length == 1 && s.length == 0)
    l = i[0], o = "add", a = (d) => d.mark(l.addToSet(d.marks));
  else if (i.length == 0 && s.length == 1)
    l = s[0], o = "remove", a = (d) => d.mark(l.removeFromSet(d.marks));
  else
    return null;
  let c = [];
  for (let d = 0; d < e.childCount; d++)
    c.push(a(e.child(d)));
  if (w.from(c).eq(t))
    return { mark: l, type: o };
}
function Xb(t, e, n, r, i) {
  if (
    // The content must have shrunk
    n - e <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Ss(r, !0, !1) < i.pos
  )
    return !1;
  let s = t.resolve(e);
  if (!r.parent.isTextblock) {
    let l = s.nodeAfter;
    return l != null && n == e + l.nodeSize;
  }
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let o = t.resolve(Ss(s, !0, !0));
  return !o.parent.isTextblock || o.pos > n || Ss(o, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function Ss(t, e, n) {
  let r = t.depth, i = e ? t.end() : t.pos;
  for (; r > 0 && (e || t.indexAfter(r) == t.node(r).childCount); )
    r--, i++, e = !1;
  if (n) {
    let s = t.node(r).maybeChild(t.indexAfter(r));
    for (; s && !s.isLeaf; )
      s = s.firstChild, i++;
  }
  return i;
}
function e2(t, e, n, r, i) {
  let s = t.findDiffStart(e, n);
  if (s == null)
    return null;
  let { a: o, b: l } = t.findDiffEnd(e, n + t.size, n + e.size);
  if (i == "end") {
    let a = Math.max(0, s - Math.min(o, l));
    r -= o + a - s;
  }
  if (o < s && t.size < e.size) {
    let a = r <= s && r >= o ? s - r : 0;
    s -= a, s && s < e.size && Ca(e.textBetween(s - 1, s + 1)) && (s += a ? 1 : -1), l = s + (l - o), o = s;
  } else if (l < s) {
    let a = r <= s && r >= l ? s - r : 0;
    s -= a, s && s < t.size && Ca(t.textBetween(s - 1, s + 1)) && (s += a ? 1 : -1), o = s + (o - l), l = s;
  }
  return { start: s, endA: o, endB: l };
}
function Ca(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && n >= 55296 && n <= 56319;
}
class eu {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new gb(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Ta), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Sa(this), wa(this), this.nodeViews = Ma(this), this.docView = na(this.state.doc, xa(this), ws(this), this.dom, this), this.domObserver = new Wb(this, (r, i, s, o) => Qb(this, r, i, s, o)), this.domObserver.start(), yb(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let n in e)
        this._props[n] = e[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && ao(this);
    let n = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Ta), this.directPlugins = e.plugins), this.updateStateInner(e.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in e)
      n[r] = e[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, n) {
    var r;
    let i = this.state, s = !1, o = !1;
    e.storedMarks && this.composing && (Kd(this), o = !0), this.state = e;
    let l = i.plugins != e.plugins || this._props.plugins != n.plugins;
    if (l || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let f = Ma(this);
      n2(f, this.nodeViews) && (this.nodeViews = f, s = !0);
    }
    (l || n.handleDOMEvents != this._props.handleDOMEvents) && ao(this), this.editable = Sa(this), wa(this);
    let a = ws(this), c = xa(this), d = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", u = s || !this.docView.matchesNode(e.doc, c, a);
    (u || !e.selection.eq(i.selection)) && (o = !0);
    let h = d == "preserve" && o && this.dom.style.overflowAnchor == null && Oy(this);
    if (o) {
      this.domObserver.stop();
      let f = u && (Oe || Ce) && !this.composing && !i.selection.empty && !e.selection.empty && t2(i.selection, e.selection);
      if (u) {
        let p = Ce ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = Ob(this)), (s || !this.docView.update(e.doc, c, a, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = na(e.doc, c, a, this.dom, this)), p && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (f = !0);
      }
      f || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && tb(this)) ? wt(this, f) : (Dd(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), d == "reset" ? this.dom.scrollTop = 0 : d == "to selection" ? this.scrollToSelection() : h && Ry(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof L) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && Jl(this, n.getBoundingClientRect(), e);
      } else
        Jl(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, n) {
    let r = e.node, i = -1;
    if (r.from < this.state.doc.content.size && this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let s = r.from + (this.state.doc.content.size - n.doc.content.size);
      (s > 0 && s < this.state.doc.content.size && this.state.doc.nodeAt(s)) == r.node && (i = s);
    }
    this.dragging = new Gd(e.slice, e.move, i < 0 ? void 0 : L.create(this.state.doc, i));
  }
  someProp(e, n) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = n ? n(r) : r))
      return i;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let l = this.directPlugins[o].props[e];
      if (l != null && (i = n ? n(l) : l))
        return i;
    }
    let s = this.state.plugins;
    if (s)
      for (let o = 0; o < s.length; o++) {
        let l = s[o].props[e];
        if (l != null && (i = n ? n(l) : l))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Oe) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && Iy(this.dom), wt(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return By(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, n = 1) {
    return Ed(this, e, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, n = 0) {
    return this.docView.domFromPos(e, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let n = this.docView.descAt(e);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, n, r = -1) {
    let i = this.docView.posFromDOM(e, n, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, n) {
    return Wy(this, n || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, n) {
    return fr(this, "", e, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, n) {
    return fr(this, e, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return Ko(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (bb(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], ws(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, Cy());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return vb(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? we && this.root.nodeType === 11 && Ty(this.dom.ownerDocument) == this.dom && jb(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
eu.prototype.dispatch = function(t) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, t) : this.updateState(this.state.apply(t));
};
function xa(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (let r in n)
        r == "class" ? e.class += " " + n[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + n[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(n[r]));
  }), e.translate || (e.translate = "no"), [he.node(0, t.state.doc.content.size, e)];
}
function wa(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: he.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function Sa(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function t2(t, e) {
  let n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function Ma(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return t.someProp("nodeViews", n), t.someProp("markViews", n), e;
}
function n2(t, e) {
  let n = 0, r = 0;
  for (let i in t) {
    if (t[i] != e[i])
      return !0;
    n++;
  }
  for (let i in e)
    r++;
  return n != r;
}
function Ta(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Wt = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, ci = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, r2 = typeof navigator < "u" && /Mac/.test(navigator.platform), i2 = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var ve = 0; ve < 10; ve++) Wt[48 + ve] = Wt[96 + ve] = String(ve);
for (var ve = 1; ve <= 24; ve++) Wt[ve + 111] = "F" + ve;
for (var ve = 65; ve <= 90; ve++)
  Wt[ve] = String.fromCharCode(ve + 32), ci[ve] = String.fromCharCode(ve);
for (var Ms in Wt) ci.hasOwnProperty(Ms) || (ci[Ms] = Wt[Ms]);
function s2(t) {
  var e = r2 && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || i2 && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? ci : Wt)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const o2 = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), l2 = typeof navigator < "u" && /Win/.test(navigator.platform);
function a2(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let r, i, s, o;
  for (let l = 0; l < e.length - 1; l++) {
    let a = e[l];
    if (/^(cmd|meta|m)$/i.test(a))
      o = !0;
    else if (/^a(lt)?$/i.test(a))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      i = !0;
    else if (/^s(hift)?$/i.test(a))
      s = !0;
    else if (/^mod$/i.test(a))
      o2 ? o = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + a);
  }
  return r && (n = "Alt-" + n), i && (n = "Ctrl-" + n), o && (n = "Meta-" + n), s && (n = "Shift-" + n), n;
}
function c2(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[a2(n)] = t[n];
  return e;
}
function Ts(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function d2(t) {
  return new Y({ props: { handleKeyDown: Xo(t) } });
}
function Xo(t) {
  let e = c2(t);
  return function(n, r) {
    let i = s2(r), s, o = e[Ts(i, r)];
    if (o && o(n.state, n.dispatch, n))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let l = e[Ts(i, r, !1)];
        if (l && l(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(l2 && r.ctrlKey && r.altKey) && (s = Wt[r.keyCode]) && s != i) {
        let l = e[Ts(s, r)];
        if (l && l(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
var u2 = Object.defineProperty, el = (t, e) => {
  for (var n in e)
    u2(t, n, { get: e[n], enumerable: !0 });
};
function Ji(t) {
  const { state: e, transaction: n } = t;
  let { selection: r } = n, { doc: i } = n, { storedMarks: s } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = n.selection, i = n.doc, s = n.storedMarks, n;
    }
  };
}
var Qi = class {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: e, state: n } = this, { view: r } = e, { tr: i } = n, s = this.buildProps(i);
    return Object.fromEntries(
      Object.entries(t).map(([o, l]) => [o, (...c) => {
        const d = l(...c)(s);
        return !i.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(i), d;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, e = !0) {
    const { rawCommands: n, editor: r, state: i } = this, { view: s } = r, o = [], l = !!t, a = t || i.tr, c = () => (!l && e && !a.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(a), o.every((u) => u === !0)), d = {
      ...Object.fromEntries(
        Object.entries(n).map(([u, h]) => [u, (...p) => {
          const m = this.buildProps(a, e), g = h(...p)(m);
          return o.push(g), d;
        }])
      ),
      run: c
    };
    return d;
  }
  createCan(t) {
    const { rawCommands: e, state: n } = this, r = !1, i = t || n.tr, s = this.buildProps(i, r);
    return {
      ...Object.fromEntries(
        Object.entries(e).map(([l, a]) => [l, (...c) => a(...c)({ ...s, dispatch: void 0 })])
      ),
      chain: () => this.createChain(i, r)
    };
  }
  buildProps(t, e = !0) {
    const { rawCommands: n, editor: r, state: i } = this, { view: s } = r, o = {
      tr: t,
      editor: r,
      view: s,
      state: Ji({
        state: i,
        transaction: t
      }),
      dispatch: e ? () => {
      } : void 0,
      chain: () => this.createChain(t, e),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(
          Object.entries(n).map(([l, a]) => [l, (...c) => a(...c)(o)])
        );
      }
    };
    return o;
  }
}, tu = {};
el(tu, {
  blur: () => h2,
  clearContent: () => f2,
  clearNodes: () => p2,
  command: () => m2,
  createParagraphNear: () => g2,
  cut: () => y2,
  deleteCurrentNode: () => b2,
  deleteNode: () => k2,
  deleteRange: () => v2,
  deleteSelection: () => C2,
  enter: () => x2,
  exitCode: () => w2,
  extendMarkRange: () => S2,
  first: () => M2,
  focus: () => E2,
  forEach: () => A2,
  insertContent: () => N2,
  insertContentAt: () => R2,
  joinBackward: () => D2,
  joinDown: () => L2,
  joinForward: () => P2,
  joinItemBackward: () => z2,
  joinItemForward: () => B2,
  joinTextblockBackward: () => $2,
  joinTextblockForward: () => H2,
  joinUp: () => I2,
  keyboardShortcut: () => F2,
  lift: () => W2,
  liftEmptyBlock: () => q2,
  liftListItem: () => j2,
  newlineInCode: () => U2,
  resetAttributes: () => K2,
  scrollIntoView: () => Z2,
  selectAll: () => G2,
  selectNodeBackward: () => J2,
  selectNodeForward: () => Q2,
  selectParentNode: () => Y2,
  selectTextblockEnd: () => X2,
  selectTextblockStart: () => ek,
  setContent: () => tk,
  setMark: () => Ck,
  setMeta: () => xk,
  setNode: () => wk,
  setNodeSelection: () => Sk,
  setTextDirection: () => Mk,
  setTextSelection: () => Tk,
  sinkListItem: () => Ek,
  splitBlock: () => Ak,
  splitListItem: () => Nk,
  toggleList: () => Ok,
  toggleMark: () => Rk,
  toggleNode: () => Ik,
  toggleWrap: () => Lk,
  undoInputRule: () => Dk,
  unsetAllMarks: () => Pk,
  unsetMark: () => zk,
  unsetTextDirection: () => Bk,
  updateAttributes: () => $k,
  wrapIn: () => Hk,
  wrapInList: () => Vk
});
var h2 = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window?.getSelection()) == null || n.removeAllRanges());
}), !0), f2 = (t = !0) => ({ commands: e }) => e.setContent("", { emitUpdate: t }), p2 = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: r } = e, { ranges: i } = r;
  return n && i.forEach(({ $from: s, $to: o }) => {
    t.doc.nodesBetween(s.pos, o.pos, (l, a) => {
      if (l.type.isText)
        return;
      const { doc: c, mapping: d } = e, u = c.resolve(d.map(a)), h = c.resolve(d.map(a + l.nodeSize)), f = u.blockRange(h);
      if (!f)
        return;
      const p = zn(f);
      if (l.type.isTextblock) {
        const { defaultType: m } = u.parent.contentMatchAt(u.index());
        e.setNodeMarkup(f.start, m);
      }
      (p || p === 0) && e.lift(f, p);
    });
  }), !0;
}, m2 = (t) => (e) => t(e), g2 = () => ({ state: t, dispatch: e }) => gd(t, e), y2 = (t, e) => ({ editor: n, tr: r }) => {
  const { state: i } = n, s = i.doc.slice(t.from, t.to);
  r.deleteRange(t.from, t.to);
  const o = r.mapping.map(e);
  return r.insert(o, s.content), r.setSelection(new I(r.doc.resolve(Math.max(o - 1, 0)))), !0;
}, b2 = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = t.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === r.type) {
      if (e) {
        const l = i.before(s), a = i.after(s);
        t.delete(l, a).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function ce(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
var k2 = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const i = ce(t, n.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === i) {
      if (r) {
        const a = s.before(o), c = s.after(o);
        e.delete(a, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, v2 = (t) => ({ tr: e, dispatch: n }) => {
  const { from: r, to: i } = t;
  return n && e.delete(r, i), !0;
}, C2 = () => ({ state: t, dispatch: e }) => $o(t, e), x2 = () => ({ commands: t }) => t.keyboardShortcut("Enter"), w2 = () => ({ state: t, dispatch: e }) => oy(t, e);
function tl(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
function di(t, e, n = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => n.strict ? e[i] === t[i] : tl(e[i]) ? e[i].test(t[i]) : e[i] === t[i]) : !0;
}
function nu(t, e, n = {}) {
  return t.find((r) => r.type === e && di(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((i) => [i, r.attrs[i]])),
    n
  ));
}
function Ea(t, e, n = {}) {
  return !!nu(t, e, n);
}
function nl(t, e, n) {
  if (!t || !e)
    return;
  let r = t.parent.childAfter(t.parentOffset);
  if ((!r.node || !r.node.marks.some((c) => c.type === e)) && (r = t.parent.childBefore(t.parentOffset)), !r.node || !r.node.marks.some((c) => c.type === e))
    return;
  if (!n) {
    const c = r.node.marks.find((d) => d.type === e);
    c && (n = c.attrs);
  }
  if (!nu([...r.node.marks], e, n))
    return;
  let s = r.index, o = t.start() + r.offset, l = s + 1, a = o + r.node.nodeSize;
  for (; s > 0 && Ea([...t.parent.child(s - 1).marks], e, n); )
    s -= 1, o -= t.parent.child(s).nodeSize;
  for (; l < t.parent.childCount && Ea([...t.parent.child(l).marks], e, n); )
    a += t.parent.child(l).nodeSize, l += 1;
  return {
    from: o,
    to: a
  };
}
function St(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
var S2 = (t, e) => ({ tr: n, state: r, dispatch: i }) => {
  const s = St(t, r.schema), { doc: o, selection: l } = n, { $from: a, from: c, to: d } = l;
  if (i) {
    const u = nl(a, s, e);
    if (u && u.from <= c && u.to >= d) {
      const h = I.create(o, u.from, u.to);
      n.setSelection(h);
    }
  }
  return !0;
}, M2 = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](e))
      return !0;
  return !1;
};
function ru(t) {
  return t instanceof I;
}
function en(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function iu(t, e = null) {
  if (!e)
    return null;
  const n = z.atStart(t), r = z.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return r;
  const i = n.from, s = r.to;
  return e === "all" ? I.create(t, en(0, i, s), en(t.content.size, i, s)) : I.create(t, en(e, i, s), en(e, i, s));
}
function Aa() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function ui() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function T2() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var E2 = (t = null, e = {}) => ({ editor: n, view: r, tr: i, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (ui() || Aa()) && r.dom.focus(), T2() && !ui() && !Aa() && r.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), e?.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  try {
    if (r.hasFocus() && t === null || t === !1)
      return !0;
  } catch {
    return !1;
  }
  if (s && t === null && !ru(n.state.selection))
    return o(), !0;
  const l = iu(i.doc, t) || n.state.selection, a = n.state.selection.eq(l);
  return s && (a || i.setSelection(l), a && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, A2 = (t, e) => (n) => t.every((r, i) => e(r, { ...n, index: i })), N2 = (t, e) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), su = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const r = e[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? t.removeChild(r) : r.nodeType === 1 && su(r);
  }
  return t;
};
function Or(t) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return su(n);
}
function mr(t, e, n) {
  if (t instanceof Qe || t instanceof w)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof t == "object" && t !== null, i = typeof t == "string";
  if (r)
    try {
      if (Array.isArray(t) && t.length > 0)
        return w.fromArray(t.map((l) => e.nodeFromJSON(l)));
      const o = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && o.check(), o;
    } catch (s) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: s });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", s), mr("", e, n);
    }
  if (i) {
    if (n.errorOnInvalidContent) {
      let o = !1, l = "";
      const a = new Wc({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (o = !0, l = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Qn.fromSchema(a).parseSlice(Or(t), n.parseOptions) : Qn.fromSchema(a).parse(Or(t), n.parseOptions), n.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${l}`)
        });
    }
    const s = Qn.fromSchema(e);
    return n.slice ? s.parseSlice(Or(t), n.parseOptions).content : s.parse(Or(t), n.parseOptions);
  }
  return mr("", e, n);
}
function _2(t, e, n) {
  const r = t.steps.length - 1;
  if (r < e)
    return;
  const i = t.steps[r];
  if (!(i instanceof le || i instanceof fe))
    return;
  const s = t.mapping.maps[r];
  let o = 0;
  s.forEach((l, a, c, d) => {
    o === 0 && (o = d);
  }), t.setSelection(z.near(t.doc.resolve(o), n));
}
var O2 = (t) => !("type" in t), R2 = (t, e, n) => ({ tr: r, dispatch: i, editor: s }) => {
  var o;
  if (i) {
    n = {
      parseOptions: s.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let l;
    const a = (g) => {
      s.emit("contentError", {
        editor: s,
        error: g,
        disableCollaboration: () => {
          "collaboration" in s.storage && typeof s.storage.collaboration == "object" && s.storage.collaboration && (s.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...n.parseOptions
    };
    if (!n.errorOnInvalidContent && !s.options.enableContentCheck && s.options.emitContentError)
      try {
        mr(e, s.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (g) {
        a(g);
      }
    try {
      l = mr(e, s.schema, {
        parseOptions: c,
        errorOnInvalidContent: (o = n.errorOnInvalidContent) != null ? o : s.options.enableContentCheck
      });
    } catch (g) {
      return a(g), !1;
    }
    let { from: d, to: u } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, h = !0, f = !0;
    if ((O2(l) ? l : [l]).forEach((g) => {
      g.check(), h = h ? g.isText && g.marks.length === 0 : !1, f = f ? g.isBlock : !1;
    }), d === u && f) {
      const { parent: g } = r.doc.resolve(d);
      g.isTextblock && !g.type.spec.code && !g.childCount && (d -= 1, u += 1);
    }
    let m;
    if (h) {
      if (Array.isArray(e))
        m = e.map((g) => g.text || "").join("");
      else if (e instanceof w) {
        let g = "";
        e.forEach((b) => {
          b.text && (g += b.text);
        }), m = g;
      } else typeof e == "object" && e && e.text ? m = e.text : m = e;
      r.insertText(m, d, u);
    } else {
      m = l;
      const g = r.doc.resolve(d), b = g.node(), k = g.parentOffset === 0, C = b.isText || b.isTextblock, v = b.content.size > 0;
      k && C && v && f && (d = Math.max(0, d - 1)), r.replaceWith(d, u, m);
    }
    n.updateSelection && _2(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: d, text: m }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: d, text: m });
  }
  return !0;
}, I2 = () => ({ state: t, dispatch: e }) => ry(t, e), L2 = () => ({ state: t, dispatch: e }) => iy(t, e), D2 = () => ({ state: t, dispatch: e }) => cd(t, e), P2 = () => ({ state: t, dispatch: e }) => fd(t, e), z2 = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = qi(t.doc, t.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, B2 = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const r = qi(t.doc, t.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, $2 = () => ({ state: t, dispatch: e }) => ty(t, e), H2 = () => ({ state: t, dispatch: e }) => ny(t, e);
function ou() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function V2(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let r, i, s, o;
  for (let l = 0; l < e.length - 1; l += 1) {
    const a = e[l];
    if (/^(cmd|meta|m)$/i.test(a))
      o = !0;
    else if (/^a(lt)?$/i.test(a))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      i = !0;
    else if (/^s(hift)?$/i.test(a))
      s = !0;
    else if (/^mod$/i.test(a))
      ui() || ou() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${a}`);
  }
  return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), o && (n = `Meta-${n}`), s && (n = `Shift-${n}`), n;
}
var F2 = (t) => ({ editor: e, view: n, tr: r, dispatch: i }) => {
  const s = V2(t).split(/-(?!$)/), o = s.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), l = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), a = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, l));
  });
  return a?.steps.forEach((c) => {
    const d = c.map(r.mapping);
    d && i && r.maybeStep(d);
  }), !0;
};
function qt(t, e, n = {}) {
  const { from: r, to: i, empty: s } = t.selection, o = e ? ce(e, t.schema) : null, l = [];
  t.doc.nodesBetween(r, i, (u, h) => {
    if (u.isText)
      return;
    const f = Math.max(r, h), p = Math.min(i, h + u.nodeSize);
    l.push({
      node: u,
      from: f,
      to: p
    });
  });
  const a = i - r, c = l.filter((u) => o ? o.name === u.node.type.name : !0).filter((u) => di(u.node.attrs, n, { strict: !1 }));
  return s ? !!c.length : c.reduce((u, h) => u + h.to - h.from, 0) >= a;
}
var W2 = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = ce(t, n.schema);
  return qt(n, i, e) ? sy(n, r) : !1;
}, q2 = () => ({ state: t, dispatch: e }) => yd(t, e), j2 = (t) => ({ state: e, dispatch: n }) => {
  const r = ce(t, e.schema);
  return yy(r)(e, n);
}, U2 = () => ({ state: t, dispatch: e }) => md(t, e);
function Yi(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function Na(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((r, i) => (n.includes(i) || (r[i] = t[i]), r), {});
}
var K2 = (t, e) => ({ tr: n, state: r, dispatch: i }) => {
  let s = null, o = null;
  const l = Yi(
    typeof t == "string" ? t : t.name,
    r.schema
  );
  if (!l)
    return !1;
  l === "node" && (s = ce(t, r.schema)), l === "mark" && (o = St(t, r.schema));
  let a = !1;
  return n.selection.ranges.forEach((c) => {
    r.doc.nodesBetween(c.$from.pos, c.$to.pos, (d, u) => {
      s && s === d.type && (a = !0, i && n.setNodeMarkup(u, void 0, Na(d.attrs, e))), o && d.marks.length && d.marks.forEach((h) => {
        o === h.type && (a = !0, i && n.addMark(u, u + d.nodeSize, o.create(Na(h.attrs, e))));
      });
    });
  }), a;
}, Z2 = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), G2 = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new ze(t.doc);
    t.setSelection(n);
  }
  return !0;
}, J2 = () => ({ state: t, dispatch: e }) => ud(t, e), Q2 = () => ({ state: t, dispatch: e }) => pd(t, e), Y2 = () => ({ state: t, dispatch: e }) => cy(t, e), X2 = () => ({ state: t, dispatch: e }) => hy(t, e), ek = () => ({ state: t, dispatch: e }) => uy(t, e);
function co(t, e, n = {}, r = {}) {
  return mr(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
var tk = (t, { errorOnInvalidContent: e, emitUpdate: n = !0, parseOptions: r = {} } = {}) => ({ editor: i, tr: s, dispatch: o, commands: l }) => {
  const { doc: a } = s;
  if (r.preserveWhitespace !== "full") {
    const c = co(t, i.schema, r, {
      errorOnInvalidContent: e ?? i.options.enableContentCheck
    });
    return o && s.replaceWith(0, a.content.size, c).setMeta("preventUpdate", !n), !0;
  }
  return o && s.setMeta("preventUpdate", !n), l.insertContentAt({ from: 0, to: a.content.size }, t, {
    parseOptions: r,
    errorOnInvalidContent: e ?? i.options.enableContentCheck
  });
};
function lu(t, e) {
  const n = St(e, t.schema), { from: r, to: i, empty: s } = t.selection, o = [];
  s ? (t.storedMarks && o.push(...t.storedMarks), o.push(...t.selection.$head.marks())) : t.doc.nodesBetween(r, i, (a) => {
    o.push(...a.marks);
  });
  const l = o.find((a) => a.type.name === n.name);
  return l ? { ...l.attrs } : {};
}
function au(t, e) {
  const n = new zo(t);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      n.step(i);
    });
  }), n;
}
function nk(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function rk(t, e, n) {
  const r = [];
  return t.nodesBetween(e.from, e.to, (i, s) => {
    n(i) && r.push({
      node: i,
      pos: s
    });
  }), r;
}
function cu(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const r = t.node(n);
    if (e(r))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: r
      };
  }
}
function Xi(t) {
  return (e) => cu(e.$from, t);
}
function O(t, e, n) {
  return t.config[e] === void 0 && t.parent ? O(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? O(t.parent, e, n) : null
  }) : t.config[e];
}
function rl(t) {
  return t.map((e) => {
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    }, r = O(e, "addExtensions", n);
    return r ? [e, ...rl(r())] : e;
  }).flat(10);
}
function il(t, e) {
  const n = gn.fromSchema(e).serializeFragment(t), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(n), i.innerHTML;
}
function du(t) {
  return typeof t == "function";
}
function F(t, e = void 0, ...n) {
  return du(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function ik(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function Ln(t) {
  const e = t.filter((i) => i.type === "extension"), n = t.filter((i) => i.type === "node"), r = t.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: r
  };
}
function uu(t) {
  const e = [], { nodeExtensions: n, markExtensions: r } = Ln(t), i = [...n, ...r], s = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, o = n.filter((c) => c.name !== "text").map((c) => c.name), l = r.map((c) => c.name), a = [...o, ...l];
  return t.forEach((c) => {
    const d = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      extensions: i
    }, u = O(
      c,
      "addGlobalAttributes",
      d
    );
    if (!u)
      return;
    u().forEach((f) => {
      let p;
      Array.isArray(f.types) ? p = f.types : f.types === "*" ? p = a : f.types === "nodes" ? p = o : f.types === "marks" ? p = l : p = [], p.forEach((m) => {
        Object.entries(f.attributes).forEach(([g, b]) => {
          e.push({
            type: m,
            name: g,
            attribute: {
              ...s,
              ...b
            }
          });
        });
      });
    });
  }), i.forEach((c) => {
    const d = {
      name: c.name,
      options: c.options,
      storage: c.storage
    }, u = O(
      c,
      "addAttributes",
      d
    );
    if (!u)
      return;
    const h = u();
    Object.entries(h).forEach(([f, p]) => {
      const m = {
        ...s,
        ...p
      };
      typeof m?.default == "function" && (m.default = m.default()), m?.isRequired && m?.default === void 0 && delete m.default, e.push({
        type: c.name,
        name: f,
        attribute: m
      });
    });
  }), e;
}
function sk(t) {
  const e = [];
  let n = "", r = !1, i = !1, s = 0;
  const o = t.length;
  for (let l = 0; l < o; l += 1) {
    const a = t[l];
    if (a === "'" && !i) {
      r = !r, n += a;
      continue;
    }
    if (a === '"' && !r) {
      i = !i, n += a;
      continue;
    }
    if (!r && !i) {
      if (a === "(") {
        s += 1, n += a;
        continue;
      }
      if (a === ")" && s > 0) {
        s -= 1, n += a;
        continue;
      }
      if (a === ";" && s === 0) {
        e.push(n), n = "";
        continue;
      }
    }
    n += a;
  }
  return n && e.push(n), e;
}
function _a(t) {
  const e = [], n = sk(t || ""), r = n.length;
  for (let i = 0; i < r; i += 1) {
    const s = n[i], o = s.indexOf(":");
    if (o === -1)
      continue;
    const l = s.slice(0, o).trim(), a = s.slice(o + 1).trim();
    l && a && e.push([l, a]);
  }
  return e;
}
function J(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const r = { ...e };
    return Object.entries(n).forEach(([i, s]) => {
      if (!r[i]) {
        r[i] = s;
        return;
      }
      if (i === "class") {
        const l = s ? String(s).split(" ") : [], a = r[i] ? r[i].split(" ") : [], c = l.filter((d) => !a.includes(d));
        r[i] = [...a, ...c].join(" ");
      } else if (i === "style") {
        const l = new Map([..._a(r[i]), ..._a(s)]);
        r[i] = Array.from(l.entries()).map(([a, c]) => `${a}: ${c}`).join("; ");
      } else
        r[i] = s;
    }), r;
  }, {});
}
function gr(t, e) {
  return e.filter((n) => n.type === t.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(t.attrs) || {} : {
    [n.name]: t.attrs[n.name]
  }).reduce((n, r) => J(n, r), {});
}
function ok(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function Oa(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (n) => {
      const r = t.getAttrs ? t.getAttrs(n) : t.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((s, o) => {
        const l = o.attribute.parseHTML ? o.attribute.parseHTML(n) : ok(n.getAttribute(o.name));
        return l == null ? s : {
          ...s,
          [o.name]: l
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function Ra(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, n]) => e === "attrs" && ik(n) ? !1 : n != null)
  );
}
function Ia(t) {
  var e, n;
  const r = {};
  return !((e = t?.attribute) != null && e.isRequired) && "default" in (t?.attribute || {}) && (r.default = t.attribute.default), ((n = t?.attribute) == null ? void 0 : n.validate) !== void 0 && (r.validate = t.attribute.validate), [t.name, r];
}
function lk(t, e) {
  var n;
  const r = uu(t), { nodeExtensions: i, markExtensions: s } = Ln(t), o = (n = i.find((c) => O(c, "topNode"))) == null ? void 0 : n.name, l = Object.fromEntries(
    i.map((c) => {
      const d = r.filter((b) => b.type === c.name), u = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, h = t.reduce((b, k) => {
        const C = O(k, "extendNodeSchema", u);
        return {
          ...b,
          ...C ? C(c) : {}
        };
      }, {}), f = Ra({
        ...h,
        content: F(O(c, "content", u)),
        marks: F(O(c, "marks", u)),
        group: F(O(c, "group", u)),
        inline: F(O(c, "inline", u)),
        atom: F(O(c, "atom", u)),
        selectable: F(O(c, "selectable", u)),
        draggable: F(O(c, "draggable", u)),
        code: F(O(c, "code", u)),
        whitespace: F(O(c, "whitespace", u)),
        linebreakReplacement: F(
          O(c, "linebreakReplacement", u)
        ),
        defining: F(O(c, "defining", u)),
        isolating: F(O(c, "isolating", u)),
        attrs: Object.fromEntries(d.map(Ia))
      }), p = F(O(c, "parseHTML", u));
      p && (f.parseDOM = p.map(
        (b) => Oa(b, d)
      ));
      const m = O(c, "renderHTML", u);
      m && (f.toDOM = (b) => m({
        node: b,
        HTMLAttributes: gr(b, d)
      }));
      const g = O(c, "renderText", u);
      return g && (f.toText = g), [c.name, f];
    })
  ), a = Object.fromEntries(
    s.map((c) => {
      const d = r.filter((g) => g.type === c.name), u = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, h = t.reduce((g, b) => {
        const k = O(b, "extendMarkSchema", u);
        return {
          ...g,
          ...k ? k(c) : {}
        };
      }, {}), f = Ra({
        ...h,
        inclusive: F(O(c, "inclusive", u)),
        excludes: F(O(c, "excludes", u)),
        group: F(O(c, "group", u)),
        spanning: F(O(c, "spanning", u)),
        code: F(O(c, "code", u)),
        attrs: Object.fromEntries(d.map(Ia))
      }), p = F(O(c, "parseHTML", u));
      p && (f.parseDOM = p.map(
        (g) => Oa(g, d)
      ));
      const m = O(c, "renderHTML", u);
      return m && (f.toDOM = (g) => m({
        mark: g,
        HTMLAttributes: gr(g, d)
      })), [c.name, f];
    })
  );
  return new Wc({
    topNode: o,
    nodes: l,
    marks: a
  });
}
function ak(t) {
  const e = t.filter((n, r) => t.indexOf(n) !== r);
  return Array.from(new Set(e));
}
function tr(t) {
  return t.sort((n, r) => {
    const i = O(n, "priority") || 100, s = O(r, "priority") || 100;
    return i > s ? -1 : i < s ? 1 : 0;
  });
}
function hu(t) {
  const e = tr(rl(t)), n = ak(e.map((r) => r.name));
  return n.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${n.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`
  ), e;
}
function fu(t, e, n) {
  const { from: r, to: i } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = n || {};
  let l = "";
  return t.nodesBetween(r, i, (a, c, d, u) => {
    var h;
    a.isBlock && c > r && (l += s);
    const f = o?.[a.type.name];
    if (f)
      return d && (l += f({
        node: a,
        pos: c,
        parent: d,
        index: u,
        range: e
      })), !1;
    a.isText && (l += (h = a?.text) == null ? void 0 : h.slice(Math.max(r, c) - c, i - c));
  }), l;
}
function ck(t, e) {
  const n = {
    from: 0,
    to: t.content.size
  };
  return fu(t, n, e);
}
function pu(t) {
  return Object.fromEntries(
    Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText])
  );
}
function dk(t, e) {
  const n = ce(e, t.schema), { from: r, to: i } = t.selection, s = [];
  t.doc.nodesBetween(r, i, (l) => {
    s.push(l);
  });
  const o = s.reverse().find((l) => l.type.name === n.name);
  return o ? { ...o.attrs } : {};
}
function mu(t, e) {
  const n = Yi(
    typeof e == "string" ? e : e.name,
    t.schema
  );
  return n === "node" ? dk(t, e) : n === "mark" ? lu(t, e) : {};
}
function uk(t, e = JSON.stringify) {
  const n = {};
  return t.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(n, i) ? !1 : n[i] = !0;
  });
}
function hk(t) {
  const e = uk(t);
  return e.length === 1 ? e : e.filter((n, r) => !e.filter((s, o) => o !== r).some((s) => n.oldRange.from >= s.oldRange.from && n.oldRange.to <= s.oldRange.to && n.newRange.from >= s.newRange.from && n.newRange.to <= s.newRange.to));
}
function gu(t) {
  const { mapping: e, steps: n } = t, r = [];
  return e.maps.forEach((i, s) => {
    const o = [];
    if (i.ranges.length)
      i.forEach((l, a) => {
        o.push({ from: l, to: a });
      });
    else {
      const { from: l, to: a } = n[s];
      if (l === void 0 || a === void 0)
        return;
      o.push({ from: l, to: a });
    }
    o.forEach(({ from: l, to: a }) => {
      const c = e.slice(s).map(l, -1), d = e.slice(s).map(a), u = e.invert().map(c, -1), h = e.invert().map(d);
      r.push({
        oldRange: {
          from: u,
          to: h
        },
        newRange: {
          from: c,
          to: d
        }
      });
    });
  }), hk(r);
}
function sl(t, e, n) {
  const r = [];
  return t === e ? n.resolve(t).marks().forEach((i) => {
    const s = n.resolve(t), o = nl(s, i.type);
    o && r.push({
      mark: i,
      ...o
    });
  }) : n.nodesBetween(t, e, (i, s) => {
    !i || i?.nodeSize === void 0 || r.push(
      ...i.marks.map((o) => ({
        from: s,
        to: s + i.nodeSize,
        mark: o
      }))
    );
  }), r;
}
var fk = (t, e, n, r = 20) => {
  const i = t.doc.resolve(n);
  let s = r, o = null;
  for (; s > 0 && o === null; ) {
    const l = i.node(s);
    l?.type.name === e ? o = l : s -= 1;
  }
  return [o, s];
};
function Fn(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function Zr(t, e, n) {
  return Object.fromEntries(
    Object.entries(n).filter(([r]) => {
      const i = t.find((s) => s.type === e && s.name === r);
      return i ? i.attribute.keepOnSplit : !1;
    })
  );
}
var pk = (t, e = 500) => {
  let n = "";
  const r = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, r - e), r, (i, s, o, l) => {
    var a, c;
    const d = ((c = (a = i.type.spec).toText) == null ? void 0 : c.call(a, {
      node: i,
      pos: s,
      parent: o,
      index: l
    })) || i.textContent || "%leaf%";
    n += i.isAtom && !i.isText ? d : d.slice(0, Math.max(0, r - s));
  }), n;
};
function uo(t, e, n = {}) {
  const { empty: r, ranges: i } = t.selection, s = e ? St(e, t.schema) : null;
  if (r)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((u) => s ? s.name === u.type.name : !0).find((u) => di(u.attrs, n, { strict: !1 }));
  let o = 0;
  const l = [];
  if (i.forEach(({ $from: u, $to: h }) => {
    const f = u.pos, p = h.pos;
    t.doc.nodesBetween(f, p, (m, g) => {
      if (s && m.inlineContent && !m.type.allowsMarkType(s))
        return !1;
      if (!m.isText && !m.marks.length)
        return;
      const b = Math.max(f, g), k = Math.min(p, g + m.nodeSize), C = k - b;
      o += C, l.push(
        ...m.marks.map((v) => ({
          mark: v,
          from: b,
          to: k
        }))
      );
    });
  }), o === 0)
    return !1;
  const a = l.filter((u) => s ? s.name === u.mark.type.name : !0).filter((u) => di(u.mark.attrs, n, { strict: !1 })).reduce((u, h) => u + h.to - h.from, 0), c = l.filter((u) => s ? u.mark.type !== s && u.mark.type.excludes(s) : !0).reduce((u, h) => u + h.to - h.from, 0);
  return (a > 0 ? a + c : a) >= o;
}
function mk(t, e, n = {}) {
  if (!e)
    return qt(t, null, n) || uo(t, null, n);
  const r = Yi(e, t.schema);
  return r === "node" ? qt(t, e, n) : r === "mark" ? uo(t, e, n) : !1;
}
var gk = (t, e) => {
  const { $from: n, $to: r, $anchor: i } = t.selection;
  if (e) {
    const s = Xi((l) => l.type.name === e)(t.selection);
    if (!s)
      return !1;
    const o = t.doc.resolve(s.pos + 1);
    return i.pos + 1 === o.end();
  }
  return !(r.parentOffset < r.parent.nodeSize - 2 || n.pos !== r.pos);
}, yk = (t) => {
  const { $from: e, $to: n } = t.selection;
  return !(e.parentOffset > 0 || e.pos !== n.pos);
};
function La(t, e) {
  return Array.isArray(e) ? e.some((n) => (typeof n == "string" ? n : n.name) === t.name) : e;
}
function Es(t, e) {
  const { nodeExtensions: n } = Ln(e), r = n.find((o) => o.name === t);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, s = F(O(r, "group", i));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function es(t, {
  checkChildren: e = !0,
  ignoreWhitespace: n = !1
} = {}) {
  var r;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return !/\S/.test((r = t.text) != null ? r : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return t.content.forEach((s) => {
      i !== !1 && (es(s, { ignoreWhitespace: n, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function yu(t) {
  return t instanceof L;
}
var bu = class ku {
  constructor(e) {
    this.position = e;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(e) {
    return new ku(e.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function bk(t, e) {
  const n = e.mapping.mapResult(t.position);
  return {
    position: new bu(n.pos),
    mapResult: n
  };
}
function kk(t) {
  return new bu(t);
}
function vk(t, e, n) {
  var r;
  const { selection: i } = e;
  let s = null;
  if (ru(i) && (s = i.$cursor), s) {
    const l = (r = t.storedMarks) != null ? r : s.marks();
    return s.parent.type.allowsMarkType(n) && (!!n.isInSet(l) || !l.some((c) => c.type.excludes(n)));
  }
  const { ranges: o } = i;
  return o.some(({ $from: l, $to: a }) => {
    let c = l.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(l.pos, a.pos, (d, u, h) => {
      if (c)
        return !1;
      if (d.isInline) {
        const f = !h || h.type.allowsMarkType(n), p = !!n.isInSet(d.marks) || !d.marks.some((m) => m.type.excludes(n));
        c = f && p;
      }
      return !c;
    }), c;
  });
}
var Ck = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: s } = n, { empty: o, ranges: l } = s, a = St(t, r.schema);
  if (i)
    if (o) {
      const c = lu(r, a);
      n.addStoredMark(
        a.create({
          ...c,
          ...e
        })
      );
    } else
      l.forEach((c) => {
        const d = c.$from.pos, u = c.$to.pos;
        r.doc.nodesBetween(d, u, (h, f) => {
          const p = Math.max(f, d), m = Math.min(f + h.nodeSize, u);
          h.marks.find((b) => b.type === a) ? h.marks.forEach((b) => {
            a === b.type && n.addMark(
              p,
              m,
              a.create({
                ...b.attrs,
                ...e
              })
            );
          }) : n.addMark(p, m, a.create(e));
        });
      });
  return vk(r, n, a);
}, xk = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), wk = (t, e = {}) => ({ state: n, dispatch: r, chain: i }) => {
  const s = ce(t, n.schema);
  let o;
  return n.selection.$anchor.sameParent(n.selection.$head) && (o = n.selection.$anchor.parent.attrs), s.isTextblock ? i().command(({ commands: l }) => Kl(s, { ...o, ...e })(n) ? !0 : l.clearNodes()).command(({ state: l }) => Kl(s, { ...o, ...e })(l, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Sk = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, i = en(t, 0, r.content.size), s = L.create(r, i);
    e.setSelection(s);
  }
  return !0;
}, Mk = (t, e) => ({ tr: n, state: r, dispatch: i }) => {
  const { selection: s } = r;
  let o, l;
  return typeof e == "number" ? (o = e, l = e) : e && "from" in e && "to" in e ? (o = e.from, l = e.to) : (o = s.from, l = s.to), i && n.doc.nodesBetween(o, l, (a, c) => {
    a.isText || n.setNodeMarkup(c, void 0, {
      ...a.attrs,
      dir: t
    });
  }), !0;
}, Tk = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: r } = e, { from: i, to: s } = typeof t == "number" ? { from: t, to: t } : t, o = I.atStart(r).from, l = I.atEnd(r).to, a = en(i, o, l), c = en(s, o, l), d = I.create(r, a, c);
    e.setSelection(d);
  }
  return !0;
}, Ek = (t) => ({ state: e, dispatch: n }) => {
  const r = ce(t, e.schema);
  return vy(r)(e, n);
};
function Da(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const r = n.filter((i) => e?.includes(i.type.name));
    t.tr.ensureMarks(r);
  }
}
var Ak = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: r, editor: i }) => {
  const { selection: s, doc: o } = e, { $from: l, $to: a } = s, c = i.extensionManager.attributes, d = Zr(c, l.node().type.name, l.node().attrs);
  if (s instanceof L && s.node.isBlock)
    return !l.parentOffset || !xt(o, l.pos) ? !1 : (r && (t && Da(n, i.extensionManager.splittableMarks), e.split(l.pos).scrollIntoView()), !0);
  if (!l.parent.isBlock)
    return !1;
  const u = a.parentOffset === a.parent.content.size, h = l.depth === 0 ? void 0 : nk(l.node(-1).contentMatchAt(l.indexAfter(-1)));
  let f = u && h ? [
    {
      type: h,
      attrs: d
    }
  ] : void 0, p = xt(e.doc, e.mapping.map(l.pos), 1, f);
  if (!f && !p && xt(e.doc, e.mapping.map(l.pos), 1, h ? [{ type: h }] : void 0) && (p = !0, f = h ? [
    {
      type: h,
      attrs: d
    }
  ] : void 0), r) {
    if (p && (s instanceof I && e.deleteSelection(), e.split(e.mapping.map(l.pos), 1, f), h && !u && !l.parentOffset && l.parent.type !== h)) {
      const m = e.mapping.map(l.before()), g = e.doc.resolve(m);
      l.node(-1).canReplaceWith(g.index(), g.index() + 1, h) && e.setNodeMarkup(e.mapping.map(l.before()), h);
    }
    t && Da(n, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, Nk = (t, e = {}) => ({ tr: n, state: r, dispatch: i, editor: s }) => {
  var o;
  const l = ce(t, r.schema), { $from: a, $to: c } = r.selection, d = r.selection.node;
  if (d && d.isBlock || a.depth < 2 || !a.sameParent(c))
    return !1;
  const u = a.node(-1);
  if (u.type !== l)
    return !1;
  const h = s.extensionManager.attributes;
  if (a.parent.content.size === 0 && a.node(-1).childCount === a.indexAfter(-1)) {
    if (a.depth === 2 || a.node(-3).type !== l || a.index(-2) !== a.node(-2).childCount - 1)
      return !1;
    if (i) {
      let b = w.empty;
      const k = a.index(-1) ? 1 : a.index(-2) ? 2 : 3;
      for (let N = a.depth - k; N >= a.depth - 3; N -= 1)
        b = w.from(a.node(N).copy(b));
      const C = (
        // eslint-disable-next-line no-nested-ternary
        a.indexAfter(-1) < a.node(-2).childCount ? 1 : a.indexAfter(-2) < a.node(-3).childCount ? 2 : 3
      ), v = {
        ...Zr(h, a.node().type.name, a.node().attrs),
        ...e
      }, x = ((o = l.contentMatch.defaultType) == null ? void 0 : o.createAndFill(v)) || void 0;
      b = b.append(w.from(l.createAndFill(null, x) || void 0));
      const M = a.before(a.depth - (k - 1));
      n.replace(M, a.after(-C), new A(b, 4 - k, 0));
      let S = -1;
      n.doc.nodesBetween(M, n.doc.content.size, (N, D) => {
        if (S > -1)
          return !1;
        N.isTextblock && N.content.size === 0 && (S = D + 1);
      }), S > -1 && n.setSelection(I.near(n.doc.resolve(S))), n.scrollIntoView();
    }
    return !0;
  }
  const f = c.pos === a.end() ? u.contentMatchAt(0).defaultType : null, p = {
    ...Zr(h, u.type.name, u.attrs),
    ...e
  }, m = {
    ...Zr(h, a.node().type.name, a.node().attrs),
    ...e
  };
  n.delete(a.pos, c.pos);
  const g = f ? [
    { type: l, attrs: p },
    { type: f, attrs: m }
  ] : [{ type: l, attrs: p }];
  if (!xt(n.doc, a.pos, 2))
    return !1;
  if (i) {
    const { selection: b, storedMarks: k } = r, { splittableMarks: C } = s.extensionManager, v = k || b.$to.parentOffset && b.$from.marks();
    if (n.split(a.pos, 2, g).scrollIntoView(), !v || !i)
      return !0;
    const x = v.filter((M) => C.includes(M.type.name));
    n.ensureMarks(x);
  }
  return !0;
}, As = (t, e) => {
  const n = Xi((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === i?.type && jt(t.doc, n.pos) && t.join(n.pos), !0;
}, Ns = (t, e) => {
  const n = Xi((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const r = t.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const i = t.doc.nodeAt(r);
  return n.node.type === i?.type && jt(t.doc, r) && t.join(r), !0;
};
function _k(t) {
  const e = t.doc, n = e.firstChild;
  if (!n)
    return null;
  const r = e.resolve(1), i = e.resolve(n.nodeSize - 1);
  return I.between(r, i);
}
var Ok = (t, e, n, r = {}) => ({ editor: i, tr: s, state: o, dispatch: l, chain: a, commands: c, can: d }) => {
  const { extensions: u, splittableMarks: h } = i.extensionManager, f = ce(t, o.schema), p = ce(e, o.schema), { selection: m, storedMarks: g } = o, { $from: b, $to: k } = m, C = b.blockRange(k), v = g || m.$to.parentOffset && m.$from.marks();
  if (!C)
    return !1;
  const x = Xi((P) => Es(P.type.name, u))(m), M = m.from === 0 && m.to === o.doc.content.size, S = o.doc.content.content, N = S.length === 1 ? S[0] : null, D = M && N && Es(N.type.name, u) ? {
    node: N,
    pos: 0
  } : null, $ = x ?? D, oe = !!x && C.depth >= 1 && C.depth - x.depth <= 1, q = !!D;
  if ((oe || q) && $) {
    if ($.node.type === f)
      return M && q ? a().command(({ tr: P, dispatch: _ }) => {
        const V = _k(P);
        return V ? (P.setSelection(V), _ && _(P), !0) : !1;
      }).liftListItem(p).run() : c.liftListItem(p);
    if (Es($.node.type.name, u) && f.validContent($.node.content))
      return a().command(() => (s.setNodeMarkup($.pos, f), !0)).command(() => As(s, f)).command(() => Ns(s, f)).run();
  }
  return !n || !v || !l ? a().command(() => d().wrapInList(f, r) ? !0 : c.clearNodes()).wrapInList(f, r).command(() => As(s, f)).command(() => Ns(s, f)).run() : a().command(() => {
    const P = d().wrapInList(f, r), _ = v.filter((V) => h.includes(V.type.name));
    return s.ensureMarks(_), P ? !0 : c.clearNodes();
  }).wrapInList(f, r).command(() => As(s, f)).command(() => Ns(s, f)).run();
}, Rk = (t, e = {}, n = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: s = !1 } = n, o = St(t, r.schema);
  return uo(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: s }) : i.setMark(o, e);
}, Ik = (t, e, n = {}) => ({ state: r, commands: i }) => {
  const s = ce(t, r.schema), o = ce(e, r.schema), l = qt(r, s, n);
  let a;
  return r.selection.$anchor.sameParent(r.selection.$head) && (a = r.selection.$anchor.parent.attrs), l ? i.setNode(o, a) : i.setNode(s, { ...a, ...n });
}, Lk = (t, e = {}) => ({ state: n, commands: r }) => {
  const i = ce(t, n.schema);
  return qt(n, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, Dk = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const i = n[r];
    let s;
    if (i.spec.isInputRules && (s = i.getState(t))) {
      if (e) {
        const o = t.tr, l = s.transform;
        for (let a = l.steps.length - 1; a >= 0; a -= 1)
          o.step(l.steps[a].invert(l.docs[a]));
        if (s.text) {
          const a = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, t.schema.text(s.text, a));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, Pk = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: r, ranges: i } = n;
  return r || e && i.forEach((s) => {
    t.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, zk = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: l } = n, a = St(t, r.schema), { $from: c, empty: d, ranges: u } = l;
  if (!i)
    return !0;
  if (d && o) {
    let { from: h, to: f } = l;
    const p = (s = c.marks().find((g) => g.type === a)) == null ? void 0 : s.attrs, m = nl(c, a, p);
    m && (h = m.from, f = m.to), n.removeMark(h, f, a);
  } else
    u.forEach((h) => {
      n.removeMark(h.$from.pos, h.$to.pos, a);
    });
  return n.removeStoredMark(a), !0;
}, Bk = (t) => ({ tr: e, state: n, dispatch: r }) => {
  const { selection: i } = n;
  let s, o;
  return typeof t == "number" ? (s = t, o = t) : t && "from" in t && "to" in t ? (s = t.from, o = t.to) : (s = i.from, o = i.to), r && e.doc.nodesBetween(s, o, (l, a) => {
    if (l.isText)
      return;
    const c = { ...l.attrs };
    delete c.dir, e.setNodeMarkup(a, void 0, c);
  }), !0;
}, $k = (t, e = {}) => ({ tr: n, state: r, dispatch: i }) => {
  let s = null, o = null;
  const l = Yi(
    typeof t == "string" ? t : t.name,
    r.schema
  );
  if (!l)
    return !1;
  l === "node" && (s = ce(t, r.schema)), l === "mark" && (o = St(t, r.schema));
  let a = !1;
  return n.selection.ranges.forEach((c) => {
    const d = c.$from.pos, u = c.$to.pos;
    let h, f, p, m;
    n.selection.empty ? r.doc.nodesBetween(d, u, (g, b) => {
      s && s === g.type && (a = !0, p = Math.max(b, d), m = Math.min(b + g.nodeSize, u), h = b, f = g);
    }) : r.doc.nodesBetween(d, u, (g, b) => {
      b < d && s && s === g.type && (a = !0, p = Math.max(b, d), m = Math.min(b + g.nodeSize, u), h = b, f = g), b >= d && b <= u && (s && s === g.type && (a = !0, i && n.setNodeMarkup(b, void 0, {
        ...g.attrs,
        ...e
      })), o && g.marks.length && g.marks.forEach((k) => {
        if (o === k.type && (a = !0, i)) {
          const C = Math.max(b, d), v = Math.min(b + g.nodeSize, u);
          n.addMark(
            C,
            v,
            o.create({
              ...k.attrs,
              ...e
            })
          );
        }
      }));
    }), f && (h !== void 0 && i && n.setNodeMarkup(h, void 0, {
      ...f.attrs,
      ...e
    }), o && f.marks.length && f.marks.forEach((g) => {
      o === g.type && i && n.addMark(
        p,
        m,
        o.create({
          ...g.attrs,
          ...e
        })
      );
    }));
  }), a;
}, Hk = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = ce(t, n.schema);
  return fy(i, e)(n, r);
}, Vk = (t, e = {}) => ({ state: n, dispatch: r }) => {
  const i = ce(t, n.schema);
  return py(i, e)(n, r);
}, Fk = class {
  constructor() {
    this.callbacks = {};
  }
  on(t, e) {
    return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(e), this;
  }
  emit(t, ...e) {
    const n = this.callbacks[t];
    return n && n.forEach((r) => r.apply(this, e)), this;
  }
  off(t, e) {
    const n = this.callbacks[t];
    return n && (e ? this.callbacks[t] = n.filter((r) => r !== e) : delete this.callbacks[t]), this;
  }
  once(t, e) {
    const n = (...r) => {
      this.off(t, n), e.apply(this, r);
    };
    return this.on(t, n);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, ts = class {
  constructor(t) {
    var e;
    this.find = t.find, this.handler = t.handler, this.undoable = (e = t.undoable) != null ? e : !0;
  }
}, Wk = (t, e) => {
  if (tl(e))
    return e.exec(t);
  const n = e(t);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = t, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function Rr(t) {
  var e;
  const { editor: n, from: r, to: i, text: s, rules: o, plugin: l } = t, { view: a } = n;
  if (a.composing)
    return !1;
  const c = a.state.doc.resolve(r);
  if (
    // check for code node
    c.parent.type.spec.code || (e = c.nodeBefore || c.nodeAfter) != null && e.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let d = !1;
  const u = pk(c) + s;
  return o.forEach((h) => {
    if (d)
      return;
    const f = Wk(u, h.find);
    if (!f)
      return;
    const p = a.state.tr, m = Ji({
      state: a.state,
      transaction: p
    }), g = {
      from: r - (f[0].length - s.length),
      to: i
    }, { commands: b, chain: k, can: C } = new Qi({
      editor: n,
      state: m
    });
    h.handler({
      state: m,
      range: g,
      match: f,
      commands: b,
      chain: k,
      can: C
    }) === null || !p.steps.length || (h.undoable && p.setMeta(l, {
      transform: p,
      from: r,
      to: i,
      text: s
    }), a.dispatch(p), d = !0);
  }), d;
}
function qk(t) {
  const { editor: e, rules: n } = t, r = new Y({
    state: {
      init() {
        return null;
      },
      apply(i, s, o) {
        const l = i.getMeta(r);
        if (l)
          return l;
        const a = i.getMeta("applyInputRules");
        return a && setTimeout(() => {
          let { text: d } = a;
          typeof d == "string" ? d = d : d = il(w.from(d), o.schema);
          const { from: u } = a, h = u + d.length;
          Rr({
            editor: e,
            from: u,
            to: h,
            text: d,
            rules: n,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : s;
      }
    },
    props: {
      handleTextInput(i, s, o, l) {
        return Rr({
          editor: e,
          from: s,
          to: o,
          text: l,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: s } = i.state.selection;
          s && Rr({
            editor: e,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: o } = i.state.selection;
        return o ? Rr({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function jk(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function Ir(t) {
  return jk(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function vu(t, e) {
  const n = { ...t };
  return Ir(t) && Ir(e) && Object.keys(e).forEach((r) => {
    Ir(e[r]) && Ir(t[r]) ? n[r] = vu(t[r], e[r]) : n[r] = e[r];
  }), n;
}
var ol = class {
  constructor(t = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...F(
        O(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...F(
        O(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(t = {}) {
    const e = this.extend({
      ...this.config,
      addOptions: () => vu(this.options, t)
    });
    return e.name = this.name, e.parent = this.parent, this.child = null, e;
  }
  extend(t = {}) {
    const e = new this.constructor({ ...this.config, ...t });
    return e.parent = this, this.child = e, e.name = "name" in t ? t.name : e.parent.name, e;
  }
}, yn = class Cu extends ol {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const n = typeof e == "function" ? e() : e;
    return new Cu(n);
  }
  static handleExit({ editor: e, mark: n }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const o = i.marks();
      if (!!!o.find((c) => c?.type.name === n.name))
        return !1;
      const a = o.find((c) => c?.type.name === n.name);
      return a && r.removeStoredMark(a), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const n = typeof e == "function" ? e() : e;
    return super.extend(n);
  }
};
function Uk(t) {
  return typeof t == "number";
}
var Kk = class {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}, Zk = (t, e, n) => {
  if (tl(e))
    return [...t.matchAll(e)];
  const r = e(t, n);
  return r ? r.map((i) => {
    const s = [i.text];
    return s.index = i.index, s.input = t, s.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), s.push(i.replaceWith)), s;
  }) : [];
};
function Gk(t) {
  const { editor: e, state: n, from: r, to: i, rule: s, pasteEvent: o, dropEvent: l } = t, { commands: a, chain: c, can: d } = new Qi({
    editor: e,
    state: n
  }), u = [];
  return n.doc.nodesBetween(r, i, (f, p) => {
    var m, g, b, k, C;
    if ((g = (m = f.type) == null ? void 0 : m.spec) != null && g.code || !(f.isText || f.isTextblock || f.isInline))
      return;
    const v = (C = (k = (b = f.content) == null ? void 0 : b.size) != null ? k : f.nodeSize) != null ? C : 0, x = Math.max(r, p), M = Math.min(i, p + v);
    if (x >= M)
      return;
    const S = f.isText ? f.text || "" : f.textBetween(x - p, M - p, void 0, "￼");
    Zk(S, s.find, o).forEach((D) => {
      if (D.index === void 0)
        return;
      const $ = x + D.index + 1, oe = $ + D[0].length, q = {
        from: n.tr.mapping.map($),
        to: n.tr.mapping.map(oe)
      }, P = s.handler({
        state: n,
        range: q,
        match: D,
        commands: a,
        chain: c,
        can: d,
        pasteEvent: o,
        dropEvent: l
      });
      u.push(P);
    });
  }), u.every((f) => f !== null);
}
var Lr = null, Jk = (t) => {
  var e;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = n.clipboardData) == null || e.setData("text/html", t), n;
};
function Qk(t) {
  const { editor: e, rules: n } = t;
  let r = null, i = !1, s = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, l;
  try {
    l = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    l = null;
  }
  const a = ({
    state: d,
    from: u,
    to: h,
    rule: f,
    pasteEvt: p
  }) => {
    const m = d.tr, g = Ji({
      state: d,
      transaction: m
    });
    if (!(!Gk({
      editor: e,
      state: g,
      from: Math.max(u - 1, 0),
      to: h.b - 1,
      rule: f,
      pasteEvent: p,
      dropEvent: l
    }) || !m.steps.length)) {
      try {
        l = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        l = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, m;
    }
  };
  return n.map((d) => new Y({
    // we register a global drag handler to track the current drag source element
    view(u) {
      const h = (p) => {
        var m;
        r = (m = u.dom.parentElement) != null && m.contains(p.target) ? u.dom.parentElement : null, r && (Lr = e);
      }, f = () => {
        Lr && (Lr = null);
      };
      return window.addEventListener("dragstart", h), window.addEventListener("dragend", f), {
        destroy() {
          window.removeEventListener("dragstart", h), window.removeEventListener("dragend", f);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (u, h) => {
          if (s = r === u.dom.parentElement, l = h, !s) {
            const f = Lr;
            f?.isEditable && setTimeout(() => {
              const p = f.state.selection;
              p && f.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (u, h) => {
          var f;
          const p = (f = h.clipboardData) == null ? void 0 : f.getData("text/html");
          return o = h, i = !!p?.includes("data-pm-slice"), !1;
        }
      }
    },
    appendTransaction: (u, h, f) => {
      const p = u[0], m = p.getMeta("uiEvent") === "paste" && !i, g = p.getMeta("uiEvent") === "drop" && !s, b = p.getMeta("applyPasteRules"), k = !!b;
      if (!m && !g && !k)
        return;
      if (k) {
        let { text: x } = b;
        typeof x == "string" ? x = x : x = il(w.from(x), f.schema);
        const { from: M } = b, S = M + x.length, N = Jk(x);
        return a({
          rule: d,
          state: f,
          from: M,
          to: { b: S },
          pasteEvt: N
        });
      }
      const C = h.doc.content.findDiffStart(f.doc.content), v = h.doc.content.findDiffEnd(f.doc.content);
      if (!(!Uk(C) || !v || C === v.b))
        return a({
          rule: d,
          state: f,
          from: C,
          to: v,
          pasteEvt: o
        });
    }
  }));
}
var ns = class {
  constructor(t, e) {
    this.splittableMarks = [], this.editor = e, this.baseExtensions = t, this.extensions = hu(t), this.schema = lk(this.extensions, e), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((t, e) => {
      const n = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: Fn(e.name, this.schema)
      }, r = O(e, "addCommands", n);
      return r ? {
        ...t,
        ...r()
      } : t;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: t } = this;
    return tr([...this.extensions].reverse()).flatMap((r) => {
      const i = {
        name: r.name,
        options: r.options,
        storage: this.editor.extensionStorage[r.name],
        editor: t,
        type: Fn(r.name, this.schema)
      }, s = [], o = O(
        r,
        "addKeyboardShortcuts",
        i
      );
      let l = {};
      if (r.type === "mark" && O(r, "exitable", i) && (l.ArrowRight = () => yn.handleExit({ editor: t, mark: r })), o) {
        const h = Object.fromEntries(
          Object.entries(o()).map(([f, p]) => [f, () => p({ editor: t })])
        );
        l = { ...l, ...h };
      }
      const a = d2(l);
      s.push(a);
      const c = O(r, "addInputRules", i);
      if (La(r, t.options.enableInputRules) && c) {
        const h = c();
        if (h && h.length) {
          const f = qk({
            editor: t,
            rules: h
          }), p = Array.isArray(f) ? f : [f];
          s.push(...p);
        }
      }
      const d = O(r, "addPasteRules", i);
      if (La(r, t.options.enablePasteRules) && d) {
        const h = d();
        if (h && h.length) {
          const f = Qk({ editor: t, rules: h });
          s.push(...f);
        }
      }
      const u = O(
        r,
        "addProseMirrorPlugins",
        i
      );
      if (u) {
        const h = u();
        s.push(...h);
      }
      return s;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return uu(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: t } = this, { nodeExtensions: e } = Ln(this.extensions);
    return Object.fromEntries(
      e.filter((n) => !!O(n, "addNodeView")).map((n) => {
        const r = this.attributes.filter((a) => a.type === n.name), i = {
          name: n.name,
          options: n.options,
          storage: this.editor.extensionStorage[n.name],
          editor: t,
          type: ce(n.name, this.schema)
        }, s = O(n, "addNodeView", i);
        if (!s)
          return [];
        const o = s();
        if (!o)
          return [];
        const l = (a, c, d, u, h) => {
          const f = gr(a, r);
          return o({
            // pass-through
            node: a,
            view: c,
            getPos: d,
            decorations: u,
            innerDecorations: h,
            // tiptap-specific
            editor: t,
            extension: n,
            HTMLAttributes: f
          });
        };
        return [n.name, l];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(t) {
    const { editor: e } = this;
    return tr([...this.extensions].reverse()).reduceRight((r, i) => {
      const s = {
        name: i.name,
        options: i.options,
        storage: this.editor.extensionStorage[i.name],
        editor: e,
        type: Fn(i.name, this.schema)
      }, o = O(
        i,
        "dispatchTransaction",
        s
      );
      return o ? (l) => {
        o.call(s, { transaction: l, next: r });
      } : r;
    }, t);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(t) {
    const { editor: e } = this;
    return tr([...this.extensions]).reduce(
      (r, i) => {
        const s = {
          name: i.name,
          options: i.options,
          storage: this.editor.extensionStorage[i.name],
          editor: e,
          type: Fn(i.name, this.schema)
        }, o = O(
          i,
          "transformPastedHTML",
          s
        );
        return o ? (l, a) => {
          const c = r(l, a);
          return o.call(s, c);
        } : r;
      },
      t || ((r) => r)
    );
  }
  get markViews() {
    const { editor: t } = this, { markExtensions: e } = Ln(this.extensions);
    return Object.fromEntries(
      e.filter((n) => !!O(n, "addMarkView")).map((n) => {
        const r = this.attributes.filter((l) => l.type === n.name), i = {
          name: n.name,
          options: n.options,
          storage: this.editor.extensionStorage[n.name],
          editor: t,
          type: St(n.name, this.schema)
        }, s = O(n, "addMarkView", i);
        if (!s)
          return [];
        const o = (l, a, c) => {
          const d = gr(l, r);
          return s()({
            // pass-through
            mark: l,
            view: a,
            inline: c,
            // tiptap-specific
            editor: t,
            extension: n,
            HTMLAttributes: d,
            updateAttributes: (u) => {
              hv(l, t, u);
            }
          });
        };
        return [n.name, o];
      })
    );
  }
  /**
   * Destroy the extension manager and clean up all extension references
   * to prevent memory leaks through parent/child extension chains.
   *
   * Walks each extension's full parent chain and nulls every forward
   * `parent.child → current` link where the parent still points to the
   * current node. This breaks the retention path from module-scope
   * singleton roots through deep extend() chains.
   *
   * Only ancestor `.child` links matching the current chain are cleared.
   * The `.parent` pointer on ancestors is never touched — extensions
   * may be shared across live editors, so their own backward references
   * and non-matching forward links must remain intact.
   */
  destroy() {
    this.extensions.forEach((t) => {
      let e = t;
      for (; e.parent; ) {
        const n = e.parent;
        n.child === e && (n.child = null), e = n;
      }
    }), this.extensions = [], this.baseExtensions = [], this.schema = null, this.editor = null;
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const t = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      t.map((e) => [e.name, e.storage])
    ), t.forEach((e) => {
      var n;
      const r = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: Fn(e.name, this.schema)
      };
      e.type === "mark" && ((n = F(O(e, "keepOnSplit", r))) == null || n) && this.splittableMarks.push(e.name);
      const i = O(e, "onBeforeCreate", r), s = O(e, "onCreate", r), o = O(e, "onUpdate", r), l = O(
        e,
        "onSelectionUpdate",
        r
      ), a = O(e, "onTransaction", r), c = O(e, "onFocus", r), d = O(e, "onBlur", r), u = O(e, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), s && this.editor.on("create", s), o && this.editor.on("update", o), l && this.editor.on("selectionUpdate", l), a && this.editor.on("transaction", a), c && this.editor.on("focus", c), d && this.editor.on("blur", d), u && this.editor.on("destroy", u);
    });
  }
};
ns.resolve = hu;
ns.sort = tr;
ns.flatten = rl;
var Yk = {};
el(Yk, {
  ClipboardTextSerializer: () => wu,
  Commands: () => Su,
  Delete: () => Mu,
  Drop: () => Tu,
  Editable: () => Eu,
  FocusEvents: () => Nu,
  Keymap: () => _u,
  Paste: () => Ou,
  Tabindex: () => Ru,
  TextDirection: () => Iu,
  focusEventsPluginKey: () => Au
});
var X = class xu extends ol {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const n = typeof e == "function" ? e() : e;
    return new xu(n);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const n = typeof e == "function" ? e() : e;
    return super.extend(n);
  }
}, wu = X.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Y({
        key: new se("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: r, selection: i } = e, { ranges: s } = i, o = Math.min(...s.map((d) => d.$from.pos)), l = Math.max(...s.map((d) => d.$to.pos)), a = pu(n);
            return fu(r, { from: o, to: l }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: a
            });
          }
        }
      })
    ];
  }
}), Su = X.create({
  name: "commands",
  addCommands() {
    return {
      ...tu
    };
  }
}), Mu = X.create({
  name: "delete",
  onUpdate({ transaction: t, appendedTransactions: e }) {
    var n, r, i;
    const s = () => {
      var o, l, a, c;
      if ((c = (a = (l = (o = this.editor.options.coreExtensionOptions) == null ? void 0 : o.delete) == null ? void 0 : l.filterTransaction) == null ? void 0 : a.call(l, t)) != null ? c : t.getMeta("y-sync$"))
        return;
      const d = au(t.before, [t, ...e]);
      gu(d).forEach((f) => {
        d.mapping.mapResult(f.oldRange.from).deletedAfter && d.mapping.mapResult(f.oldRange.to).deletedBefore && d.before.nodesBetween(f.oldRange.from, f.oldRange.to, (p, m) => {
          const g = m + p.nodeSize - 2, b = f.oldRange.from <= m && g <= f.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: p,
            from: m,
            to: g,
            newFrom: d.mapping.map(m),
            newTo: d.mapping.map(g),
            deletedRange: f.oldRange,
            newRange: f.newRange,
            partial: !b,
            editor: this.editor,
            transaction: t,
            combinedTransform: d
          });
        });
      });
      const h = d.mapping;
      d.steps.forEach((f, p) => {
        var m, g;
        if (f instanceof Je) {
          const b = h.slice(p).map(f.from, -1), k = h.slice(p).map(f.to), C = h.invert().map(b, -1), v = h.invert().map(k), x = b > 0 ? (m = d.doc.nodeAt(b - 1)) == null ? void 0 : m.marks.some((S) => S.eq(f.mark)) : !1, M = (g = d.doc.nodeAt(k)) == null ? void 0 : g.marks.some((S) => S.eq(f.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: f.mark,
            from: f.from,
            to: f.to,
            deletedRange: {
              from: C,
              to: v
            },
            newRange: {
              from: b,
              to: k
            },
            partial: !!(M || x),
            editor: this.editor,
            transaction: t,
            combinedTransform: d
          });
        }
      });
    };
    (i = (r = (n = this.editor.options.coreExtensionOptions) == null ? void 0 : n.delete) == null ? void 0 : r.async) == null || i ? setTimeout(s, 0) : s();
  }
}), Tu = X.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Y({
        key: new se("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), Eu = X.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Y({
        key: new se("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Au = new se("focusEvents"), Nu = X.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Y({
        key: Au,
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const r = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const r = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), _u = X.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: l }) => {
        const { selection: a, doc: c } = l, { empty: d, $anchor: u } = a, { pos: h, parent: f } = u, p = u.parent.isTextblock && h > 0 ? l.doc.resolve(h - 1) : u, m = p.parent.type.spec.isolating, g = u.pos - u.parentOffset, b = m && p.parent.childCount === 1 ? g === u.pos : z.atStart(c).from === h;
        return !d || !f.type.isTextblock || f.textContent.length || !b || b && u.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, s = {
      ...r,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return ui() || ou() ? s : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Y({
        key: new se("clearDocument"),
        appendTransaction: (t, e, n) => {
          if (t.some((m) => m.getMeta("composition")))
            return;
          const r = t.some((m) => m.docChanged) && !e.doc.eq(n.doc), i = t.some((m) => m.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: s, from: o, to: l } = e.selection, a = z.atStart(e.doc).from, c = z.atEnd(e.doc).to;
          if (s || !(o === a && l === c) || !es(n.doc))
            return;
          const h = n.tr, f = Ji({
            state: n,
            transaction: h
          }), { commands: p } = new Qi({
            editor: this.editor,
            state: f
          });
          if (p.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), Ou = X.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Y({
        key: new se("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
}), Ru = X.create({
  name: "tabindex",
  addOptions() {
    return {
      value: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Y({
        key: new se("tabindex"),
        props: {
          attributes: () => {
            var t;
            return !this.editor.isEditable && this.options.value === void 0 ? {} : { tabindex: (t = this.options.value) != null ? t : "0" };
          }
        }
      })
    ];
  }
}), Iu = X.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: t } = Ln(this.extensions);
    return [
      {
        types: t.filter((e) => e.name !== "text").map((e) => e.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (e) => {
              const n = e.getAttribute("dir");
              return n && (n === "ltr" || n === "rtl" || n === "auto") ? n : this.options.direction;
            },
            renderHTML: (e) => e.dir ? {
              dir: e.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new Y({
        key: new se("textDirection"),
        props: {
          attributes: () => {
            const t = this.options.direction;
            return t ? {
              dir: t
            } : {};
          }
        }
      })
    ];
  }
}), Xk = class Zn {
  constructor(e, n, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = n, this.currentNode = i;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) != null ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(e);
    return new Zn(n, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Zn(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Zn(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((n, r) => {
      const i = n.isBlock && !n.isTextblock, s = n.isAtom && !n.isText, o = n.isInline, l = this.pos + r + (s ? 0 : 1);
      if (l < 0 || l > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(l);
      if (!i && !o && a.depth <= this.depth)
        return;
      const c = new Zn(a, this.editor, i, i || o ? n : null);
      i && (c.actualDepth = this.depth + 1), e.push(c);
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, n = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === e)
        if (Object.keys(n).length > 0) {
          const s = i.node.attrs, o = Object.keys(n);
          for (let l = 0; l < o.length; l += 1) {
            const a = o[l];
            if (s[a] !== n[a])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(e, n = {}) {
    return this.querySelectorAll(e, n, !0)[0] || null;
  }
  querySelectorAll(e, n = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const s = Object.keys(n);
    return this.children.forEach((o) => {
      r && i.length > 0 || (o.node.type.name === e && s.every((a) => n[a] === o.node.attrs[a]) && i.push(o), !(r && i.length > 0) && (i = i.concat(o.querySelectorAll(e, n, r))));
    }), i;
  }
  setAttribute(e) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(n);
  }
}, ev = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function tv(t, e, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(i), i;
}
var nv = class extends Fk {
  constructor(t = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.destroyed = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: r }) => {
        throw r;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: bk,
      createMappablePosition: kk
    }, this.setOptions(t), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: r, slice: i, moved: s }) => this.options.onDrop(r, i, s)), this.on("paste", ({ event: r, slice: i }) => this.options.onPaste(r, i)), this.on("delete", this.options.onDelete);
    const e = this.createDoc(), n = iu(e, this.options.autofocus);
    this.editorState = En.create({
      doc: e,
      schema: this.schema,
      selection: n || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(t) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(t), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const t = this.editorView.dom;
      t?.editor && delete t.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (t) {
        console.warn("Failed to remove CSS element:", t);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = tv(ev, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(t = {}) {
    this.options = {
      ...this.options,
      ...t
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(t, e = !0) {
    this.setOptions({ editable: t }), e && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (t) => {
          this.editorState = t;
        },
        dispatch: (t) => {
          this.dispatchTransaction(t);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (t, e) => {
          if (this.editorView)
            return this.editorView[e];
          if (e === "state")
            return this.editorState;
          if (e in t)
            return Reflect.get(t, e);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${e}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(t, e) {
    const n = du(e) ? e(t, [...this.state.plugins]) : [...this.state.plugins, t], r = this.state.reconfigure({ plugins: n });
    return this.view.updateState(r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(t) {
    if (this.isDestroyed)
      return;
    const e = this.state.plugins;
    let n = e;
    if ([].concat(t).forEach((i) => {
      const s = typeof i == "string" ? `${i}$` : i.key;
      n = n.filter((o) => !o.key.startsWith(s));
    }), e.length === n.length)
      return;
    const r = this.state.reconfigure({
      plugins: n
    });
    return this.view.updateState(r), r;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var t, e, n, r;
    const s = [...this.options.enableCoreExtensions ? [
      Eu,
      wu.configure({
        blockSeparator: (e = (t = this.options.coreExtensionOptions) == null ? void 0 : t.clipboardTextSerializer) == null ? void 0 : e.blockSeparator
      }),
      Su,
      Nu,
      _u,
      Ru.configure({
        value: (r = (n = this.options.coreExtensionOptions) == null ? void 0 : n.tabindex) == null ? void 0 : r.value
      }),
      Tu,
      Ou,
      Mu,
      Iu.configure({
        direction: this.options.textDirection
      })
    ].filter((o) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[o.name] !== !1 : !0) : [], ...this.options.extensions].filter((o) => ["extension", "node", "mark"].includes(o?.type));
    this.extensionManager = new ns(s, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Qi({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let t;
    try {
      t = co(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (e) {
      if (!(e instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(e.message))
        throw e;
      this.emit("contentError", {
        editor: this,
        error: e,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((n) => n.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = co(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return t;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(t) {
    const { editorProps: e, enableExtensionDispatchTransaction: n } = this.options, r = e.dispatchTransaction || this.dispatchTransaction.bind(this), i = n ? this.extensionManager.dispatchTransaction(r) : r, s = e.transformPastedHTML, o = this.extensionManager.transformPastedHTML(s);
    this.editorView = new eu(t, {
      ...e,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...e?.attributes
      },
      dispatchTransaction: i,
      transformPastedHTML: o,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const l = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(l), this.prependClass(), this.injectCSS();
    const a = this.view.dom;
    a.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(t) {
    this.isCapturingTransaction = !0, t(), this.isCapturingTransaction = !1;
    const e = this.capturedTransaction;
    return this.capturedTransaction = null, e;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(t) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = t;
        return;
      }
      t.steps.forEach((c) => {
        var d;
        return (d = this.capturedTransaction) == null ? void 0 : d.step(c);
      });
      return;
    }
    const { state: e, transactions: n } = this.state.applyTransaction(t), r = !this.state.selection.eq(e.selection), i = n.includes(t), s = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: t,
      nextState: e
    }), !i)
      return;
    this.view.updateState(e), this.emit("transaction", {
      editor: this,
      transaction: t,
      appendedTransactions: n.slice(1)
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: t
    });
    const o = n.findLast((c) => c.getMeta("focus") || c.getMeta("blur")), l = o?.getMeta("focus"), a = o?.getMeta("blur");
    l && this.emit("focus", {
      editor: this,
      event: l.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: o
    }), a && this.emit("blur", {
      editor: this,
      event: a.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: o
    }), !(t.getMeta("preventUpdate") || !n.some((c) => c.docChanged) || s.doc.eq(e.doc)) && this.emit("update", {
      editor: this,
      transaction: t,
      appendedTransactions: n.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(t) {
    return mu(this.state, t);
  }
  isActive(t, e) {
    const n = typeof t == "string" ? t : null, r = typeof t == "string" ? e : t;
    return mk(this.state, n, r);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return il(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(t) {
    const { blockSeparator: e = `

`, textSerializers: n = {} } = t || {};
    return ck(this.state.doc, {
      blockSeparator: e,
      textSerializers: {
        ...pu(this.schema),
        ...n
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return es(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.emit("destroy"), this.unmount(), this.removeAllListeners(), this.extensionManager.destroy(), this.extensionManager = null, this.schema = null, this.commandManager = null, this.extensionStorage = {});
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var t, e;
    return (e = (t = this.editorView) == null ? void 0 : t.isDestroyed) != null ? e : !0;
  }
  $node(t, e) {
    var n;
    return ((n = this.$doc) == null ? void 0 : n.querySelector(t, e)) || null;
  }
  $nodes(t, e) {
    var n;
    return ((n = this.$doc) == null ? void 0 : n.querySelectorAll(t, e)) || null;
  }
  $pos(t) {
    const e = this.state.doc.resolve(t);
    return new Xk(e, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function Dn(t) {
  return new ts({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = F(t.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = e, o = r[r.length - 1], l = r[0];
      if (o) {
        const a = l.search(/\S/), c = n.from + l.indexOf(o), d = c + o.length;
        if (sl(n.from, n.to, e.doc).filter((f) => f.mark.type.excluded.find((m) => m === t.type && m !== f.mark.type)).filter((f) => f.to > c).length)
          return null;
        d < n.to && s.delete(d, n.to), c > n.from && s.delete(n.from + a, c);
        const h = n.from + a + o.length;
        s.addMark(n.from + a, h, t.type.create(i || {})), s.removeStoredMark(t.type);
      }
    },
    undoable: t.undoable
  });
}
function Lu(t) {
  return new ts({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = F(t.getAttributes, void 0, r) || {}, { tr: s } = e, o = n.from;
      let l = n.to;
      const a = t.type.create(i);
      if (r[1]) {
        const c = r[0].lastIndexOf(r[1]);
        let d = o + c;
        d > l ? d = l : l = d + r[1].length;
        const u = r[0][r[0].length - 1];
        s.insertText(u, o + r[0].length - 1), s.replaceWith(d, l, a);
      } else if (r[0]) {
        const c = t.type.isInline ? o : o - 1;
        s.insert(c, t.type.create(i)).delete(s.mapping.map(o), s.mapping.map(l));
      }
      s.scrollIntoView();
    },
    undoable: t.undoable
  });
}
function ho(t) {
  return new ts({
    find: t.find,
    handler: ({ state: e, range: n, match: r }) => {
      const i = e.doc.resolve(n.from), s = F(t.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), t.type))
        return null;
      e.tr.delete(n.from, n.to).setBlockType(n.from, n.from, t.type, s);
    },
    undoable: t.undoable
  });
}
function Pn(t) {
  return new ts({
    find: t.find,
    handler: ({ state: e, range: n, match: r, chain: i }) => {
      const s = F(t.getAttributes, void 0, r) || {}, o = e.tr.delete(n.from, n.to), a = o.doc.resolve(n.from).blockRange(), c = a && Po(a, t.type, s);
      if (!c)
        return null;
      if (o.wrap(a, c), t.keepMarks && t.editor) {
        const { selection: u, storedMarks: h } = e, { splittableMarks: f } = t.editor.extensionManager, p = h || u.$to.parentOffset && u.$from.marks();
        if (p) {
          const m = p.filter((g) => f.includes(g.type.name));
          o.ensureMarks(m);
        }
      }
      if (t.keepAttributes) {
        const u = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(u, s).run();
      }
      const d = o.doc.resolve(n.from - 1).nodeBefore;
      d && d.type === t.type && jt(o.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(r, d)) && o.join(n.from - 1);
    },
    undoable: t.undoable
  });
}
var rv = (t) => "touches" in t, iv = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(t) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (l) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const a = l.clientX - this.startX, c = l.clientY - this.startY;
      this.handleResize(a, c);
    }, this.handleTouchMove = (l) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const a = l.touches[0];
      if (!a)
        return;
      const c = a.clientX - this.startX, d = a.clientY - this.startY;
      this.handleResize(c, d);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const l = this.element.offsetWidth, a = this.element.offsetHeight;
      this.onCommit(l, a), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (l) => {
      l.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (l) => {
      l.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var e, n, r, i, s, o;
    this.node = t.node, this.editor = t.editor, this.element = t.element, this.contentElement = t.contentElement, this.getPos = t.getPos, this.onResize = t.onResize, this.onCommit = t.onCommit, this.onUpdate = t.onUpdate, (e = t.options) != null && e.min && (this.minSize = {
      ...this.minSize,
      ...t.options.min
    }), (n = t.options) != null && n.max && (this.maxSize = t.options.max), (r = t?.options) != null && r.directions && (this.directions = t.options.directions), (i = t.options) != null && i.preserveAspectRatio && (this.preserveAspectRatio = t.options.preserveAspectRatio), (s = t.options) != null && s.className && (this.classNames = {
      container: t.options.className.container || "",
      wrapper: t.options.className.wrapper || "",
      handle: t.options.className.handle || "",
      resizing: t.options.className.resizing || ""
    }), (o = t.options) != null && o.createCustomHandle && (this.createCustomHandle = t.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var t;
    return (t = this.contentElement) != null ? t : null;
  }
  handleEditorUpdate() {
    const t = this.editor.isEditable;
    t !== this.lastEditableState && (this.lastEditableState = t, t ? t && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(t, e, n) {
    return t.type !== this.node.type ? !1 : (this.node = t, this.onUpdate ? this.onUpdate(t, e, n) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const t = document.createElement("div");
    return t.dataset.resizeContainer = "", t.dataset.node = this.node.type.name, t.style.display = this.node.type.isInline ? "inline-flex" : "flex", this.classNames.container && (t.className = this.classNames.container), t.appendChild(this.wrapper), t;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const t = document.createElement("div");
    return t.style.position = "relative", t.style.display = "block", t.dataset.resizeWrapper = "", this.classNames.wrapper && (t.className = this.classNames.wrapper), t.appendChild(this.element), t;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(t) {
    const e = document.createElement("div");
    return e.dataset.resizeHandle = t, e.style.position = "absolute", this.classNames.handle && (e.className = this.classNames.handle), e;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(t, e) {
    const n = e.includes("top"), r = e.includes("bottom"), i = e.includes("left"), s = e.includes("right");
    n && (t.style.top = "0"), r && (t.style.bottom = "0"), i && (t.style.left = "0"), s && (t.style.right = "0"), (e === "top" || e === "bottom") && (t.style.left = "0", t.style.right = "0"), (e === "left" || e === "right") && (t.style.top = "0", t.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((t) => {
      let e;
      this.createCustomHandle ? e = this.createCustomHandle(t) : e = this.createHandle(t), e instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${t}") did not return an HTMLElement. Falling back to default handle.`
      ), e = this.createHandle(t)), this.createCustomHandle || this.positionHandle(e, t), e.addEventListener("mousedown", (n) => this.handleResizeStart(n, t)), e.addEventListener("touchstart", (n) => this.handleResizeStart(n, t)), this.handleMap.set(t, e), this.wrapper.appendChild(e);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((t) => t.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const t = this.node.attrs.width, e = this.node.attrs.height;
    t ? (this.element.style.width = `${t}px`, this.initialWidth = t) : this.initialWidth = this.element.offsetWidth, e ? (this.element.style.height = `${e}px`, this.initialHeight = e) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(t, e) {
    t.preventDefault(), t.stopPropagation(), this.isResizing = !0, this.activeHandle = e, rv(t) ? (this.startX = t.touches[0].clientX, this.startY = t.touches[0].clientY) : (this.startX = t.clientX, this.startY = t.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(t, e) {
    if (!this.activeHandle)
      return;
    const n = this.preserveAspectRatio || this.isShiftKeyPressed, { width: r, height: i } = this.calculateNewDimensions(this.activeHandle, t, e), s = this.applyConstraints(r, i, n);
    this.element.style.width = `${s.width}px`, this.element.style.height = `${s.height}px`, this.onResize && this.onResize(s.width, s.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(t, e, n) {
    let r = this.startWidth, i = this.startHeight;
    const s = t.includes("right"), o = t.includes("left"), l = t.includes("bottom"), a = t.includes("top");
    return s ? r = this.startWidth + e : o && (r = this.startWidth - e), l ? i = this.startHeight + n : a && (i = this.startHeight - n), (t === "right" || t === "left") && (r = this.startWidth + (s ? e : -e)), (t === "top" || t === "bottom") && (i = this.startHeight + (l ? n : -n)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(r, i, t) : { width: r, height: i };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(t, e, n) {
    var r, i, s, o;
    if (!n) {
      let c = Math.max(this.minSize.width, t), d = Math.max(this.minSize.height, e);
      return (r = this.maxSize) != null && r.width && (c = Math.min(this.maxSize.width, c)), (i = this.maxSize) != null && i.height && (d = Math.min(this.maxSize.height, d)), { width: c, height: d };
    }
    let l = t, a = e;
    return l < this.minSize.width && (l = this.minSize.width, a = l / this.aspectRatio), a < this.minSize.height && (a = this.minSize.height, l = a * this.aspectRatio), (s = this.maxSize) != null && s.width && l > this.maxSize.width && (l = this.maxSize.width, a = l / this.aspectRatio), (o = this.maxSize) != null && o.height && a > this.maxSize.height && (a = this.maxSize.height, l = a * this.aspectRatio), { width: l, height: a };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(t, e, n) {
    const r = n === "left" || n === "right", i = n === "top" || n === "bottom";
    return r ? {
      width: t,
      height: t / this.aspectRatio
    } : i ? {
      width: e * this.aspectRatio,
      height: e
    } : {
      width: t,
      height: t / this.aspectRatio
    };
  }
};
function sv(t, e) {
  const { selection: n } = t, { $from: r } = n;
  if (n instanceof L) {
    const s = r.index();
    return r.parent.canReplaceWith(s, s + 1, e);
  }
  let i = r.depth;
  for (; i >= 0; ) {
    const s = r.index(i);
    if (r.node(i).contentMatchAt(s).matchType(e))
      return !0;
    i -= 1;
  }
  return !1;
}
var ov = {};
el(ov, {
  createAtomBlockMarkdownSpec: () => lv,
  createBlockMarkdownSpec: () => av,
  createInlineMarkdownSpec: () => uv,
  parseAttributes: () => ll,
  parseIndentedBlocks: () => fo,
  renderNestedMarkdownContent: () => cl,
  serializeAttributes: () => al
});
function ll(t) {
  if (!t?.trim())
    return {};
  const e = {}, n = [], r = t.replace(/["']([^"']*)["']/g, (c) => (n.push(c), `__QUOTED_${n.length - 1}__`)), i = r.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (i) {
    const c = i.map((d) => d.trim().slice(1));
    e.class = c.join(" ");
  }
  const s = r.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  s && (e.id = s[1]);
  const o = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(r.matchAll(o)).forEach(([, c, d]) => {
    var u;
    const h = parseInt(((u = d.match(/__QUOTED_(\d+)__/)) == null ? void 0 : u[1]) || "0", 10), f = n[h];
    f && (e[c] = f.slice(1, -1));
  });
  const a = r.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return a && a.split(/\s+/).filter(Boolean).forEach((d) => {
    d.match(/^[a-zA-Z][\w-]*$/) && (e[d] = !0);
  }), e;
}
function al(t) {
  if (!t || Object.keys(t).length === 0)
    return "";
  const e = [];
  return t.class && String(t.class).split(/\s+/).filter(Boolean).forEach((r) => e.push(`.${r}`)), t.id && e.push(`#${t.id}`), Object.entries(t).forEach(([n, r]) => {
    n === "class" || n === "id" || (r === !0 ? e.push(n) : r !== !1 && r != null && e.push(`${n}="${String(r)}"`));
  }), e.join(" ");
}
function lv(t) {
  const {
    nodeName: e,
    name: n,
    parseAttributes: r = ll,
    serializeAttributes: i = al,
    defaultAttributes: s = {},
    requiredAttributes: o = [],
    allowedAttributes: l
  } = t, a = n || e, c = (d) => {
    if (!l)
      return d;
    const u = {};
    return l.forEach((h) => {
      h in d && (u[h] = d[h]);
    }), u;
  };
  return {
    parseMarkdown: (d, u) => {
      const h = { ...s, ...d.attributes };
      return u.createNode(e, h, []);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(d) {
        var u;
        const h = new RegExp(`^:::${a}(?:\\s|$)`, "m"), f = (u = d.match(h)) == null ? void 0 : u.index;
        return f !== void 0 ? f : -1;
      },
      tokenize(d, u, h) {
        const f = new RegExp(`^:::${a}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), p = d.match(f);
        if (!p)
          return;
        const m = p[1] || "", g = r(m);
        if (!o.find((k) => !(k in g)))
          return {
            type: e,
            raw: p[0],
            attributes: g
          };
      }
    },
    renderMarkdown: (d) => {
      const u = c(d.attrs || {}), h = i(u), f = h ? ` {${h}}` : "";
      return `:::${a}${f} :::`;
    }
  };
}
function av(t) {
  const {
    nodeName: e,
    name: n,
    getContent: r,
    parseAttributes: i = ll,
    serializeAttributes: s = al,
    defaultAttributes: o = {},
    content: l = "block",
    allowedAttributes: a
  } = t, c = n || e, d = (u) => {
    if (!a)
      return u;
    const h = {};
    return a.forEach((f) => {
      f in u && (h[f] = u[f]);
    }), h;
  };
  return {
    parseMarkdown: (u, h) => {
      let f;
      if (r) {
        const m = r(u);
        f = typeof m == "string" ? [{ type: "text", text: m }] : m;
      } else l === "block" ? f = h.parseChildren(u.tokens || []) : f = h.parseInline(u.tokens || []);
      const p = { ...o, ...u.attributes };
      return h.createNode(e, p, f);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(u) {
        var h;
        const f = new RegExp(`^:::${c}`, "m"), p = (h = u.match(f)) == null ? void 0 : h.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(u, h, f) {
        var p;
        const m = new RegExp(`^:::${c}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), g = u.match(m);
        if (!g)
          return;
        const [b, k = ""] = g, C = i(k);
        let v = 1;
        const x = b.length;
        let M = "";
        const S = /^:::([\w-]*)(\s.*)?/gm, N = u.slice(x);
        for (S.lastIndex = 0; ; ) {
          const D = S.exec(N);
          if (D === null)
            break;
          const $ = D.index, oe = D[1];
          if (!((p = D[2]) != null && p.endsWith(":::"))) {
            if (oe)
              v += 1;
            else if (v -= 1, v === 0) {
              const q = N.slice(0, $);
              M = q.trim();
              const P = u.slice(0, x + $ + D[0].length);
              let _ = [];
              if (M)
                if (l === "block")
                  for (_ = f.blockTokens(q), _.forEach((V) => {
                    V.text && (!V.tokens || V.tokens.length === 0) && (V.tokens = f.inlineTokens(V.text));
                  }); _.length > 0; ) {
                    const V = _[_.length - 1];
                    if (V.type === "paragraph" && (!V.text || V.text.trim() === ""))
                      _.pop();
                    else
                      break;
                  }
                else
                  _ = f.inlineTokens(M);
              return {
                type: e,
                raw: P,
                attributes: C,
                content: M,
                tokens: _
              };
            }
          }
        }
      }
    },
    renderMarkdown: (u, h) => {
      const f = d(u.attrs || {}), p = s(f), m = p ? ` {${p}}` : "", g = h.renderChildren(u.content || [], `

`);
      return `:::${c}${m}

${g}

:::`;
    }
  };
}
function cv(t) {
  if (!t.trim())
    return {};
  const e = {}, n = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let r = n.exec(t);
  for (; r !== null; ) {
    const [, i, s, o] = r;
    e[i] = s || o, r = n.exec(t);
  }
  return e;
}
function dv(t) {
  return Object.entries(t).filter(([, e]) => e != null).map(([e, n]) => `${e}="${n}"`).join(" ");
}
function uv(t) {
  const {
    nodeName: e,
    name: n,
    getContent: r,
    parseAttributes: i = cv,
    serializeAttributes: s = dv,
    defaultAttributes: o = {},
    selfClosing: l = !1,
    allowedAttributes: a
  } = t, c = n || e, d = (h) => {
    if (!a)
      return h;
    const f = {};
    return a.forEach((p) => {
      const m = typeof p == "string" ? p : p.name, g = typeof p == "string" ? void 0 : p.skipIfDefault;
      if (m in h) {
        const b = h[m];
        if (g !== void 0 && b === g)
          return;
        f[m] = b;
      }
    }), f;
  }, u = c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (h, f) => {
      const p = { ...o, ...h.attributes };
      if (l)
        return f.createNode(e, p);
      const m = r ? r(h) : h.content || "";
      return m ? f.createNode(e, p, [f.createTextNode(m)]) : f.createNode(e, p, []);
    },
    markdownTokenizer: {
      name: e,
      level: "inline",
      start(h) {
        const f = l ? new RegExp(`\\[${u}\\s*[^\\]]*\\]`) : new RegExp(`\\[${u}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${u}\\]`), p = h.match(f), m = p?.index;
        return m !== void 0 ? m : -1;
      },
      tokenize(h, f, p) {
        const m = l ? new RegExp(`^\\[${u}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${u}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${u}\\]`), g = h.match(m);
        if (!g)
          return;
        let b = "", k = "";
        if (l) {
          const [, v] = g;
          k = v;
        } else {
          const [, v, x] = g;
          k = v, b = x || "";
        }
        const C = i(k.trim());
        return {
          type: e,
          raw: g[0],
          content: b.trim(),
          attributes: C
        };
      }
    },
    renderMarkdown: (h) => {
      let f = "";
      r ? f = r(h) : h.content && h.content.length > 0 && (f = h.content.filter((b) => b.type === "text").map((b) => b.text).join(""));
      const p = d(h.attrs || {}), m = s(p), g = m ? ` ${m}` : "";
      return l ? `[${c}${g}]` : `[${c}${g}]${f}[/${c}]`;
    }
  };
}
function fo(t, e, n) {
  var r, i, s, o;
  const l = t.split(`
`), a = [];
  let c = "", d = 0;
  const u = e.baseIndentSize || 2;
  for (; d < l.length; ) {
    const h = l[d], f = h.match(e.itemPattern);
    if (!f) {
      if (a.length > 0)
        break;
      if (h.trim() === "") {
        d += 1, c = `${c}${h}
`;
        continue;
      } else
        return;
    }
    const p = e.extractItemData(f), { indentLevel: m, mainContent: g } = p;
    c = `${c}${h}
`;
    const b = [g];
    for (d += 1; d < l.length; ) {
      const x = l[d];
      if (x.trim() === "") {
        const S = l.slice(d + 1).findIndex(($) => $.trim() !== "");
        if (S === -1)
          break;
        if ((((i = (r = l[d + 1 + S].match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : i.length) || 0) > m) {
          b.push(x), c = `${c}${x}
`, d += 1;
          continue;
        } else
          break;
      }
      if ((((o = (s = x.match(/^(\s*)/)) == null ? void 0 : s[1]) == null ? void 0 : o.length) || 0) > m)
        b.push(x), c = `${c}${x}
`, d += 1;
      else
        break;
    }
    let k;
    const C = b.slice(1);
    if (C.length > 0) {
      const x = C.map((M) => M.slice(m + u)).join(`
`);
      x.trim() && (e.customNestedParser ? k = e.customNestedParser(x) : k = n.blockTokens(x));
    }
    const v = e.createToken(p, k);
    a.push(v);
  }
  if (a.length !== 0)
    return {
      items: a,
      raw: c
    };
}
function cl(t, e, n, r) {
  if (!t || !Array.isArray(t.content))
    return "";
  const i = typeof n == "function" ? n(r) : n, [s, ...o] = t.content, l = e.renderChildren([s]);
  let a = `${i}${l}`;
  return o && o.length > 0 && o.forEach((c, d) => {
    var u, h;
    const f = (h = (u = e.renderChild) == null ? void 0 : u.call(e, c, d + 1)) != null ? h : e.renderChildren([c]);
    if (f != null) {
      const p = f.split(`
`).map((m) => m ? e.indent(m) : e.indent("")).join(`
`);
      a += c.type === "paragraph" ? `

${p}` : `
${p}`;
    }
  }), a;
}
function hv(t, e, n = {}) {
  const { state: r } = e, { doc: i, tr: s } = r, o = t;
  i.descendants((l, a) => {
    const c = s.mapping.map(a), d = s.mapping.map(a) + l.nodeSize;
    let u = null;
    if (l.marks.forEach((f) => {
      if (f !== o)
        return !1;
      u = f;
    }), !u)
      return;
    let h = !1;
    if (Object.keys(n).forEach((f) => {
      n[f] !== u.attrs[f] && (h = !0);
    }), h) {
      const f = t.type.create({
        ...t.attrs,
        ...n
      });
      s.removeMark(c, d, t.type), s.addMark(c, d, f);
    }
  }), s.docChanged && e.view.dispatch(s);
}
var de = class Du extends ol {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const n = typeof e == "function" ? e() : e;
    return new Du(n);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const n = typeof e == "function" ? e() : e;
    return super.extend(n);
  }
};
function fn(t) {
  return new Kk({
    find: t.find,
    handler: ({ state: e, range: n, match: r, pasteEvent: i }) => {
      const s = F(t.getAttributes, void 0, r, i);
      if (s === !1 || s === null)
        return null;
      const { tr: o } = e, l = r[r.length - 1], a = r[0];
      let c = n.to;
      if (l) {
        const d = a.search(/\S/), u = n.from + a.indexOf(l), h = u + l.length;
        if (sl(n.from, n.to, e.doc).filter((m) => m.mark.type.excluded.find((b) => b === t.type && b !== m.mark.type)).filter((m) => m.to > u).length)
          return null;
        h < n.to && o.delete(h, n.to), u > n.from && o.delete(n.from + d, u), c = n.from + d + l.length, o.addMark(n.from + d, c, t.type.create(s || {})), r.index !== void 0 && r.input !== void 0 && r.index + r[0].length >= r.input.length || o.removeStoredMark(t.type);
      }
    }
  });
}
const { getOwnPropertyNames: fv, getOwnPropertySymbols: pv } = Object, { hasOwnProperty: mv } = Object.prototype;
function _s(t, e) {
  return function(r, i, s) {
    return t(r, i, s) && e(r, i, s);
  };
}
function Dr(t) {
  return function(n, r, i) {
    if (!n || !r || typeof n != "object" || typeof r != "object")
      return t(n, r, i);
    const { cache: s } = i, o = s.get(n), l = s.get(r);
    if (o && l)
      return o === r && l === n;
    s.set(n, r), s.set(r, n);
    const a = t(n, r, i);
    return s.delete(n), s.delete(r), a;
  };
}
function gv(t) {
  return t?.[Symbol.toStringTag];
}
function Pa(t) {
  return fv(t).concat(pv(t));
}
const yv = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((t, e) => mv.call(t, e))
);
function bn(t, e) {
  return t === e || !t && !e && t !== t && e !== e;
}
const bv = "__v", kv = "__o", vv = "_owner", { getOwnPropertyDescriptor: za, keys: Ba } = Object;
function Cv(t, e) {
  return t.byteLength === e.byteLength && hi(new Uint8Array(t), new Uint8Array(e));
}
function xv(t, e, n) {
  let r = t.length;
  if (e.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!n.equals(t[r], e[r], r, r, t, e, n))
      return !1;
  return !0;
}
function wv(t, e) {
  return t.byteLength === e.byteLength && hi(new Uint8Array(t.buffer, t.byteOffset, t.byteLength), new Uint8Array(e.buffer, e.byteOffset, e.byteLength));
}
function Sv(t, e) {
  return bn(t.getTime(), e.getTime());
}
function Mv(t, e) {
  return t.name === e.name && t.message === e.message && t.cause === e.cause && t.stack === e.stack;
}
function Tv(t, e) {
  return t === e;
}
function $a(t, e, n) {
  const r = t.size;
  if (r !== e.size)
    return !1;
  if (!r)
    return !0;
  const i = new Array(r), s = t.entries();
  let o, l, a = 0;
  for (; (o = s.next()) && !o.done; ) {
    const c = e.entries();
    let d = !1, u = 0;
    for (; (l = c.next()) && !l.done; ) {
      if (i[u]) {
        u++;
        continue;
      }
      const h = o.value, f = l.value;
      if (n.equals(h[0], f[0], a, u, t, e, n) && n.equals(h[1], f[1], h[0], f[0], t, e, n)) {
        d = i[u] = !0;
        break;
      }
      u++;
    }
    if (!d)
      return !1;
    a++;
  }
  return !0;
}
const Ev = bn;
function Av(t, e, n) {
  const r = Ba(t);
  let i = r.length;
  if (Ba(e).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!Pu(t, e, n, r[i]))
      return !1;
  return !0;
}
function Wn(t, e, n) {
  const r = Pa(t);
  let i = r.length;
  if (Pa(e).length !== i)
    return !1;
  let s, o, l;
  for (; i-- > 0; )
    if (s = r[i], !Pu(t, e, n, s) || (o = za(t, s), l = za(e, s), (o || l) && (!o || !l || o.configurable !== l.configurable || o.enumerable !== l.enumerable || o.writable !== l.writable)))
      return !1;
  return !0;
}
function Nv(t, e) {
  return bn(t.valueOf(), e.valueOf());
}
function _v(t, e) {
  return t.source === e.source && t.flags === e.flags;
}
function Ha(t, e, n) {
  const r = t.size;
  if (r !== e.size)
    return !1;
  if (!r)
    return !0;
  const i = new Array(r), s = t.values();
  let o, l;
  for (; (o = s.next()) && !o.done; ) {
    const a = e.values();
    let c = !1, d = 0;
    for (; (l = a.next()) && !l.done; ) {
      if (!i[d] && n.equals(o.value, l.value, o.value, l.value, t, e, n)) {
        c = i[d] = !0;
        break;
      }
      d++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function hi(t, e) {
  let n = t.byteLength;
  if (e.byteLength !== n || t.byteOffset !== e.byteOffset)
    return !1;
  for (; n-- > 0; )
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function Ov(t, e) {
  return t.hostname === e.hostname && t.pathname === e.pathname && t.protocol === e.protocol && t.port === e.port && t.hash === e.hash && t.username === e.username && t.password === e.password;
}
function Pu(t, e, n, r) {
  return (r === vv || r === kv || r === bv) && (t.$$typeof || e.$$typeof) ? !0 : yv(e, r) && n.equals(t[r], e[r], r, r, t, e, n);
}
const Rv = "[object ArrayBuffer]", Iv = "[object Arguments]", Lv = "[object Boolean]", Dv = "[object DataView]", Pv = "[object Date]", zv = "[object Error]", Bv = "[object Map]", $v = "[object Number]", Hv = "[object Object]", Vv = "[object RegExp]", Fv = "[object Set]", Wv = "[object String]", qv = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, jv = "[object URL]", Uv = Object.prototype.toString;
function Kv({ areArrayBuffersEqual: t, areArraysEqual: e, areDataViewsEqual: n, areDatesEqual: r, areErrorsEqual: i, areFunctionsEqual: s, areMapsEqual: o, areNumbersEqual: l, areObjectsEqual: a, arePrimitiveWrappersEqual: c, areRegExpsEqual: d, areSetsEqual: u, areTypedArraysEqual: h, areUrlsEqual: f, unknownTagComparators: p }) {
  return function(g, b, k) {
    if (g === b)
      return !0;
    if (g == null || b == null)
      return !1;
    const C = typeof g;
    if (C !== typeof b)
      return !1;
    if (C !== "object")
      return C === "number" ? l(g, b, k) : C === "function" ? s(g, b, k) : !1;
    const v = g.constructor;
    if (v !== b.constructor)
      return !1;
    if (v === Object)
      return a(g, b, k);
    if (Array.isArray(g))
      return e(g, b, k);
    if (v === Date)
      return r(g, b, k);
    if (v === RegExp)
      return d(g, b, k);
    if (v === Map)
      return o(g, b, k);
    if (v === Set)
      return u(g, b, k);
    const x = Uv.call(g);
    if (x === Pv)
      return r(g, b, k);
    if (x === Vv)
      return d(g, b, k);
    if (x === Bv)
      return o(g, b, k);
    if (x === Fv)
      return u(g, b, k);
    if (x === Hv)
      return typeof g.then != "function" && typeof b.then != "function" && a(g, b, k);
    if (x === jv)
      return f(g, b, k);
    if (x === zv)
      return i(g, b, k);
    if (x === Iv)
      return a(g, b, k);
    if (qv[x])
      return h(g, b, k);
    if (x === Rv)
      return t(g, b, k);
    if (x === Dv)
      return n(g, b, k);
    if (x === Lv || x === $v || x === Wv)
      return c(g, b, k);
    if (p) {
      let M = p[x];
      if (!M) {
        const S = gv(g);
        S && (M = p[S]);
      }
      if (M)
        return M(g, b, k);
    }
    return !1;
  };
}
function Zv({ circular: t, createCustomConfig: e, strict: n }) {
  let r = {
    areArrayBuffersEqual: Cv,
    areArraysEqual: n ? Wn : xv,
    areDataViewsEqual: wv,
    areDatesEqual: Sv,
    areErrorsEqual: Mv,
    areFunctionsEqual: Tv,
    areMapsEqual: n ? _s($a, Wn) : $a,
    areNumbersEqual: Ev,
    areObjectsEqual: n ? Wn : Av,
    arePrimitiveWrappersEqual: Nv,
    areRegExpsEqual: _v,
    areSetsEqual: n ? _s(Ha, Wn) : Ha,
    areTypedArraysEqual: n ? _s(hi, Wn) : hi,
    areUrlsEqual: Ov,
    unknownTagComparators: void 0
  };
  if (e && (r = Object.assign({}, r, e(r))), t) {
    const i = Dr(r.areArraysEqual), s = Dr(r.areMapsEqual), o = Dr(r.areObjectsEqual), l = Dr(r.areSetsEqual);
    r = Object.assign({}, r, {
      areArraysEqual: i,
      areMapsEqual: s,
      areObjectsEqual: o,
      areSetsEqual: l
    });
  }
  return r;
}
function Gv(t) {
  return function(e, n, r, i, s, o, l) {
    return t(e, n, l);
  };
}
function Jv({ circular: t, comparator: e, createState: n, equals: r, strict: i }) {
  if (n)
    return function(l, a) {
      const { cache: c = t ? /* @__PURE__ */ new WeakMap() : void 0, meta: d } = n();
      return e(l, a, {
        cache: c,
        equals: r,
        meta: d,
        strict: i
      });
    };
  if (t)
    return function(l, a) {
      return e(l, a, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: r,
        meta: void 0,
        strict: i
      });
    };
  const s = {
    cache: void 0,
    equals: r,
    meta: void 0,
    strict: i
  };
  return function(l, a) {
    return e(l, a, s);
  };
}
const Qv = Kt();
Kt({ strict: !0 });
Kt({ circular: !0 });
Kt({
  circular: !0,
  strict: !0
});
Kt({
  createInternalComparator: () => bn
});
Kt({
  strict: !0,
  createInternalComparator: () => bn
});
Kt({
  circular: !0,
  createInternalComparator: () => bn
});
Kt({
  circular: !0,
  createInternalComparator: () => bn,
  strict: !0
});
function Kt(t = {}) {
  const { circular: e = !1, createInternalComparator: n, createState: r, strict: i = !1 } = t, s = Zv(t), o = Kv(s), l = n ? n(o) : Gv(o);
  return Jv({ circular: e, comparator: o, createState: r, equals: l, strict: i });
}
var Pr = { exports: {} }, Os = {};
var Va;
function Yv() {
  if (Va) return Os;
  Va = 1;
  var t = Ye, e = Io();
  function n(c, d) {
    return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = e.useSyncExternalStore, s = t.useRef, o = t.useEffect, l = t.useMemo, a = t.useDebugValue;
  return Os.useSyncExternalStoreWithSelector = function(c, d, u, h, f) {
    var p = s(null);
    if (p.current === null) {
      var m = { hasValue: !1, value: null };
      p.current = m;
    } else m = p.current;
    p = l(
      function() {
        function b(M) {
          if (!k) {
            if (k = !0, C = M, M = h(M), f !== void 0 && m.hasValue) {
              var S = m.value;
              if (f(S, M))
                return v = S;
            }
            return v = M;
          }
          if (S = v, r(C, M)) return S;
          var N = h(M);
          return f !== void 0 && f(S, N) ? (C = M, S) : (C = M, v = N);
        }
        var k = !1, C, v, x = u === void 0 ? null : u;
        return [
          function() {
            return b(d());
          },
          x === null ? void 0 : function() {
            return b(x());
          }
        ];
      },
      [d, u, h, f]
    );
    var g = i(c, p[0], p[1]);
    return o(
      function() {
        m.hasValue = !0, m.value = g;
      },
      [g]
    ), a(g), g;
  }, Os;
}
var Rs = {};
var Fa;
function Xv() {
  return Fa || (Fa = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(c, d) {
      return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = Ye, n = Io(), r = typeof Object.is == "function" ? Object.is : t, i = n.useSyncExternalStore, s = e.useRef, o = e.useEffect, l = e.useMemo, a = e.useDebugValue;
    Rs.useSyncExternalStoreWithSelector = function(c, d, u, h, f) {
      var p = s(null);
      if (p.current === null) {
        var m = { hasValue: !1, value: null };
        p.current = m;
      } else m = p.current;
      p = l(
        function() {
          function b(M) {
            if (!k) {
              if (k = !0, C = M, M = h(M), f !== void 0 && m.hasValue) {
                var S = m.value;
                if (f(S, M))
                  return v = S;
              }
              return v = M;
            }
            if (S = v, r(C, M))
              return S;
            var N = h(M);
            return f !== void 0 && f(S, N) ? (C = M, S) : (C = M, v = N);
          }
          var k = !1, C, v, x = u === void 0 ? null : u;
          return [
            function() {
              return b(d());
            },
            x === null ? void 0 : function() {
              return b(x());
            }
          ];
        },
        [d, u, h, f]
      );
      var g = i(c, p[0], p[1]);
      return o(
        function() {
          m.hasValue = !0, m.value = g;
        },
        [g]
      ), a(g), g;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Rs;
}
var Wa;
function eC() {
  return Wa || (Wa = 1, process.env.NODE_ENV === "production" ? Pr.exports = Yv() : Pr.exports = Xv()), Pr.exports;
}
var tC = eC(), nC = (...t) => (e) => {
  t.forEach((n) => {
    typeof n == "function" ? n(e) : n && (n.current = e);
  });
}, rC = ({ contentComponent: t }) => {
  const e = Ec.useSyncExternalStore(
    t.subscribe,
    t.getSnapshot,
    t.getServerSnapshot
  );
  return /* @__PURE__ */ y(Re, { children: Object.values(e) });
};
function iC() {
  const t = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return t.add(n), () => {
        t.delete(n);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, r) {
      e = {
        ...e,
        [n]: Ih.createPortal(r.reactElement, r.element, n)
      }, t.forEach((i) => i());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const r = { ...e };
      delete r[n], e = r, t.forEach((i) => i());
    }
  };
}
var sC = class extends Ye.Component {
  constructor(t) {
    super(t), this.editorContentRef = Ye.createRef();
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    var t;
    const e = this.props.editor;
    if (e && !e.isDestroyed && ((t = e.view.dom) != null && t.parentNode)) {
      if (e.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...e.view.dom.parentNode.childNodes), e.setOptions({
        element: n
      }), e.contentComponent = iC(), e.createNodeViews(), e.isEditorContentInitialized = !0, this.forceUpdate();
    }
  }
  componentWillUnmount() {
    var t;
    const e = this.props.editor;
    if (e) {
      e.isEditorContentInitialized = !1, e.isDestroyed || e.view.setProps({
        nodeViews: {}
      }), e.contentComponent = null;
      try {
        if (!((t = e.view.dom) != null && t.parentNode))
          return;
        const n = document.createElement("div");
        n.append(...e.view.dom.parentNode.childNodes), e.setOptions({
          element: n
        });
      } catch {
      }
    }
  }
  render() {
    const { editor: t, innerRef: e, ...n } = this.props;
    return /* @__PURE__ */ E(Re, { children: [
      /* @__PURE__ */ y("div", { ref: nC(e, this.editorContentRef), ...n }),
      t?.contentComponent && /* @__PURE__ */ y(rC, { contentComponent: t.contentComponent })
    ] });
  }
}, oC = dt(
  (t, e) => {
    const n = Ye.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [t.editor]);
    return Ye.createElement(sC, {
      key: n,
      innerRef: e,
      ...t
    });
  }
), zu = Ye.memo(oC), lC = typeof window < "u" ? _h : _e, aC = class {
  constructor(t) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = t, this.lastSnapshot = { editor: t, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(t) {
    return this.subscribers.add(t), () => {
      this.subscribers.delete(t);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(t) {
    if (this.editor = t, this.editor) {
      const e = () => {
        this.transactionNumber += 1, this.subscribers.forEach((r) => r());
      }, n = this.editor;
      return n.on("transaction", e), () => {
        n.off("transaction", e);
      };
    }
  }
};
function cC(t) {
  var e;
  const [n] = ie(() => new aC(t.editor)), r = tC.useSyncExternalStoreWithSelector(
    n.subscribe,
    n.getSnapshot,
    n.getServerSnapshot,
    t.selector,
    (e = t.equalityFn) != null ? e : Qv
  );
  return lC(() => n.watch(t.editor), [t.editor, n]), Cc(r), r;
}
var qa = process.env.NODE_ENV !== "production", po = typeof window > "u", dC = po || !!(typeof window < "u" && window.next), uC = class Bu {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((n) => n());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0) {
      if (po || dC) {
        if (qa)
          throw new Error(
            "Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."
          );
        return null;
      }
      return this.createEditor();
    }
    if (this.options.current.immediatelyRender && po && qa)
      throw new Error(
        "Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches."
      );
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBeforeCreate) == null ? void 0 : s.call(i, ...r);
      },
      onBlur: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBlur) == null ? void 0 : s.call(i, ...r);
      },
      onCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onCreate) == null ? void 0 : s.call(i, ...r);
      },
      onDestroy: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDestroy) == null ? void 0 : s.call(i, ...r);
      },
      onFocus: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onFocus) == null ? void 0 : s.call(i, ...r);
      },
      onSelectionUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onSelectionUpdate) == null ? void 0 : s.call(i, ...r);
      },
      onTransaction: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onTransaction) == null ? void 0 : s.call(i, ...r);
      },
      onUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onUpdate) == null ? void 0 : s.call(i, ...r);
      },
      onContentError: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onContentError) == null ? void 0 : s.call(i, ...r);
      },
      onDrop: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDrop) == null ? void 0 : s.call(i, ...r);
      },
      onPaste: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onPaste) == null ? void 0 : s.call(i, ...r);
      },
      onDelete: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDelete) == null ? void 0 : s.call(i, ...r);
      }
    };
    return new nv(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, n) {
    return Object.keys(e).every((r) => [
      "onCreate",
      "onBeforeCreate",
      "onDestroy",
      "onUpdate",
      "onTransaction",
      "onFocus",
      "onBlur",
      "onSelectionUpdate",
      "onContentError",
      "onDrop",
      "onPaste"
    ].includes(r) ? !0 : r === "extensions" && e.extensions && n.extensions ? e.extensions.length !== n.extensions.length ? !1 : e.extensions.every((i, s) => {
      var o;
      return i === ((o = n.extensions) == null ? void 0 : o[s]);
    }) : e[r] === n[r]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? Bu.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((r, i) => r === e[i]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, n = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        n && n.setOptions(this.options.current);
        return;
      }
      n && !n.isDestroyed && (n.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
};
function hC(t = {}, e = []) {
  const n = lt(t);
  n.current = t;
  const [r] = ie(() => new uC(n)), i = Ec.useSyncExternalStore(
    r.subscribe,
    r.getEditor,
    r.getServerSnapshot
  );
  return Cc(i), _e(r.onRender(e)), cC({
    editor: i,
    selector: ({ transactionNumber: s }) => t.shouldRerenderOnTransaction === !1 || t.shouldRerenderOnTransaction === void 0 ? null : t.immediatelyRender && s === 0 ? 0 : s + 1
  }), i;
}
var $u = Ro({
  editor: null
});
$u.Consumer;
var fC = Ro({
  onDragStart: () => {
  },
  nodeViewContentChildren: void 0,
  nodeViewContentRef: () => {
  }
}), pC = () => xc(fC);
Ye.forwardRef((t, e) => {
  const { onDragStart: n } = pC(), r = t.as || "div";
  return (
    // @ts-ignore
    /* @__PURE__ */ y(
      r,
      {
        ...t,
        ref: e,
        "data-node-view-wrapper": "",
        onDragStart: n,
        style: {
          whiteSpace: "normal",
          ...t.style
        }
      }
    )
  );
});
Ye.createContext({
  markViewContentRef: () => {
  }
});
var dl = Ro({
  get editor() {
    throw new Error("useTiptap must be used within a <Tiptap> provider");
  }
});
dl.displayName = "TiptapContext";
var mC = () => xc(dl);
function Hu({ editor: t, instance: e, children: n }) {
  const r = t ?? e;
  if (!r)
    throw new Error("Tiptap: An editor instance is required. Pass a non-null `editor` prop.");
  const i = Ct(() => ({ editor: r }), [r]), s = Ct(() => ({ editor: r }), [r]);
  return /* @__PURE__ */ y($u.Provider, { value: s, children: /* @__PURE__ */ y(dl.Provider, { value: i, children: n }) });
}
Hu.displayName = "Tiptap";
function Vu({ ...t }) {
  const { editor: e } = mC();
  return /* @__PURE__ */ y(zu, { editor: e, ...t });
}
Vu.displayName = "Tiptap.Content";
Object.assign(Hu, {
  /**
   * The Tiptap Content component that renders the EditorContent with the editor instance from the context.
   * @see TiptapContent
   */
  Content: Vu
});
var fi = (t, e) => {
  if (t === "slot")
    return 0;
  if (t instanceof Function)
    return t(e);
  const { children: n, ...r } = e ?? {};
  if (t === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [t, r, n];
}, gC = /^\s*>\s$/, yC = de.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return /* @__PURE__ */ fi("blockquote", { ...J(this.options.HTMLAttributes, t), children: /* @__PURE__ */ fi("slot", {}) });
  },
  parseMarkdown: (t, e) => {
    var n;
    const r = (n = e.parseBlockChildren) != null ? n : e.parseChildren;
    return e.createNode("blockquote", void 0, r(t.tokens || []));
  },
  renderMarkdown: (t, e) => {
    if (!t.content)
      return "";
    const n = ">", r = [];
    return t.content.forEach((i, s) => {
      var o, l;
      const d = ((l = (o = e.renderChild) == null ? void 0 : o.call(e, i, s)) != null ? l : e.renderChildren([i])).split(`
`).map((u) => u.trim() === "" ? n : `${n} ${u}`);
      r.push(d.join(`
`));
    }), r.join(`
${n}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Pn({
        find: gC,
        type: this.type
      })
    ];
  }
}), bC = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, kC = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, vC = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, CC = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, xC = yn.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return /* @__PURE__ */ fi("strong", { ...J(this.options.HTMLAttributes, t), children: /* @__PURE__ */ fi("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (t, e) => e.applyMark("bold", e.parseInline(t.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<strong>",
      close: "</strong>"
    }
  },
  renderMarkdown: (t, e) => `**${e.renderChildren(t)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Dn({
        find: bC,
        type: this.type
      }),
      Dn({
        find: vC,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fn({
        find: kC,
        type: this.type
      }),
      fn({
        find: CC,
        type: this.type
      })
    ];
  }
}), wC = /(^|[^`])`([^`]+)`(?!`)$/, SC = /(^|[^`])`([^`]+)`(?!`)/g, MC = yn.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", J(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (t, e) => e.applyMark("code", [{ type: "text", text: t.text || "" }]),
  renderMarkdown: (t, e) => t.content ? `\`${e.renderChildren(t.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Dn({
        find: wC,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fn({
        find: SC,
        type: this.type
      })
    ];
  }
}), Is = 4, TC = /^```([a-z]+)?[\s\n]$/, EC = /^~~~([a-z]+)?[\s\n]$/, AC = de.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: Is,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: n } = this.options;
          if (!n)
            return null;
          const s = [...((e = t.firstElementChild) == null ? void 0 : e.classList) || []].filter((o) => o.startsWith(n)).map((o) => o.replace(n, ""))[0];
          return s || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      J(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (t, e) => {
    var n, r;
    return ((n = t.raw) == null ? void 0 : n.startsWith("```")) === !1 && ((r = t.raw) == null ? void 0 : r.startsWith("~~~")) === !1 && t.codeBlockStyle !== "indented" ? [] : e.createNode(
      "codeBlock",
      { language: t.lang || null },
      t.text ? [e.createTextNode(t.text)] : []
    );
  },
  renderMarkdown: (t, e) => {
    var n;
    let r = "";
    const i = ((n = t.attrs) == null ? void 0 : n.language) || "";
    return t.content ? r = [`\`\`\`${i}`, e.renderChildren(t.content), "```"].join(`
`) : r = `\`\`\`${i}

\`\`\``, r;
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, n = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : n || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: t }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const n = (e = this.options.tabSize) != null ? e : Is, { state: r } = t, { selection: i } = r, { $from: s, empty: o } = i;
        if (s.parent.type !== this.type)
          return !1;
        const l = " ".repeat(n);
        return o ? t.commands.insertContent(l) : t.commands.command(({ tr: a }) => {
          const { from: c, to: d } = i, f = r.doc.textBetween(c, d, `
`, `
`).split(`
`).map((p) => l + p).join(`
`);
          return a.replaceWith(c, d, r.schema.text(f)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: t }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const n = (e = this.options.tabSize) != null ? e : Is, { state: r } = t, { selection: i } = r, { $from: s, empty: o } = i;
        return s.parent.type !== this.type ? !1 : o ? t.commands.command(({ tr: l }) => {
          var a;
          const { pos: c } = s, d = s.start(), u = s.end(), f = r.doc.textBetween(d, u, `
`, `
`).split(`
`);
          let p = 0, m = 0;
          const g = c - d;
          for (let M = 0; M < f.length; M += 1) {
            if (m + f[M].length >= g) {
              p = M;
              break;
            }
            m += f[M].length + 1;
          }
          const k = ((a = f[p].match(/^ */)) == null ? void 0 : a[0]) || "", C = Math.min(k.length, n);
          if (C === 0)
            return !0;
          let v = d;
          for (let M = 0; M < p; M += 1)
            v += f[M].length + 1;
          return l.delete(v, v + C), c - v <= C && l.setSelection(I.create(l.doc, v)), !0;
        }) : t.commands.command(({ tr: l }) => {
          const { from: a, to: c } = i, h = r.doc.textBetween(a, c, `
`, `
`).split(`
`).map((f) => {
            var p;
            const m = ((p = f.match(/^ */)) == null ? void 0 : p[0]) || "", g = Math.min(m.length, n);
            return f.slice(g);
          }).join(`
`);
          return l.replaceWith(a, c, r.schema.text(h)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: n } = e, { $from: r, empty: i } = n;
        if (!i || r.parent.type !== this.type)
          return !1;
        const s = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !s || !o ? !1 : t.chain().command(({ tr: l }) => (l.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: n, doc: r } = e, { $from: i, empty: s } = n;
        if (!s || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const l = i.after();
        return l === void 0 ? !1 : r.nodeAt(l) ? t.commands.command(({ tr: c }) => (c.setSelection(z.near(r.resolve(l))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      ho({
        find: TC,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      ho({
        find: EC,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Y({
        key: new se("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, s = i?.mode;
            if (!n || !s)
              return !1;
            const { tr: o, schema: l } = t.state, a = l.text(n.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: s }, a)), o.selection.$from.parent.type !== this.type && o.setSelection(I.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), t.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), NC = de.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `

`) : ""
}), _C = de.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", J(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: n, editor: r }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: i, storedMarks: s } = n;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: l } = r.extensionManager, a = s || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: d }) => {
            if (d && a && o) {
              const u = a.filter((h) => l.includes(h.type.name));
              c.ensureMarks(u);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), OC = de.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, J(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (t, e) => e.createNode("heading", { level: t.depth || 1 }, e.parseInline(t.tokens || [])),
  renderMarkdown: (t, e) => {
    var n;
    const r = (n = t.attrs) != null && n.level ? parseInt(t.attrs.level, 10) : 1, i = "#".repeat(r);
    return t.content ? `${i} ${e.renderChildren(t.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (t, e) => ({
        ...t,
        [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((t) => ho({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
}), RC = de.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", J(this.options.HTMLAttributes, t)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (t, e) => e.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        if (!sv(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: n } = e, { $to: r } = n, i = t();
        return yu(n) ? i.insertContentAt(r.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ state: s, tr: o, dispatch: l }) => {
          if (l) {
            const { $to: a } = o.selection, c = a.end();
            if (a.nodeAfter)
              a.nodeAfter.isTextblock ? o.setSelection(I.create(o.doc, a.pos + 1)) : a.nodeAfter.isBlock ? o.setSelection(L.create(o.doc, a.pos)) : o.setSelection(I.create(o.doc, a.pos));
            else {
              const d = s.schema.nodes[this.options.nextNodeType] || a.parent.type.contentMatch.defaultType, u = d?.create();
              u && (o.insert(c, u), o.setSelection(I.create(o.doc, c + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Lu({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), IC = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, LC = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, DC = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, PC = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, zC = yn.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", J(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (t, e) => e.applyMark("italic", e.parseInline(t.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<em>",
      close: "</em>"
    }
  },
  renderMarkdown: (t, e) => `*${e.renderChildren(t)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Dn({
        find: IC,
        type: this.type
      }),
      Dn({
        find: DC,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fn({
        find: LC,
        type: this.type
      }),
      fn({
        find: PC,
        type: this.type
      })
    ];
  }
});
const BC = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", $C = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", mo = "numeric", go = "ascii", yo = "alpha", nr = "asciinumeric", Gn = "alphanumeric", bo = "domain", Fu = "emoji", HC = "scheme", VC = "slashscheme", Ls = "whitespace";
function FC(t, e) {
  return t in e || (e[t] = []), e[t];
}
function tn(t, e, n) {
  e[mo] && (e[nr] = !0, e[Gn] = !0), e[go] && (e[nr] = !0, e[yo] = !0), e[nr] && (e[Gn] = !0), e[yo] && (e[Gn] = !0), e[Gn] && (e[bo] = !0), e[Fu] && (e[bo] = !0);
  for (const r in e) {
    const i = FC(r, n);
    i.indexOf(t) < 0 && i.push(t);
  }
}
function WC(t, e) {
  const n = {};
  for (const r in e)
    e[r].indexOf(t) >= 0 && (n[r] = !0);
  return n;
}
function Ne(t = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = t;
}
Ne.groups = {};
Ne.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(t) {
    const e = this, n = e.j[t];
    if (n)
      return n;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], s = e.jr[r][1];
      if (s && i.test(t))
        return s;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(t, e = !1) {
    return e ? t in this.j : !!this.go(t);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(t, e, n, r) {
    for (let i = 0; i < t.length; i++)
      this.tt(t[i], e, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(t, e, n, r) {
    r = r || Ne.groups;
    let i;
    return e && e.j ? i = e : (i = new Ne(e), n && r && tn(e, n, r)), this.jr.push([t, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(t, e, n, r) {
    let i = this;
    const s = t.length;
    if (!s)
      return i;
    for (let o = 0; o < s - 1; o++)
      i = i.tt(t[o]);
    return i.tt(t[s - 1], e, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(t, e, n, r) {
    r = r || Ne.groups;
    const i = this;
    if (e && e.j)
      return i.j[t] = e, e;
    const s = e;
    let o, l = i.go(t);
    if (l ? (o = new Ne(), Object.assign(o.j, l.j), o.jr.push.apply(o.jr, l.jr), o.jd = l.jd, o.t = l.t) : o = new Ne(), s) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const a = Object.assign(WC(o.t, r), n);
          tn(s, a, r);
        } else n && tn(s, n, r);
      o.t = s;
    }
    return i.j[t] = o, o;
  }
};
const B = (t, e, n, r, i) => t.ta(e, n, r, i), te = (t, e, n, r, i) => t.tr(e, n, r, i), ja = (t, e, n, r, i) => t.ts(e, n, r, i), T = (t, e, n, r, i) => t.tt(e, n, r, i), yt = "WORD", ko = "UWORD", Wu = "ASCIINUMERICAL", qu = "ALPHANUMERICAL", yr = "LOCALHOST", vo = "TLD", Co = "UTLD", Gr = "SCHEME", Tn = "SLASH_SCHEME", ul = "NUM", xo = "WS", hl = "NL", rr = "OPENBRACE", ir = "CLOSEBRACE", pi = "OPENBRACKET", mi = "CLOSEBRACKET", gi = "OPENPAREN", yi = "CLOSEPAREN", bi = "OPENANGLEBRACKET", ki = "CLOSEANGLEBRACKET", vi = "FULLWIDTHLEFTPAREN", Ci = "FULLWIDTHRIGHTPAREN", xi = "LEFTCORNERBRACKET", wi = "RIGHTCORNERBRACKET", Si = "LEFTWHITECORNERBRACKET", Mi = "RIGHTWHITECORNERBRACKET", Ti = "FULLWIDTHLESSTHAN", Ei = "FULLWIDTHGREATERTHAN", Ai = "AMPERSAND", Ni = "APOSTROPHE", _i = "ASTERISK", It = "AT", Oi = "BACKSLASH", Ri = "BACKTICK", Ii = "CARET", nn = "COLON", fl = "COMMA", Li = "DOLLAR", rt = "DOT", Di = "EQUALS", pl = "EXCLAMATION", He = "HYPHEN", sr = "PERCENT", Pi = "PIPE", zi = "PLUS", Bi = "POUND", or = "QUERY", ml = "QUOTE", ju = "FULLWIDTHMIDDLEDOT", gl = "SEMI", it = "SLASH", lr = "TILDE", $i = "UNDERSCORE", Uu = "EMOJI", Hi = "SYM";
var Ku = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: qu,
  AMPERSAND: Ai,
  APOSTROPHE: Ni,
  ASCIINUMERICAL: Wu,
  ASTERISK: _i,
  AT: It,
  BACKSLASH: Oi,
  BACKTICK: Ri,
  CARET: Ii,
  CLOSEANGLEBRACKET: ki,
  CLOSEBRACE: ir,
  CLOSEBRACKET: mi,
  CLOSEPAREN: yi,
  COLON: nn,
  COMMA: fl,
  DOLLAR: Li,
  DOT: rt,
  EMOJI: Uu,
  EQUALS: Di,
  EXCLAMATION: pl,
  FULLWIDTHGREATERTHAN: Ei,
  FULLWIDTHLEFTPAREN: vi,
  FULLWIDTHLESSTHAN: Ti,
  FULLWIDTHMIDDLEDOT: ju,
  FULLWIDTHRIGHTPAREN: Ci,
  HYPHEN: He,
  LEFTCORNERBRACKET: xi,
  LEFTWHITECORNERBRACKET: Si,
  LOCALHOST: yr,
  NL: hl,
  NUM: ul,
  OPENANGLEBRACKET: bi,
  OPENBRACE: rr,
  OPENBRACKET: pi,
  OPENPAREN: gi,
  PERCENT: sr,
  PIPE: Pi,
  PLUS: zi,
  POUND: Bi,
  QUERY: or,
  QUOTE: ml,
  RIGHTCORNERBRACKET: wi,
  RIGHTWHITECORNERBRACKET: Mi,
  SCHEME: Gr,
  SEMI: gl,
  SLASH: it,
  SLASH_SCHEME: Tn,
  SYM: Hi,
  TILDE: lr,
  TLD: vo,
  UNDERSCORE: $i,
  UTLD: Co,
  UWORD: ko,
  WORD: yt,
  WS: xo
});
const mt = /[a-z]/, qn = new RegExp("\\p{L}", "u"), Ds = new RegExp("\\p{Emoji}", "u"), gt = /\d/, Ps = /\s/, Ua = "\r", zs = `
`, qC = "️", jC = "‍", Bs = "￼";
let zr = null, Br = null;
function UC(t = []) {
  const e = {};
  Ne.groups = e;
  const n = new Ne();
  zr == null && (zr = Ka(BC)), Br == null && (Br = Ka($C)), T(n, "'", Ni), T(n, "{", rr), T(n, "}", ir), T(n, "[", pi), T(n, "]", mi), T(n, "(", gi), T(n, ")", yi), T(n, "<", bi), T(n, ">", ki), T(n, "（", vi), T(n, "）", Ci), T(n, "「", xi), T(n, "」", wi), T(n, "『", Si), T(n, "』", Mi), T(n, "＜", Ti), T(n, "＞", Ei), T(n, "&", Ai), T(n, "*", _i), T(n, "@", It), T(n, "`", Ri), T(n, "^", Ii), T(n, ":", nn), T(n, ",", fl), T(n, "$", Li), T(n, ".", rt), T(n, "=", Di), T(n, "!", pl), T(n, "-", He), T(n, "%", sr), T(n, "|", Pi), T(n, "+", zi), T(n, "#", Bi), T(n, "?", or), T(n, '"', ml), T(n, "/", it), T(n, ";", gl), T(n, "~", lr), T(n, "_", $i), T(n, "\\", Oi), T(n, "・", ju);
  const r = te(n, gt, ul, {
    [mo]: !0
  });
  te(r, gt, r);
  const i = te(r, mt, Wu, {
    [nr]: !0
  }), s = te(r, qn, qu, {
    [Gn]: !0
  }), o = te(n, mt, yt, {
    [go]: !0
  });
  te(o, gt, i), te(o, mt, o), te(i, gt, i), te(i, mt, i);
  const l = te(n, qn, ko, {
    [yo]: !0
  });
  te(l, mt), te(l, gt, s), te(l, qn, l), te(s, gt, s), te(s, mt), te(s, qn, s);
  const a = T(n, zs, hl, {
    [Ls]: !0
  }), c = T(n, Ua, xo, {
    [Ls]: !0
  }), d = te(n, Ps, xo, {
    [Ls]: !0
  });
  T(n, Bs, d), T(c, zs, a), T(c, Bs, d), te(c, Ps, d), T(d, Ua), T(d, zs), te(d, Ps, d), T(d, Bs, d);
  const u = te(n, Ds, Uu, {
    [Fu]: !0
  });
  T(u, "#"), te(u, Ds, u), T(u, qC, u);
  const h = T(u, jC);
  T(h, "#"), te(h, Ds, u);
  const f = [[mt, o], [gt, i]], p = [[mt, null], [qn, l], [gt, s]];
  for (let m = 0; m < zr.length; m++)
    _t(n, zr[m], vo, yt, f);
  for (let m = 0; m < Br.length; m++)
    _t(n, Br[m], Co, ko, p);
  tn(vo, {
    tld: !0,
    ascii: !0
  }, e), tn(Co, {
    utld: !0,
    alpha: !0
  }, e), _t(n, "file", Gr, yt, f), _t(n, "mailto", Gr, yt, f), _t(n, "http", Tn, yt, f), _t(n, "https", Tn, yt, f), _t(n, "ftp", Tn, yt, f), _t(n, "ftps", Tn, yt, f), tn(Gr, {
    scheme: !0,
    ascii: !0
  }, e), tn(Tn, {
    slashscheme: !0,
    ascii: !0
  }, e), t = t.sort((m, g) => m[0] > g[0] ? 1 : -1);
  for (let m = 0; m < t.length; m++) {
    const g = t[m][0], k = t[m][1] ? {
      [HC]: !0
    } : {
      [VC]: !0
    };
    g.indexOf("-") >= 0 ? k[bo] = !0 : mt.test(g) ? gt.test(g) ? k[nr] = !0 : k[go] = !0 : k[mo] = !0, ja(n, g, g, k);
  }
  return ja(n, "localhost", yr, {
    ascii: !0
  }), n.jd = new Ne(Hi), {
    start: n,
    tokens: Object.assign({
      groups: e
    }, Ku)
  };
}
function Zu(t, e) {
  const n = KC(e.replace(/[A-Z]/g, (l) => l.toLowerCase())), r = n.length, i = [];
  let s = 0, o = 0;
  for (; o < r; ) {
    let l = t, a = null, c = 0, d = null, u = -1, h = -1;
    for (; o < r && (a = l.go(n[o])); )
      l = a, l.accepts() ? (u = 0, h = 0, d = l) : u >= 0 && (u += n[o].length, h++), c += n[o].length, s += n[o].length, o++;
    s -= u, o -= h, c -= u, i.push({
      t: d.t,
      // token type/name
      v: e.slice(s - c, s),
      // string value
      s: s - c,
      // start index
      e: s
      // end index (excluding)
    });
  }
  return i;
}
function KC(t) {
  const e = [], n = t.length;
  let r = 0;
  for (; r < n; ) {
    let i = t.charCodeAt(r), s, o = i < 55296 || i > 56319 || r + 1 === n || (s = t.charCodeAt(r + 1)) < 56320 || s > 57343 ? t[r] : t.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function _t(t, e, n, r, i) {
  let s;
  const o = e.length;
  for (let l = 0; l < o - 1; l++) {
    const a = e[l];
    t.j[a] ? s = t.j[a] : (s = new Ne(r), s.jr = i.slice(), t.j[a] = s), t = s;
  }
  return s = new Ne(n), s.jr = i.slice(), t.j[e[o - 1]] = s, s;
}
function Ka(t) {
  const e = [], n = [];
  let r = 0, i = "0123456789";
  for (; r < t.length; ) {
    let s = 0;
    for (; i.indexOf(t[r + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(n.join(""));
      for (let o = parseInt(t.substring(r, r + s), 10); o > 0; o--)
        n.pop();
      r += s;
    } else
      n.push(t[r]), r++;
  }
  return e;
}
const br = {
  defaultProtocol: "http",
  events: null,
  format: Za,
  formatHref: Za,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function yl(t, e = null) {
  let n = Object.assign({}, br);
  t && (n = Object.assign(n, t instanceof yl ? t.o : t));
  const r = n.ignoreTags, i = [];
  for (let s = 0; s < r.length; s++)
    i.push(r[s].toUpperCase());
  this.o = n, e && (this.defaultRender = e), this.ignoreTags = i;
}
yl.prototype = {
  o: br,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(t) {
    return t;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(t) {
    return this.get("validate", t.toString(), t);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(t, e, n) {
    const r = e != null;
    let i = this.o[t];
    return i && (typeof i == "object" ? (i = n.t in i ? i[n.t] : br[t], typeof i == "function" && r && (i = i(e, n))) : typeof i == "function" && r && (i = i(e, n.t, n)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(t, e, n) {
    let r = this.o[t];
    return typeof r == "function" && e != null && (r = r(e, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(t) {
    const e = t.render(this);
    return (this.get("render", null, t) || this.defaultRender)(e, t.t, t);
  }
};
function Za(t) {
  return t;
}
function Gu(t, e) {
  this.t = "token", this.v = t, this.tk = e;
}
Gu.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(t) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(t) {
    const e = this.toString(), n = t.get("truncate", e, this), r = t.get("format", e, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(t) {
    return t.get("formatHref", this.toHref(t.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(t = br.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(t) {
    return {
      type: this.t,
      value: this.toFormattedString(t),
      isLink: this.isLink,
      href: this.toFormattedHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(t) {
    return t.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(t) {
    const e = this, n = this.toHref(t.get("defaultProtocol")), r = t.get("formatHref", n, this), i = t.get("tagName", n, e), s = this.toFormattedString(t), o = {}, l = t.get("className", n, e), a = t.get("target", n, e), c = t.get("rel", n, e), d = t.getObj("attributes", n, e), u = t.getObj("events", n, e);
    return o.href = r, l && (o.class = l), a && (o.target = a), c && (o.rel = c), d && Object.assign(o, d), {
      tagName: i,
      attributes: o,
      content: s,
      eventListeners: u
    };
  }
};
function rs(t, e) {
  class n extends Gu {
    constructor(i, s) {
      super(i, s), this.t = t;
    }
  }
  for (const r in e)
    n.prototype[r] = e[r];
  return n.t = t, n;
}
const ZC = rs("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Ga = rs("text"), GC = rs("nl"), $r = rs("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(t = br.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${t}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const t = this.tk;
    return t.length >= 2 && t[0].t !== yr && t[1].t === nn;
  }
}), $e = (t) => new Ne(t);
function JC({
  groups: t
}) {
  const e = t.domain.concat([Ai, _i, It, Oi, Ri, Ii, Li, Di, He, ul, sr, Pi, zi, Bi, it, Hi, lr, $i]), n = [Ni, nn, fl, rt, pl, sr, or, ml, gl, bi, ki, rr, ir, mi, pi, gi, yi, vi, Ci, xi, wi, Si, Mi, Ti, Ei], r = [Ai, Ni, _i, Oi, Ri, Ii, Li, Di, He, rr, ir, sr, Pi, zi, Bi, or, it, Hi, lr, $i], i = $e(), s = T(i, lr);
  B(s, r, s), B(s, t.domain, s);
  const o = $e(), l = $e(), a = $e();
  B(i, t.domain, o), B(i, t.scheme, l), B(i, t.slashscheme, a), B(o, r, s), B(o, t.domain, o);
  const c = T(o, It);
  T(s, It, c), T(l, It, c), T(a, It, c);
  const d = T(s, rt);
  B(d, r, s), B(d, t.domain, s);
  const u = $e();
  B(c, t.domain, u), B(u, t.domain, u);
  const h = T(u, rt);
  B(h, t.domain, u);
  const f = $e(ZC);
  B(h, t.tld, f), B(h, t.utld, f), T(c, yr, f);
  const p = T(u, He);
  T(p, He, p), B(p, t.domain, u), B(f, t.domain, u), T(f, rt, h), T(f, He, p);
  const m = T(o, He), g = T(o, rt);
  T(m, He, m), B(m, t.domain, o), B(g, r, s), B(g, t.domain, o);
  const b = $e($r);
  B(g, t.tld, b), B(g, t.utld, b), B(b, t.domain, o), B(b, r, s), T(b, rt, g), T(b, He, m), T(b, It, c);
  const k = T(b, nn), C = $e($r);
  B(k, t.numeric, C);
  const v = $e($r), x = $e();
  B(v, e, v), B(v, n, x), B(x, e, v), B(x, n, x), T(b, it, v), T(C, it, v);
  const M = T(l, nn), S = T(a, nn), N = T(S, it), D = T(N, it);
  B(l, t.domain, o), T(l, rt, g), T(l, He, m), B(a, t.domain, o), T(a, rt, g), T(a, He, m), B(M, t.domain, v), T(M, it, v), T(M, or, v), B(D, t.domain, v), B(D, e, v), T(D, it, v);
  const $ = [
    [rr, ir],
    // {}
    [pi, mi],
    // []
    [gi, yi],
    // ()
    [bi, ki],
    // <>
    [vi, Ci],
    // （）
    [xi, wi],
    // 「」
    [Si, Mi],
    // 『』
    [Ti, Ei]
    // ＜＞
  ];
  for (let oe = 0; oe < $.length; oe++) {
    const [q, P] = $[oe], _ = T(v, q);
    T(x, q, _);
    const V = $e($r);
    B(_, e, V);
    const je = $e();
    B(_, n, je), T(_, P, v), B(V, e, V), B(V, n, je), B(je, e, V), B(je, n, je), T(V, P, v), T(je, P, v);
  }
  return T(i, yr, b), T(i, hl, GC), {
    start: i,
    tokens: Ku
  };
}
function QC(t, e, n) {
  let r = n.length, i = 0, s = [], o = [];
  for (; i < r; ) {
    let l = t, a = null, c = null, d = 0, u = null, h = -1;
    for (; i < r && !(a = l.go(n[i].t)); )
      o.push(n[i++]);
    for (; i < r && (c = a || l.go(n[i].t)); )
      a = null, l = c, l.accepts() ? (h = 0, u = l) : h >= 0 && h++, i++, d++;
    if (h < 0)
      i -= d, i < r && (o.push(n[i]), i++);
    else {
      o.length > 0 && (s.push($s(Ga, e, o)), o = []), i -= h, d -= h;
      const f = u.t, p = n.slice(i - d, i);
      s.push($s(f, e, p));
    }
  }
  return o.length > 0 && s.push($s(Ga, e, o)), s;
}
function $s(t, e, n) {
  const r = n[0].s, i = n[n.length - 1].e, s = e.slice(r, i);
  return new t(s, n);
}
const YC = typeof console < "u" && console && console.warn || (() => {
}), XC = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Q = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function ex() {
  return Ne.groups = {}, Q.scanner = null, Q.parser = null, Q.tokenQueue = [], Q.pluginQueue = [], Q.customSchemes = [], Q.initialized = !1, Q;
}
function Ja(t, e = !1) {
  if (Q.initialized && YC(`linkifyjs: already initialized - will not register custom scheme "${t}" ${XC}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(t))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Q.customSchemes.push([t, e]);
}
function tx() {
  Q.scanner = UC(Q.customSchemes);
  for (let t = 0; t < Q.tokenQueue.length; t++)
    Q.tokenQueue[t][1]({
      scanner: Q.scanner
    });
  Q.parser = JC(Q.scanner.tokens);
  for (let t = 0; t < Q.pluginQueue.length; t++)
    Q.pluginQueue[t][1]({
      scanner: Q.scanner,
      parser: Q.parser
    });
  return Q.initialized = !0, Q;
}
function bl(t) {
  return Q.initialized || tx(), QC(Q.parser.start, t, Zu(Q.scanner.start, t));
}
bl.scan = Zu;
function Ju(t, e = null, n = null) {
  if (e && typeof e == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    n = e, e = null;
  }
  const r = new yl(n), i = bl(t), s = [];
  for (let o = 0; o < i.length; o++) {
    const l = i[o];
    l.isLink && (!e || l.t === e) && r.check(l) && s.push(l.toFormattedObject(r));
  }
  return s;
}
var kl = "[\0-   ᠎ -\u2029 　]", nx = new RegExp(kl), rx = new RegExp(`${kl}$`), ix = new RegExp(kl, "g");
function sx(t) {
  return t.length === 1 ? t[0].isLink : t.length === 3 && t[1].isLink ? ["()", "[]"].includes(t[0].value + t[2].value) : !1;
}
function ox(t) {
  return new Y({
    key: new se("autolink"),
    appendTransaction: (e, n, r) => {
      const i = e.some((c) => c.docChanged) && !n.doc.eq(r.doc), s = e.some((c) => c.getMeta("preventAutolink"));
      if (!i || s)
        return;
      const { tr: o } = r, l = au(n.doc, [...e]);
      if (gu(l).forEach(({ newRange: c }) => {
        const d = rk(r.doc, c, (f) => f.isTextblock);
        let u, h;
        if (d.length > 1)
          u = d[0], h = r.doc.textBetween(
            u.pos,
            u.pos + u.node.nodeSize,
            void 0,
            " "
          );
        else if (d.length) {
          const f = r.doc.textBetween(c.from, c.to, " ", " ");
          if (!rx.test(f))
            return;
          u = d[0], h = r.doc.textBetween(u.pos, c.to, void 0, " ");
        }
        if (u && h) {
          const f = h.split(nx).filter(Boolean);
          if (f.length <= 0)
            return !1;
          const p = f[f.length - 1], m = u.pos + h.lastIndexOf(p);
          if (!p)
            return !1;
          const g = bl(p).map((b) => b.toObject(t.defaultProtocol));
          if (!sx(g))
            return !1;
          g.filter((b) => b.isLink).map((b) => ({
            ...b,
            from: m + b.start + 1,
            to: m + b.end + 1
          })).filter((b) => r.schema.marks.code ? !r.doc.rangeHasMark(b.from, b.to, r.schema.marks.code) : !0).filter((b) => t.validate(b.value)).filter((b) => t.shouldAutoLink(b.value)).forEach((b) => {
            sl(b.from, b.to, r.doc).some((k) => k.mark.type === t.type) || o.addMark(
              b.from,
              b.to,
              t.type.create({
                href: b.href
              })
            );
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function lx(t) {
  return new Y({
    key: new se("handleClickLink"),
    props: {
      handleClick: (e, n, r) => {
        var i, s;
        if (r.button !== 0 || !e.editable)
          return !1;
        let o = null;
        if (r.target instanceof HTMLAnchorElement)
          o = r.target;
        else {
          const a = r.target;
          if (!a)
            return !1;
          const c = t.editor.view.dom;
          o = a.closest("a"), o && !c.contains(o) && (o = null);
        }
        if (!o)
          return !1;
        let l = !1;
        if (t.enableClickSelection && (l = t.editor.commands.extendMarkRange(t.type.name)), t.openOnClick) {
          const a = mu(e.state, t.type.name), c = (i = o.href) != null ? i : a.href, d = (s = o.target) != null ? s : a.target;
          c && (window.open(c, d), l = !0);
        }
        return l;
      }
    }
  });
}
function ax(t) {
  return new Y({
    key: new se("handlePasteLink"),
    props: {
      handlePaste: (e, n, r) => {
        const { shouldAutoLink: i } = t, { state: s } = e, { selection: o } = s, { empty: l } = o;
        if (l)
          return !1;
        let a = "";
        r.content.forEach((d) => {
          a += d.textContent;
        });
        const c = Ju(a, { defaultProtocol: t.defaultProtocol }).find(
          (d) => d.isLink && d.value === a
        );
        return !a || !c || i !== void 0 && !i(c.value) ? !1 : t.editor.commands.setMark(t.type, {
          href: c.href
        });
      }
    }
  });
}
function Gt(t, e) {
  const n = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return e && e.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && n.push(i);
  }), !t || t.replace(ix, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${n.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var Qu = yn.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((t) => {
      if (typeof t == "string") {
        Ja(t);
        return;
      }
      Ja(t.scheme, t.optionalSlashes);
    });
  },
  onDestroy() {
    ex();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (t, e) => !!Gt(t, e.protocols),
      validate: (t) => !!t,
      shouldAutoLink: (t) => {
        const e = /^[a-z][a-z0-9+.-]*:\/\//i.test(t), n = /^[a-z][a-z0-9+.-]*:/i.test(t);
        if (e || n && !t.includes("@"))
          return !0;
        const i = (t.includes("@") ? t.split("@").pop() : t).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(i) || !/\./.test(i));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(t) {
          return t.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (t) => {
          const e = t.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (n) => !!Gt(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return this.options.isAllowedUri(t.href, {
      defaultValidate: (e) => !!Gt(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", J(this.options.HTMLAttributes, t), 0] : ["a", J(this.options.HTMLAttributes, { ...t, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (t, e) => e.applyMark("link", e.parseInline(t.tokens || []), {
    href: t.href,
    title: t.title || null
  }),
  renderMarkdown: (t, e) => {
    var n, r, i, s;
    const o = (r = (n = t.attrs) == null ? void 0 : n.href) != null ? r : "", l = (s = (i = t.attrs) == null ? void 0 : i.title) != null ? s : "", a = e.renderChildren(t);
    return l ? `[${a}](${o} "${l}")` : `[${a}](${o})`;
  },
  addCommands() {
    return {
      setLink: (t) => ({ chain: e }) => {
        const { href: n } = t;
        return this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!Gt(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, t).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (t) => ({ chain: e }) => {
        const { href: n } = t || {};
        return n && !this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!Gt(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : e().toggleMark(this.name, t, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: t }) => t().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      fn({
        find: (t) => {
          const e = [];
          if (t) {
            const { protocols: n, defaultProtocol: r } = this.options, i = Ju(t).filter(
              (s) => s.isLink && this.options.isAllowedUri(s.value, {
                defaultValidate: (o) => !!Gt(o, n),
                protocols: n,
                defaultProtocol: r
              })
            );
            i.length && i.forEach((s) => {
              this.options.shouldAutoLink(s.value) && e.push({
                text: s.value,
                data: {
                  href: s.href
                },
                index: s.start
              });
            });
          }
          return e;
        },
        type: this.type,
        getAttributes: (t) => {
          var e;
          return {
            href: (e = t.data) == null ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const t = [], { protocols: e, defaultProtocol: n } = this.options;
    return this.options.autolink && t.push(
      ox({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (r) => this.options.isAllowedUri(r, {
          defaultValidate: (i) => !!Gt(i, e),
          protocols: e,
          defaultProtocol: n
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), t.push(
      lx({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && t.push(
      ax({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), t;
  }
}), cx = Qu, dx = Object.defineProperty, ux = (t, e) => {
  for (var n in e)
    dx(t, n, { get: e[n], enumerable: !0 });
}, hx = "listItem", Qa = "textStyle", Ya = /^\s*([-+*])\s$/, Yu = de.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", J(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (t, e) => t.type !== "list" || t.ordered ? [] : {
    type: "bulletList",
    content: t.items ? e.parseChildren(t.items) : []
  },
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(hx, this.editor.getAttributes(Qa)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = Pn({
      find: Ya,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Pn({
      find: Ya,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Qa),
      editor: this.editor
    })), [t];
  }
});
function fx(t) {
  var e, n;
  const r = (e = t.tokens) == null ? void 0 : e[0];
  return !!(t.text && ((n = t.tokens) == null ? void 0 : n.length) === 1 && r?.type === "list" && r.ordered && r.raw === t.text);
}
function px(t, e) {
  return e.tokenizeInline ? e.parseInline(e.tokenizeInline(t)) : e.parseInline([
    {
      type: "text",
      raw: t,
      text: t
    }
  ]);
}
var Xu = de.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", J(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (t, e) => {
    var n;
    if (t.type !== "list_item")
      return [];
    const r = (n = e.parseBlockChildren) != null ? n : e.parseChildren;
    let i = [];
    if (t.tokens && t.tokens.length > 0) {
      if (fx(t))
        return {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: px(t.text || "", e)
            }
          ]
        };
      if (t.tokens.some((o) => o.type === "paragraph"))
        i = r(t.tokens);
      else {
        const o = t.tokens[0];
        if (o && o.type === "text" && o.tokens && o.tokens.length > 0) {
          if (i = [
            {
              type: "paragraph",
              content: e.parseInline(o.tokens)
            }
          ], t.tokens.length > 1) {
            const a = t.tokens.slice(1), c = r(a);
            i.push(...c);
          }
        } else
          i = r(t.tokens);
      }
    }
    return i.length === 0 && (i = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: i
    };
  },
  renderMarkdown: (t, e, n) => cl(
    t,
    e,
    (r) => {
      var i, s;
      return r.parentType === "bulletList" ? "- " : r.parentType === "orderedList" ? `${(((s = (i = r.meta) == null ? void 0 : i.parentAttrs) == null ? void 0 : s.start) || 1) + r.index}. ` : "- ";
    },
    n
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), mx = {};
ux(mx, {
  findListItemPos: () => wr,
  getNextListDepth: () => vl,
  handleBackspace: () => wo,
  handleDelete: () => So,
  hasListBefore: () => eh,
  hasListItemAfter: () => gx,
  hasListItemBefore: () => th,
  listItemHasSubList: () => nh,
  nextListIsDeeper: () => rh,
  nextListIsHigher: () => ih
});
var wr = (t, e) => {
  const { $from: n } = e.selection, r = ce(t, e.schema);
  let i = null, s = n.depth, o = n.pos, l = null;
  for (; s > 0 && l === null; )
    i = n.node(s), i.type === r ? l = s : (s -= 1, o -= 1);
  return l === null ? null : { $pos: e.doc.resolve(o), depth: l };
}, vl = (t, e) => {
  const n = wr(t, e);
  if (!n)
    return !1;
  const [, r] = fk(e, t, n.$pos.pos + 4);
  return r;
}, eh = (t, e, n) => {
  const { $anchor: r } = t.selection, i = Math.max(0, r.pos - 2), s = t.doc.resolve(i).node();
  return !(!s || !n.includes(s.type.name));
}, th = (t, e) => {
  var n;
  const { $anchor: r } = e.selection, i = e.doc.resolve(r.pos - 2);
  return !(i.index() === 0 || ((n = i.nodeBefore) == null ? void 0 : n.type.name) !== t);
}, nh = (t, e, n) => {
  if (!n)
    return !1;
  const r = ce(t, e.schema);
  let i = !1;
  return n.descendants((s) => {
    s.type === r && (i = !0);
  }), i;
}, wo = (t, e, n) => {
  if (t.commands.undoInputRule())
    return !0;
  if (t.state.selection.from !== t.state.selection.to)
    return !1;
  if (!qt(t.state, e) && eh(t.state, e, n)) {
    const { $anchor: l } = t.state.selection, a = t.state.doc.resolve(l.before() - 1), c = [];
    a.node().descendants((h, f) => {
      h.type.name === e && c.push({ node: h, pos: f });
    });
    const d = c.at(-1);
    if (!d)
      return !1;
    const u = t.state.doc.resolve(a.start() + d.pos + 1);
    return t.chain().cut({ from: l.start() - 1, to: l.end() + 1 }, u.end()).joinForward().run();
  }
  if (!qt(t.state, e) || !yk(t.state))
    return !1;
  const r = wr(e, t.state);
  if (!r)
    return !1;
  const s = t.state.doc.resolve(r.$pos.pos - 2).node(r.depth), o = nh(e, t.state, s);
  return th(e, t.state) && !o ? t.commands.joinItemBackward() : t.chain().liftListItem(e).run();
}, rh = (t, e) => {
  const n = vl(t, e), r = wr(t, e);
  return !r || !n ? !1 : n > r.depth;
}, ih = (t, e) => {
  const n = vl(t, e), r = wr(t, e);
  return !r || !n ? !1 : n < r.depth;
}, So = (t, e) => {
  if (!qt(t.state, e) || !gk(t.state, e))
    return !1;
  const { selection: n } = t.state, { $from: r, $to: i } = n;
  return !n.empty && r.sameParent(i) ? !1 : rh(e, t.state) ? t.chain().focus(t.state.selection.from + 4).lift(e).joinBackward().run() : ih(e, t.state) ? t.chain().joinForward().joinBackward().run() : t.commands.joinItemForward();
}, gx = (t, e) => {
  var n;
  const { $anchor: r } = e.selection, i = e.doc.resolve(r.pos - r.parentOffset - 2);
  return !(i.index() === i.parent.childCount - 1 || ((n = i.nodeAfter) == null ? void 0 : n.type.name) !== t);
}, sh = X.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: n }) => {
          t.state.schema.nodes[n] !== void 0 && So(t, n) && (e = !0);
        }), e;
      },
      "Mod-Delete": ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: n }) => {
          t.state.schema.nodes[n] !== void 0 && So(t, n) && (e = !0);
        }), e;
      },
      Backspace: ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
          t.state.schema.nodes[n] !== void 0 && wo(t, n, r) && (e = !0);
        }), e;
      },
      "Mod-Backspace": ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
          t.state.schema.nodes[n] !== void 0 && wo(t, n, r) && (e = !0);
        }), e;
      }
    };
  }
}), Xa = /^(\s*)(\d+)\.\s+(.*)$/, yx = /^\s/;
function bx(t) {
  const e = t.trimStart();
  return /^[-+*]\s+/.test(e) || /^\d+\.\s+/.test(e) || /^>\s?/.test(e) || /^```/.test(e) || /^~~~/.test(e);
}
function kx(t) {
  const e = [], n = [];
  let r = !1;
  return t.forEach((i) => {
    if (r) {
      n.push(i);
      return;
    }
    if (i.trim() === "") {
      r = !0, n.push(i);
      return;
    }
    if (e.length > 0 && bx(i)) {
      r = !0, n.push(i);
      return;
    }
    e.push(i);
  }), {
    paragraphLines: e,
    blockLines: n
  };
}
function vx(t) {
  const e = [];
  let n = 0, r = 0;
  for (; n < t.length; ) {
    const i = t[n], s = i.match(Xa);
    if (!s)
      break;
    const [, o, l, a] = s, c = o.length, d = [a];
    let u = n + 1;
    const h = [i];
    let f = !1;
    for (; u < t.length; ) {
      const p = t[u];
      if (p.match(Xa))
        break;
      if (p.trim() === "")
        h.push(p), d.push(""), f = !0, u += 1;
      else if (p.match(yx))
        h.push(p), d.push(p.slice(c + 2)), u += 1;
      else {
        if (f)
          break;
        h.push(p), d.push(p), u += 1;
      }
    }
    e.push({
      indent: c,
      number: parseInt(l, 10),
      content: d.join(`
`).trim(),
      contentLines: d,
      raw: h.join(`
`)
    }), r = u, n = u;
  }
  return [e, r];
}
function oh(t, e, n) {
  const r = [];
  let i = 0;
  for (; i < t.length; ) {
    const s = t[i];
    if (s.indent === e) {
      const { paragraphLines: o, blockLines: l } = kx(s.contentLines), a = o.join(`
`).trim(), c = [];
      a && c.push({
        type: "paragraph",
        raw: a,
        tokens: n.inlineTokens(a)
      });
      const d = l.join(`
`).trim();
      if (d) {
        const f = n.blockTokens(d);
        c.push(...f);
      }
      let u = i + 1;
      const h = [];
      for (; u < t.length && t[u].indent > e; )
        h.push(t[u]), u += 1;
      if (h.length > 0) {
        const f = Math.min(...h.map((m) => m.indent)), p = oh(h, f, n);
        c.push({
          type: "list",
          ordered: !0,
          start: h[0].number,
          items: p,
          raw: h.map((m) => m.raw).join(`
`)
        });
      }
      r.push({
        type: "list_item",
        raw: s.raw,
        tokens: c
      }), i = u;
    } else
      i += 1;
  }
  return r;
}
function Cx(t, e) {
  return t.map((n) => {
    if (n.type !== "list_item")
      return e.parseChildren([n])[0];
    const r = [];
    return n.tokens && n.tokens.length > 0 && n.tokens.forEach((i) => {
      if (i.type === "paragraph" || i.type === "list" || i.type === "blockquote" || i.type === "code")
        r.push(...e.parseChildren([i]));
      else if (i.type === "text" && i.tokens) {
        const s = e.parseChildren([i]);
        r.push({
          type: "paragraph",
          content: s
        });
      } else {
        const s = e.parseChildren([i]);
        s.length > 0 && r.push(...s);
      }
    }), {
      type: "listItem",
      content: r
    };
  });
}
var xx = "listItem", ec = "textStyle", tc = /^(\d+)\.\s$/, lh = de.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...n } = t;
    return e === 1 ? ["ol", J(this.options.HTMLAttributes, n), 0] : ["ol", J(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (t, e) => {
    if (t.type !== "list" || !t.ordered)
      return [];
    const n = t.start || 1, r = t.items ? Cx(t.items, e) : [];
    return n !== 1 ? {
      type: "orderedList",
      attrs: { start: n },
      content: r
    } : {
      type: "orderedList",
      content: r
    };
  },
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (t) => {
      const e = t.match(/^(\s*)(\d+)\.\s+/), n = e?.index;
      return n !== void 0 ? n : -1;
    },
    tokenize: (t, e, n) => {
      var r;
      const i = t.split(`
`), [s, o] = vx(i);
      if (s.length === 0)
        return;
      const l = oh(s, 0, n);
      return l.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((r = s[0]) == null ? void 0 : r.number) || 1,
        items: l,
        raw: i.slice(0, o).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(xx, this.editor.getAttributes(ec)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = Pn({
      find: tc,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Pn({
      find: tc,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(ec) }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1],
      editor: this.editor
    })), [t];
  }
}), wx = /^\s*(\[([( |x])?\])\s$/, Sx = de.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (t) => {
          const e = t.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (t) => ({
          "data-checked": t.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "li",
      J(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: t.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (t, e) => {
    const n = [];
    if (t.tokens && t.tokens.length > 0 ? n.push(e.createNode("paragraph", {}, e.parseInline(t.tokens))) : t.text ? n.push(e.createNode("paragraph", {}, [e.createNode("text", { text: t.text })])) : n.push(e.createNode("paragraph", {}, [])), t.nestedTokens && t.nestedTokens.length > 0) {
      const r = e.parseChildren(t.nestedTokens);
      n.push(...r);
    }
    return e.createNode("taskItem", { checked: t.checked || !1 }, n);
  },
  renderMarkdown: (t, e) => {
    var n;
    const i = `- [${(n = t.attrs) != null && n.checked ? "x" : " "}] `;
    return cl(t, e, i);
  },
  addKeyboardShortcuts() {
    const t = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...t,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : t;
  },
  addNodeView() {
    return ({ node: t, HTMLAttributes: e, getPos: n, editor: r }) => {
      const i = document.createElement("li"), s = document.createElement("label"), o = document.createElement("span"), l = document.createElement("input"), a = document.createElement("div"), c = (u) => {
        var h, f;
        l.ariaLabel = ((f = (h = this.options.a11y) == null ? void 0 : h.checkboxLabel) == null ? void 0 : f.call(h, u, l.checked)) || `Task item checkbox for ${u.textContent || "empty task item"}`;
      };
      c(t), s.contentEditable = "false", l.type = "checkbox", l.addEventListener("mousedown", (u) => u.preventDefault()), l.addEventListener("change", (u) => {
        if (!r.isEditable && !this.options.onReadOnlyChecked) {
          l.checked = !l.checked;
          return;
        }
        const { checked: h } = u.target;
        r.isEditable && typeof n == "function" && r.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: f }) => {
          const p = n();
          if (typeof p != "number")
            return !1;
          const m = f.doc.nodeAt(p);
          return f.setNodeMarkup(p, void 0, {
            ...m?.attrs,
            checked: h
          }), !0;
        }).run(), !r.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(t, h) || (l.checked = !l.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([u, h]) => {
        i.setAttribute(u, h);
      }), i.dataset.checked = t.attrs.checked, l.checked = t.attrs.checked, s.append(l, o), i.append(s, a), Object.entries(e).forEach(([u, h]) => {
        i.setAttribute(u, h);
      });
      let d = new Set(Object.keys(e));
      return {
        dom: i,
        contentDOM: a,
        update: (u) => {
          if (u.type !== this.type)
            return !1;
          i.dataset.checked = u.attrs.checked, l.checked = u.attrs.checked, c(u);
          const h = r.extensionManager.attributes, f = gr(u, h), p = new Set(Object.keys(f)), m = this.options.HTMLAttributes;
          return d.forEach((g) => {
            p.has(g) || (g in m ? i.setAttribute(g, m[g]) : i.removeAttribute(g));
          }), Object.entries(f).forEach(([g, b]) => {
            b == null ? g in m ? i.setAttribute(g, m[g]) : i.removeAttribute(g) : i.setAttribute(g, b);
          }), d = p, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      Pn({
        find: wx,
        type: this.type,
        getAttributes: (t) => ({
          checked: t[t.length - 1] === "x"
        })
      })
    ];
  }
}), Mx = de.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", J(this.options.HTMLAttributes, t, { "data-type": this.name }), 0];
  },
  parseMarkdown: (t, e) => e.createNode("taskList", {}, e.parseChildren(t.items || [])),
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(t) {
      var e;
      const n = (e = t.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : e.index;
      return n !== void 0 ? n : -1;
    },
    tokenize(t, e, n) {
      const r = (s) => {
        const o = fo(
          s,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (l) => ({
              indentLevel: l[1].length,
              mainContent: l[4],
              checked: l[3].toLowerCase() === "x"
            }),
            createToken: (l, a) => ({
              type: "taskItem",
              raw: "",
              mainContent: l.mainContent,
              indentLevel: l.indentLevel,
              checked: l.checked,
              text: l.mainContent,
              tokens: n.inlineTokens(l.mainContent),
              nestedTokens: a
            }),
            // Allow recursive nesting
            customNestedParser: r
          },
          n
        );
        return o ? [
          {
            type: "taskList",
            raw: o.raw,
            items: o.items
          }
        ] : n.blockTokens(s);
      }, i = fo(
        t,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (s) => ({
            indentLevel: s[1].length,
            mainContent: s[4],
            checked: s[3].toLowerCase() === "x"
          }),
          createToken: (s, o) => ({
            type: "taskItem",
            raw: "",
            mainContent: s.mainContent,
            indentLevel: s.indentLevel,
            checked: s.checked,
            text: s.mainContent,
            tokens: n.inlineTokens(s.mainContent),
            nestedTokens: o
          }),
          // Use the recursive parser for nested content
          customNestedParser: r
        },
        n
      );
      if (i)
        return {
          type: "taskList",
          raw: i.raw,
          items: i.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: t }) => t.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
X.create({
  name: "listKit",
  addExtensions() {
    const t = [];
    return this.options.bulletList !== !1 && t.push(Yu.configure(this.options.bulletList)), this.options.listItem !== !1 && t.push(Xu.configure(this.options.listItem)), this.options.listKeymap !== !1 && t.push(sh.configure(this.options.listKeymap)), this.options.orderedList !== !1 && t.push(lh.configure(this.options.orderedList)), this.options.taskItem !== !1 && t.push(Sx.configure(this.options.taskItem)), this.options.taskList !== !1 && t.push(Mx.configure(this.options.taskList)), t;
  }
});
var Hr = "&nbsp;", Hs = " ", Tx = de.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", J(this.options.HTMLAttributes, t), 0];
  },
  parseMarkdown: (t, e) => {
    const n = t.tokens || [];
    if (n.length === 1 && n[0].type === "image")
      return e.parseChildren([n[0]]);
    const r = e.parseInline(n);
    return n.length === 1 && n[0].type === "text" && (n[0].raw === Hr || n[0].text === Hr || n[0].raw === Hs || n[0].text === Hs) && r.length === 1 && r[0].type === "text" && (r[0].text === Hr || r[0].text === Hs) ? e.createNode("paragraph", void 0, []) : e.createNode("paragraph", void 0, r);
  },
  renderMarkdown: (t, e, n) => {
    var r, i;
    if (!t)
      return "";
    const s = Array.isArray(t.content) ? t.content : [];
    if (s.length === 0) {
      const o = Array.isArray((r = n?.previousNode) == null ? void 0 : r.content) ? n.previousNode.content : [];
      return ((i = n?.previousNode) == null ? void 0 : i.type) === "paragraph" && o.length === 0 ? Hr : "";
    }
    return e.renderChildren(s);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), Ex = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, Ax = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, Nx = yn.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", J(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (t, e) => e.applyMark("strike", e.parseInline(t.tokens || [])),
  renderMarkdown: (t, e) => `~~${e.renderChildren(t)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Dn({
        find: Ex,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      fn({
        find: Ax,
        type: this.type
      })
    ];
  }
}), _x = de.create({
  name: "text",
  group: "inline",
  parseMarkdown: (t) => ({
    type: "text",
    text: t.text || ""
  }),
  renderMarkdown: (t) => t.text || ""
}), Ox = yn.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["u", J(this.options.HTMLAttributes, t), 0];
  },
  parseMarkdown(t, e) {
    return e.applyMark(this.name || "underline", e.parseInline(t.tokens || []));
  },
  renderMarkdown(t, e) {
    return `++${e.renderChildren(t)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(t) {
      return t.indexOf("++");
    },
    tokenize(t, e, n) {
      const i = /^(\+\+)([\s\S]+?)(\+\+)/.exec(t);
      if (!i)
        return;
      const s = i[2].trim();
      return {
        type: "underline",
        raw: i[0],
        text: s,
        tokens: n.inlineTokens(s)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: t }) => t.setMark(this.name),
      toggleUnderline: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetUnderline: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function Rx(t = {}) {
  return new Y({
    view(e) {
      return new Ix(e, t);
    }
  });
}
class Ix {
  constructor(e, n) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let s = (o) => {
        this[i](o);
      };
      return e.dom.addEventListener(i, s), { name: i, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, r, i = this.editorView.dom, s = i.getBoundingClientRect(), o = s.width / i.offsetWidth, l = s.height / i.offsetHeight;
    if (n) {
      let u = e.nodeBefore, h = e.nodeAfter;
      if (u || h) {
        let f = this.editorView.nodeDOM(this.cursorPos - (u ? u.nodeSize : 0));
        if (f) {
          let p = f.getBoundingClientRect(), m = u ? p.bottom : p.top;
          u && h && (m = (m + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let g = this.width / 2 * l;
          r = { left: p.left, right: p.right, top: m - g, bottom: m + g };
        }
      }
    }
    if (!r) {
      let u = this.editorView.coordsAtPos(this.cursorPos), h = this.width / 2 * o;
      r = { left: u.left - h, right: u.left + h, top: u.top, bottom: u.bottom };
    }
    let a = this.editorView.dom.offsetParent;
    this.element || (this.element = a.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let c, d;
    if (!a || a == document.body && getComputedStyle(a).position == "static")
      c = -pageXOffset, d = -pageYOffset;
    else {
      let u = a.getBoundingClientRect(), h = u.width / a.offsetWidth, f = u.height / a.offsetHeight;
      c = u.left - a.scrollLeft * h, d = u.top - a.scrollTop * f;
    }
    this.element.style.left = (r.left - c) / o + "px", this.element.style.top = (r.top - d) / l + "px", this.element.style.width = (r.right - r.left) / o + "px", this.element.style.height = (r.bottom - r.top) / l + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), i = r && r.type.spec.disableDropCursor, s = typeof i == "function" ? i(this.editorView, n, e) : i;
    if (n && !s) {
      let o = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let l = ed(this.editorView.state.doc, o, this.editorView.dragging.slice);
        l != null && (o = l);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
class ne extends z {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let r = e.resolve(n.map(this.head));
    return ne.valid(r) ? new ne(r) : z.near(r);
  }
  content() {
    return A.empty;
  }
  eq(e) {
    return e instanceof ne && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new ne(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Cl(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.inlineContent || !Lx(e) || !Dx(e))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = n.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, r = !1) {
    e: for (; ; ) {
      if (!r && ne.valid(e))
        return e;
      let i = e.pos, s = null;
      for (let o = e.depth; ; o--) {
        let l = e.node(o);
        if (n > 0 ? e.indexAfter(o) < l.childCount : e.index(o) > 0) {
          s = l.child(n > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        i += n;
        let a = e.doc.resolve(i);
        if (ne.valid(a))
          return a;
      }
      for (; ; ) {
        let o = n > 0 ? s.firstChild : s.lastChild;
        if (!o) {
          if (s.isAtom && !s.isText && !L.isSelectable(s)) {
            e = e.doc.resolve(i + s.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        s = o, i += n;
        let l = e.doc.resolve(i);
        if (ne.valid(l))
          return l;
      }
      return null;
    }
  }
}
ne.prototype.visible = !1;
ne.findFrom = ne.findGapCursorFrom;
z.jsonID("gapcursor", ne);
class Cl {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Cl(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return ne.valid(n) ? new ne(n) : z.near(n);
  }
}
function ah(t) {
  return t.isAtom || t.spec.isolating || t.spec.createGapCursor;
}
function Lx(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), r = t.node(e);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || ah(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Dx(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), r = t.node(e);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(n); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || ah(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Px() {
  return new Y({
    props: {
      decorations: Hx,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && ne.valid(n) ? new ne(n) : null;
      },
      handleClick: Bx,
      handleKeyDown: zx,
      handleDOMEvents: { beforeinput: $x }
    }
  });
}
const zx = Xo({
  ArrowLeft: Vr("horiz", -1),
  ArrowRight: Vr("horiz", 1),
  ArrowUp: Vr("vert", -1),
  ArrowDown: Vr("vert", 1)
});
function Vr(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, s) {
    let o = r.selection, l = e > 0 ? o.$to : o.$from, a = o.empty;
    if (o instanceof I) {
      if (!s.endOfTextblock(n) || l.depth == 0)
        return !1;
      a = !1, l = r.doc.resolve(e > 0 ? l.after() : l.before());
    }
    let c = ne.findGapCursorFrom(l, e, a);
    return c ? (i && i(r.tr.setSelection(new ne(c))), !0) : !1;
  };
}
function Bx(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let r = t.state.doc.resolve(e);
  if (!ne.valid(r))
    return !1;
  let i = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return i && i.inside > -1 && L.isSelectable(t.state.doc.nodeAt(i.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new ne(r))), !0);
}
function $x(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof ne))
    return !1;
  let { $from: n } = t.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = w.empty;
  for (let o = r.length - 1; o >= 0; o--)
    i = w.from(r[o].createAndFill(null, i));
  let s = t.state.tr.replace(n.pos, n.pos, new A(i, 0, 0));
  return s.setSelection(I.near(s.doc.resolve(n.pos + 1))), t.dispatch(s), !1;
}
function Hx(t) {
  if (!(t.selection instanceof ne))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", Z.create(t.doc, [he.widget(t.selection.head, e, { key: "gapcursor" })]);
}
var Vi = 200, pe = function() {
};
pe.prototype.append = function(e) {
  return e.length ? (e = pe.from(e), !this.length && e || e.length < Vi && this.leafAppend(e) || this.length < Vi && e.leafPrepend(this) || this.appendInner(e)) : this;
};
pe.prototype.prepend = function(e) {
  return e.length ? pe.from(e).append(this) : this;
};
pe.prototype.appendInner = function(e) {
  return new Vx(this, e);
};
pe.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? pe.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
pe.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
pe.prototype.forEach = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(e, n, r, 0) : this.forEachInvertedInner(e, n, r, 0);
};
pe.prototype.map = function(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(s, o) {
    return i.push(e(s, o));
  }, n, r), i;
};
pe.from = function(e) {
  return e instanceof pe ? e : e && e.length ? new ch(e) : pe.empty;
};
var ch = /* @__PURE__ */ (function(t) {
  function e(r) {
    t.call(this), this.values = r;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, s) {
    return i == 0 && s == this.length ? this : new e(this.values.slice(i, s));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, s, o, l) {
    for (var a = s; a < o; a++)
      if (i(this.values[a], l + a) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, s, o, l) {
    for (var a = s - 1; a >= o; a--)
      if (i(this.values[a], l + a) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Vi)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Vi)
      return new e(i.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
})(pe);
pe.empty = new ch([]);
var Vx = /* @__PURE__ */ (function(t) {
  function e(n, r) {
    t.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, s, o) {
    var l = this.left.length;
    if (i < l && this.left.forEachInner(r, i, Math.min(s, l), o) === !1 || s > l && this.right.forEachInner(r, Math.max(i - l, 0), Math.min(this.length, s) - l, o + l) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, s, o) {
    var l = this.left.length;
    if (i > l && this.right.forEachInvertedInner(r, i - l, Math.max(s, l) - l, o + l) === !1 || s < l && this.left.forEachInvertedInner(r, Math.min(i, l), s, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var s = this.left.length;
    return i <= s ? this.left.slice(r, i) : r >= s ? this.right.slice(r - s, i - s) : this.left.slice(r, s).append(this.right.slice(0, i - s));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
})(pe);
const Fx = 500;
class Ge {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, s;
    n && (i = this.remapping(r, this.items.length), s = i.maps.length);
    let o = e.tr, l, a, c = [], d = [];
    return this.items.forEach((u, h) => {
      if (!u.step) {
        i || (i = this.remapping(r, h + 1), s = i.maps.length), s--, d.push(u);
        return;
      }
      if (i) {
        d.push(new st(u.map));
        let f = u.step.map(i.slice(s)), p;
        f && o.maybeStep(f).doc && (p = o.mapping.maps[o.mapping.maps.length - 1], c.push(new st(p, void 0, void 0, c.length + d.length))), s--, p && i.appendMap(p, s);
      } else
        o.maybeStep(u.step);
      if (u.selection)
        return l = i ? u.selection.map(i.slice(s)) : u.selection, a = new Ge(this.items.slice(0, r).append(d.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: a, transform: o, selection: l };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, r, i) {
    let s = [], o = this.eventCount, l = this.items, a = !i && l.length ? l.get(l.length - 1) : null;
    for (let d = 0; d < e.steps.length; d++) {
      let u = e.steps[d].invert(e.docs[d]), h = new st(e.mapping.maps[d], u, n), f;
      (f = a && a.merge(h)) && (h = f, d ? s.pop() : l = l.slice(0, l.length - 1)), s.push(h), n && (o++, n = void 0), i || (a = h);
    }
    let c = o - r.depth;
    return c > qx && (l = Wx(l, c), o -= c), new Ge(l.append(s), o);
  }
  remapping(e, n) {
    let r = new dr();
    return this.items.forEach((i, s) => {
      let o = i.mirrorOffset != null && s - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, o);
    }, e, n), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Ge(this.items.append(e.map((n) => new st(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - n), s = e.mapping, o = e.steps.length, l = this.eventCount;
    this.items.forEach((h) => {
      h.selection && l--;
    }, i);
    let a = n;
    this.items.forEach((h) => {
      let f = s.getMirror(--a);
      if (f == null)
        return;
      o = Math.min(o, f);
      let p = s.maps[f];
      if (h.step) {
        let m = e.steps[f].invert(e.docs[f]), g = h.selection && h.selection.map(s.slice(a + 1, f));
        g && l++, r.push(new st(p, m, g));
      } else
        r.push(new st(p));
    }, i);
    let c = [];
    for (let h = n; h < o; h++)
      c.push(new st(s.maps[h]));
    let d = this.items.slice(0, i).append(c).append(r), u = new Ge(d, l);
    return u.emptyItemCount() > Fx && (u = u.compress(this.items.length - r.length)), u;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), r = n.maps.length, i = [], s = 0;
    return this.items.forEach((o, l) => {
      if (l >= e)
        i.push(o), o.selection && s++;
      else if (o.step) {
        let a = o.step.map(n.slice(r)), c = a && a.getMap();
        if (r--, c && n.appendMap(c, r), a) {
          let d = o.selection && o.selection.map(n.slice(r));
          d && s++;
          let u = new st(c.invert(), a, d), h, f = i.length - 1;
          (h = i.length && i[f].merge(u)) ? i[f] = h : i.push(u);
        }
      } else o.map && r--;
    }, this.items.length, 0), new Ge(pe.from(i.reverse()), s);
  }
}
Ge.empty = new Ge(pe.empty, 0);
function Wx(t, e) {
  let n;
  return t.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return n = i, !1;
  }), t.slice(n);
}
class st {
  constructor(e, n, r, i) {
    this.map = e, this.step = n, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new st(n.getMap().invert(), n, this.selection);
    }
  }
}
class Lt {
  constructor(e, n, r, i, s) {
    this.done = e, this.undone = n, this.prevRanges = r, this.prevTime = i, this.prevComposition = s;
  }
}
const qx = 20;
function jx(t, e, n, r) {
  let i = n.getMeta(an), s;
  if (i)
    return i.historyState;
  n.getMeta(Zx) && (t = new Lt(t.done, t.undone, null, 0, -1));
  let o = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (o && o.getMeta(an))
    return o.getMeta(an).redo ? new Lt(t.done.addTransform(n, void 0, r, Jr(e)), t.undone, nc(n.mapping.maps), t.prevTime, t.prevComposition) : new Lt(t.done, t.undone.addTransform(n, void 0, r, Jr(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let l = n.getMeta("composition"), a = t.prevTime == 0 || !o && t.prevComposition != l && (t.prevTime < (n.time || 0) - r.newGroupDelay || !Ux(n, t.prevRanges)), c = o ? Vs(t.prevRanges, n.mapping) : nc(n.mapping.maps);
    return new Lt(t.done.addTransform(n, a ? e.selection.getBookmark() : void 0, r, Jr(e)), Ge.empty, c, n.time, l ?? t.prevComposition);
  } else return (s = n.getMeta("rebased")) ? new Lt(t.done.rebased(n, s), t.undone.rebased(n, s), Vs(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new Lt(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), Vs(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function Ux(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((r, i) => {
    for (let s = 0; s < e.length; s += 2)
      r <= e[s + 1] && i >= e[s] && (n = !0);
  }), n;
}
function nc(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((r, i, s, o) => e.push(s, o));
  return e;
}
function Vs(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let r = 0; r < t.length; r += 2) {
    let i = e.map(t[r], 1), s = e.map(t[r + 1], -1);
    i <= s && n.push(i, s);
  }
  return n;
}
function Kx(t, e, n) {
  let r = Jr(e), i = an.get(e).spec.config, s = (n ? t.undone : t.done).popEvent(e, r);
  if (!s)
    return null;
  let o = s.selection.resolve(s.transform.doc), l = (n ? t.done : t.undone).addTransform(s.transform, e.selection.getBookmark(), i, r), a = new Lt(n ? l : s.remaining, n ? s.remaining : l, null, 0, -1);
  return s.transform.setSelection(o).setMeta(an, { redo: n, historyState: a });
}
let Fs = !1, rc = null;
function Jr(t) {
  let e = t.plugins;
  if (rc != e) {
    Fs = !1, rc = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        Fs = !0;
        break;
      }
  }
  return Fs;
}
const an = new se("history"), Zx = new se("closeHistory");
function Gx(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new Y({
    key: an,
    state: {
      init() {
        return new Lt(Ge.empty, Ge.empty, null, 0, -1);
      },
      apply(e, n, r) {
        return jx(n, r, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let r = n.inputType, i = r == "historyUndo" ? uh : r == "historyRedo" ? hh : null;
          return !i || !e.editable ? !1 : (n.preventDefault(), i(e.state, e.dispatch));
        }
      }
    }
  });
}
function dh(t, e) {
  return (n, r) => {
    let i = an.getState(n);
    if (!i || (t ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let s = Kx(i, n, t);
      s && r(e ? s.scrollIntoView() : s);
    }
    return !0;
  };
}
const uh = dh(!1, !0), hh = dh(!0, !0);
X.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      autoTrim: !0,
      mode: "textSize",
      textCounter: (t) => t.length,
      wordCounter: (t) => t.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (t) => {
      const e = t?.node || this.editor.state.doc;
      if ((t?.mode || this.options.mode) === "textSize") {
        const r = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(r);
      }
      return e.nodeSize;
    }, this.storage.words = (t) => {
      const e = t?.node || this.editor.state.doc, n = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(n);
    };
  },
  addProseMirrorPlugins() {
    let t = !1;
    return [
      new Y({
        key: new se("characterCount"),
        appendTransaction: (e, n, r) => {
          if (t)
            return;
          const i = this.options.limit, s = this.options.autoTrim;
          if (i == null || i === 0 || s === !1) {
            t = !0;
            return;
          }
          const o = this.storage.characters({ node: r.doc });
          if (o > i) {
            const l = o - i, a = 0, c = l;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${i} characters. Content was automatically trimmed.`
            );
            const d = r.tr.deleteRange(a, c);
            return t = !0, d;
          }
          t = !0;
        },
        filterTransaction: (e, n) => {
          const r = this.options.limit;
          if (!e.docChanged || r === 0 || r === null || r === void 0)
            return !0;
          const i = this.storage.characters({ node: n.doc }), s = this.storage.characters({ node: e.doc });
          if (s <= r || i > r && s > r && s <= i)
            return !0;
          if (i > r && s > r && s > i || !e.getMeta("paste"))
            return !1;
          const l = e.selection.$head.pos, a = s - r, c = l - a, d = l;
          return e.deleteRange(c, d), !(this.storage.characters({ node: e.doc }) > r);
        }
      })
    ];
  }
});
var Jx = X.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [Rx(this.options)];
  }
});
X.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new Y({
        key: new se("focus"),
        props: {
          decorations: ({ doc: t, selection: e }) => {
            const { isEditable: n, isFocused: r } = this.editor, { anchor: i } = e, s = [];
            if (!n || !r)
              return Z.create(t, []);
            let o = 0;
            this.options.mode === "deepest" && t.descendants((a, c) => {
              if (a.isText)
                return;
              if (!(i >= c && i <= c + a.nodeSize - 1))
                return !1;
              o += 1;
            });
            let l = 0;
            return t.descendants((a, c) => {
              if (a.isText || !(i >= c && i <= c + a.nodeSize - 1))
                return !1;
              if (l += 1, this.options.mode === "deepest" && o - l > 0 || this.options.mode === "shallowest" && l > 1)
                return this.options.mode === "deepest";
              s.push(
                he.node(c, c + a.nodeSize, {
                  class: this.options.className
                })
              );
            }), Z.create(t, s);
          }
        }
      })
    ];
  }
});
var Qx = X.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [Px()];
  },
  extendNodeSchema(t) {
    var e;
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = F(O(t, "allowGapCursor", n))) != null ? e : null
    };
  }
}), ic = "placeholder";
function Yx(t) {
  return t.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
X.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: ic,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const t = this.options.dataAttribute ? `data-${Yx(this.options.dataAttribute)}` : `data-${ic}`;
    return [
      new Y({
        key: new se("placeholder"),
        props: {
          decorations: ({ doc: e, selection: n }) => {
            const r = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: i } = n, s = [];
            if (!r)
              return null;
            const o = this.editor.isEmpty;
            return e.descendants((l, a) => {
              const c = i >= a && i <= a + l.nodeSize, d = !l.isLeaf && es(l);
              if (!l.type.isTextblock)
                return this.options.includeChildren;
              if ((c || !this.options.showOnlyCurrent) && d) {
                const u = [this.options.emptyNodeClass];
                o && u.push(this.options.emptyEditorClass);
                const h = he.node(a, a + l.nodeSize, {
                  class: u.join(" "),
                  [t]: typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: l,
                    pos: a,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                s.push(h);
              }
              return this.options.includeChildren;
            }), Z.create(e, s);
          }
        }
      })
    ];
  }
});
X.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: t, options: e } = this;
    return [
      new Y({
        key: new se("selection"),
        props: {
          decorations(n) {
            return n.selection.empty || t.isFocused || !t.isEditable || yu(n.selection) || t.view.dragging ? null : Z.create(n.doc, [
              he.inline(n.selection.from, n.selection.to, {
                class: e.className
              })
            ]);
          }
        }
      })
    ];
  }
});
var Xx = "skipTrailingNode";
function sc({ types: t, node: e }) {
  return e && Array.isArray(t) && t.includes(e.type) || e?.type === t;
}
var e3 = X.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var t;
    const e = new se(this.name), n = this.options.node || ((t = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : t.name) || "paragraph", r = Object.entries(this.editor.schema.nodes).map(([, i]) => i).filter((i) => (this.options.notAfter || []).concat(n).includes(i.name));
    return [
      new Y({
        key: e,
        appendTransaction: (i, s, o) => {
          const { doc: l, tr: a, schema: c } = o, d = e.getState(o), u = l.content.size, h = c.nodes[n];
          if (!i.some((f) => f.getMeta(Xx)) && d)
            return a.insert(u, h.create());
        },
        state: {
          init: (i, s) => {
            const o = s.tr.doc.lastChild;
            return !sc({ node: o, types: r });
          },
          apply: (i, s) => {
            if (!i.docChanged || i.getMeta("__uniqueIDTransaction"))
              return s;
            const o = i.doc.lastChild;
            return !sc({ node: o, types: r });
          }
        }
      })
    ];
  }
}), t3 = X.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => uh(t, e),
      redo: () => ({ state: t, dispatch: e }) => hh(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [Gx(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), n3 = X.create({
  name: "starterKit",
  addExtensions() {
    var t, e, n, r;
    const i = [];
    return this.options.bold !== !1 && i.push(xC.configure(this.options.bold)), this.options.blockquote !== !1 && i.push(yC.configure(this.options.blockquote)), this.options.bulletList !== !1 && i.push(Yu.configure(this.options.bulletList)), this.options.code !== !1 && i.push(MC.configure(this.options.code)), this.options.codeBlock !== !1 && i.push(AC.configure(this.options.codeBlock)), this.options.document !== !1 && i.push(NC.configure(this.options.document)), this.options.dropcursor !== !1 && i.push(Jx.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && i.push(Qx.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && i.push(_C.configure(this.options.hardBreak)), this.options.heading !== !1 && i.push(OC.configure(this.options.heading)), this.options.undoRedo !== !1 && i.push(t3.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && i.push(RC.configure(this.options.horizontalRule)), this.options.italic !== !1 && i.push(zC.configure(this.options.italic)), this.options.listItem !== !1 && i.push(Xu.configure(this.options.listItem)), this.options.listKeymap !== !1 && i.push(sh.configure((t = this.options) == null ? void 0 : t.listKeymap)), this.options.link !== !1 && i.push(Qu.configure((e = this.options) == null ? void 0 : e.link)), this.options.orderedList !== !1 && i.push(lh.configure(this.options.orderedList)), this.options.paragraph !== !1 && i.push(Tx.configure(this.options.paragraph)), this.options.strike !== !1 && i.push(Nx.configure(this.options.strike)), this.options.text !== !1 && i.push(_x.configure(this.options.text)), this.options.underline !== !1 && i.push(Ox.configure((n = this.options) == null ? void 0 : n.underline)), this.options.trailingNode !== !1 && i.push(e3.configure((r = this.options) == null ? void 0 : r.trailingNode)), i;
  }
}), Ws = n3, r3 = X.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (t) => {
              const e = t.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (t) => t.textAlign ? { style: `text-align: ${t.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (t) => ({ commands: e }) => this.options.alignments.includes(t) ? this.options.types.map((n) => e.updateAttributes(n, { textAlign: t })).some((n) => n) : !1,
      unsetTextAlign: () => ({ commands: t }) => this.options.types.map((e) => t.resetAttributes(e, "textAlign")).some((e) => e),
      toggleTextAlign: (t) => ({ editor: e, commands: n }) => this.options.alignments.includes(t) ? e.isActive({ textAlign: t }) ? n.unsetTextAlign() : n.setTextAlign(t) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), oc = r3;
let Mo, To;
if (typeof WeakMap < "u") {
  let t = /* @__PURE__ */ new WeakMap();
  Mo = (e) => t.get(e), To = (e, n) => (t.set(e, n), n);
} else {
  const t = [];
  let n = 0;
  Mo = (r) => {
    for (let i = 0; i < t.length; i += 2) if (t[i] == r) return t[i + 1];
  }, To = (r, i) => (n == 10 && (n = 0), t[n++] = r, t[n++] = i);
}
var re = class {
  constructor(t, e, n, r) {
    this.width = t, this.height = e, this.map = n, this.problems = r;
  }
  findCell(t) {
    for (let e = 0; e < this.map.length; e++) {
      const n = this.map[e];
      if (n != t) continue;
      const r = e % this.width, i = e / this.width | 0;
      let s = r + 1, o = i + 1;
      for (let l = 1; s < this.width && this.map[e + l] == n; l++) s++;
      for (let l = 1; o < this.height && this.map[e + this.width * l] == n; l++) o++;
      return {
        left: r,
        top: i,
        right: s,
        bottom: o
      };
    }
    throw new RangeError(`No cell with offset ${t} found`);
  }
  colCount(t) {
    for (let e = 0; e < this.map.length; e++) if (this.map[e] == t) return e % this.width;
    throw new RangeError(`No cell with offset ${t} found`);
  }
  nextCell(t, e, n) {
    const { left: r, right: i, top: s, bottom: o } = this.findCell(t);
    return e == "horiz" ? (n < 0 ? r == 0 : i == this.width) ? null : this.map[s * this.width + (n < 0 ? r - 1 : i)] : (n < 0 ? s == 0 : o == this.height) ? null : this.map[r + this.width * (n < 0 ? s - 1 : o)];
  }
  rectBetween(t, e) {
    const { left: n, right: r, top: i, bottom: s } = this.findCell(t), { left: o, right: l, top: a, bottom: c } = this.findCell(e);
    return {
      left: Math.min(n, o),
      top: Math.min(i, a),
      right: Math.max(r, l),
      bottom: Math.max(s, c)
    };
  }
  cellsInRect(t) {
    const e = [], n = {};
    for (let r = t.top; r < t.bottom; r++) for (let i = t.left; i < t.right; i++) {
      const s = r * this.width + i, o = this.map[s];
      n[o] || (n[o] = !0, !(i == t.left && i && this.map[s - 1] == o || r == t.top && r && this.map[s - this.width] == o) && e.push(o));
    }
    return e;
  }
  positionAt(t, e, n) {
    for (let r = 0, i = 0; ; r++) {
      const s = i + n.child(r).nodeSize;
      if (r == t) {
        let o = e + t * this.width;
        const l = (t + 1) * this.width;
        for (; o < l && this.map[o] < i; ) o++;
        return o == l ? s - 1 : this.map[o];
      }
      i = s;
    }
  }
  static get(t) {
    return Mo(t) || To(t, i3(t));
  }
};
function i3(t) {
  if (t.type.spec.tableRole != "table") throw new RangeError("Not a table node: " + t.type.name);
  const e = s3(t), n = t.childCount, r = [];
  let i = 0, s = null;
  const o = [];
  for (let c = 0, d = e * n; c < d; c++) r[c] = 0;
  for (let c = 0, d = 0; c < n; c++) {
    const u = t.child(c);
    d++;
    for (let p = 0; ; p++) {
      for (; i < r.length && r[i] != 0; ) i++;
      if (p == u.childCount) break;
      const m = u.child(p), { colspan: g, rowspan: b, colwidth: k } = m.attrs;
      for (let C = 0; C < b; C++) {
        if (C + c >= n) {
          (s || (s = [])).push({
            type: "overlong_rowspan",
            pos: d,
            n: b - C
          });
          break;
        }
        const v = i + C * e;
        for (let x = 0; x < g; x++) {
          r[v + x] == 0 ? r[v + x] = d : (s || (s = [])).push({
            type: "collision",
            row: c,
            pos: d,
            n: g - x
          });
          const M = k && k[x];
          if (M) {
            const S = (v + x) % e * 2, N = o[S];
            N == null || N != M && o[S + 1] == 1 ? (o[S] = M, o[S + 1] = 1) : N == M && o[S + 1]++;
          }
        }
      }
      i += g, d += m.nodeSize;
    }
    const h = (c + 1) * e;
    let f = 0;
    for (; i < h; ) r[i++] == 0 && f++;
    f && (s || (s = [])).push({
      type: "missing",
      row: c,
      n: f
    }), d++;
  }
  (e === 0 || n === 0) && (s || (s = [])).push({ type: "zero_sized" });
  const l = new re(e, n, r, s);
  let a = !1;
  for (let c = 0; !a && c < o.length; c += 2) o[c] != null && o[c + 1] < n && (a = !0);
  return a && o3(l, o, t), l;
}
function s3(t) {
  let e = -1, n = !1;
  for (let r = 0; r < t.childCount; r++) {
    const i = t.child(r);
    let s = 0;
    if (n) for (let o = 0; o < r; o++) {
      const l = t.child(o);
      for (let a = 0; a < l.childCount; a++) {
        const c = l.child(a);
        o + c.attrs.rowspan > r && (s += c.attrs.colspan);
      }
    }
    for (let o = 0; o < i.childCount; o++) {
      const l = i.child(o);
      s += l.attrs.colspan, l.attrs.rowspan > 1 && (n = !0);
    }
    e == -1 ? e = s : e != s && (e = Math.max(e, s));
  }
  return e;
}
function o3(t, e, n) {
  t.problems || (t.problems = []);
  const r = {};
  for (let i = 0; i < t.map.length; i++) {
    const s = t.map[i];
    if (r[s]) continue;
    r[s] = !0;
    const o = n.nodeAt(s);
    if (!o) throw new RangeError(`No cell with offset ${s} found`);
    let l = null;
    const a = o.attrs;
    for (let c = 0; c < a.colspan; c++) {
      const d = e[(i + c) % t.width * 2];
      d != null && (!a.colwidth || a.colwidth[c] != d) && ((l || (l = l3(a)))[c] = d);
    }
    l && t.problems.unshift({
      type: "colwidth mismatch",
      pos: s,
      colwidth: l
    });
  }
}
function l3(t) {
  if (t.colwidth) return t.colwidth.slice();
  const e = [];
  for (let n = 0; n < t.colspan; n++) e.push(0);
  return e;
}
function Se(t) {
  let e = t.cached.tableNodeTypes;
  if (!e) {
    e = t.cached.tableNodeTypes = {};
    for (const n in t.nodes) {
      const r = t.nodes[n], i = r.spec.tableRole;
      i && (e[i] = r);
    }
  }
  return e;
}
const Pt = new se("selectingCells");
function pn(t) {
  for (let e = t.depth - 1; e > 0; e--) if (t.node(e).type.spec.tableRole == "row") return t.node(0).resolve(t.before(e + 1));
  return null;
}
function a3(t) {
  for (let e = t.depth; e > 0; e--) {
    const n = t.node(e).type.spec.tableRole;
    if (n === "cell" || n === "header_cell") return t.node(e);
  }
  return null;
}
function Xe(t) {
  const e = t.selection.$head;
  for (let n = e.depth; n > 0; n--) if (e.node(n).type.spec.tableRole == "row") return !0;
  return !1;
}
function is(t) {
  const e = t.selection;
  if ("$anchorCell" in e && e.$anchorCell) return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell") return e.$anchor;
  const n = pn(e.$head) || c3(e.$head);
  if (n) return n;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function c3(t) {
  for (let e = t.nodeAfter, n = t.pos; e; e = e.firstChild, n++) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return t.doc.resolve(n);
  }
  for (let e = t.nodeBefore, n = t.pos; e; e = e.lastChild, n--) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return t.doc.resolve(n - e.nodeSize);
  }
}
function Eo(t) {
  return t.parent.type.spec.tableRole == "row" && !!t.nodeAfter;
}
function d3(t) {
  return t.node(0).resolve(t.pos + t.nodeAfter.nodeSize);
}
function xl(t, e) {
  return t.depth == e.depth && t.pos >= e.start(-1) && t.pos <= e.end(-1);
}
function fh(t, e, n) {
  const r = t.node(-1), i = re.get(r), s = t.start(-1), o = i.nextCell(t.pos - s, e, n);
  return o == null ? null : t.node(0).resolve(s + o);
}
function mn(t, e, n = 1) {
  const r = {
    ...t,
    colspan: t.colspan - n
  };
  return r.colwidth && (r.colwidth = r.colwidth.slice(), r.colwidth.splice(e, n), r.colwidth.some((i) => i > 0) || (r.colwidth = null)), r;
}
function ph(t, e, n = 1) {
  const r = {
    ...t,
    colspan: t.colspan + n
  };
  if (r.colwidth) {
    r.colwidth = r.colwidth.slice();
    for (let i = 0; i < n; i++) r.colwidth.splice(e, 0, 0);
  }
  return r;
}
function u3(t, e, n) {
  const r = Se(e.type.schema).header_cell;
  for (let i = 0; i < t.height; i++) if (e.nodeAt(t.map[n + i * t.width]).type != r) return !1;
  return !0;
}
var G = class bt extends z {
  constructor(e, n = e) {
    const r = e.node(-1), i = re.get(r), s = e.start(-1), o = i.rectBetween(e.pos - s, n.pos - s), l = e.node(0), a = i.cellsInRect(o).filter((d) => d != n.pos - s);
    a.unshift(n.pos - s);
    const c = a.map((d) => {
      const u = r.nodeAt(d);
      if (!u) throw new RangeError(`No cell with offset ${d} found`);
      const h = s + d + 1;
      return new sd(l.resolve(h), l.resolve(h + u.content.size));
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = n;
  }
  map(e, n) {
    const r = e.resolve(n.map(this.$anchorCell.pos)), i = e.resolve(n.map(this.$headCell.pos));
    if (Eo(r) && Eo(i) && xl(r, i)) {
      const s = this.$anchorCell.node(-1) != r.node(-1);
      return s && this.isRowSelection() ? bt.rowSelection(r, i) : s && this.isColSelection() ? bt.colSelection(r, i) : new bt(r, i);
    }
    return I.between(r, i);
  }
  content() {
    const e = this.$anchorCell.node(-1), n = re.get(e), r = this.$anchorCell.start(-1), i = n.rectBetween(this.$anchorCell.pos - r, this.$headCell.pos - r), s = {}, o = [];
    for (let a = i.top; a < i.bottom; a++) {
      const c = [];
      for (let d = a * n.width + i.left, u = i.left; u < i.right; u++, d++) {
        const h = n.map[d];
        if (s[h]) continue;
        s[h] = !0;
        const f = n.findCell(h);
        let p = e.nodeAt(h);
        if (!p) throw new RangeError(`No cell with offset ${h} found`);
        const m = i.left - f.left, g = f.right - i.right;
        if (m > 0 || g > 0) {
          let b = p.attrs;
          if (m > 0 && (b = mn(b, 0, m)), g > 0 && (b = mn(b, b.colspan - g, g)), f.left < i.left) {
            if (p = p.type.createAndFill(b), !p) throw new RangeError(`Could not create cell with attrs ${JSON.stringify(b)}`);
          } else p = p.type.create(b, p.content);
        }
        if (f.top < i.top || f.bottom > i.bottom) {
          const b = {
            ...p.attrs,
            rowspan: Math.min(f.bottom, i.bottom) - Math.max(f.top, i.top)
          };
          f.top < i.top ? p = p.type.createAndFill(b) : p = p.type.create(b, p.content);
        }
        c.push(p);
      }
      o.push(e.child(a).copy(w.from(c)));
    }
    const l = this.isColSelection() && this.isRowSelection() ? e : o;
    return new A(w.from(l), 1, 1);
  }
  replace(e, n = A.empty) {
    const r = e.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      const { $from: l, $to: a } = i[o], c = e.mapping.slice(r);
      e.replace(c.map(l.pos), c.map(a.pos), o ? A.empty : n);
    }
    const s = z.findFrom(e.doc.resolve(e.mapping.slice(r).map(this.to)), -1);
    s && e.setSelection(s);
  }
  replaceWith(e, n) {
    this.replace(e, new A(w.from(n), 0, 0));
  }
  forEachCell(e) {
    const n = this.$anchorCell.node(-1), r = re.get(n), i = this.$anchorCell.start(-1), s = r.cellsInRect(r.rectBetween(this.$anchorCell.pos - i, this.$headCell.pos - i));
    for (let o = 0; o < s.length; o++) e(n.nodeAt(s[o]), i + s[o]);
  }
  isColSelection() {
    const e = this.$anchorCell.index(-1), n = this.$headCell.index(-1);
    if (Math.min(e, n) > 0) return !1;
    const r = e + this.$anchorCell.nodeAfter.attrs.rowspan, i = n + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, i) == this.$headCell.node(-1).childCount;
  }
  static colSelection(e, n = e) {
    const r = e.node(-1), i = re.get(r), s = e.start(-1), o = i.findCell(e.pos - s), l = i.findCell(n.pos - s), a = e.node(0);
    return o.top <= l.top ? (o.top > 0 && (e = a.resolve(s + i.map[o.left])), l.bottom < i.height && (n = a.resolve(s + i.map[i.width * (i.height - 1) + l.right - 1]))) : (l.top > 0 && (n = a.resolve(s + i.map[l.left])), o.bottom < i.height && (e = a.resolve(s + i.map[i.width * (i.height - 1) + o.right - 1]))), new bt(e, n);
  }
  isRowSelection() {
    const e = this.$anchorCell.node(-1), n = re.get(e), r = this.$anchorCell.start(-1), i = n.colCount(this.$anchorCell.pos - r), s = n.colCount(this.$headCell.pos - r);
    if (Math.min(i, s) > 0) return !1;
    const o = i + this.$anchorCell.nodeAfter.attrs.colspan, l = s + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(o, l) == n.width;
  }
  eq(e) {
    return e instanceof bt && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  static rowSelection(e, n = e) {
    const r = e.node(-1), i = re.get(r), s = e.start(-1), o = i.findCell(e.pos - s), l = i.findCell(n.pos - s), a = e.node(0);
    return o.left <= l.left ? (o.left > 0 && (e = a.resolve(s + i.map[o.top * i.width])), l.right < i.width && (n = a.resolve(s + i.map[i.width * (l.top + 1) - 1]))) : (l.left > 0 && (n = a.resolve(s + i.map[l.top * i.width])), o.right < i.width && (e = a.resolve(s + i.map[i.width * (o.top + 1) - 1]))), new bt(e, n);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, n) {
    return new bt(e.resolve(n.anchor), e.resolve(n.head));
  }
  static create(e, n, r = n) {
    return new bt(e.resolve(n), e.resolve(r));
  }
  getBookmark() {
    return new h3(this.$anchorCell.pos, this.$headCell.pos);
  }
};
G.prototype.visible = !1;
z.jsonID("cell", G);
var h3 = class mh {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new mh(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const n = e.resolve(this.anchor), r = e.resolve(this.head);
    return n.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && n.index() < n.parent.childCount && r.index() < r.parent.childCount && xl(n, r) ? new G(n, r) : z.near(r, 1);
  }
};
function f3(t) {
  if (!(t.selection instanceof G)) return null;
  const e = [];
  return t.selection.forEachCell((n, r) => {
    e.push(he.node(r, r + n.nodeSize, { class: "selectedCell" }));
  }), Z.create(t.doc, e);
}
function p3({ $from: t, $to: e }) {
  if (t.pos == e.pos || t.pos < e.pos - 6) return !1;
  let n = t.pos, r = e.pos, i = t.depth;
  for (; i >= 0 && !(t.after(i + 1) < t.end(i)); i--, n++) ;
  for (let s = e.depth; s >= 0 && !(e.before(s + 1) > e.start(s)); s--, r--) ;
  return n == r && /row|table/.test(t.node(i).type.spec.tableRole);
}
function m3({ $from: t, $to: e }) {
  let n, r;
  for (let i = t.depth; i > 0; i--) {
    const s = t.node(i);
    if (s.type.spec.tableRole === "cell" || s.type.spec.tableRole === "header_cell") {
      n = s;
      break;
    }
  }
  for (let i = e.depth; i > 0; i--) {
    const s = e.node(i);
    if (s.type.spec.tableRole === "cell" || s.type.spec.tableRole === "header_cell") {
      r = s;
      break;
    }
  }
  return n !== r && e.parentOffset === 0;
}
function g3(t, e, n) {
  const r = (e || t).selection, i = (e || t).doc;
  let s, o;
  if (r instanceof L && (o = r.node.type.spec.tableRole)) {
    if (o == "cell" || o == "header_cell") s = G.create(i, r.from);
    else if (o == "row") {
      const l = i.resolve(r.from + 1);
      s = G.rowSelection(l, l);
    } else if (!n) {
      const l = re.get(r.node), a = r.from + 1, c = a + l.map[l.width * l.height - 1];
      s = G.create(i, a + 1, c);
    }
  } else r instanceof I && p3(r) ? s = I.create(i, r.from) : r instanceof I && m3(r) && (s = I.create(i, r.$from.start(), r.$from.end()));
  return s && (e || (e = t.tr)).setSelection(s), e;
}
const y3 = new se("fix-tables");
function gh(t, e, n, r) {
  const i = t.childCount, s = e.childCount;
  e: for (let o = 0, l = 0; o < s; o++) {
    const a = e.child(o);
    for (let c = l, d = Math.min(i, o + 3); c < d; c++) if (t.child(c) == a) {
      l = c + 1, n += a.nodeSize;
      continue e;
    }
    r(a, n), l < i && t.child(l).sameMarkup(a) ? gh(t.child(l), a, n + 1, r) : a.nodesBetween(0, a.content.size, r, n + 1), n += a.nodeSize;
  }
}
function yh(t, e) {
  let n;
  const r = (i, s) => {
    i.type.spec.tableRole == "table" && (n = b3(t, i, s, n));
  };
  return e ? e.doc != t.doc && gh(e.doc, t.doc, 0, r) : t.doc.descendants(r), n;
}
function b3(t, e, n, r) {
  const i = re.get(e);
  if (!i.problems) return r;
  r || (r = t.tr);
  const s = [];
  for (let a = 0; a < i.height; a++) s.push(0);
  for (let a = 0; a < i.problems.length; a++) {
    const c = i.problems[a];
    if (c.type == "collision") {
      const d = e.nodeAt(c.pos);
      if (!d) continue;
      const u = d.attrs;
      for (let h = 0; h < u.rowspan; h++) s[c.row + h] += c.n;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, mn(u, u.colspan - c.n, c.n));
    } else if (c.type == "missing") s[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const d = e.nodeAt(c.pos);
      if (!d) continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...d.attrs,
        rowspan: d.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const d = e.nodeAt(c.pos);
      if (!d) continue;
      r.setNodeMarkup(r.mapping.map(n + 1 + c.pos), null, {
        ...d.attrs,
        colwidth: c.colwidth
      });
    } else if (c.type == "zero_sized") {
      const d = r.mapping.map(n);
      r.delete(d, d + e.nodeSize);
    }
  }
  let o, l;
  for (let a = 0; a < s.length; a++) s[a] && (o == null && (o = a), l = a);
  for (let a = 0, c = n + 1; a < i.height; a++) {
    const d = e.child(a), u = c + d.nodeSize, h = s[a];
    if (h > 0) {
      let f = "cell";
      d.firstChild && (f = d.firstChild.type.spec.tableRole);
      const p = [];
      for (let g = 0; g < h; g++) {
        const b = Se(t.schema)[f].createAndFill();
        b && p.push(b);
      }
      const m = (a == 0 || o == a - 1) && l == a ? c + 1 : u - 1;
      r.insert(r.mapping.map(m), p);
    }
    c = u;
  }
  return r.setMeta(y3, { fixTables: !0 });
}
function ut(t) {
  const e = t.selection, n = is(t), r = n.node(-1), i = n.start(-1), s = re.get(r);
  return {
    ...e instanceof G ? s.rectBetween(e.$anchorCell.pos - i, e.$headCell.pos - i) : s.findCell(n.pos - i),
    tableStart: i,
    map: s,
    table: r
  };
}
function bh(t, { map: e, tableStart: n, table: r }, i) {
  let s = i > 0 ? -1 : 0;
  u3(e, r, i + s) && (s = i == 0 || i == e.width ? null : 0);
  for (let o = 0; o < e.height; o++) {
    const l = o * e.width + i;
    if (i > 0 && i < e.width && e.map[l - 1] == e.map[l]) {
      const a = e.map[l], c = r.nodeAt(a);
      t.setNodeMarkup(t.mapping.map(n + a), null, ph(c.attrs, i - e.colCount(a))), o += c.attrs.rowspan - 1;
    } else {
      const a = s == null ? Se(r.type.schema).cell : r.nodeAt(e.map[l + s]).type, c = e.positionAt(o, i, r);
      t.insert(t.mapping.map(n + c), a.createAndFill());
    }
  }
  return t;
}
function k3(t, e) {
  if (!Xe(t)) return !1;
  if (e) {
    const n = ut(t);
    e(bh(t.tr, n, n.left));
  }
  return !0;
}
function v3(t, e) {
  if (!Xe(t)) return !1;
  if (e) {
    const n = ut(t);
    e(bh(t.tr, n, n.right));
  }
  return !0;
}
function C3(t, { map: e, table: n, tableStart: r }, i) {
  const s = t.mapping.maps.length;
  for (let o = 0; o < e.height; ) {
    const l = o * e.width + i, a = e.map[l], c = n.nodeAt(a), d = c.attrs;
    if (i > 0 && e.map[l - 1] == a || i < e.width - 1 && e.map[l + 1] == a) t.setNodeMarkup(t.mapping.slice(s).map(r + a), null, mn(d, i - e.colCount(a)));
    else {
      const u = t.mapping.slice(s).map(r + a);
      t.delete(u, u + c.nodeSize);
    }
    o += d.rowspan;
  }
}
function x3(t, e) {
  if (!Xe(t)) return !1;
  if (e) {
    const n = ut(t), r = t.tr;
    if (n.left == 0 && n.right == n.map.width) return !1;
    for (let i = n.right - 1; C3(r, n, i), i != n.left; i--) {
      const s = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!s) throw new RangeError("No table found");
      n.table = s, n.map = re.get(s);
    }
    e(r);
  }
  return !0;
}
function w3(t, e, n) {
  var r;
  const i = Se(e.type.schema).header_cell;
  for (let s = 0; s < t.width; s++) if (((r = e.nodeAt(t.map[s + n * t.width])) === null || r === void 0 ? void 0 : r.type) != i) return !1;
  return !0;
}
function kh(t, { map: e, tableStart: n, table: r }, i) {
  let s = n;
  for (let c = 0; c < i; c++) s += r.child(c).nodeSize;
  const o = [];
  let l = i > 0 ? -1 : 0;
  w3(e, r, i + l) && (l = i == 0 || i == e.height ? null : 0);
  for (let c = 0, d = e.width * i; c < e.width; c++, d++) if (i > 0 && i < e.height && e.map[d] == e.map[d - e.width]) {
    const u = e.map[d], h = r.nodeAt(u).attrs;
    t.setNodeMarkup(n + u, null, {
      ...h,
      rowspan: h.rowspan + 1
    }), c += h.colspan - 1;
  } else {
    var a;
    const u = l == null ? Se(r.type.schema).cell : (a = r.nodeAt(e.map[d + l * e.width])) === null || a === void 0 ? void 0 : a.type, h = u?.createAndFill();
    h && o.push(h);
  }
  return t.insert(s, Se(r.type.schema).row.create(null, o)), t;
}
function S3(t, e) {
  if (!Xe(t)) return !1;
  if (e) {
    const n = ut(t);
    e(kh(t.tr, n, n.top));
  }
  return !0;
}
function M3(t, e) {
  if (!Xe(t)) return !1;
  if (e) {
    const n = ut(t);
    e(kh(t.tr, n, n.bottom));
  }
  return !0;
}
function T3(t, { map: e, table: n, tableStart: r }, i) {
  let s = 0;
  for (let c = 0; c < i; c++) s += n.child(c).nodeSize;
  const o = s + n.child(i).nodeSize, l = t.mapping.maps.length;
  t.delete(s + r, o + r);
  const a = /* @__PURE__ */ new Set();
  for (let c = 0, d = i * e.width; c < e.width; c++, d++) {
    const u = e.map[d];
    if (!a.has(u)) {
      if (a.add(u), i > 0 && u == e.map[d - e.width]) {
        const h = n.nodeAt(u).attrs;
        t.setNodeMarkup(t.mapping.slice(l).map(u + r), null, {
          ...h,
          rowspan: h.rowspan - 1
        }), c += h.colspan - 1;
      } else if (i < e.height && u == e.map[d + e.width]) {
        const h = n.nodeAt(u), f = h.attrs, p = h.type.create({
          ...f,
          rowspan: h.attrs.rowspan - 1
        }, h.content), m = e.positionAt(i + 1, c, n);
        t.insert(t.mapping.slice(l).map(r + m), p), c += f.colspan - 1;
      }
    }
  }
}
function E3(t, e) {
  if (!Xe(t)) return !1;
  if (e) {
    const n = ut(t), r = t.tr;
    if (n.top == 0 && n.bottom == n.map.height) return !1;
    for (let i = n.bottom - 1; T3(r, n, i), i != n.top; i--) {
      const s = n.tableStart ? r.doc.nodeAt(n.tableStart - 1) : r.doc;
      if (!s) throw new RangeError("No table found");
      n.table = s, n.map = re.get(n.table);
    }
    e(r);
  }
  return !0;
}
function lc(t) {
  const e = t.content;
  return e.childCount == 1 && e.child(0).isTextblock && e.child(0).childCount == 0;
}
function A3({ width: t, height: e, map: n }, r) {
  let i = r.top * t + r.left, s = i, o = (r.bottom - 1) * t + r.left, l = i + (r.right - r.left - 1);
  for (let a = r.top; a < r.bottom; a++) {
    if (r.left > 0 && n[s] == n[s - 1] || r.right < t && n[l] == n[l + 1]) return !0;
    s += t, l += t;
  }
  for (let a = r.left; a < r.right; a++) {
    if (r.top > 0 && n[i] == n[i - t] || r.bottom < e && n[o] == n[o + t]) return !0;
    i++, o++;
  }
  return !1;
}
function ac(t, e) {
  const n = t.selection;
  if (!(n instanceof G) || n.$anchorCell.pos == n.$headCell.pos) return !1;
  const r = ut(t), { map: i } = r;
  if (A3(i, r)) return !1;
  if (e) {
    const s = t.tr, o = {};
    let l = w.empty, a, c;
    for (let d = r.top; d < r.bottom; d++) for (let u = r.left; u < r.right; u++) {
      const h = i.map[d * i.width + u], f = r.table.nodeAt(h);
      if (!(o[h] || !f))
        if (o[h] = !0, a == null)
          a = h, c = f;
        else {
          lc(f) || (l = l.append(f.content));
          const p = s.mapping.map(h + r.tableStart);
          s.delete(p, p + f.nodeSize);
        }
    }
    if (a == null || c == null) return !0;
    if (s.setNodeMarkup(a + r.tableStart, null, {
      ...ph(c.attrs, c.attrs.colspan, r.right - r.left - c.attrs.colspan),
      rowspan: r.bottom - r.top
    }), l.size > 0) {
      const d = a + 1 + c.content.size, u = lc(c) ? a + 1 : d;
      s.replaceWith(u + r.tableStart, d + r.tableStart, l);
    }
    s.setSelection(new G(s.doc.resolve(a + r.tableStart))), e(s);
  }
  return !0;
}
function cc(t, e) {
  const n = Se(t.schema);
  return N3(({ node: r }) => n[r.type.spec.tableRole])(t, e);
}
function N3(t) {
  return (e, n) => {
    const r = e.selection;
    let i, s;
    if (r instanceof G) {
      if (r.$anchorCell.pos != r.$headCell.pos) return !1;
      i = r.$anchorCell.nodeAfter, s = r.$anchorCell.pos;
    } else {
      var o;
      if (i = a3(r.$from), !i) return !1;
      s = (o = pn(r.$from)) === null || o === void 0 ? void 0 : o.pos;
    }
    if (i == null || s == null || i.attrs.colspan == 1 && i.attrs.rowspan == 1) return !1;
    if (n) {
      let l = i.attrs;
      const a = [], c = l.colwidth;
      l.rowspan > 1 && (l = {
        ...l,
        rowspan: 1
      }), l.colspan > 1 && (l = {
        ...l,
        colspan: 1
      });
      const d = ut(e), u = e.tr;
      for (let f = 0; f < d.right - d.left; f++) a.push(c ? {
        ...l,
        colwidth: c && c[f] ? [c[f]] : null
      } : l);
      let h;
      for (let f = d.top; f < d.bottom; f++) {
        let p = d.map.positionAt(f, d.left, d.table);
        f == d.top && (p += i.nodeSize);
        for (let m = d.left, g = 0; m < d.right; m++, g++)
          m == d.left && f == d.top || u.insert(h = u.mapping.map(p + d.tableStart, 1), t({
            node: i,
            row: f,
            col: m
          }).createAndFill(a[g]));
      }
      u.setNodeMarkup(s, t({
        node: i,
        row: d.top,
        col: d.left
      }), a[0]), r instanceof G && u.setSelection(new G(u.doc.resolve(r.$anchorCell.pos), h ? u.doc.resolve(h) : void 0)), n(u);
    }
    return !0;
  };
}
function _3(t, e) {
  return function(n, r) {
    if (!Xe(n)) return !1;
    const i = is(n);
    if (i.nodeAfter.attrs[t] === e) return !1;
    if (r) {
      const s = n.tr;
      n.selection instanceof G ? n.selection.forEachCell((o, l) => {
        o.attrs[t] !== e && s.setNodeMarkup(l, null, {
          ...o.attrs,
          [t]: e
        });
      }) : s.setNodeMarkup(i.pos, null, {
        ...i.nodeAfter.attrs,
        [t]: e
      }), r(s);
    }
    return !0;
  };
}
function O3(t) {
  return function(e, n) {
    if (!Xe(e)) return !1;
    if (n) {
      const r = Se(e.schema), i = ut(e), s = e.tr, o = i.map.cellsInRect(t == "column" ? {
        left: i.left,
        top: 0,
        right: i.right,
        bottom: i.map.height
      } : t == "row" ? {
        left: 0,
        top: i.top,
        right: i.map.width,
        bottom: i.bottom
      } : i), l = o.map((a) => i.table.nodeAt(a));
      for (let a = 0; a < o.length; a++) l[a].type == r.header_cell && s.setNodeMarkup(i.tableStart + o[a], r.cell, l[a].attrs);
      if (s.steps.length === 0) for (let a = 0; a < o.length; a++) s.setNodeMarkup(i.tableStart + o[a], r.header_cell, l[a].attrs);
      n(s);
    }
    return !0;
  };
}
function dc(t, e, n) {
  const r = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: t == "row" ? e.map.width : 1,
    bottom: t == "column" ? e.map.height : 1
  });
  for (let i = 0; i < r.length; i++) {
    const s = e.table.nodeAt(r[i]);
    if (s && s.type !== n.header_cell) return !1;
  }
  return !0;
}
function kr(t, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? O3(t) : function(n, r) {
    if (!Xe(n)) return !1;
    if (r) {
      const i = Se(n.schema), s = ut(n), o = n.tr, l = dc("row", s, i), a = dc("column", s, i), c = (t === "column" ? l : t === "row" && a) ? 1 : 0, d = t == "column" ? {
        left: 0,
        top: c,
        right: 1,
        bottom: s.map.height
      } : t == "row" ? {
        left: c,
        top: 0,
        right: s.map.width,
        bottom: 1
      } : s, u = t == "column" ? a ? i.cell : i.header_cell : t == "row" ? l ? i.cell : i.header_cell : i.cell;
      s.map.cellsInRect(d).forEach((h) => {
        const f = h + s.tableStart, p = o.doc.nodeAt(f);
        p && o.setNodeMarkup(f, u, p.attrs);
      }), r(o);
    }
    return !0;
  };
}
kr("row", { useDeprecatedLogic: !0 });
kr("column", { useDeprecatedLogic: !0 });
const R3 = kr("cell", { useDeprecatedLogic: !0 });
function I3(t, e) {
  if (e < 0) {
    const n = t.nodeBefore;
    if (n) return t.pos - n.nodeSize;
    for (let r = t.index(-1) - 1, i = t.before(); r >= 0; r--) {
      const s = t.node(-1).child(r), o = s.lastChild;
      if (o) return i - 1 - o.nodeSize;
      i -= s.nodeSize;
    }
  } else {
    if (t.index() < t.parent.childCount - 1) return t.pos + t.nodeAfter.nodeSize;
    const n = t.node(-1);
    for (let r = t.indexAfter(-1), i = t.after(); r < n.childCount; r++) {
      const s = n.child(r);
      if (s.childCount) return i + 1;
      i += s.nodeSize;
    }
  }
  return null;
}
function uc(t) {
  return function(e, n) {
    if (!Xe(e)) return !1;
    const r = I3(is(e), t);
    if (r == null) return !1;
    if (n) {
      const i = e.doc.resolve(r);
      n(e.tr.setSelection(I.between(i, d3(i))).scrollIntoView());
    }
    return !0;
  };
}
function L3(t, e) {
  const n = t.selection.$anchor;
  for (let r = n.depth; r > 0; r--) if (n.node(r).type.spec.tableRole == "table")
    return e && e(t.tr.delete(n.before(r), n.after(r)).scrollIntoView()), !0;
  return !1;
}
function Fr(t, e) {
  const n = t.selection;
  if (!(n instanceof G)) return !1;
  if (e) {
    const r = t.tr, i = Se(t.schema).cell.createAndFill().content;
    n.forEachCell((s, o) => {
      s.content.eq(i) || r.replace(r.mapping.map(o + 1), r.mapping.map(o + s.nodeSize - 1), new A(i, 0, 0));
    }), r.docChanged && e(r);
  }
  return !0;
}
function D3(t) {
  if (t.size === 0) return null;
  let { content: e, openStart: n, openEnd: r } = t;
  for (; e.childCount == 1 && (n > 0 && r > 0 || e.child(0).type.spec.tableRole == "table"); )
    n--, r--, e = e.child(0).content;
  const i = e.child(0), s = i.type.spec.tableRole, o = i.type.schema, l = [];
  if (s == "row") for (let a = 0; a < e.childCount; a++) {
    let c = e.child(a).content;
    const d = a ? 0 : Math.max(0, n - 1), u = a < e.childCount - 1 ? 0 : Math.max(0, r - 1);
    (d || u) && (c = Ao(Se(o).row, new A(c, d, u)).content), l.push(c);
  }
  else if (s == "cell" || s == "header_cell") l.push(n || r ? Ao(Se(o).row, new A(e, n, r)).content : e);
  else return null;
  return P3(o, l);
}
function P3(t, e) {
  const n = [];
  for (let i = 0; i < e.length; i++) {
    const s = e[i];
    for (let o = s.childCount - 1; o >= 0; o--) {
      const { rowspan: l, colspan: a } = s.child(o).attrs;
      for (let c = i; c < i + l; c++) n[c] = (n[c] || 0) + a;
    }
  }
  let r = 0;
  for (let i = 0; i < n.length; i++) r = Math.max(r, n[i]);
  for (let i = 0; i < n.length; i++)
    if (i >= e.length && e.push(w.empty), n[i] < r) {
      const s = Se(t).cell.createAndFill(), o = [];
      for (let l = n[i]; l < r; l++) o.push(s);
      e[i] = e[i].append(w.from(o));
    }
  return {
    height: e.length,
    width: r,
    rows: e
  };
}
function Ao(t, e) {
  const n = t.createAndFill();
  return new zo(n).replace(0, n.content.size, e).doc;
}
function z3({ width: t, height: e, rows: n }, r, i) {
  if (t != r) {
    const s = [], o = [];
    for (let l = 0; l < n.length; l++) {
      const a = n[l], c = [];
      for (let d = s[l] || 0, u = 0; d < r; u++) {
        let h = a.child(u % a.childCount);
        d + h.attrs.colspan > r && (h = h.type.createChecked(mn(h.attrs, h.attrs.colspan, d + h.attrs.colspan - r), h.content)), c.push(h), d += h.attrs.colspan;
        for (let f = 1; f < h.attrs.rowspan; f++) s[l + f] = (s[l + f] || 0) + h.attrs.colspan;
      }
      o.push(w.from(c));
    }
    n = o, t = r;
  }
  if (e != i) {
    const s = [];
    for (let o = 0, l = 0; o < i; o++, l++) {
      const a = [], c = n[l % e];
      for (let d = 0; d < c.childCount; d++) {
        let u = c.child(d);
        o + u.attrs.rowspan > i && (u = u.type.create({
          ...u.attrs,
          rowspan: Math.max(1, i - u.attrs.rowspan)
        }, u.content)), a.push(u);
      }
      s.push(w.from(a));
    }
    n = s, e = i;
  }
  return {
    width: t,
    height: e,
    rows: n
  };
}
function B3(t, e, n, r, i, s, o) {
  const l = t.doc.type.schema, a = Se(l);
  let c, d;
  if (i > e.width) for (let u = 0, h = 0; u < e.height; u++) {
    const f = n.child(u);
    h += f.nodeSize;
    const p = [];
    let m;
    f.lastChild == null || f.lastChild.type == a.cell ? m = c || (c = a.cell.createAndFill()) : m = d || (d = a.header_cell.createAndFill());
    for (let g = e.width; g < i; g++) p.push(m);
    t.insert(t.mapping.slice(o).map(h - 1 + r), p);
  }
  if (s > e.height) {
    const u = [];
    for (let p = 0, m = (e.height - 1) * e.width; p < Math.max(e.width, i); p++) {
      const g = p >= e.width ? !1 : n.nodeAt(e.map[m + p]).type == a.header_cell;
      u.push(g ? d || (d = a.header_cell.createAndFill()) : c || (c = a.cell.createAndFill()));
    }
    const h = a.row.create(null, w.from(u)), f = [];
    for (let p = e.height; p < s; p++) f.push(h);
    t.insert(t.mapping.slice(o).map(r + n.nodeSize - 2), f);
  }
  return !!(c || d);
}
function hc(t, e, n, r, i, s, o, l) {
  if (o == 0 || o == e.height) return !1;
  let a = !1;
  for (let c = i; c < s; c++) {
    const d = o * e.width + c, u = e.map[d];
    if (e.map[d - e.width] == u) {
      a = !0;
      const h = n.nodeAt(u), { top: f, left: p } = e.findCell(u);
      t.setNodeMarkup(t.mapping.slice(l).map(u + r), null, {
        ...h.attrs,
        rowspan: o - f
      }), t.insert(t.mapping.slice(l).map(e.positionAt(o, p, n)), h.type.createAndFill({
        ...h.attrs,
        rowspan: f + h.attrs.rowspan - o
      })), c += h.attrs.colspan - 1;
    }
  }
  return a;
}
function fc(t, e, n, r, i, s, o, l) {
  if (o == 0 || o == e.width) return !1;
  let a = !1;
  for (let c = i; c < s; c++) {
    const d = c * e.width + o, u = e.map[d];
    if (e.map[d - 1] == u) {
      a = !0;
      const h = n.nodeAt(u), f = e.colCount(u), p = t.mapping.slice(l).map(u + r);
      t.setNodeMarkup(p, null, mn(h.attrs, o - f, h.attrs.colspan - (o - f))), t.insert(p + h.nodeSize, h.type.createAndFill(mn(h.attrs, 0, o - f))), c += h.attrs.rowspan - 1;
    }
  }
  return a;
}
function pc(t, e, n, r, i) {
  let s = n ? t.doc.nodeAt(n - 1) : t.doc;
  if (!s) throw new Error("No table found");
  let o = re.get(s);
  const { top: l, left: a } = r, c = a + i.width, d = l + i.height, u = t.tr;
  let h = 0;
  function f() {
    if (s = n ? u.doc.nodeAt(n - 1) : u.doc, !s) throw new Error("No table found");
    o = re.get(s), h = u.mapping.maps.length;
  }
  B3(u, o, s, n, c, d, h) && f(), hc(u, o, s, n, a, c, l, h) && f(), hc(u, o, s, n, a, c, d, h) && f(), fc(u, o, s, n, l, d, a, h) && f(), fc(u, o, s, n, l, d, c, h) && f();
  for (let p = l; p < d; p++) {
    const m = o.positionAt(p, a, s), g = o.positionAt(p, c, s);
    u.replace(u.mapping.slice(h).map(m + n), u.mapping.slice(h).map(g + n), new A(i.rows[p - l], 0, 0));
  }
  f(), u.setSelection(new G(u.doc.resolve(n + o.positionAt(l, a, s)), u.doc.resolve(n + o.positionAt(d - 1, c - 1, s)))), e(u);
}
const $3 = Xo({
  ArrowLeft: Wr("horiz", -1),
  ArrowRight: Wr("horiz", 1),
  ArrowUp: Wr("vert", -1),
  ArrowDown: Wr("vert", 1),
  "Shift-ArrowLeft": qr("horiz", -1),
  "Shift-ArrowRight": qr("horiz", 1),
  "Shift-ArrowUp": qr("vert", -1),
  "Shift-ArrowDown": qr("vert", 1),
  Backspace: Fr,
  "Mod-Backspace": Fr,
  Delete: Fr,
  "Mod-Delete": Fr
});
function Qr(t, e, n) {
  return n.eq(t.selection) ? !1 : (e && e(t.tr.setSelection(n).scrollIntoView()), !0);
}
function Wr(t, e) {
  return (n, r, i) => {
    if (!i) return !1;
    const s = n.selection;
    if (s instanceof G) return Qr(n, r, z.near(s.$headCell, e));
    if (t != "horiz" && !s.empty) return !1;
    const o = vh(i, t, e);
    if (o == null) return !1;
    if (t == "horiz") return Qr(n, r, z.near(n.doc.resolve(s.head + e), e));
    {
      const l = n.doc.resolve(o), a = fh(l, t, e);
      let c;
      return a ? c = z.near(a, 1) : e < 0 ? c = z.near(n.doc.resolve(l.before(-1)), -1) : c = z.near(n.doc.resolve(l.after(-1)), 1), Qr(n, r, c);
    }
  };
}
function qr(t, e) {
  return (n, r, i) => {
    if (!i) return !1;
    const s = n.selection;
    let o;
    if (s instanceof G) o = s;
    else {
      const a = vh(i, t, e);
      if (a == null) return !1;
      o = new G(n.doc.resolve(a));
    }
    const l = fh(o.$headCell, t, e);
    return l ? Qr(n, r, new G(o.$anchorCell, l)) : !1;
  };
}
function H3(t, e) {
  const n = t.state.doc, r = pn(n.resolve(e));
  return r ? (t.dispatch(t.state.tr.setSelection(new G(r))), !0) : !1;
}
function V3(t, e, n) {
  if (!Xe(t.state)) return !1;
  let r = D3(n);
  const i = t.state.selection;
  if (i instanceof G) {
    r || (r = {
      width: 1,
      height: 1,
      rows: [w.from(Ao(Se(t.state.schema).cell, n))]
    });
    const s = i.$anchorCell.node(-1), o = i.$anchorCell.start(-1), l = re.get(s).rectBetween(i.$anchorCell.pos - o, i.$headCell.pos - o);
    return r = z3(r, l.right - l.left, l.bottom - l.top), pc(t.state, t.dispatch, o, l, r), !0;
  } else if (r) {
    const s = is(t.state), o = s.start(-1);
    return pc(t.state, t.dispatch, o, re.get(s.node(-1)).findCell(s.pos - o), r), !0;
  } else return !1;
}
function F3(t, e) {
  var n;
  if (e.button != 0 || e.ctrlKey || e.metaKey) return;
  const r = mc(t, e.target);
  let i;
  if (e.shiftKey && t.state.selection instanceof G)
    s(t.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && r && (i = pn(t.state.selection.$anchor)) != null && ((n = qs(t, e)) === null || n === void 0 ? void 0 : n.pos) != i.pos)
    s(i, e), e.preventDefault();
  else if (!r) return;
  function s(a, c) {
    let d = qs(t, c);
    const u = Pt.getState(t.state) == null;
    if (!d || !xl(a, d)) if (u) d = a;
    else return;
    const h = new G(a, d);
    if (u || !t.state.selection.eq(h)) {
      const f = t.state.tr.setSelection(h);
      u && f.setMeta(Pt, a.pos), t.dispatch(f);
    }
  }
  function o() {
    t.root.removeEventListener("mouseup", o), t.root.removeEventListener("dragstart", o), t.root.removeEventListener("mousemove", l), Pt.getState(t.state) != null && t.dispatch(t.state.tr.setMeta(Pt, -1));
  }
  function l(a) {
    const c = a, d = Pt.getState(t.state);
    let u;
    if (d != null) u = t.state.doc.resolve(d);
    else if (mc(t, c.target) != r && (u = qs(t, e), !u))
      return o();
    u && s(u, c);
  }
  t.root.addEventListener("mouseup", o), t.root.addEventListener("dragstart", o), t.root.addEventListener("mousemove", l);
}
function vh(t, e, n) {
  if (!(t.state.selection instanceof I)) return null;
  const { $head: r } = t.state.selection;
  for (let i = r.depth - 1; i >= 0; i--) {
    const s = r.node(i);
    if ((n < 0 ? r.index(i) : r.indexAfter(i)) != (n < 0 ? 0 : s.childCount)) return null;
    if (s.type.spec.tableRole == "cell" || s.type.spec.tableRole == "header_cell") {
      const o = r.before(i), l = e == "vert" ? n > 0 ? "down" : "up" : n > 0 ? "right" : "left";
      return t.endOfTextblock(l) ? o : null;
    }
  }
  return null;
}
function mc(t, e) {
  for (; e && e != t.dom; e = e.parentNode) if (e.nodeName == "TD" || e.nodeName == "TH") return e;
  return null;
}
function qs(t, e) {
  const n = t.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  if (!n) return null;
  let { inside: r, pos: i } = n;
  return r >= 0 && pn(t.state.doc.resolve(r)) || pn(t.state.doc.resolve(i));
}
var W3 = class {
  constructor(e, n) {
    this.node = e, this.defaultCellMinWidth = n, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.table.style.setProperty("--default-cell-min-width", `${n}px`), this.colgroup = this.table.appendChild(document.createElement("colgroup")), No(e, this.colgroup, this.table, n), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type != this.node.type ? !1 : (this.node = e, No(e, this.colgroup, this.table, this.defaultCellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type == "attributes" && (e.target == this.table || this.colgroup.contains(e.target));
  }
};
function No(t, e, n, r, i, s) {
  let o = 0, l = !0, a = e.firstChild;
  const c = t.firstChild;
  if (c) {
    for (let u = 0, h = 0; u < c.childCount; u++) {
      const { colspan: f, colwidth: p } = c.child(u).attrs;
      for (let m = 0; m < f; m++, h++) {
        const g = i == h ? s : p && p[m], b = g ? g + "px" : "";
        if (o += g || r, g || (l = !1), a)
          a.style.width != b && (a.style.width = b), a = a.nextSibling;
        else {
          const k = document.createElement("col");
          k.style.width = b, e.appendChild(k);
        }
      }
    }
    for (; a; ) {
      var d;
      const u = a.nextSibling;
      (d = a.parentNode) === null || d === void 0 || d.removeChild(a), a = u;
    }
    l ? (n.style.width = o + "px", n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = o + "px");
  }
}
const Pe = new se("tableColumnResizing");
function q3({ handleWidth: t = 5, cellMinWidth: e = 25, defaultCellMinWidth: n = 100, View: r = W3, lastColumnResizable: i = !0 } = {}) {
  const s = new Y({
    key: Pe,
    state: {
      init(o, l) {
        var a;
        const c = (a = s.spec) === null || a === void 0 || (a = a.props) === null || a === void 0 ? void 0 : a.nodeViews, d = Se(l.schema).table.name;
        return r && c && (c[d] = (u, h) => new r(u, n, h)), new j3(-1, !1);
      },
      apply(o, l) {
        return l.apply(o);
      }
    },
    props: {
      attributes: (o) => {
        const l = Pe.getState(o);
        return l && l.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (o, l) => {
          U3(o, l, t, i);
        },
        mouseleave: (o) => {
          K3(o);
        },
        mousedown: (o, l) => {
          Z3(o, l, e, n);
        }
      },
      decorations: (o) => {
        const l = Pe.getState(o);
        if (l && l.activeHandle > -1) return X3(o, l.activeHandle);
      },
      nodeViews: {}
    }
  });
  return s;
}
var j3 = class Yr {
  constructor(e, n) {
    this.activeHandle = e, this.dragging = n;
  }
  apply(e) {
    const n = this, r = e.getMeta(Pe);
    if (r && r.setHandle != null) return new Yr(r.setHandle, !1);
    if (r && r.setDragging !== void 0) return new Yr(n.activeHandle, r.setDragging);
    if (n.activeHandle > -1 && e.docChanged) {
      let i = e.mapping.map(n.activeHandle, -1);
      return Eo(e.doc.resolve(i)) || (i = -1), new Yr(i, n.dragging);
    }
    return n;
  }
};
function U3(t, e, n, r) {
  if (!t.editable) return;
  const i = Pe.getState(t.state);
  if (i && !i.dragging) {
    const s = J3(e.target);
    let o = -1;
    if (s) {
      const { left: l, right: a } = s.getBoundingClientRect();
      e.clientX - l <= n ? o = gc(t, e, "left", n) : a - e.clientX <= n && (o = gc(t, e, "right", n));
    }
    if (o != i.activeHandle) {
      if (!r && o !== -1) {
        const l = t.state.doc.resolve(o), a = l.node(-1), c = re.get(a), d = l.start(-1);
        if (c.colCount(l.pos - d) + l.nodeAfter.attrs.colspan - 1 == c.width - 1) return;
      }
      Ch(t, o);
    }
  }
}
function K3(t) {
  if (!t.editable) return;
  const e = Pe.getState(t.state);
  e && e.activeHandle > -1 && !e.dragging && Ch(t, -1);
}
function Z3(t, e, n, r) {
  var i;
  if (!t.editable) return !1;
  const s = (i = t.dom.ownerDocument.defaultView) !== null && i !== void 0 ? i : window, o = Pe.getState(t.state);
  if (!o || o.activeHandle == -1 || o.dragging) return !1;
  const l = t.state.doc.nodeAt(o.activeHandle), a = G3(t, o.activeHandle, l.attrs);
  t.dispatch(t.state.tr.setMeta(Pe, { setDragging: {
    startX: e.clientX,
    startWidth: a
  } }));
  function c(u) {
    s.removeEventListener("mouseup", c), s.removeEventListener("mousemove", d);
    const h = Pe.getState(t.state);
    h?.dragging && (Q3(t, h.activeHandle, yc(h.dragging, u, n)), t.dispatch(t.state.tr.setMeta(Pe, { setDragging: null })));
  }
  function d(u) {
    if (!u.which) return c(u);
    const h = Pe.getState(t.state);
    if (h && h.dragging) {
      const f = yc(h.dragging, u, n);
      bc(t, h.activeHandle, f, r);
    }
  }
  return bc(t, o.activeHandle, a, r), s.addEventListener("mouseup", c), s.addEventListener("mousemove", d), e.preventDefault(), !0;
}
function G3(t, e, { colspan: n, colwidth: r }) {
  const i = r && r[r.length - 1];
  if (i) return i;
  const s = t.domAtPos(e);
  let o = s.node.childNodes[s.offset].offsetWidth, l = n;
  if (r)
    for (let a = 0; a < n; a++) r[a] && (o -= r[a], l--);
  return o / l;
}
function J3(t) {
  for (; t && t.nodeName != "TD" && t.nodeName != "TH"; ) t = t.classList && t.classList.contains("ProseMirror") ? null : t.parentNode;
  return t;
}
function gc(t, e, n, r) {
  const i = n == "right" ? -r : r, s = t.posAtCoords({
    left: e.clientX + i,
    top: e.clientY
  });
  if (!s) return -1;
  const { pos: o } = s, l = pn(t.state.doc.resolve(o));
  if (!l) return -1;
  if (n == "right") return l.pos;
  const a = re.get(l.node(-1)), c = l.start(-1), d = a.map.indexOf(l.pos - c);
  return d % a.width == 0 ? -1 : c + a.map[d - 1];
}
function yc(t, e, n) {
  const r = e.clientX - t.startX;
  return Math.max(n, t.startWidth + r);
}
function Ch(t, e) {
  t.dispatch(t.state.tr.setMeta(Pe, { setHandle: e }));
}
function Q3(t, e, n) {
  const r = t.state.doc.resolve(e), i = r.node(-1), s = re.get(i), o = r.start(-1), l = s.colCount(r.pos - o) + r.nodeAfter.attrs.colspan - 1, a = t.state.tr;
  for (let c = 0; c < s.height; c++) {
    const d = c * s.width + l;
    if (c && s.map[d] == s.map[d - s.width]) continue;
    const u = s.map[d], h = i.nodeAt(u).attrs, f = h.colspan == 1 ? 0 : l - s.colCount(u);
    if (h.colwidth && h.colwidth[f] == n) continue;
    const p = h.colwidth ? h.colwidth.slice() : Y3(h.colspan);
    p[f] = n, a.setNodeMarkup(o + u, null, {
      ...h,
      colwidth: p
    });
  }
  a.docChanged && t.dispatch(a);
}
function bc(t, e, n, r) {
  const i = t.state.doc.resolve(e), s = i.node(-1), o = i.start(-1), l = re.get(s).colCount(i.pos - o) + i.nodeAfter.attrs.colspan - 1;
  let a = t.domAtPos(i.start(-1)).node;
  for (; a && a.nodeName != "TABLE"; ) a = a.parentNode;
  a && No(s, a.firstChild, a, r, l, n);
}
function Y3(t) {
  return Array(t).fill(0);
}
function X3(t, e) {
  const n = [], r = t.doc.resolve(e), i = r.node(-1);
  if (!i) return Z.empty;
  const s = re.get(i), o = r.start(-1), l = s.colCount(r.pos - o) + r.nodeAfter.attrs.colspan - 1;
  for (let c = 0; c < s.height; c++) {
    const d = l + c * s.width;
    if ((l == s.width - 1 || s.map[d] != s.map[d + 1]) && (c == 0 || s.map[d] != s.map[d - s.width])) {
      var a;
      const u = s.map[d], h = o + u + i.nodeAt(u).nodeSize - 1, f = document.createElement("div");
      f.className = "column-resize-handle", !((a = Pe.getState(t)) === null || a === void 0) && a.dragging && n.push(he.node(o + u, o + u + i.nodeAt(u).nodeSize, { class: "column-resize-dragging" })), n.push(he.widget(h, f));
    }
  }
  return Z.create(t.doc, n);
}
function ew({ allowTableNodeSelection: t = !1 } = {}) {
  return new Y({
    key: Pt,
    state: {
      init() {
        return null;
      },
      apply(e, n) {
        const r = e.getMeta(Pt);
        if (r != null) return r == -1 ? null : r;
        if (n == null || !e.docChanged) return n;
        const { deleted: i, pos: s } = e.mapping.mapResult(n);
        return i ? null : s;
      }
    },
    props: {
      decorations: f3,
      handleDOMEvents: { mousedown: F3 },
      createSelectionBetween(e) {
        return Pt.getState(e.state) != null ? e.state.selection : null;
      },
      handleTripleClick: H3,
      handleKeyDown: $3,
      handlePaste: V3
    },
    appendTransaction(e, n, r) {
      return g3(r, yh(r, n), t);
    }
  });
}
function Fi(t) {
  return t === "left" || t === "right" || t === "center" ? t : null;
}
function tw(t) {
  const e = (t.style.textAlign || "").trim().toLowerCase(), n = (t.getAttribute("align") || "").trim().toLowerCase();
  return Fi(e || n);
}
function nw(t) {
  return Fi(t?.align);
}
function xh() {
  return {
    default: null,
    parseHTML: (t) => tw(t),
    renderHTML: (t) => t.align ? {
      style: `text-align: ${t.align}`
    } : {}
  };
}
var wh = de.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          var e, n;
          const r = t.getAttribute("colwidth"), i = r ? r.split(",").map((s) => parseInt(s, 10)) : null;
          if (!i) {
            const s = (e = t.closest("table")) == null ? void 0 : e.querySelectorAll("colgroup > col"), o = Array.from(((n = t.parentElement) == null ? void 0 : n.children) || []).indexOf(t);
            if (o && o > -1 && s && s[o]) {
              const l = s[o].getAttribute("width");
              return l ? [parseInt(l, 10)] : null;
            }
          }
          return i;
        }
      },
      align: xh()
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["td", J(this.options.HTMLAttributes, t), 0];
  }
}), Sh = de.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? e.split(",").map((r) => parseInt(r, 10)) : null;
        }
      },
      align: xh()
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["th", J(this.options.HTMLAttributes, t), 0];
  }
}), Mh = de.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["tr", J(this.options.HTMLAttributes, t), 0];
  }
});
function _o(t, e) {
  return e ? ["width", `${Math.max(e, t)}px`] : ["min-width", `${t}px`];
}
function kc(t, e, n, r, i, s) {
  var o;
  let l = 0, a = !0, c = e.firstChild;
  const d = t.firstChild;
  if (d !== null)
    for (let h = 0, f = 0; h < d.childCount; h += 1) {
      const { colspan: p, colwidth: m } = d.child(h).attrs;
      for (let g = 0; g < p; g += 1, f += 1) {
        const b = i === f ? s : m && m[g], k = b ? `${b}px` : "";
        if (l += b || r, b || (a = !1), c) {
          if (c.style.width !== k) {
            const [C, v] = _o(r, b);
            c.style.setProperty(C, v);
          }
          c = c.nextSibling;
        } else {
          const C = document.createElement("col"), [v, x] = _o(r, b);
          C.style.setProperty(v, x), e.appendChild(C);
        }
      }
    }
  for (; c; ) {
    const h = c.nextSibling;
    (o = c.parentNode) == null || o.removeChild(c), c = h;
  }
  const u = t.attrs.style && typeof t.attrs.style == "string" && /\bwidth\s*:/i.test(t.attrs.style);
  a && !u ? (n.style.width = `${l}px`, n.style.minWidth = "") : (n.style.width = "", n.style.minWidth = `${l}px`);
}
var rw = class {
  constructor(t, e) {
    this.node = t, this.cellMinWidth = e, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), t.attrs.style && (this.table.style.cssText = t.attrs.style), this.colgroup = this.table.appendChild(document.createElement("colgroup")), kc(t, this.colgroup, this.table, e), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(t) {
    return t.type !== this.node.type ? !1 : (this.node = t, kc(t, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(t) {
    const e = t.target, n = this.dom.contains(e), r = this.contentDOM.contains(e);
    return !!(n && !r && (t.type === "attributes" || t.type === "childList" || t.type === "characterData"));
  }
};
function iw(t, e, n, r) {
  let i = 0, s = !0;
  const o = [], l = t.firstChild;
  if (!l)
    return {};
  for (let u = 0, h = 0; u < l.childCount; u += 1) {
    const { colspan: f, colwidth: p } = l.child(u).attrs;
    for (let m = 0; m < f; m += 1, h += 1) {
      const g = n === h ? r : p && p[m];
      i += g || e, g || (s = !1);
      const [b, k] = _o(e, g);
      o.push(["col", { style: `${b}: ${k}` }]);
    }
  }
  const a = s ? `${i}px` : "", c = s ? "" : `${i}px`;
  return { colgroup: ["colgroup", {}, ...o], tableWidth: a, tableMinWidth: c };
}
function vc(t, e) {
  return t.createAndFill();
}
function sw(t) {
  if (t.cached.tableNodeTypes)
    return t.cached.tableNodeTypes;
  const e = {};
  return Object.keys(t.nodes).forEach((n) => {
    const r = t.nodes[n];
    r.spec.tableRole && (e[r.spec.tableRole] = r);
  }), t.cached.tableNodeTypes = e, e;
}
function ow(t, e, n, r, i) {
  const s = sw(t), o = [], l = [];
  for (let c = 0; c < n; c += 1) {
    const d = vc(s.cell);
    if (d && l.push(d), r) {
      const u = vc(s.header_cell);
      u && o.push(u);
    }
  }
  const a = [];
  for (let c = 0; c < e; c += 1)
    a.push(s.row.createChecked(null, r && c === 0 ? o : l));
  return s.table.createChecked(null, a);
}
function lw(t) {
  return t instanceof G;
}
var jr = ({ editor: t }) => {
  const { selection: e } = t.state;
  if (!lw(e))
    return !1;
  let n = 0;
  const r = cu(e.ranges[0].$from, (s) => s.type.name === "table");
  return r?.node.descendants((s) => {
    if (s.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(s.type.name) && (n += 1);
  }), n === e.ranges.length ? (t.commands.deleteTable(), !0) : !1;
}, aw = "";
function cw(t) {
  return (t || "").replace(/\s+/g, " ").trim();
}
function dw(t, e, n = {}) {
  var r;
  const i = (r = n.cellLineSeparator) != null ? r : aw;
  if (!t || !t.content || t.content.length === 0)
    return "";
  const s = [];
  t.content.forEach((m) => {
    const g = [];
    m.content && m.content.forEach((b) => {
      let k = "";
      b.content && Array.isArray(b.content) && b.content.length > 1 ? k = b.content.map((S) => e.renderChildren(S)).join(i) : k = b.content ? e.renderChildren(b.content) : "";
      const C = cw(k), v = b.type === "tableHeader", x = nw(b.attrs);
      g.push({ text: C, isHeader: v, align: x });
    }), s.push(g);
  });
  const o = s.reduce((m, g) => Math.max(m, g.length), 0);
  if (o === 0)
    return "";
  const l = new Array(o).fill(0);
  s.forEach((m) => {
    var g;
    for (let b = 0; b < o; b += 1) {
      const C = (((g = m[b]) == null ? void 0 : g.text) || "").length;
      C > l[b] && (l[b] = C), l[b] < 3 && (l[b] = 3);
    }
  });
  const a = (m, g) => m + " ".repeat(Math.max(0, g - m.length)), c = s[0], d = c.some((m) => m.isHeader), u = new Array(o).fill(null);
  s.forEach((m) => {
    var g;
    for (let b = 0; b < o; b += 1)
      !u[b] && ((g = m[b]) != null && g.align) && (u[b] = m[b].align);
  });
  let h = `
`;
  const f = new Array(o).fill(0).map((m, g) => d && c[g] && c[g].text || "");
  return h += `| ${f.map((m, g) => a(m, l[g])).join(" | ")} |
`, h += `| ${l.map((m, g) => {
    const b = Math.max(3, m), k = u[g];
    return k === "left" ? `:${"-".repeat(b)}` : k === "right" ? `${"-".repeat(b)}:` : k === "center" ? `:${"-".repeat(b)}:` : "-".repeat(b);
  }).join(" | ")} |
`, (d ? s.slice(1) : s).forEach((m) => {
    h += `| ${new Array(o).fill(0).map((g, b) => a(m[b] && m[b].text || "", l[b])).join(" | ")} |
`;
  }), h;
}
var uw = dw, Th = de.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      renderWrapper: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: rw,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    const { colgroup: n, tableWidth: r, tableMinWidth: i } = iw(t, this.options.cellMinWidth), s = e.style;
    function o() {
      return s || (r ? `width: ${r}` : `min-width: ${i}`);
    }
    const l = [
      "table",
      J(this.options.HTMLAttributes, e, {
        style: o()
      }),
      n,
      ["tbody", 0]
    ];
    return this.options.renderWrapper ? ["div", { class: "tableWrapper" }, l] : l;
  },
  parseMarkdown: (t, e) => {
    const n = [], r = Array.isArray(t.align) ? t.align : [];
    if (t.header) {
      const i = [];
      t.header.forEach((s, o) => {
        var l;
        const a = Fi((l = r[o]) != null ? l : s.align), c = a ? { align: a } : {};
        i.push(
          e.createNode("tableHeader", c, [{ type: "paragraph", content: e.parseInline(s.tokens) }])
        );
      }), n.push(e.createNode("tableRow", {}, i));
    }
    return t.rows && t.rows.forEach((i) => {
      const s = [];
      i.forEach((o, l) => {
        var a;
        const c = Fi((a = r[l]) != null ? a : o.align), d = c ? { align: c } : {};
        s.push(e.createNode("tableCell", d, [{ type: "paragraph", content: e.parseInline(o.tokens) }]));
      }), n.push(e.createNode("tableRow", {}, s));
    }), e.createNode("table", void 0, n);
  },
  renderMarkdown: (t, e) => uw(t, e),
  addCommands() {
    return {
      insertTable: ({ rows: t = 3, cols: e = 3, withHeaderRow: n = !0 } = {}) => ({ tr: r, dispatch: i, editor: s }) => {
        const o = ow(s.schema, t, e, n);
        if (i) {
          const l = r.selection.from + 1;
          r.replaceSelectionWith(o).scrollIntoView().setSelection(I.near(r.doc.resolve(l)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: t, dispatch: e }) => k3(t, e),
      addColumnAfter: () => ({ state: t, dispatch: e }) => v3(t, e),
      deleteColumn: () => ({ state: t, dispatch: e }) => x3(t, e),
      addRowBefore: () => ({ state: t, dispatch: e }) => S3(t, e),
      addRowAfter: () => ({ state: t, dispatch: e }) => M3(t, e),
      deleteRow: () => ({ state: t, dispatch: e }) => E3(t, e),
      deleteTable: () => ({ state: t, dispatch: e }) => L3(t, e),
      mergeCells: () => ({ state: t, dispatch: e }) => ac(t, e),
      splitCell: () => ({ state: t, dispatch: e }) => cc(t, e),
      toggleHeaderColumn: () => ({ state: t, dispatch: e }) => kr("column")(t, e),
      toggleHeaderRow: () => ({ state: t, dispatch: e }) => kr("row")(t, e),
      toggleHeaderCell: () => ({ state: t, dispatch: e }) => R3(t, e),
      mergeOrSplit: () => ({ state: t, dispatch: e }) => ac(t, e) ? !0 : cc(t, e),
      setCellAttribute: (t, e) => ({ state: n, dispatch: r }) => _3(t, e)(n, r),
      goToNextCell: () => ({ state: t, dispatch: e }) => uc(1)(t, e),
      goToPreviousCell: () => ({ state: t, dispatch: e }) => uc(-1)(t, e),
      fixTables: () => ({ state: t, dispatch: e }) => (e && yh(t), !0),
      setCellSelection: (t) => ({ tr: e, dispatch: n }) => {
        if (n) {
          const r = G.create(e.doc, t.anchorCell, t.headCell);
          e.setSelection(r);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: jr,
      "Mod-Backspace": jr,
      Delete: jr,
      "Mod-Delete": jr
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        q3({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          defaultCellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      ew({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  addNodeView() {
    const t = this.options.resizable && this.editor.isEditable, e = this.options.View;
    return t || !e ? null : ({ node: n, view: r }) => new e(n, this.options.cellMinWidth, r);
  },
  extendNodeSchema(t) {
    const e = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      tableRole: F(O(t, "tableRole", e))
    };
  }
});
X.create({
  name: "tableKit",
  addExtensions() {
    const t = [];
    return this.options.table !== !1 && t.push(Th.configure(this.options.table)), this.options.tableCell !== !1 && t.push(wh.configure(this.options.tableCell)), this.options.tableHeader !== !1 && t.push(Sh.configure(this.options.tableHeader)), this.options.tableRow !== !1 && t.push(Mh.configure(this.options.tableRow)), t;
  }
});
var hw = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, fw = de.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["img", J(this.options.HTMLAttributes, t)];
  },
  parseMarkdown: (t, e) => e.createNode("image", {
    src: t.href,
    title: t.title,
    alt: t.text
  }),
  renderMarkdown: (t) => {
    var e, n, r, i, s, o;
    const l = (n = (e = t.attrs) == null ? void 0 : e.src) != null ? n : "", a = (i = (r = t.attrs) == null ? void 0 : r.alt) != null ? i : "", c = (o = (s = t.attrs) == null ? void 0 : s.title) != null ? o : "";
    return c ? `![${a}](${l} "${c}")` : `![${a}](${l})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: t, minWidth: e, minHeight: n, alwaysPreserveAspectRatio: r } = this.options.resize;
    return ({ node: i, getPos: s, HTMLAttributes: o, editor: l }) => {
      const a = document.createElement("img");
      Object.entries(o).forEach(([u, h]) => {
        if (h != null)
          switch (u) {
            case "width":
            case "height":
              break;
            default:
              a.setAttribute(u, h);
              break;
          }
      }), a.src = o.src;
      const c = new iv({
        element: a,
        editor: l,
        node: i,
        getPos: s,
        onResize: (u, h) => {
          a.style.width = `${u}px`, a.style.height = `${h}px`;
        },
        onCommit: (u, h) => {
          const f = s();
          f !== void 0 && this.editor.chain().setNodeSelection(f).updateAttributes(this.name, {
            width: u,
            height: h
          }).run();
        },
        onUpdate: (u, h, f) => u.type === i.type,
        options: {
          directions: t,
          min: {
            width: e,
            height: n
          },
          preserveAspectRatio: r === !0
        }
      }), d = c.dom;
      return d.style.visibility = "hidden", d.style.pointerEvents = "none", a.onload = () => {
        d.style.visibility = "", d.style.pointerEvents = "";
      }, c;
    };
  },
  addCommands() {
    return {
      setImage: (t) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: t
      })
    };
  },
  addInputRules() {
    return [
      Lu({
        find: hw,
        type: this.type,
        getAttributes: (t) => {
          const [, , e, n, r] = t;
          return { src: n, alt: e, title: r };
        }
      })
    ];
  }
}), pw = fw;
function Jt(t, e) {
  return {
    default: null,
    parseHTML: (n) => n.getAttribute(t),
    renderHTML: (n) => {
      const r = n[e];
      return r == null ? {} : { [t]: String(r) };
    }
  };
}
const js = de.create({
  name: "entityReference",
  group: "inline",
  inline: !0,
  atom: !0,
  selectable: !0,
  addAttributes() {
    return {
      label: {
        default: null,
        parseHTML: (t) => t.textContent,
        renderHTML: () => ({})
      },
      type: Jt("data-type", "type"),
      id: Jt("data-id", "id"),
      officeId: Jt("data-office-id", "officeId"),
      contactId: Jt("data-contact-id", "contactId"),
      parentType: Jt("data-parent-type", "parentType"),
      parentId: Jt("data-parent-id", "parentId"),
      disabledFlag: Jt("data-disabled-flag", "disabledFlag")
    };
  },
  parseHTML() {
    return [{ tag: "span.legalease-display-reference" }];
  },
  renderHTML({
    HTMLAttributes: t,
    node: e
  }) {
    return [
      "span",
      J({ class: "legalease-display-reference" }, t),
      e.attrs.label
    ];
  }
}), mw = /^[a-z][a-z0-9-]*$/;
function Eh(t) {
  return t?.trim().startsWith("#") ?? !1;
}
const gw = X.create({
  name: "headingId",
  addGlobalAttributes() {
    return [
      {
        types: ["heading"],
        attributes: {
          id: {
            default: null,
            parseHTML: (t) => {
              const e = t.getAttribute("id");
              return e && mw.test(e) ? e : null;
            },
            renderHTML: (t) => {
              const e = t.id;
              return e ? { id: String(e) } : {};
            }
          }
        }
      }
    ];
  }
}), yw = cx.extend({
  parseHTML() {
    return (this.parent?.() ?? []).map((t) => "style" in t ? t : {
      ...t,
      getAttrs: (e) => {
        const n = (t.getAttrs ? t.getAttrs(e) : t.attrs) ?? null;
        return n === !1 || !Eh(e.getAttribute("href")) ? n : {
          ...n,
          target: e.getAttribute("target"),
          rel: e.getAttribute("rel")
        };
      }
    });
  }
}), bw = pw.extend({
  name: "image",
  addAttributes() {
    return {
      ...this.parent?.(),
      "data-media-id": {
        default: null,
        parseHTML: (t) => t.getAttribute("data-media-id"),
        renderHTML: (t) => {
          const e = t["data-media-id"];
          return e ? { "data-media-id": String(e) } : {};
        }
      }
    };
  }
});
function kw(t, e) {
  const n = {
    openOnClick: !1,
    autolink: !0,
    defaultProtocol: "https",
    HTMLAttributes: {
      rel: "noopener noreferrer",
      target: "_blank"
    }
  }, r = {
    bulletList: {
      HTMLAttributes: {
        style: "list-style-type: disc; padding-left: 1.5rem;"
      }
    },
    orderedList: {
      HTMLAttributes: {
        style: "list-style-type: decimal; padding-left: 1.5rem;"
      }
    },
    listItem: {
      HTMLAttributes: {
        style: "display: list-item;"
      }
    }
  }, i = e.headingIds ? [yw.configure(n), gw] : [], s = e.headingIds ? !1 : n;
  if (t === "basic") {
    const l = [
      Ws.configure({
        heading: !1,
        blockquote: !1,
        codeBlock: !1,
        code: !1,
        horizontalRule: !1,
        link: !1,
        ...r
      })
    ];
    return e.entityReferences && l.push(js), l;
  }
  if (t === "basic_enhanced") {
    const l = [
      Ws.configure({
        codeBlock: !1,
        code: !1,
        horizontalRule: !1,
        heading: { levels: [2, 3, 4] },
        link: s,
        ...r
      }),
      oc.configure({
        types: ["paragraph", "heading"],
        alignments: ["left", "center", "right"]
      }),
      ...i
    ];
    return e.entityReferences && l.push(js), l;
  }
  const o = [
    Ws.configure({
      heading: { levels: [1, 2, 3, 4] },
      link: s,
      ...r
    }),
    oc.configure({
      types: ["paragraph", "heading"],
      alignments: ["left", "center", "right"]
    }),
    Th.configure({ resizable: !0 }),
    Mh,
    Sh,
    wh,
    ...i
  ];
  return e.mediaEnabled && o.push(
    bw.configure({
      allowBase64: !1,
      inline: !1
    })
  ), e.entityReferences && o.push(js), o;
}
const vw = "_field_1xz2u_4", Cw = "_label_1xz2u_11", xw = "_required_1xz2u_17", ww = "_description_1xz2u_22", Sw = "_container_1xz2u_28", Mw = "_fieldError_1xz2u_45", Tw = "_errorText_1xz2u_53", Ew = "_modeToggle_1xz2u_61", Aw = "_modeButton_1xz2u_67", Nw = "_modeActive_1xz2u_82", _w = "_toolbar_1xz2u_89", Ow = "_toolbarDivider_1xz2u_99", Rw = "_toolbarButton_1xz2u_107", Iw = "_active_1xz2u_137", Lw = "_headingSelectLabel_1xz2u_146", Dw = "_headingSelect_1xz2u_146", Pw = "_visuallyHidden_1xz2u_162", zw = "_editorWrapper_1xz2u_176", Bw = "_editorContent_1xz2u_188", $w = "_contentEditable_1xz2u_184", Hw = "_htmlTextarea_1xz2u_285", Vw = "_popover_1xz2u_301", Fw = "_popoverField_1xz2u_317", Ww = "_popoverCheckbox_1xz2u_339", qw = "_popoverError_1xz2u_347", jw = "_popoverActions_1xz2u_353", Uw = "_primaryButton_1xz2u_359", Kw = "_secondaryButton_1xz2u_373", H = {
  field: vw,
  label: Cw,
  required: xw,
  description: ww,
  container: Sw,
  fieldError: Mw,
  errorText: Tw,
  modeToggle: Ew,
  modeButton: Aw,
  modeActive: Nw,
  toolbar: _w,
  toolbarDivider: Ow,
  toolbarButton: Rw,
  active: Iw,
  headingSelectLabel: Lw,
  headingSelect: Dw,
  visuallyHidden: Pw,
  editorWrapper: zw,
  editorContent: Bw,
  contentEditable: $w,
  htmlTextarea: Hw,
  popover: Vw,
  popoverField: Fw,
  popoverCheckbox: Ww,
  popoverError: qw,
  popoverActions: jw,
  primaryButton: Uw,
  secondaryButton: Kw
}, Zw = {
  bold: "Bold",
  italic: "Italic",
  underline: "Underline",
  strike: "Strikethrough",
  bulletList: "Bullet list",
  orderedList: "Numbered list",
  clearFormatting: "Clear formatting",
  blockquote: "Blockquote",
  heading: "Heading",
  paragraph: "Paragraph",
  alignLeft: "Align left",
  alignCenter: "Align centre",
  alignRight: "Align right",
  link: "Insert link",
  unlink: "Remove link",
  undo: "Undo",
  redo: "Redo",
  insertTable: "Insert table",
  insertImage: "Insert image",
  visualMode: "Visual",
  htmlMode: "HTML",
  linkPopoverTitle: "Insert link",
  linkHref: "URL",
  linkOpenInNewTab: "Open in new tab",
  linkApply: "Apply",
  linkCancel: "Cancel",
  linkInvalidScheme: "Only http, https, mailto and tel links are allowed.",
  dropFileRejected: "Use the toolbar image button to insert from the media library."
}, Gw = ["http:", "https:", "mailto:", "tel:"];
function Jw(t) {
  if (!t) return !1;
  if (t.startsWith("/") || t.startsWith("#")) return !0;
  try {
    const e = new URL(t, "https://placeholder.example");
    return /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(t) ? Gw.includes(e.protocol) : !0;
  } catch {
    return !1;
  }
}
function Qw(t) {
  if (typeof DOMParser > "u") return t;
  let e;
  try {
    e = new DOMParser().parseFromString(`<body>${t}</body>`, "text/html");
  } catch {
    return t;
  }
  const n = e.body;
  return n.querySelectorAll("img").forEach((r) => {
    (r.getAttribute("src") ?? "").toLowerCase().startsWith("data:") && r.remove();
  }), n.querySelectorAll("[style]").forEach((r) => {
    const i = r.tagName.toLowerCase();
    if (!(i === "p" || i === "h2" || i === "h3" || i === "h4")) {
      r.removeAttribute("style");
      return;
    }
    const o = r.style.textAlign;
    r.removeAttribute("style"), o && /^(left|center|right)$/.test(o) && (r.style.textAlign = o);
  }), n.innerHTML;
}
function ye({
  active: t,
  disabled: e,
  onClick: n,
  title: r,
  children: i,
  testId: s
}) {
  return /* @__PURE__ */ y(
    "button",
    {
      type: "button",
      className: `${H.toolbarButton} ${t ? H.active : ""}`,
      onMouseDown: (o) => o.preventDefault(),
      onClick: n,
      disabled: e,
      "aria-pressed": t ? "true" : void 0,
      "aria-label": r,
      title: r,
      "data-testid": s,
      children: i
    }
  );
}
function Ie({ children: t }) {
  return /* @__PURE__ */ y(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      focusable: "false",
      children: t
    }
  );
}
const Le = {
  bulletList: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("line", { x1: "8", y1: "6", x2: "21", y2: "6" }),
    /* @__PURE__ */ y("line", { x1: "8", y1: "12", x2: "21", y2: "12" }),
    /* @__PURE__ */ y("line", { x1: "8", y1: "18", x2: "21", y2: "18" }),
    /* @__PURE__ */ y("circle", { cx: "4", cy: "6", r: "1", fill: "currentColor" }),
    /* @__PURE__ */ y("circle", { cx: "4", cy: "12", r: "1", fill: "currentColor" }),
    /* @__PURE__ */ y("circle", { cx: "4", cy: "18", r: "1", fill: "currentColor" })
  ] }),
  orderedList: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("line", { x1: "10", y1: "6", x2: "21", y2: "6" }),
    /* @__PURE__ */ y("line", { x1: "10", y1: "12", x2: "21", y2: "12" }),
    /* @__PURE__ */ y("line", { x1: "10", y1: "18", x2: "21", y2: "18" }),
    /* @__PURE__ */ y("path", { d: "M4 6h1v4" }),
    /* @__PURE__ */ y("path", { d: "M4 10h2" }),
    /* @__PURE__ */ y("path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" })
  ] }),
  blockquote: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("path", { d: "M6 11h4v-1c0-1.5-.5-3-3-3" }),
    /* @__PURE__ */ y("path", { d: "M14 11h4v-1c0-1.5-.5-3-3-3" }),
    /* @__PURE__ */ y("path", { d: "M6 11v6h4v-6" }),
    /* @__PURE__ */ y("path", { d: "M14 11v6h4v-6" })
  ] }),
  alignLeft: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("line", { x1: "4", y1: "6", x2: "20", y2: "6" }),
    /* @__PURE__ */ y("line", { x1: "4", y1: "12", x2: "14", y2: "12" }),
    /* @__PURE__ */ y("line", { x1: "4", y1: "18", x2: "18", y2: "18" })
  ] }),
  alignCenter: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("line", { x1: "4", y1: "6", x2: "20", y2: "6" }),
    /* @__PURE__ */ y("line", { x1: "7", y1: "12", x2: "17", y2: "12" }),
    /* @__PURE__ */ y("line", { x1: "5", y1: "18", x2: "19", y2: "18" })
  ] }),
  alignRight: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("line", { x1: "4", y1: "6", x2: "20", y2: "6" }),
    /* @__PURE__ */ y("line", { x1: "10", y1: "12", x2: "20", y2: "12" }),
    /* @__PURE__ */ y("line", { x1: "6", y1: "18", x2: "20", y2: "18" })
  ] }),
  link: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("path", { d: "M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1 1" }),
    /* @__PURE__ */ y("path", { d: "M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1-1" })
  ] }),
  unlink: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("path", { d: "M18 9a5 5 0 0 0-7.07 0l-1 1" }),
    /* @__PURE__ */ y("path", { d: "M6 15a5 5 0 0 0 7.07 0l1-1" }),
    /* @__PURE__ */ y("line", { x1: "3", y1: "3", x2: "21", y2: "21" })
  ] }),
  undo: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("path", { d: "M3 7v6h6" }),
    /* @__PURE__ */ y("path", { d: "M3 13a9 9 0 1 0 3-7.7L3 8" })
  ] }),
  redo: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("path", { d: "M21 7v6h-6" }),
    /* @__PURE__ */ y("path", { d: "M21 13a9 9 0 1 1-3-7.7L21 8" })
  ] }),
  table: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("rect", { x: "3", y: "3", width: "18", height: "18", rx: "1" }),
    /* @__PURE__ */ y("line", { x1: "3", y1: "9", x2: "21", y2: "9" }),
    /* @__PURE__ */ y("line", { x1: "3", y1: "15", x2: "21", y2: "15" }),
    /* @__PURE__ */ y("line", { x1: "9", y1: "3", x2: "9", y2: "21" }),
    /* @__PURE__ */ y("line", { x1: "15", y1: "3", x2: "15", y2: "21" })
  ] }),
  image: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }),
    /* @__PURE__ */ y("circle", { cx: "9", cy: "9", r: "2" }),
    /* @__PURE__ */ y("path", { d: "m21 15-5-5L5 21" })
  ] }),
  clearFormatting: /* @__PURE__ */ E(Ie, { children: [
    /* @__PURE__ */ y("path", { d: "M4 7V4h16v3" }),
    /* @__PURE__ */ y("path", { d: "M5 20h6" }),
    /* @__PURE__ */ y("path", { d: "M13 4 8 20" }),
    /* @__PURE__ */ y("line", { x1: "15", y1: "15", x2: "20", y2: "20" }),
    /* @__PURE__ */ y("line", { x1: "20", y1: "15", x2: "15", y2: "20" })
  ] })
};
function Yw({ editor: t, preset: e, mediaEnabled: n, pickMedia: r, labels: i, onOpenLink: s }) {
  const o = e === "basic_enhanced" || e === "full", l = e === "full", a = Rh(async () => {
    if (!r) return;
    const d = await r();
    if (!d) return;
    const u = d;
    t.chain().focus().insertContent({
      type: "image",
      attrs: {
        src: u.url,
        alt: u.altText ?? "",
        "data-media-id": u.id
      }
    }).run();
  }, [t, r]), c = t.isActive("heading", { level: 2 }) ? "2" : t.isActive("heading", { level: 3 }) ? "3" : t.isActive("heading", { level: 4 }) ? "4" : "p";
  return /* @__PURE__ */ E("div", { className: H.toolbar, role: "toolbar", "aria-label": "Formatting toolbar", children: [
    /* @__PURE__ */ y(
      ye,
      {
        title: i.bold,
        active: t.isActive("bold"),
        disabled: !t.can().chain().focus().toggleBold().run(),
        onClick: () => t.chain().focus().toggleBold().run(),
        testId: "rte-bold",
        children: /* @__PURE__ */ y("strong", { children: "B" })
      }
    ),
    /* @__PURE__ */ y(
      ye,
      {
        title: i.italic,
        active: t.isActive("italic"),
        disabled: !t.can().chain().focus().toggleItalic().run(),
        onClick: () => t.chain().focus().toggleItalic().run(),
        testId: "rte-italic",
        children: /* @__PURE__ */ y("em", { children: "I" })
      }
    ),
    /* @__PURE__ */ y(
      ye,
      {
        title: i.underline,
        active: t.isActive("underline"),
        disabled: !t.can().chain().focus().toggleUnderline().run(),
        onClick: () => t.chain().focus().toggleUnderline().run(),
        testId: "rte-underline",
        children: /* @__PURE__ */ y("span", { style: { textDecoration: "underline" }, children: "U" })
      }
    ),
    /* @__PURE__ */ y(
      ye,
      {
        title: i.strike,
        active: t.isActive("strike"),
        onClick: () => t.chain().focus().toggleStrike().run(),
        testId: "rte-strike",
        children: /* @__PURE__ */ y("span", { style: { textDecoration: "line-through" }, children: "S" })
      }
    ),
    /* @__PURE__ */ y("span", { className: H.toolbarDivider, "aria-hidden": "true" }),
    /* @__PURE__ */ y(
      ye,
      {
        title: i.bulletList,
        active: t.isActive("bulletList"),
        onClick: () => t.chain().focus().toggleBulletList().run(),
        testId: "rte-bullet-list",
        children: Le.bulletList
      }
    ),
    /* @__PURE__ */ y(
      ye,
      {
        title: i.orderedList,
        active: t.isActive("orderedList"),
        onClick: () => t.chain().focus().toggleOrderedList().run(),
        testId: "rte-ordered-list",
        children: Le.orderedList
      }
    ),
    o && /* @__PURE__ */ E(Re, { children: [
      /* @__PURE__ */ y("span", { className: H.toolbarDivider, "aria-hidden": "true" }),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.blockquote,
          active: t.isActive("blockquote"),
          onClick: () => t.chain().focus().toggleBlockquote().run(),
          testId: "rte-blockquote",
          children: Le.blockquote
        }
      ),
      /* @__PURE__ */ E("label", { className: H.headingSelectLabel, children: [
        /* @__PURE__ */ y("span", { className: H.visuallyHidden, children: i.heading }),
        /* @__PURE__ */ E(
          "select",
          {
            className: H.headingSelect,
            value: c,
            onChange: (d) => {
              const u = d.target.value;
              u === "p" ? t.chain().focus().setParagraph().run() : t.chain().focus().toggleHeading({ level: Number(u) }).run();
            },
            "data-testid": "rte-heading",
            "aria-label": i.heading,
            children: [
              /* @__PURE__ */ y("option", { value: "p", children: i.paragraph }),
              /* @__PURE__ */ y("option", { value: "2", children: "H2" }),
              /* @__PURE__ */ y("option", { value: "3", children: "H3" }),
              /* @__PURE__ */ y("option", { value: "4", children: "H4" })
            ]
          }
        )
      ] }),
      /* @__PURE__ */ y("span", { className: H.toolbarDivider, "aria-hidden": "true" }),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.alignLeft,
          active: t.isActive({ textAlign: "left" }),
          onClick: () => t.chain().focus().setTextAlign("left").run(),
          testId: "rte-align-left",
          children: Le.alignLeft
        }
      ),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.alignCenter,
          active: t.isActive({ textAlign: "center" }),
          onClick: () => t.chain().focus().setTextAlign("center").run(),
          testId: "rte-align-center",
          children: Le.alignCenter
        }
      ),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.alignRight,
          active: t.isActive({ textAlign: "right" }),
          onClick: () => t.chain().focus().setTextAlign("right").run(),
          testId: "rte-align-right",
          children: Le.alignRight
        }
      ),
      /* @__PURE__ */ y("span", { className: H.toolbarDivider, "aria-hidden": "true" }),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.link,
          active: t.isActive("link"),
          onClick: s,
          testId: "rte-link",
          children: Le.link
        }
      ),
      t.isActive("link") && /* @__PURE__ */ y(
        ye,
        {
          title: i.unlink,
          onClick: () => t.chain().focus().unsetLink().run(),
          testId: "rte-unlink",
          children: Le.unlink
        }
      ),
      /* @__PURE__ */ y("span", { className: H.toolbarDivider, "aria-hidden": "true" }),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.undo,
          disabled: !t.can().chain().focus().undo().run(),
          onClick: () => t.chain().focus().undo().run(),
          testId: "rte-undo",
          children: Le.undo
        }
      ),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.redo,
          disabled: !t.can().chain().focus().redo().run(),
          onClick: () => t.chain().focus().redo().run(),
          testId: "rte-redo",
          children: Le.redo
        }
      )
    ] }),
    l && /* @__PURE__ */ E(Re, { children: [
      /* @__PURE__ */ y("span", { className: H.toolbarDivider, "aria-hidden": "true" }),
      /* @__PURE__ */ y(
        ye,
        {
          title: i.insertTable,
          onClick: () => t.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: !0 }).run(),
          testId: "rte-insert-table",
          children: Le.table
        }
      ),
      n && r && /* @__PURE__ */ y(
        ye,
        {
          title: i.insertImage,
          onClick: a,
          testId: "rte-insert-image",
          children: Le.image
        }
      )
    ] }),
    /* @__PURE__ */ y("span", { className: H.toolbarDivider, "aria-hidden": "true" }),
    /* @__PURE__ */ y(
      ye,
      {
        title: i.clearFormatting,
        onClick: () => t.chain().focus().unsetAllMarks().clearNodes().run(),
        testId: "rte-clear-format",
        children: Le.clearFormatting
      }
    )
  ] });
}
function Xw({
  editor: t,
  open: e,
  onClose: n,
  labels: r,
  headingIds: i
}) {
  const s = t.getAttributes("link").href ?? "", o = t.getAttributes("link").target === "_blank" || s === "", [l, a] = ie(s), [c, d] = ie(o), [u, h] = ie(!1), [f, p] = ie(null);
  if (_e(() => {
    if (e) {
      const g = t.getAttributes("link");
      a(g.href ?? ""), d(g.target === "_blank" || !g.href), h(!1), p(null);
    }
  }, [e, t]), !e) return null;
  const m = () => {
    if (!l) {
      t.chain().focus().unsetLink().run(), n();
      return;
    }
    if (!Jw(l)) {
      p(r.linkInvalidScheme);
      return;
    }
    t.chain().focus().extendMarkRange("link").setLink({
      href: l,
      target: c ? "_blank" : null,
      rel: c ? "noopener noreferrer" : null
    }).run(), n();
  };
  return /* @__PURE__ */ E("div", { className: H.popover, role: "dialog", "aria-label": r.linkPopoverTitle, children: [
    /* @__PURE__ */ E("label", { className: H.popoverField, children: [
      /* @__PURE__ */ y("span", { children: r.linkHref }),
      /* @__PURE__ */ y(
        "input",
        {
          type: "text",
          value: l,
          onChange: (g) => {
            const b = g.target.value;
            i && !u && d(!Eh(b)), a(b), f && p(null);
          },
          autoFocus: !0,
          "data-testid": "rte-link-href"
        }
      )
    ] }),
    /* @__PURE__ */ E("label", { className: H.popoverCheckbox, children: [
      /* @__PURE__ */ y(
        "input",
        {
          type: "checkbox",
          checked: c,
          onChange: (g) => {
            d(g.target.checked), h(!0);
          }
        }
      ),
      /* @__PURE__ */ y("span", { children: r.linkOpenInNewTab })
    ] }),
    f && /* @__PURE__ */ y("p", { className: H.popoverError, role: "alert", "data-testid": "rte-link-error", children: f }),
    /* @__PURE__ */ E("div", { className: H.popoverActions, children: [
      /* @__PURE__ */ y("button", { type: "button", onClick: n, className: H.secondaryButton, children: r.linkCancel }),
      /* @__PURE__ */ y(
        "button",
        {
          type: "button",
          onClick: m,
          className: H.primaryButton,
          "data-testid": "rte-link-apply",
          children: r.linkApply
        }
      )
    ] })
  ] });
}
const e4 = dt(
  (t, e) => {
    const {
      value: n,
      onChange: r,
      preset: i,
      mediaEnabled: s = !1,
      entityReferences: o = !1,
      headingIds: l = !1,
      htmlTab: a = !1,
      toolbar: c = !0,
      label: d,
      description: u,
      required: h,
      error: f,
      disabled: p = !1,
      id: m,
      ariaLabel: g,
      minHeight: b = 240,
      pickMedia: k,
      labels: C,
      onUploadAttempt: v
    } = t, x = Ct(
      () => ({ ...Zw, ...C }),
      [C]
    ), M = Oo(), S = m ?? `rte-${M}`, N = `${S}-label`, D = `${S}-description`, $ = `${S}-error`, oe = `${S}-editor`, [q, P] = ie("visual"), [_, V] = ie(!1), [je, me] = ie(n), ht = lt(v);
    ht.current = v;
    const Zt = lt(r);
    Zt.current = r;
    const Bn = Ct(
      () => kw(i, { mediaEnabled: s, entityReferences: o, headingIds: l }),
      [i, s, k, o, l]
    ), ge = hC(
      {
        extensions: Bn,
        content: n || "",
        editable: !p,
        // Tiptap 3.x disabled this by default — without it, React never re-renders
        // the toolbar when the cursor moves into a mark like bold/italic, so
        // editor.isActive("bold") stays stale and the active button highlight
        // never reflects selection state.
        shouldRerenderOnTransaction: !0,
        editorProps: {
          attributes: {
            role: "textbox",
            "aria-multiline": "true",
            "aria-label": g ?? d ?? "Rich text editor",
            class: H.contentEditable,
            id: oe
          },
          transformPastedHTML: (R) => Qw(R),
          handleDrop: (R, U) => {
            const et = U.dataTransfer;
            return et && et.files && et.files.length > 0 ? (U.preventDefault(), ht.current?.(x.dropFileRejected), !0) : !1;
          },
          handlePaste: (R, U) => {
            const et = U.clipboardData;
            return et && et.files && et.files.length > 0 ? (U.preventDefault(), ht.current?.(x.dropFileRejected), !0) : !1;
          }
        },
        onUpdate: ({ editor: R }) => {
          const U = R.isEmpty ? "" : R.getHTML();
          Zt.current(U);
        }
      },
      [Bn]
    );
    Oh(
      e,
      () => ({
        insertContent: (R) => {
          ge?.chain().focus().insertContent(R).run();
        }
      }),
      [ge]
    ), _e(() => {
      if (!ge) return;
      const R = ge.isEmpty ? "" : ge.getHTML();
      n !== R && ge.commands.setContent(n || "", { emitUpdate: !1 });
    }, [n]), _e(() => {
      ge?.setEditable(!p, !1);
    }, [ge, p]);
    const Sr = (R) => {
      R !== q && (R === "html" ? me(ge?.getHTML() ?? n ?? "") : ge?.commands.setContent(je || "", { emitUpdate: !0 }), P(R));
    }, ss = (R) => {
      me(R), r(R);
    }, ls = [u ? D : null, f ? $ : null].filter(Boolean).join(" ");
    return /* @__PURE__ */ E(
      "div",
      {
        className: `${H.field} ${f ? H.fieldError : ""}`,
        "data-testid": "rich-text-editor",
        children: [
          d && /* @__PURE__ */ E("label", { id: N, htmlFor: oe, className: H.label, children: [
            d,
            h && /* @__PURE__ */ y("span", { className: H.required, "aria-hidden": "true", children: " *" })
          ] }),
          u && /* @__PURE__ */ y("p", { id: D, className: H.description, children: u }),
          /* @__PURE__ */ E(
            "div",
            {
              className: H.container,
              style: { minHeight: b },
              "aria-invalid": f ? "true" : void 0,
              "aria-describedby": ls || void 0,
              children: [
                a && /* @__PURE__ */ E("div", { className: H.modeToggle, role: "tablist", "aria-label": "Editor mode", children: [
                  /* @__PURE__ */ y(
                    "button",
                    {
                      type: "button",
                      role: "tab",
                      "aria-selected": q === "visual",
                      className: `${H.modeButton} ${q === "visual" ? H.modeActive : ""}`,
                      onClick: () => Sr("visual"),
                      "data-testid": "rte-mode-visual",
                      children: x.visualMode
                    }
                  ),
                  /* @__PURE__ */ y(
                    "button",
                    {
                      type: "button",
                      role: "tab",
                      "aria-selected": q === "html",
                      className: `${H.modeButton} ${q === "html" ? H.modeActive : ""}`,
                      onClick: () => Sr("html"),
                      "data-testid": "rte-mode-html",
                      children: x.htmlMode
                    }
                  )
                ] }),
                q === "visual" && ge && !p && c && /* @__PURE__ */ y(
                  Yw,
                  {
                    editor: ge,
                    preset: i,
                    mediaEnabled: s,
                    pickMedia: k,
                    labels: x,
                    onOpenLink: () => V(!0)
                  }
                ),
                /* @__PURE__ */ y("div", { className: H.editorWrapper, style: { minHeight: b }, children: q === "visual" ? /* @__PURE__ */ y(zu, { editor: ge, className: H.editorContent }) : /* @__PURE__ */ y(
                  "textarea",
                  {
                    className: H.htmlTextarea,
                    style: { minHeight: b },
                    value: je,
                    onChange: (R) => ss(R.target.value),
                    "data-testid": "rte-html-textarea",
                    "aria-label": "HTML source"
                  }
                ) }),
                ge && _ && q === "visual" && /* @__PURE__ */ y(
                  Xw,
                  {
                    editor: ge,
                    open: _,
                    onClose: () => V(!1),
                    labels: x,
                    headingIds: l
                  }
                )
              ]
            }
          ),
          f && /* @__PURE__ */ y("p", { id: $, className: H.errorText, role: "alert", children: f })
        ]
      }
    );
  }
);
e4.displayName = "RichTextEditor";
export {
  i4 as Breadcrumb,
  ot as Button,
  wc as Checkbox,
  Kf as Chip,
  Xm as ComboField,
  _1 as DatePicker,
  s4 as Disclosure,
  o4 as EditorialCategorySelect,
  L1 as Header,
  j as Icon,
  hm as Input,
  bw as MediaImage,
  Sc as Modal,
  Us as NavLink,
  l4 as Navigation,
  ag as Pagination,
  a1 as Radio,
  e4 as RichTextEditor,
  rp as SearchBar,
  Tm as Select,
  kg as Table,
  v1 as Textarea,
  c4 as Tile,
  a4 as Toast,
  Rg as Tooltip,
  Jg as TreeNode,
  kw as buildExtensions,
  f4 as getAllowList,
  Tc as isNavGroup,
  p4 as richTextAllowList,
  Ym as shouldDropUp
};
